var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatures(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.672,
    height: 79,
    viewBox: "0 0 78.672 79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Features",
    transform: "translate(-41.045 -40.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M85.177,41.914l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.468.468,0,0,0,.377.171c.1,0,.2,0,.3.006a.548.548,0,0,1,.294.111l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.477.477,0,0,0,.371.173h.3a3.158,3.158,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.477.477,0,0,0,.371.173h.3a3.158,3.158,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.47.47,0,0,0,.371.173h.3a3.159,3.159,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.47.47,0,0,0,.371.173h.3a3.162,3.162,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.47.47,0,0,0,.371.173h.3a3.16,3.16,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.47.47,0,0,0,.371.173h.3a3.158,3.158,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.538.538,0,0,1,.292.113l-.013.028a.47.47,0,0,0,.371.173h.3a3.159,3.159,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.479.479,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.47.47,0,0,0,.371.173h.3a3.159,3.159,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.479.479,0,0,0,.377.168c.1,0,.2,0,.3.006a.538.538,0,0,1,.292.113l-.013.028a.467.467,0,0,0,.371.173h.3a3.16,3.16,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.479.479,0,0,0,.377.168c.1,0,.2,0,.3.006a.538.538,0,0,1,.292.113l-.013.028a.466.466,0,0,0,.369.173h.3a3.16,3.16,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.377.171c.1,0,.2,0,.3.006a.538.538,0,0,1,.292.113l-.013.028a.466.466,0,0,0,.369.173h.3a3.16,3.16,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.377.171c.1,0,.2,0,.3.006a.551.551,0,0,1,.294.113l-.013.028a.472.472,0,0,0,.375.173c.1,0,.2,0,.3.006a.547.547,0,0,1,.294.115l-.013.021a1.786,1.786,0,0,0,.3.241.383.383,0,0,1,.092.094.65.65,0,0,0,.228.228.426.426,0,0,1,.094.092,2.093,2.093,0,0,0,.241.307l.015-.011a.455.455,0,0,1,.115.254.508.508,0,0,0,.192.392l.015-.011c.087.124.209.215.3.339l.013-.011a.426.426,0,0,1,.122.25.547.547,0,0,0,.19.4l.017-.011a.456.456,0,0,1,.115.254.511.511,0,0,0,.192.392l.015-.011a.488.488,0,0,1,.111.254.344.344,0,0,0,.179.32.546.546,0,0,1,.092.094,1.987,1.987,0,0,0,.241.307l.017-.011a.455.455,0,0,1,.115.254.511.511,0,0,0,.192.392l.015-.011a.472.472,0,0,1,.111.254.344.344,0,0,0,.179.32.547.547,0,0,1,.092.094,1.986,1.986,0,0,0,.241.307l.015-.011a.455.455,0,0,1,.115.254.519.519,0,0,0,.192.395l.015-.011a.465.465,0,0,1,.111.254.344.344,0,0,0,.179.32.478.478,0,0,1,.092.094,2.112,2.112,0,0,0,.239.307l.017-.011a.441.441,0,0,1,.115.254.531.531,0,0,0,.19.395l.017-.011a.49.49,0,0,1,.113.256.513.513,0,0,0,.19.395l.019-.013a.521.521,0,0,1,.111.256.557.557,0,0,0,.183.4l.026-.013a.544.544,0,0,1,.119.307c.009.109.011.22.009.328V60.8c.009.232-.043.48.164.663v.318a.46.46,0,0,0-.166.363c0,.1,0,.2,0,.294s0,.209,0,.313,0,.218-.006.326a.544.544,0,0,1-.119.309l-.026-.013a.463.463,0,0,0-.173.375c0,.1,0,.2-.006.3a.505.505,0,0,1-.122.29l-.019-.013a.547.547,0,0,0-.186.4.4.4,0,0,1-.122.25l-.011-.011c-.09.122-.209.218-.3.335l-.009-.006c-.1.111-.215.211-.309.331l0,0a3.511,3.511,0,0,0-.318.324c-.117.1-.22.207-.326.313l.006.006c-.117.094-.218.209-.331.307l.009.011a.432.432,0,0,1-.252.117.5.5,0,0,0-.392.194l.011.015a.5.5,0,0,1-.258.111.507.507,0,0,0-.395.19l.013.021a.525.525,0,0,1-.258.109.563.563,0,0,0-.4.181l.013.026a.543.543,0,0,1-.3.119c-.1.009-.207.011-.309.017-.3.019-.183.245-.2.405q0,11.177,0,22.349c-.006.13,0,.258-.006.388a3.536,3.536,0,0,1-.011.369.56.56,0,0,1-.128.333l-.026-.013a.552.552,0,0,0-.183.4.453.453,0,0,1-.113.254l-.017-.011a1.753,1.753,0,0,0-.239.3.478.478,0,0,1-.092.094.346.346,0,0,0-.181.318.352.352,0,0,1-.128.243h0a.356.356,0,0,1-.243.124.346.346,0,0,0-.318.181.547.547,0,0,1-.094.092,2.078,2.078,0,0,0-.307.239l.013.019a.5.5,0,0,1-.288.119c-.1.011-.2.006-.3.011a.483.483,0,0,0-.38.168l.013.028a.577.577,0,0,1-.3.117,3.119,3.119,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.562.562,0,0,1-.292.113c-.1.009-.2.006-.3.009a.485.485,0,0,0-.38.166l.013.028a.544.544,0,0,1-.3.117,3.119,3.119,0,0,1-.316.006c-.1,0-.2,0-.3,0a.471.471,0,0,0-.375.168l.013.028a.521.521,0,0,1-.29.113c-.1.009-.2.006-.3.009a.493.493,0,0,0-.38.164l-.307.034a.519.519,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.544.544,0,0,1-.3.117,3.119,3.119,0,0,1-.316.006c-.1,0-.2,0-.3,0a.471.471,0,0,0-.375.168l.013.028a.538.538,0,0,1-.29.113c-.1.009-.2.006-.3.009a.488.488,0,0,0-.38.166l-.307.034a.525.525,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.544.544,0,0,1-.3.117,3.115,3.115,0,0,1-.316.006c-.1,0-.2,0-.3,0a.471.471,0,0,0-.375.168l.013.028a.55.55,0,0,1-.3.115c-.1.009-.207.009-.309.015-.294.019-.183.243-.2.4q0,8.624,0,17.248c-.006.132,0,.264-.011.4a.6.6,0,0,1-.128.363c-.011.1-.023.2-.034.307a.567.567,0,0,0-.181.4.5.5,0,0,1-.111.256l-.021-.013a.526.526,0,0,0-.188.4.449.449,0,0,1-.115.254l-.015-.011c-.1.117-.215.211-.3.335l-.006-.009a1.187,1.187,0,0,0-.247.288.435.435,0,0,1-.094.094.656.656,0,0,0-.232.232.49.49,0,0,1-.092.1,1.192,1.192,0,0,0-.3.252l.009.006c-.124.087-.218.207-.335.3l.011.015a.455.455,0,0,1-.254.115.537.537,0,0,0-.4.188l.013.021a.514.514,0,0,1-.254.111.576.576,0,0,0-.4.181l-.307.034a.624.624,0,0,1-.358.126c-.132.015-.264.006-.4.013q-14.75.01-29.5,0c-.13-.006-.26,0-.39-.006a3.534,3.534,0,0,1-.369-.011.581.581,0,0,1-.335-.124l.013-.03a.481.481,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.5.5,0,0,1-.29-.119l.013-.021a.545.545,0,0,0-.4-.188.417.417,0,0,1-.252-.119l.011-.013c-.119-.094-.215-.211-.333-.3l.006-.009c-.109-.1-.211-.218-.328-.311h0a3.507,3.507,0,0,0-.32-.322v0c-.1-.117-.211-.218-.311-.328l-.011.009c-.094-.117-.213-.213-.3-.335l-.013.011a.414.414,0,0,1-.122-.249.571.571,0,0,0-.186-.4l-.019.013a.5.5,0,0,1-.119-.288c-.011-.1-.006-.2-.011-.3a.481.481,0,0,0-.166-.38c-.011-.1-.023-.207-.034-.311a.634.634,0,0,1-.13-.392c-.023-5.764-.006-11.526-.011-17.288-.021-.158.1-.384-.2-.407-.1,0-.2-.006-.309-.015a.547.547,0,0,1-.3-.117l.013-.028a.481.481,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.522.522,0,0,1-.292-.113l-.307-.034a.482.482,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.477.477,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.476.476,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.522.522,0,0,1-.292-.113l-.307-.034a.482.482,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.525.525,0,0,1-.292-.115l.013-.028a.477.477,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.482.482,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.522.522,0,0,1-.292-.113l-.307-.034a.477.477,0,0,0-.377-.166c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028A.471.471,0,0,0,50.9,94.2h-.3a3.16,3.16,0,0,1-.318,0,.54.54,0,0,1-.3-.119L50,94.052a.539.539,0,0,0-.331-.177,1.119,1.119,0,0,1-.264-.053.346.346,0,0,1-.111-.081.358.358,0,0,0-.331-.19.452.452,0,0,1-.256-.113l.009-.011a1.553,1.553,0,0,0-.3-.243.383.383,0,0,1-.092-.094.65.65,0,0,0-.228-.228A.426.426,0,0,1,48,92.771a1.537,1.537,0,0,0-.247-.3l-.013.009c-.09-.122-.211-.215-.3-.337l-.015.011a.47.47,0,0,1-.124-.286c-.011-.1-.006-.2-.011-.3a.483.483,0,0,0-.168-.38l-.028.013a.611.611,0,0,1-.128-.358c-.015-.132-.006-.264-.013-.4q-.013-11.186,0-22.368c-.015-.164.081-.386-.209-.412a.581.581,0,0,1-.277-.122c-.1-.011-.2-.021-.3-.034a.568.568,0,0,0-.4-.181.5.5,0,0,1-.256-.111l.013-.021a.526.526,0,0,0-.4-.188.474.474,0,0,1-.256-.113l.011-.015a.512.512,0,0,0-.395-.192.4.4,0,0,1-.25-.122l.006-.006c-.117-.1-.218-.209-.331-.309l0-.006c-.111-.1-.213-.213-.324-.316s-.213-.213-.316-.324l-.006,0c-.1-.113-.213-.213-.309-.328l-.006.006a.4.4,0,0,1-.122-.25.522.522,0,0,0-.192-.392l-.015.011a.49.49,0,0,1-.113-.256.53.53,0,0,0-.188-.4l-.021.013a.492.492,0,0,1-.109-.256.567.567,0,0,0-.181-.4c-.011-.1-.023-.2-.034-.307a.594.594,0,0,1-.115-.318c-.011-.113-.009-.228-.009-.343s0-.23,0-.345q-.01-.435,0-.87c0-.115,0-.228,0-.343v-.339c0-.113,0-.226.006-.339a.564.564,0,0,1,.119-.316l.028.013a.474.474,0,0,0,.171-.377c0-.1,0-.2.006-.3a.5.5,0,0,1,.119-.29l.021.013a.538.538,0,0,0,.186-.4.414.414,0,0,1,.117-.252l.017.011a2.182,2.182,0,0,0,.237-.307.478.478,0,0,1,.092-.094.342.342,0,0,0,.179-.32.453.453,0,0,1,.113-.254l.017.011a.513.513,0,0,0,.19-.395.438.438,0,0,1,.117-.254l.015.011a2.233,2.233,0,0,0,.239-.307.478.478,0,0,1,.092-.094.342.342,0,0,0,.179-.32.453.453,0,0,1,.113-.254l.015.011a.523.523,0,0,0,.192-.395.438.438,0,0,1,.117-.254l.015.011a2.112,2.112,0,0,0,.239-.307.478.478,0,0,1,.092-.094.342.342,0,0,0,.179-.32.453.453,0,0,1,.113-.254l.015.011a.512.512,0,0,0,.192-.395.452.452,0,0,1,.117-.254l.017.011a2.113,2.113,0,0,0,.239-.307.478.478,0,0,1,.092-.094.342.342,0,0,0,.179-.32.465.465,0,0,1,.111-.254l.015.011a.512.512,0,0,0,.192-.395.463.463,0,0,1,.115-.254l.015.011a1.974,1.974,0,0,0,.239-.307.478.478,0,0,1,.092-.094.342.342,0,0,0,.179-.32.453.453,0,0,1,.113-.254l.013.009a1.554,1.554,0,0,0,.241-.3.416.416,0,0,1,.092-.092,1.849,1.849,0,0,0,.3-.241l-.013-.019a.543.543,0,0,1,.29-.117c.1-.009.2-.006.3-.009a.473.473,0,0,0,.38-.168l-.013-.028A.522.522,0,0,1,49,49.792c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034a.559.559,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.466.466,0,0,0,.377-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034a.559.559,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.469.469,0,0,0,.377-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034a.559.559,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034A.559.559,0,0,1,57,47.559c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034a.542.542,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.542.542,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.542.542,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.525.525,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.54.54,0,0,1,.29-.115c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.525.525,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.54.54,0,0,1,.29-.115c.1-.009.2-.006.3-.009a.493.493,0,0,0,.38-.164l.307-.034a.525.525,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.118,3.118,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.118,3.118,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.118,3.118,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.118,3.118,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.564.564,0,0,1,.3-.115,3.119,3.119,0,0,1,.316-.006c.1,0,.2,0,.3,0A.459.459,0,0,0,80.389,41l.316-.036a.871.871,0,0,1,.964,0l.313.034a.474.474,0,0,0,.377.166c.1,0,.2,0,.3.006a.535.535,0,0,1,.292.111l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.475.475,0,0,0,.377.171c.1,0,.2,0,.3.006a.534.534,0,0,1,.294.113Z",
    transform: "translate(-0.631 -0.635)",
    fill: "#517e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M156.266,408.975c.141,0,.284-.015.424-.015h29c.107,0,.213.011.318.015a.193.193,0,0,1-.011.29c-.373,0-.746.015-1.12.015H157.119c-.284,0-.567-.006-.853-.011a.2.2,0,0,1,0-.294Z",
    transform: "translate(-90.598 -290.27)",
    fill: "#b3c7a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M65.251,167.26q.006,7.194.011,14.388,0,4.155-.015,8.313a.2.2,0,0,1-.292-.009q-.006-9.961-.013-19.924c0-.923-.013-1.847-.021-2.768.017-.019.036-.036.053-.055a.212.212,0,0,1,.275.058Z",
    transform: "translate(-18.783 -100.049)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M384.481,189.934q-.006-4.929-.011-9.859,0-6.423.006-12.844a.211.211,0,0,1,.23-.081.2.2,0,0,1,.1.075c-.009.213-.021.424-.021.638v21.21c0,.284-.013.567-.019.851A.2.2,0,0,1,384.481,189.934Z",
    transform: "translate(-270.188 -100.023)",
    fill: "#90ad82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M317,322.792q-.006-5.86-.011-11.723,0-2.93.006-5.862a.2.2,0,0,1,.23-.081.188.188,0,0,1,.1.081c-.006.994-.017,1.988-.019,2.981q-.013,7.3-.019,14.591a.193.193,0,0,1-.29.013Z",
    transform: "translate(-217.099 -208.574)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M132.782,305.226q0,8.79,0,17.581a.2.2,0,0,1-.294-.013q-.006-8.41-.011-16.817c0-.247-.009-.5-.013-.744.015-.021.032-.041.047-.062a.2.2,0,0,1,.275.053Z",
    transform: "translate(-71.92 -208.59)",
    fill: "#c6d6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M41.416,135.782c0,.322,0,.644,0,.966a.2.2,0,0,1-.292-.009c0-.318,0-.635,0-.953a.206.206,0,0,1,.3,0Z",
    transform: "translate(-0.059 -75.299)",
    fill: "#7e9f6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M224.952,40.32c-.322,0-.644,0-.964,0-.013-.38.269-.3.482-.3s.495-.075.482.3Z",
    transform: "translate(-143.93)",
    fill: "#e9efe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M408.724,134.921c-.5-.026-.232-.414-.3-.642a.207.207,0,0,1,.3,0v.638Z",
    transform: "translate(-289.024 -74.116)",
    fill: "#5c8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M275.076,53.851c-.107,0-.211,0-.318,0a.2.2,0,0,1-.019-.294l.322-.009a.2.2,0,0,1,.015.3Z",
    transform: "translate(-183.815 -10.652)",
    fill: "#c5d5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M276.465,53.839c0-.1-.009-.2-.015-.3.23-.03.348.064.333.3-.107,0-.213,0-.318,0Z",
    transform: "translate(-185.204 -10.64)",
    fill: "#f5f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M168.8,55.336c-.107,0-.213,0-.318,0-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3Z",
    transform: "translate(-100.263 -11.818)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M169.972,55.359c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-101.431 -11.84)",
    fill: "#b9cbb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M171.46,55.4c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0,.017.247-.1.333-.337.29Z",
    transform: "translate(-102.603 -11.88)",
    fill: "#86a676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M273.56,53.59l.019.294c-.107,0-.213,0-.32.009a.2.2,0,0,1-.017-.3C273.349,53.594,273.453,53.592,273.56,53.59Z",
    transform: "translate(-182.636 -10.684)",
    fill: "#93af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M278.283,55.4c-.235.041-.35-.053-.337-.294h.32A.2.2,0,0,1,278.283,55.4Z",
    transform: "translate(-186.381 -11.88)",
    fill: "#7b9d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M279.467,55.381c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318,0Z",
    transform: "translate(-187.564 -11.856)",
    fill: "#aac19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M280.949,55.341l-.019-.294c.235-.041.35.055.337.3h-.32Z",
    transform: "translate(-188.729 -11.823)",
    fill: "#dde5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M164.293,56.857h-.318c-.015-.243.1-.333.335-.292a.2.2,0,0,1-.019.294Z",
    transform: "translate(-96.714 -13.017)",
    fill: "#d0ddca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M165.47,56.884l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3c-.107,0-.213,0-.318-.006Z",
    transform: "translate(-97.891 -13.044)",
    fill: "#9eb892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M166.96,56.9c.006-.1.013-.2.017-.3h.32C167.308,56.839,167.195,56.935,166.96,56.9Z",
    transform: "translate(-99.063 -13.052)",
    fill: "#6f945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M282.788,56.893c-.23.032-.348-.064-.333-.3.107,0,.213,0,.318,0a.207.207,0,0,1,.015.3Z",
    transform: "translate(-189.928 -13.044)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M283.965,56.893c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-191.105 -13.044)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M285.459,56.853l-.019-.294.322-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-192.277 -13.012)",
    fill: "#c3d3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M286.965,56.837c0-.1-.011-.2-.015-.3.23-.032.348.064.333.3Z",
    transform: "translate(-193.465 -12.998)",
    fill: "#f3f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M158.3,58.336c-.107,0-.213,0-.318,0-.013-.239.1-.333.335-.3A.2.2,0,0,1,158.3,58.336Z",
    transform: "translate(-92.003 -14.178)",
    fill: "#e9efe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M159.48,58.359c.006-.1.011-.2.017-.3l.32.009a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-93.178 -14.2)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M160.96,58.4c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C161.314,58.36,161.192,58.447,160.96,58.4Z",
    transform: "translate(-94.343 -14.24)",
    fill: "#84a476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M288.784,58.4c-.235.041-.348-.055-.337-.294h.32A.2.2,0,0,1,288.784,58.4Z",
    transform: "translate(-194.642 -14.24)",
    fill: "#7a9c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M289.967,58.381c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-195.825 -14.216)",
    fill: "#aac19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M291.449,58.341l-.019-.294c.235-.041.35.055.337.3h-.32Z",
    transform: "translate(-196.99 -14.183)",
    fill: "#dde5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M153.793,59.85c-.107,0-.211,0-.318,0-.015-.243.1-.333.335-.292a.2.2,0,0,1-.019.294Z",
    transform: "translate(-88.453 -15.369)",
    fill: "#d0dcca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M154.97,59.884l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3c-.107,0-.213,0-.318-.006Z",
    transform: "translate(-89.63 -15.404)",
    fill: "#9eb791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M156.47,59.9c.006-.1.011-.2.017-.3h.32C156.82,59.839,156.7,59.935,156.47,59.9Z",
    transform: "translate(-90.81 -15.412)",
    fill: "#6e935b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M293.288,59.893c-.23.032-.348-.064-.333-.3.107,0,.213,0,.318,0A.206.206,0,0,1,293.288,59.893Z",
    transform: "translate(-198.189 -15.404)",
    fill: "#61894c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M294.465,59.9c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-199.365 -15.412)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M295.959,59.853l-.019-.294.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-200.538 -15.373)",
    fill: "#c2d2ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M297.455,59.837c0-.1-.011-.2-.015-.3.232-.032.348.064.335.3-.107,0-.213,0-.318,0Z",
    transform: "translate(-201.718 -15.359)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M147.8,61.339c-.107,0-.213,0-.318,0-.013-.239.1-.335.335-.3A.2.2,0,0,1,147.8,61.339Z",
    transform: "translate(-83.742 -16.541)",
    fill: "#e7ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M148.98,61.367c.006-.1.011-.2.017-.3l.32.009a.2.2,0,0,1-.019.292C149.191,61.371,149.087,61.369,148.98,61.367Z",
    transform: "translate(-84.917 -16.569)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M150.47,61.4c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C150.822,61.357,150.7,61.447,150.47,61.4Z",
    transform: "translate(-86.09 -16.6)",
    fill: "#83a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M299.284,61.4c-.232.041-.348-.055-.337-.294h.32A.2.2,0,0,1,299.284,61.4Z",
    transform: "translate(-202.903 -16.6)",
    fill: "#779b67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M300.467,61.381c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-204.086 -16.576)",
    fill: "#a8bf9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M301.949,61.341l-.019-.294c.235-.041.35.055.337.3h-.32Z",
    transform: "translate(-205.25 -16.543)",
    fill: "#dbe4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M143.293,62.849c-.107,0-.211,0-.318,0-.015-.245.1-.333.337-.292A.2.2,0,0,1,143.293,62.849Z",
    transform: "translate(-80.192 -17.729)",
    fill: "#cfdcc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M144.47,62.884l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3l-.318-.006Z",
    transform: "translate(-81.369 -17.764)",
    fill: "#9cb68f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M145.97,62.907c.006-.1.011-.2.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-82.549 -17.78)",
    fill: "#6b9258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M303.788,62.893c-.23.032-.348-.064-.333-.3.107,0,.213,0,.318,0A.207.207,0,0,1,303.788,62.893Z",
    transform: "translate(-206.449 -17.764)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M304.965,62.9c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-207.626 -17.772)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M306.449,62.853l-.019-.294.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-208.791 -17.733)",
    fill: "#c1d2ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M307.955,62.837c0-.1-.011-.2-.015-.3.23-.032.348.064.335.3l-.318,0Z",
    transform: "translate(-209.979 -17.719)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M137.3,64.339h-.318c-.013-.237.1-.333.335-.3A.2.2,0,0,1,137.3,64.339Z",
    transform: "translate(-75.481 -18.901)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M138.48,64.367c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C138.691,64.371,138.587,64.369,138.48,64.367Z",
    transform: "translate(-76.657 -18.929)",
    fill: "#b4c8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M139.97,64.4c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C140.322,64.357,140.2,64.447,139.97,64.4Z",
    transform: "translate(-77.829 -18.96)",
    fill: "#84a374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "M309.784,64.4c-.232.038-.348-.055-.337-.294h.32A.2.2,0,0,1,309.784,64.4Z",
    transform: "translate(-211.164 -18.96)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "M310.967,64.389c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-212.347 -18.945)",
    fill: "#a7be9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "M312.449,64.341l-.019-.294c.235-.041.35.055.339.294Z",
    transform: "translate(-213.511 -18.903)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M132.8,65.849c-.107,0-.211,0-.318,0-.015-.245.1-.333.337-.292A.2.2,0,0,1,132.8,65.849Z",
    transform: "translate(-71.939 -20.09)",
    fill: "#cddac7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M133.98,65.884,134,65.59c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3l-.318-.006Z",
    transform: "translate(-73.116 -20.125)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M135.47,65.907c.006-.1.011-.2.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-74.288 -20.14)",
    fill: "#6a9157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M314.288,65.893c-.23.03-.348-.064-.333-.3.107,0,.213,0,.318,0A.207.207,0,0,1,314.288,65.893Z",
    transform: "translate(-214.71 -20.125)",
    fill: "#5f874b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M315.465,65.9c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-215.887 -20.133)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M316.949,65.853l-.019-.294.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-217.052 -20.093)",
    fill: "#c0d1b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M318.455,65.836c0-.1-.011-.2-.015-.3.232-.032.348.062.335.3-.107,0-.213,0-.318,0Z",
    transform: "translate(-218.24 -20.079)",
    fill: "#f1f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M126.8,67.333h-.318c-.013-.239.1-.333.335-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-67.22 -21.256)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M127.98,67.367c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C128.191,67.371,128.087,67.369,127.98,67.367Z",
    transform: "translate(-68.396 -21.289)",
    fill: "#b3c7aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M129.47,67.4c.006-.1.013-.2.019-.292h.318c.015.245-.1.335-.337.29Z",
    transform: "translate(-69.568 -21.321)",
    fill: "#82a373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M320.274,67.4c-.232.038-.348-.055-.337-.294h.32A.2.2,0,0,1,320.274,67.4Z",
    transform: "translate(-219.417 -21.321)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M321.457,67.389c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-220.6 -21.305)",
    fill: "#a7be9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    d: "M322.949,67.341l-.019-.294c.235-.041.35.053.339.294Z",
    transform: "translate(-221.772 -21.263)",
    fill: "#dae3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    d: "M122.3,68.854c-.107,0-.211,0-.318,0-.015-.245.1-.333.337-.29a.2.2,0,0,1-.019.294Z",
    transform: "translate(-63.679 -22.454)",
    fill: "#cbdac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    d: "M123.48,68.884l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3l-.318-.006Z",
    transform: "translate(-64.855 -22.485)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    d: "M124.97,68.907c.006-.1.011-.2.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-66.028 -22.501)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    d: "M324.778,68.893c-.23.03-.348-.064-.333-.3.107,0,.213,0,.318,0A.206.206,0,0,1,324.778,68.893Z",
    transform: "translate(-222.963 -22.485)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    d: "M325.955,68.9c0-.1-.009-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-224.14 -22.493)",
    fill: "#8dab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    d: "M327.449,68.853l-.019-.294.32-.009a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-225.312 -22.453)",
    fill: "#becfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    d: "M328.947,68.836c-.006-.1-.011-.2-.017-.3.232-.032.348.062.335.3C329.158,68.84,329.052,68.838,328.947,68.836Z",
    transform: "translate(-226.493 -22.439)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    d: "M116.314,70.331H116c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-58.967 -23.614)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    d: "M117.49,70.367c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C117.7,70.371,117.6,70.369,117.49,70.367Z",
    transform: "translate(-60.143 -23.649)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    d: "M118.97,70.4c.006-.1.013-.2.019-.292h.318c.015.245-.1.335-.337.29Z",
    transform: "translate(-61.307 -23.681)",
    fill: "#80a270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M330.774,70.4c-.232.038-.348-.055-.337-.3h.32a.2.2,0,0,1,.017.294Z",
    transform: "translate(-227.678 -23.673)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M331.957,70.389c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-228.861 -23.665)",
    fill: "#a5bd9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M333.439,70.338l-.019-.294c.235-.043.35.053.339.294Z",
    transform: "translate(-230.025 -23.621)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M111.8,71.844c-.107,0-.213,0-.318,0-.015-.245.1-.333.337-.29a.2.2,0,0,1-.017.294Z",
    transform: "translate(-55.418 -24.807)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    d: "M112.98,71.874c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-56.595 -24.837)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    d: "M114.48,71.9c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0C114.83,71.839,114.712,71.935,114.48,71.9Z",
    transform: "translate(-57.775 -24.853)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    d: "M335.278,71.893c-.23.03-.348-.064-.333-.3l.318,0A.206.206,0,0,1,335.278,71.893Z",
    transform: "translate(-231.224 -24.845)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    d: "M336.455,71.9c0-.1-.009-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292Z",
    transform: "translate(-232.401 -24.853)",
    fill: "#8dab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    d: "M337.949,71.861c-.006-.1-.013-.2-.019-.292.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3C338.16,71.859,338.056,71.859,337.949,71.861Z",
    transform: "translate(-233.573 -24.822)",
    fill: "#bdcfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    d: "M339.447,71.836c0-.1-.011-.2-.017-.3.232-.032.348.062.335.3-.107,0-.213,0-.318,0Z",
    transform: "translate(-234.753 -24.799)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    d: "M105.806,73.331h-.32c-.013-.239.1-.335.337-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-50.698 -25.974)",
    fill: "#e2eade"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    d: "M106.99,73.367c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.292l-.318,0Z",
    transform: "translate(-51.882 -26.01)",
    fill: "#b0c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    d: "M108.48,73.4c.006-.1.013-.2.019-.292h.318C108.832,73.355,108.715,73.445,108.48,73.4Z",
    transform: "translate(-53.054 -26.041)",
    fill: "#7fa16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    d: "M341.274,73.4c-.232.038-.348-.058-.337-.3h.32A.2.2,0,0,1,341.274,73.4Z",
    transform: "translate(-235.939 -26.033)",
    fill: "#739760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    d: "M342.457,73.381c-.006-.1-.013-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.318.006Z",
    transform: "translate(-237.121 -26.017)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    d: "M343.939,73.338l-.019-.294c.235-.043.35.053.339.294Z",
    transform: "translate(-238.286 -25.981)",
    fill: "#d7e1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    d: "M101.3,74.836c-.107,0-.211,0-.318,0-.015-.245.1-.333.337-.29A.2.2,0,0,1,101.3,74.836Z",
    transform: "translate(-47.157 -27.159)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M102.48,74.874l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-48.334 -27.198)",
    fill: "#98b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M103.972,74.9c.006-.1.011-.2.017-.3.107,0,.213,0,.318,0,.013.239-.1.335-.337.3Z",
    transform: "translate(-49.506 -27.213)",
    fill: "#668e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M345.778,74.893c-.23.03-.348-.066-.333-.3.107,0,.213,0,.318,0a.2.2,0,0,1,.013.3Z",
    transform: "translate(-239.485 -27.205)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M346.963,74.9c0-.1-.009-.2-.013-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-240.67 -27.213)",
    fill: "#8baa7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M348.449,74.853l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-241.834 -27.174)",
    fill: "#bdceb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M349.947,74.836c-.006-.1-.011-.2-.017-.3.232-.032.348.062.335.3C350.158,74.838,350.052,74.838,349.947,74.836Z",
    transform: "translate(-243.014 -27.159)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M95.314,76.331H95c-.013-.239.1-.335.337-.3a.206.206,0,0,1-.017.3Z",
    transform: "translate(-42.445 -28.334)",
    fill: "#e1e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M96.49,76.367c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.294C96.7,76.371,96.6,76.369,96.49,76.367Z",
    transform: "translate(-43.621 -28.37)",
    fill: "#afc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M97.98,76.394,98,76.1h.318c.015.245-.1.335-.337.292Z",
    transform: "translate(-44.793 -28.393)",
    fill: "#7d9f6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M351.774,76.4c-.232.038-.348-.058-.337-.3h.32A.2.2,0,0,1,351.774,76.4Z",
    transform: "translate(-244.2 -28.393)",
    fill: "#739760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M352.957,76.381c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.318.006Z",
    transform: "translate(-245.382 -28.378)",
    fill: "#a3bc98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M354.439,76.338l-.019-.294c.235-.043.35.053.339.294Z",
    transform: "translate(-246.547 -28.341)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M90.813,77.833c-.107,0-.213,0-.318,0-.015-.245.1-.335.337-.29A.2.2,0,0,1,90.813,77.833Z",
    transform: "translate(-38.904 -29.517)",
    fill: "#c7d6c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M91.99,77.874l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-40.081 -29.558)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M93.48,77.9c.006-.1.011-.2.017-.3.107,0,.213,0,.318,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-41.253 -29.574)",
    fill: "#658c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M356.268,77.885c-.23.03-.348-.066-.333-.3.107,0,.213,0,.318,0a.207.207,0,0,1,.013.3Z",
    transform: "translate(-247.738 -29.558)",
    fill: "#5c8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    d: "M357.453,77.893l-.013-.3c.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-248.923 -29.566)",
    fill: "#89a97b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    d: "M358.939,77.853l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3C359.15,77.849,359.046,77.851,358.939,77.853Z",
    transform: "translate(-250.087 -29.534)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M360.437,77.824c-.006-.1-.011-.2-.017-.3.232-.034.348.062.335.3C360.648,77.826,360.542,77.826,360.437,77.824Z",
    transform: "translate(-251.267 -29.509)",
    fill: "#edf2eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M84.807,79.336h-.32c-.011-.239.1-.335.337-.3A.2.2,0,0,1,84.807,79.336Z",
    transform: "translate(-34.178 -30.7)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    d: "M85.99,79.367c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.294Z",
    transform: "translate(-35.36 -30.73)",
    fill: "#afc4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    d: "M87.48,79.394,87.5,79.1h.318c.015.245-.1.335-.337.292Z",
    transform: "translate(-36.532 -30.754)",
    fill: "#7d9e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M362.264,79.4c-.232.038-.348-.058-.337-.3h.32A.2.2,0,0,1,362.264,79.4Z",
    transform: "translate(-252.453 -30.754)",
    fill: "#719660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M363.447,79.381c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.318.006Z",
    transform: "translate(-253.635 -30.738)",
    fill: "#a3bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    d: "M364.939,79.338l-.019-.294c.235-.043.35.053.339.294Z",
    transform: "translate(-254.808 -30.702)",
    fill: "#d5dfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M80.312,80.836c-.107,0-.213,0-.318,0-.017-.247.1-.333.337-.29A.2.2,0,0,1,80.312,80.836Z",
    transform: "translate(-30.642 -31.879)",
    fill: "#c6d6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "M81.49,80.874l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3C81.7,80.881,81.6,80.879,81.49,80.874Z",
    transform: "translate(-31.82 -31.918)",
    fill: "#95b186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M82.98,80.891c.006-.1.011-.2.017-.3.107,0,.213,0,.318,0C83.328,80.829,83.212,80.925,82.98,80.891Z",
    transform: "translate(-32.992 -31.926)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_914",
    "data-name": "Path 914",
    d: "M366.769,80.885c-.23.03-.345-.066-.333-.3.107,0,.213,0,.318,0a.207.207,0,0,1,.013.3Z",
    transform: "translate(-256 -31.918)",
    fill: "#5c8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M367.953,80.893l-.013-.3c.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-257.184 -31.926)",
    fill: "#89a77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M369.439,80.853l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-258.348 -31.894)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M370.937,80.824c-.006-.1-.011-.2-.017-.3.232-.034.348.06.335.3C371.148,80.826,371.042,80.826,370.937,80.824Z",
    transform: "translate(-259.528 -31.869)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M74.307,82.336h-.32c-.011-.239.1-.335.337-.3A.206.206,0,0,1,74.307,82.336Z",
    transform: "translate(-25.917 -33.06)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M75.482,82.367c.006-.1.011-.2.017-.3l.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-27.091 -33.09)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M76.98,82.394,77,82.1h.318c.015.243-.1.335-.335.292Z",
    transform: "translate(-28.272 -33.114)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M372.764,82.4c-.232.036-.348-.058-.337-.3h.32A.2.2,0,0,1,372.764,82.4Z",
    transform: "translate(-260.714 -33.114)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M373.947,82.381c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-261.896 -33.098)",
    fill: "#a0ba95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M375.439,82.337l-.019-.294c.235-.043.35.051.339.292h-.32Z",
    transform: "translate(-263.068 -33.061)",
    fill: "#d3decd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M69.813,83.843c-.107,0-.211,0-.318,0-.015-.243.1-.343.337-.3A.2.2,0,0,1,69.813,83.843Z",
    transform: "translate(-22.382 -34.245)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M70.982,83.884,71,83.59c.1,0,.211,0,.316,0a.2.2,0,0,1-.017.3l-.32-.006Z",
    transform: "translate(-23.551 -34.286)",
    fill: "#93af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M72.49,83.891c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-24.739 -34.286)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M377.276,83.885c-.23.03-.345-.066-.331-.3.107,0,.213,0,.318,0A.207.207,0,0,1,377.276,83.885Z",
    transform: "translate(-264.267 -34.278)",
    fill: "#5b8446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M378.453,83.893l-.013-.3c.1,0,.211,0,.316,0a.2.2,0,0,1,.019.292l-.324.009Z",
    transform: "translate(-265.444 -34.286)",
    fill: "#87a679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M379.939,83.846c-.006-.1-.013-.2-.019-.292.239-.049.354.045.339.292Z",
    transform: "translate(-266.609 -34.248)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M66.54,85.366q-.048-.374.326-.326a.232.232,0,0,1-.326.326Z",
    transform: "translate(-20.054 -35.422)",
    fill: "#f0f4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M68.01,85.361c.006-.1.011-.207.017-.311.1,0,.209,0,.311,0,.017.237-.094.339-.328.307Z",
    transform: "translate(-21.215 -35.435)",
    fill: "#749862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M381.774,85.367c-.237.032-.348-.068-.331-.307h.311A.206.206,0,0,1,381.774,85.367Z",
    transform: "translate(-267.806 -35.443)",
    fill: "#628a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M382.929,85.334l-.019-.307c.243-.045.341.081.36.3l-.055.058a.232.232,0,0,1-.288-.055h0Z",
    transform: "translate(-268.961 -35.409)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M66.56,86.519l.309-.019c.034.239-.068.35-.309.328v-.309Z",
    transform: "translate(-20.074 -36.575)",
    fill: "#7c9e6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M384.249,86.489c.239-.006.318.122.286.341a.212.212,0,0,1-.3-.021l-.011.009a.23.23,0,0,1-.013-.311Z",
    transform: "translate(-269.94 -36.567)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M65.223,87.984c0,.1,0,.209,0,.313a.212.212,0,0,1-.345.013C64.9,88.1,64.974,87.952,65.223,87.984Z",
    transform: "translate(-18.752 -37.74)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M384.48,87.99l.3.021v.313c-.243.017-.345-.094-.3-.335Z",
    transform: "translate(-270.19 -37.748)",
    fill: "#8cab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M63.54,89.856c-.026-.213.034-.352.281-.333l.049,0a.243.243,0,0,1-.015.318l-.013-.011A.21.21,0,0,1,63.54,89.856Z",
    transform: "translate(-17.693 -38.953)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M386,89.805v-.311c.245-.017.343.1.3.337A.207.207,0,0,1,386,89.805Z",
    transform: "translate(-271.392 -38.93)",
    fill: "#d3decc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M63.56,91.011l.3-.021c.047.243-.055.352-.3.337,0-.1,0-.209,0-.313Z",
    transform: "translate(-17.713 -40.108)",
    fill: "#94b086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M385.973,90.952l.3.026c0,.1,0,.207,0,.309-.245.019-.343-.1-.307-.337Z",
    transform: "translate(-271.365 -40.077)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M62.345,92.5c0,.1,0,.207,0,.311a.207.207,0,0,1-.3.026C62,92.6,62.1,92.487,62.345,92.5Z",
    transform: "translate(-16.511 -41.298)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M387.77,92.823c-.252.021-.345-.1-.3-.339C387.721,92.467,387.821,92.577,387.77,92.823Z",
    transform: "translate(-272.542 -41.282)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M62.062,94l.3-.026c.038.239-.06.354-.3.337C62.06,94.2,62.06,94.1,62.062,94Z",
    transform: "translate(-16.533 -42.452)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M388.979,94.32c0-.1-.006-.207-.009-.309.245-.021.345.094.313.333a.21.21,0,0,1-.3-.023Z",
    transform: "translate(-273.729 -42.483)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_946",
    "data-name": "Path 946",
    d: "M60.723,95.474c0,.1,0,.209,0,.313a.207.207,0,0,1-.237.087.22.22,0,0,1-.111-.075c.019-.207.094-.358.341-.326Z",
    transform: "translate(-15.212 -43.633)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_947",
    "data-name": "Path 947",
    d: "M388.972,95.47c.1.009.2.017.3.023,0,.1,0,.209,0,.313C389.027,95.824,388.927,95.711,388.972,95.47Z",
    transform: "translate(-273.722 -43.633)",
    fill: "#8fac7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M59.04,97.356c-.026-.213.034-.352.281-.333l.049,0a.243.243,0,0,1-.015.318l-.013-.011A.21.21,0,0,1,59.04,97.356Z",
    transform: "translate(-14.153 -44.853)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_949",
    "data-name": "Path 949",
    d: "M272.284,53.6c.006.1.011.2.017.3-.232.034-.348-.062-.335-.3.107,0,.213,0,.32,0Z",
    transform: "translate(-181.676 -10.692)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_950",
    "data-name": "Path 950",
    d: "M390.5,97.305v-.311c.245-.017.343.1.3.337A.208.208,0,0,1,390.5,97.305Z",
    transform: "translate(-274.933 -44.83)",
    fill: "#d6e0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_951",
    "data-name": "Path 951",
    d: "M59.06,98.511l.3-.021c.047.243-.055.352-.3.337,0-.1,0-.209,0-.313Z",
    transform: "translate(-14.173 -46.009)",
    fill: "#96b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_952",
    "data-name": "Path 952",
    d: "M390.473,98.452l.3.026c0,.1,0,.207,0,.309-.245.019-.343-.1-.307-.337Z",
    transform: "translate(-274.906 -45.977)",
    fill: "#70965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M57.855,100c0,.1,0,.207,0,.309a.207.207,0,0,1-.3.026c-.038-.239.06-.354.3-.337Z",
    transform: "translate(-12.979 -47.19)",
    fill: "#dce5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_954",
    "data-name": "Path 954",
    d: "M391.99,100.29c0-.1,0-.209,0-.316.25-.032.322.119.341.328l-.06.053A.228.228,0,0,1,391.99,100.29Z",
    transform: "translate(-276.105 -47.173)",
    fill: "#b4c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_955",
    "data-name": "Path 955",
    d: "M57.562,101.5l.3-.026c.038.239-.06.354-.3.337C57.56,101.7,57.56,101.6,57.562,101.5Z",
    transform: "translate(-12.993 -48.353)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_956",
    "data-name": "Path 956",
    d: "M393.23,101.522c.247-.019.309.119.281.333a.212.212,0,0,1-.3-.023l-.013.011a.241.241,0,0,1-.017-.318l.049,0Z",
    transform: "translate(-276.999 -48.392)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_957",
    "data-name": "Path 957",
    d: "M56.223,102.974c0,.1,0,.209,0,.313a.207.207,0,0,1-.237.087.22.22,0,0,1-.111-.075C55.9,103.094,55.974,102.942,56.223,102.974Z",
    transform: "translate(-11.671 -49.533)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_958",
    "data-name": "Path 958",
    d: "M393.472,102.98l.3.023c0,.1,0,.209,0,.313C393.53,103.332,393.427,103.223,393.472,102.98Z",
    transform: "translate(-277.263 -49.541)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_959",
    "data-name": "Path 959",
    d: "M54.54,104.846c-.026-.213.034-.352.281-.333l.049,0a.243.243,0,0,1-.015.318l-.013-.011A.21.21,0,0,1,54.54,104.846Z",
    transform: "translate(-10.613 -50.746)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_960",
    "data-name": "Path 960",
    d: "M395,104.805v-.311c.243-.017.341.1.3.337A.208.208,0,0,1,395,104.805Z",
    transform: "translate(-278.473 -50.731)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_961",
    "data-name": "Path 961",
    d: "M54.56,106l.3-.021c.047.243-.055.352-.3.337l0-.313Z",
    transform: "translate(-10.633 -51.901)",
    fill: "#97b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_962",
    "data-name": "Path 962",
    d: "M394.978,105.952l.3.026c0,.1,0,.207,0,.309-.245.019-.343-.1-.3-.337Z",
    transform: "translate(-278.451 -51.878)",
    fill: "#739760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_963",
    "data-name": "Path 963",
    d: "M53.355,107.5c0,.1,0,.207,0,.309a.208.208,0,0,1-.3.026c-.038-.239.06-.354.3-.337Z",
    transform: "translate(-9.439 -53.091)",
    fill: "#dce5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M396.49,107.78c0-.1,0-.209,0-.316.247-.032.322.119.341.328l-.06.053A.228.228,0,0,1,396.49,107.78Z",
    transform: "translate(-279.645 -53.066)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M53.072,108.986l.3-.026c.038.239-.06.354-.3.337v-.311Z",
    transform: "translate(-9.461 -54.246)",
    fill: "#779b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_966",
    "data-name": "Path 966",
    d: "M397.734,109.013c.247-.019.309.119.281.333a.214.214,0,0,1-.3-.021l-.013.011a.241.241,0,0,1-.015-.318Z",
    transform: "translate(-280.543 -54.286)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_967",
    "data-name": "Path 967",
    d: "M51.715,110.482c0,.1,0,.209,0,.313a.212.212,0,0,1-.237.09.234.234,0,0,1-.111-.075c.021-.207.1-.358.343-.326Z",
    transform: "translate(-8.123 -55.442)",
    fill: "#bdceb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_968",
    "data-name": "Path 968",
    d: "M397.969,110.472l.3.021c0,.1,0,.209,0,.313-.243.017-.345-.094-.3-.337Z",
    transform: "translate(-280.8 -55.434)",
    fill: "#94b085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M50.04,112.346c-.026-.211.034-.352.281-.333l.049,0a.243.243,0,0,1-.015.318l-.013-.011A.21.21,0,0,1,50.04,112.346Z",
    transform: "translate(-7.072 -56.647)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M399.492,112.305c0-.1,0-.207,0-.311.245-.017.343.1.3.337A.208.208,0,0,1,399.492,112.305Z",
    transform: "translate(-282.005 -56.631)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_971",
    "data-name": "Path 971",
    d: "M50.06,113.5l.3-.021c.047.243-.055.354-.3.337C50.064,113.712,50.062,113.608,50.06,113.5Z",
    transform: "translate(-7.092 -57.802)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_972",
    "data-name": "Path 972",
    d: "M399.47,113.46l.3.026c0,.1,0,.207,0,.311C399.53,113.816,399.432,113.7,399.47,113.46Z",
    transform: "translate(-281.984 -57.786)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_973",
    "data-name": "Path 973",
    d: "M48.848,115l0,.309a.208.208,0,0,1-.3.026c-.038-.239.062-.354.3-.337Z",
    transform: "translate(-5.891 -58.992)",
    fill: "#dde6d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_974",
    "data-name": "Path 974",
    d: "M400.99,115.288c0-.1,0-.209,0-.313.247-.032.322.119.341.326-.019.017-.04.034-.06.053A.228.228,0,0,1,400.99,115.288Z",
    transform: "translate(-283.185 -58.974)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M48.572,116.486l.3-.026c.038.239-.06.354-.3.337v-.311Z",
    transform: "translate(-5.92 -60.146)",
    fill: "#799c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_976",
    "data-name": "Path 976",
    d: "M402.237,116.513c.247-.019.307.119.281.333a.214.214,0,0,1-.3-.021l-.013.011a.243.243,0,0,1-.015-.318Z",
    transform: "translate(-284.087 -60.187)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_977",
    "data-name": "Path 977",
    d: "M47.215,117.982c0,.1,0,.209,0,.313a.212.212,0,0,1-.237.09.234.234,0,0,1-.111-.075c.021-.207.1-.358.343-.326Z",
    transform: "translate(-4.583 -61.342)",
    fill: "#bfd0b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_978",
    "data-name": "Path 978",
    d: "M402.469,117.972l.3.021c0,.1,0,.209,0,.313-.245.017-.345-.094-.3-.337Z",
    transform: "translate(-284.34 -61.334)",
    fill: "#95b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_979",
    "data-name": "Path 979",
    d: "M45.54,119.846c-.026-.211.034-.352.281-.333l.049,0a.246.246,0,0,1-.013.318l-.013-.011a.212.212,0,0,1-.3.021Z",
    transform: "translate(-3.532 -62.547)",
    fill: "#f5f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_980",
    "data-name": "Path 980",
    d: "M403.992,119.805c0-.1,0-.207,0-.311.245-.017.343.1.3.337A.208.208,0,0,1,403.992,119.805Z",
    transform: "translate(-285.546 -62.532)",
    fill: "#dce5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_981",
    "data-name": "Path 981",
    d: "M45.56,121l.3-.021c.047.243-.053.352-.3.337C45.564,121.212,45.56,121.106,45.56,121Z",
    transform: "translate(-3.552 -63.703)",
    fill: "#9cb68f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_982",
    "data-name": "Path 982",
    d: "M403.962,120.96l.3.026v.311c-.245.017-.343-.1-.3-.337Z",
    transform: "translate(-285.516 -63.687)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_983",
    "data-name": "Path 983",
    d: "M44.35,122.51c0,.1,0,.207-.006.311a.208.208,0,0,1-.3.026c-.036-.239.062-.354.307-.335Z",
    transform: "translate(-2.353 -64.906)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_984",
    "data-name": "Path 984",
    d: "M405.5,122.8c0-.1,0-.209,0-.313.245-.015.345.1.3.337A.2.2,0,0,1,405.5,122.8Z",
    transform: "translate(-286.734 -64.886)",
    fill: "#bed0b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_985",
    "data-name": "Path 985",
    d: "M44.08,123.986l.3-.026c.045.239-.053.354-.3.339C44.084,124.195,44.082,124.09,44.08,123.986Z",
    transform: "translate(-2.388 -66.047)",
    fill: "#8aa97c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_986",
    "data-name": "Path 986",
    d: "M405.473,123.952c.1.009.2.017.3.023,0,.1,0,.209,0,.311-.245.017-.341-.1-.3-.337Z",
    transform: "translate(-286.706 -66.039)",
    fill: "#698f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M42.856,125.494c0,.1,0,.209,0,.313a.207.207,0,0,1-.3.021C42.517,125.592,42.615,125.477,42.856,125.494Z",
    transform: "translate(-1.181 -67.253)",
    fill: "#e4ebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M407.01,125.791c0-.1,0-.211,0-.316q.368-.022.294.339A.2.2,0,0,1,407.01,125.791Z",
    transform: "translate(-287.922 -67.238)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_989",
    "data-name": "Path 989",
    d: "M42.57,126.991l.3-.021.006.32a.2.2,0,0,1-.3.019Z",
    transform: "translate(-1.2 -68.415)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_990",
    "data-name": "Path 990",
    d: "M406.977,126.96l.3.023v.316C407.032,127.312,406.936,127.195,406.977,126.96Z",
    transform: "translate(-287.889 -68.407)",
    fill: "#799c66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    "data-name": "Path 991",
    d: "M42.61,128.489l.3-.019c.034.232-.06.35-.3.337Z",
    transform: "translate(-1.231 -69.595)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    "data-name": "Path 992",
    d: "M408.524,128.814c0-.107,0-.213,0-.318.239-.013.335.1.3.335a.2.2,0,0,1-.3-.015Z",
    transform: "translate(-289.11 -69.615)",
    fill: "#e8efe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    "data-name": "Path 993",
    d: "M41.349,129.986v.32a.2.2,0,0,1-.3.015c-.036-.232.06-.348.3-.335Z",
    transform: "translate(0 -70.788)",
    fill: "#e2eadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    "data-name": "Path 994",
    d: "M408.524,129.99l.3.015c0,.107-.006.213-.008.32a.2.2,0,0,1-.292-.017c0-.107,0-.213,0-.318Z",
    transform: "translate(-289.11 -70.791)",
    fill: "#b9cbb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_995",
    "data-name": "Path 995",
    d: "M41.07,131.5l.3-.015v.32a.2.2,0,0,1-.29.011l-.006-.318Z",
    transform: "translate(-0.02 -71.971)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M408.5,131.48l.292.017v.316a.206.206,0,0,1-.3-.006l.009-.324Z",
    transform: "translate(-289.086 -71.963)",
    fill: "#8fac81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    "data-name": "Path 997",
    d: "M41.11,133c.1,0,.194-.009.29-.011,0,.107,0,.215.006.322a.2.2,0,0,1-.3.006Z",
    transform: "translate(-0.051 -73.151)",
    fill: "#9db790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    "data-name": "Path 998",
    d: "M408.472,133l.3.006v.32c-.1,0-.2,0-.3,0,0-.107,0-.215,0-.322Z",
    transform: "translate(-289.07 -73.159)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_999",
    "data-name": "Path 999",
    d: "M41.11,134.506l.3-.006c0,.107,0,.215,0,.322-.1,0-.2,0-.3,0v-.32Z",
    transform: "translate(-0.051 -74.339)",
    fill: "#88a87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M177.589,53.6c.013.239-.1.335-.337.3a.2.2,0,0,1,.017-.3Z",
    transform: "translate(-107.116 -10.692)",
    fill: "#6f945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M176.1,53.594c-.006.1-.011.2-.017.3l-.32-.006a.2.2,0,0,1,.019-.294Z",
    transform: "translate(-105.948 -10.684)",
    fill: "#9fb993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M408.456,139.323c-.023-.222.064-.343.3-.322v.318A.207.207,0,0,1,408.456,139.323Z",
    transform: "translate(-289.057 -77.879)",
    fill: "#5b8546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M41.1,140.5l.292.009c0,.107,0,.213-.006.32a.2.2,0,0,1-.29-.009c0-.107,0-.213,0-.32Z",
    transform: "translate(-0.043 -79.06)",
    fill: "#94b086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M408.47,140.5c.1,0,.2,0,.3,0v.318a.206.206,0,0,1-.3.009Z",
    transform: "translate(-289.07 -79.06)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M41.094,141.99l.29.009c0,.107,0,.213,0,.322a.2.2,0,0,1-.292-.015C41.09,142.2,41.092,142.094,41.094,141.99Z",
    transform: "translate(-0.035 -80.232)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M408.472,142.009c.1,0,.2,0,.3-.009v.316a.2.2,0,0,1-.292.015c0-.109,0-.215-.006-.324Z",
    transform: "translate(-289.07 -80.24)",
    fill: "#82a372"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M41.06,143.48l.292.015v.32c-.245.017-.333-.1-.29-.335Z",
    transform: "translate(-0.005 -81.404)",
    fill: "#d0ddca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M408.51,143.495c.1,0,.194-.009.292-.015,0,.107,0,.211,0,.318a.2.2,0,0,1-.292.017C408.514,143.708,408.512,143.6,408.51,143.495Z",
    transform: "translate(-289.102 -81.404)",
    fill: "#a7be9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M408.522,144.987l.292-.017c.045.237-.053.348-.294.337v-.32Z",
    transform: "translate(-289.11 -82.577)",
    fill: "#d1deca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M42.6,146.475c.245-.015.335.1.292.339a.2.2,0,0,1-.294-.021c0-.1,0-.211,0-.316Z",
    transform: "translate(-1.223 -83.76)",
    fill: "#87a778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M406.968,146.82c-.032-.232.064-.35.3-.335,0,.1,0,.211,0,.316A.207.207,0,0,1,406.968,146.82Z",
    transform: "translate(-287.884 -83.768)",
    fill: "#5f884b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M42.558,147.96l.294.021v.318Q42.488,148.318,42.558,147.96Z",
    transform: "translate(-1.181 -84.929)",
    fill: "#c4d4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M406.982,147.989l.3-.019c0,.1,0,.211.006.316a.205.205,0,0,1-.3.023c0-.107,0-.213-.009-.32Z",
    transform: "translate(-287.898 -84.937)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M44.072,149.485c.243-.015.339.1.3.337a.208.208,0,0,1-.3-.023c0-.1,0-.209,0-.313Z",
    transform: "translate(-2.38 -86.128)",
    fill: "#678f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M407,149.473l.3-.023c.036.237-.06.354-.3.337,0-.1,0-.209,0-.313Z",
    transform: "translate(-287.906 -86.101)",
    fill: "#e7ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M44.049,150.952c.1.009.2.017.3.023,0,.1,0,.209,0,.313-.245.017-.345-.1-.3-.339Z",
    transform: "translate(-2.354 -87.281)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M405.471,151.314c-.045-.239.053-.354.3-.339,0,.1,0,.209.006.316A.2.2,0,0,1,405.471,151.314Z",
    transform: "translate(-286.703 -87.3)",
    fill: "#8fad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M45.57,152.493c.245-.019.343.1.3.335a.206.206,0,0,1-.3-.026v-.309Z",
    transform: "translate(-3.56 -88.493)",
    fill: "#739861"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M405.471,152.483c.1-.009.2-.017.3-.023.034.241-.066.356-.314.333C405.464,152.69,405.466,152.588,405.471,152.483Z",
    transform: "translate(-286.702 -88.469)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M45.546,153.95l.3.026c0,.1.006.2.009.307-.247.026-.35-.09-.313-.333Z",
    transform: "translate(-3.534 -89.642)",
    fill: "#dce5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M403.947,154.284c-.041-.241.053-.358.3-.335C404.3,154.2,404.192,154.3,403.947,154.284Z",
    transform: "translate(-285.504 -89.639)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M47.036,155.467c.247-.026.348.085.309.328C47.1,155.821,46.994,155.712,47.036,155.467Z",
    transform: "translate(-4.706 -90.832)",
    fill: "#baccb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M402.461,155.811c-.038-.243.066-.352.309-.331C402.813,155.726,402.711,155.839,402.461,155.811Z",
    transform: "translate(-284.337 -90.843)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M48.522,156.986c.243-.026.348.081.316.324C48.59,157.342,48.483,157.236,48.522,156.986Z",
    transform: "translate(-5.876 -92.027)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M400.959,157.329c-.032-.243.073-.352.318-.324C401.315,157.254,401.209,157.361,400.959,157.329Z",
    transform: "translate(-283.157 -92.041)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M50.012,158.5c.243-.032.35.072.324.316C50.089,158.853,49.982,158.747,50.012,158.5Z",
    transform: "translate(-7.051 -93.216)",
    fill: "#a1ba96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M174.812,53.56l-.019.294h-.318c-.015-.245.1-.335.337-.292Z",
    transform: "translate(-104.975 -10.654)",
    fill: "#d2decb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M270.569,52.346h-.32a.2.2,0,0,1-.017-.3C270.465,52.011,270.58,52.107,270.569,52.346Z",
    transform: "translate(-180.268 -9.465)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M399.447,158.823c-.026-.243.083-.35.326-.316C399.8,158.757,399.694,158.861,399.447,158.823Z",
    transform: "translate(-281.968 -93.222)",
    fill: "#7e9f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M51.518,159.991c.243-.038.354.064.331.309C51.6,160.343,51.5,160.236,51.518,159.991Z",
    transform: "translate(-8.237 -94.388)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M397.93,160.316c-.021-.243.087-.348.331-.307C398.286,160.256,398.176,160.36,397.93,160.316Z",
    transform: "translate(-280.776 -94.401)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M53.029,161.5l.307.009a.208.208,0,0,1,.026.3c-.243.036-.356-.066-.333-.313Z",
    transform: "translate(-9.426 -95.582)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M54.506,161.823l-.026-.3c.239-.038.354.06.337.3h-.311Z",
    transform: "translate(-10.57 -95.591)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M394.951,161.835c-.021-.245.1-.343.335-.309a.21.21,0,0,1-.023.3c-.1,0-.207,0-.309.006Z",
    transform: "translate(-278.432 -95.597)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M396.4,161.845c.009-.1.017-.2.023-.3.1,0,.207,0,.309,0,.021.247-.092.348-.335.307Z",
    transform: "translate(-279.574 -95.613)",
    fill: "#c7d6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M55.994,163.06h.313a.2.2,0,0,1,.023.3C56.088,163.408,55.977,163.305,55.994,163.06Z",
    transform: "translate(-11.759 -96.809)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M57.5,163.321c-.009-.1-.017-.2-.023-.3.237-.036.354.06.337.3-.1,0-.209,0-.313,0Z",
    transform: "translate(-12.93 -96.774)",
    fill: "#6b9258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M391.944,163.325c-.017-.243.1-.339.335-.307a.209.209,0,0,1-.021.3C392.153,163.319,392.048,163.323,391.944,163.325Z",
    transform: "translate(-276.067 -96.771)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M393.42,163.341c.006-.1.015-.2.021-.3l.318.006C393.778,163.3,393.661,163.392,393.42,163.341Z",
    transform: "translate(-277.23 -96.793)",
    fill: "#a8bf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M58.989,164.57H59.3a.2.2,0,0,1,.021.294c-.239.047-.352-.053-.339-.294Z",
    transform: "translate(-14.114 -97.997)",
    fill: "#c9d8c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M60.511,164.82c-.006-.1-.015-.2-.021-.294.237-.047.354.043.339.29C60.722,164.816,60.618,164.818,60.511,164.82Z",
    transform: "translate(-15.298 -97.953)",
    fill: "#8eac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M388.927,164.823c-.011-.241.1-.337.339-.292a.2.2,0,0,1-.021.294h-.318Z",
    transform: "translate(-273.695 -97.957)",
    fill: "#80a16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M390.42,164.864c.006-.1.015-.2.021-.294.107,0,.213,0,.318,0C390.774,164.822,390.657,164.913,390.42,164.864Z",
    transform: "translate(-274.87 -97.997)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M63.5,166.074c.1,0,.209,0,.313,0a.206.206,0,0,1,.032.3l-.043.017C63.583,166.4,63.479,166.3,63.5,166.074Z",
    transform: "translate(-17.664 -99.177)",
    fill: "#d1deca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M385.717,166.05c.1,0,.209,0,.313.009a.2.2,0,0,1-.015.3c-.1,0-.192,0-.29.006h-.049a.225.225,0,0,1,.04-.311Z",
    transform: "translate(-271.103 -99.161)",
    fill: "#c5d5bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M387.43,166.373c0-.1.009-.2.015-.3.107,0,.213,0,.318,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-272.517 -99.177)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M269.056,52.08c.006.1.013.2.017.3-.107,0-.211,0-.318,0a.2.2,0,0,1-.019-.294l.318-.006Z",
    transform: "translate(-179.092 -9.496)",
    fill: "#abc2a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M267.767,52.11l.019.294c-.235.043-.35-.053-.339-.294Z",
    transform: "translate(-178.121 -9.519)",
    fill: "#7b9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M183.6,52.09c.015.239-.1.333-.331.3a.207.207,0,0,1,.013-.3Z",
    transform: "translate(-111.845 -9.504)",
    fill: "#5b8446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M182.1,52.1l-.013.3-.322-.009a.2.2,0,0,1,.019-.294h.316Z",
    transform: "translate(-110.671 -9.511)",
    fill: "#87a779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M180.6,52.069l-.019.294c-.107,0-.211,0-.318,0a.2.2,0,0,1,.017-.3C180.386,52.062,180.492,52.064,180.6,52.069Z",
    transform: "translate(-109.484 -9.48)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M179.311,52.045c-.006.1-.011.2-.017.3-.107,0-.213,0-.318,0C178.964,52.107,179.081,52.011,179.311,52.045Z",
    transform: "translate(-108.516 -9.463)",
    fill: "#ebf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M266.075,50.835c-.107,0-.213,0-.318,0a.207.207,0,0,1-.013-.3c.23-.03.348.066.333.3Z",
    transform: "translate(-176.736 -8.272)",
    fill: "#f5f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M264.566,50.55l.013.3c-.107,0-.211,0-.318,0a.2.2,0,0,1-.019-.294l.322-.009Z",
    transform: "translate(-175.557 -8.292)",
    fill: "#c5d5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M263.07,50.6l.019.294c-.107,0-.213,0-.32.009a.2.2,0,0,1-.017-.3C262.859,50.6,262.963,50.6,263.07,50.6Z",
    transform: "translate(-174.383 -8.331)",
    fill: "#94b086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M261.784,50.6c.006.1.011.2.017.3-.232.034-.348-.062-.335-.3.107,0,.213,0,.32,0Z",
    transform: "translate(-173.415 -8.331)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M188.089,50.6c.011.239-.1.335-.337.3a.2.2,0,0,1,.017-.3Z",
    transform: "translate(-115.377 -8.331)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M186.593,50.594c-.006.1-.011.2-.017.3l-.32-.006a.2.2,0,0,1,.019-.294C186.382,50.59,186.486,50.592,186.593,50.594Z",
    transform: "translate(-114.201 -8.323)",
    fill: "#a0ba95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M185.307,50.559l-.019.294h-.32c-.011-.241.1-.337.339-.292Z",
    transform: "translate(-113.23 -8.292)",
    fill: "#d3decd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M260.069,49.346h-.32a.2.2,0,0,1-.017-.3C259.965,49.011,260.08,49.107,260.069,49.346Z",
    transform: "translate(-172.007 -7.105)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M258.566,49.08c.006.1.011.2.017.3-.107,0-.211,0-.318,0a.2.2,0,0,1-.019-.294l.318-.006Z",
    transform: "translate(-170.839 -7.135)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M257.28,49.11l.019.294c-.232.043-.352-.049-.335-.292h.318Z",
    transform: "translate(-169.872 -7.159)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M194.087,49.09c.015.239-.1.333-.333.3a.207.207,0,0,1,.013-.3c.107,0,.213,0,.318,0Z",
    transform: "translate(-120.098 -7.143)",
    fill: "#5c8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M192.6,49.1l-.013.3-.322-.009a.2.2,0,0,1,.019-.294c.107,0,.211,0,.318,0Z",
    transform: "translate(-118.932 -7.151)",
    fill: "#89a77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M191.1,49.069l-.019.294c-.107,0-.211,0-.318,0a.2.2,0,0,1,.017-.3C190.886,49.062,190.992,49.064,191.1,49.069Z",
    transform: "translate(-117.745 -7.12)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M189.811,49.045c-.006.1-.011.2-.017.3-.107,0-.213,0-.318,0C189.464,49.107,189.579,49.011,189.811,49.045Z",
    transform: "translate(-116.777 -7.103)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M254.083,47.839l-.318,0a.2.2,0,0,1-.019-.294C253.978,47.5,254.1,47.591,254.083,47.839Z",
    transform: "translate(-167.298 -5.922)",
    fill: "#c6d6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M252.57,47.6l.019.294c-.107,0-.213,0-.32.009a.2.2,0,0,1-.017-.3C252.359,47.6,252.463,47.6,252.57,47.6Z",
    transform: "translate(-166.122 -5.971)",
    fill: "#95b186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M251.284,47.6c.006.1.011.2.017.3-.232.034-.348-.062-.335-.3C251.073,47.6,251.18,47.6,251.284,47.6Z",
    transform: "translate(-165.154 -5.971)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M198.592,47.6c.011.239-.1.335-.337.3a.2.2,0,0,1,.017-.3Z",
    transform: "translate(-123.641 -5.971)",
    fill: "#71965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M197.1,47.594c-.006.1-.011.2-.017.3l-.318-.006a.2.2,0,0,1,.019-.294c.107,0,.211,0,.318,0Z",
    transform: "translate(-122.469 -5.963)",
    fill: "#a3bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M195.8,47.554l-.019.294h-.32C195.447,47.607,195.56,47.511,195.8,47.554Z",
    transform: "translate(-121.483 -5.927)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M249.582,46.346h-.32a.2.2,0,0,1-.017-.3C249.478,46.011,249.593,46.107,249.582,46.346Z",
    transform: "translate(-163.757 -4.745)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M248.066,46.08c.006.1.011.2.017.3-.107,0-.211,0-.318,0a.2.2,0,0,1-.019-.294Z",
    transform: "translate(-162.578 -4.775)",
    fill: "#aec4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M65.066,273.96l.292.009v.32a.2.2,0,0,1-.3-.009c0-.107,0-.213.009-.32Z",
    transform: "translate(-18.894 -184.059)",
    fill: "#d0ddca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M384.52,273.971l.29-.011c0,.107,0,.213.006.32a.2.2,0,0,1-.29.011c0-.107,0-.213,0-.32Z",
    transform: "translate(-270.228 -184.059)",
    fill: "#a8bf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M65.036,275.46l.3.009c0,.107,0,.215,0,.322-.237.013-.333-.1-.3-.331Z",
    transform: "translate(-18.872 -185.239)",
    fill: "#ecf2eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M246.773,46.11l.019.294c-.232.043-.352-.047-.337-.292h.318Z",
    transform: "translate(-161.605 -4.799)",
    fill: "#7d9e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M384.54,275.471l.29-.011c0,.107,0,.211.009.318a.2.2,0,0,1-.3.015v-.322Z",
    transform: "translate(-270.244 -185.239)",
    fill: "#c3d3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M66.6,276.947c.241-.013.333.107.3.337a.2.2,0,0,1-.3-.019Z",
    transform: "translate(-20.105 -186.408)",
    fill: "#6c9259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M384.524,276.965c.1,0,.2-.009.3-.015.032.232-.064.348-.3.333,0-.107,0-.213.006-.318Z",
    transform: "translate(-270.228 -186.411)",
    fill: "#f0f4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M66.561,278.432l.3.019c0,.107,0,.213-.006.318a.206.206,0,0,1-.3-.021c0-.107.006-.211.009-.318Z",
    transform: "translate(-20.066 -187.576)",
    fill: "#a8bf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M382.984,278.786c-.043-.237.053-.352.294-.339,0,.1,0,.211,0,.316a.205.205,0,0,1-.3.026Z",
    transform: "translate(-269.011 -187.588)",
    fill: "#80a06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M66.536,279.93l.3.021c0,.1.006.207.011.311C66.6,280.284,66.5,280.169,66.536,279.93Z",
    transform: "translate(-20.05 -188.756)",
    fill: "#f0f4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M383.012,279.946l.3-.026c.045.241-.055.354-.3.337,0-.1,0-.209,0-.313Z",
    transform: "translate(-269.04 -188.748)",
    fill: "#ccd9c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M68.043,281.432c.247-.019.345.1.3.337C68.094,281.789,67.991,281.678,68.043,281.432Z",
    transform: "translate(-21.23 -189.936)",
    fill: "#acc2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M381.478,281.79c-.041-.239.06-.35.3-.335v.311a.207.207,0,0,1-.3.023Z",
    transform: "translate(-267.827 -189.955)",
    fill: "#83a374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M69.55,282.97c.241-.021.345.09.311.328a.209.209,0,0,1-.309-.019C69.552,283.177,69.552,283.073,69.55,282.97Z",
    transform: "translate(-22.426 -191.146)",
    fill: "#779b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M381.213,282.943l.3-.023c.032.22-.045.35-.286.343-.021-.015-.045-.028-.066-.043a.227.227,0,0,1,.038-.286Z",
    transform: "translate(-267.563 -191.108)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M69.533,284.43l.309.019v0a.216.216,0,0,1,.075.235.18.18,0,0,1-.085.1C69.6,284.775,69.5,284.662,69.533,284.43Z",
    transform: "translate(-22.407 -192.296)",
    fill: "#f0f4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M379.93,284.562l.013-.3a.206.206,0,0,1,.3-.019l.041.019c-.019.217-.111.35-.356.3Z",
    transform: "translate(-266.617 -192.102)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M71.308,286.057c-.235.036-.345-.068-.348-.3l.026-.023a.22.22,0,0,1,.307.013h0a.221.221,0,0,1,.019.309Z",
    transform: "translate(-23.535 -193.277)",
    fill: "#f0f4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M72.519,286.3,72.5,286c.241-.034.35.068.328.311-.1,0-.207,0-.309,0Z",
    transform: "translate(-24.747 -193.524)",
    fill: "#7a9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M204.587,46.09c.015.239-.1.333-.333.3a.207.207,0,0,1,.013-.3c.107,0,.213,0,.318,0Z",
    transform: "translate(-128.359 -4.783)",
    fill: "#5c8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M203.094,46.1l-.013.3-.322-.009a.2.2,0,0,1,.019-.294c.107,0,.211,0,.318,0Z",
    transform: "translate(-127.185 -4.791)",
    fill: "#89a97b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M378.2,285.963l.3-.013c.043.245-.09.337-.307.356l-.055-.058A.224.224,0,0,1,378.2,285.963Z",
    transform: "translate(-265.191 -193.492)",
    fill: "#dbe4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M73.974,287.52h.313a.2.2,0,0,1,.087.232.219.219,0,0,1-.075.111c-.211-.017-.363-.09-.328-.343Z",
    transform: "translate(-25.901 -194.727)",
    fill: "#adc3a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M201.6,46.069l-.019.294c-.107,0-.211,0-.318,0a.2.2,0,0,1,.017-.3C201.386,46.062,201.492,46.064,201.6,46.069Z",
    transform: "translate(-126.006 -4.76)",
    fill: "#bbcdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M375.425,287.79c-.015-.243.1-.343.337-.3a.206.206,0,0,1-.021.3C375.636,287.8,375.532,287.792,375.425,287.79Z",
    transform: "translate(-263.071 -194.697)",
    fill: "#94b086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M376.91,287.551c.006-.1.015-.2.021-.3l-.009-.011a.233.233,0,0,1,.313-.011l.015.041c.009.241-.122.316-.339.286Z",
    transform: "translate(-264.241 -194.451)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M75.867,289.042c-.213.023-.35-.036-.326-.284v-.049a.257.257,0,0,1,.322.011l-.013.021a.209.209,0,0,1,.019.3Z",
    transform: "translate(-27.137 -195.622)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M77.009,289.335l-.019-.3c.107,0,.211,0,.318,0a.2.2,0,0,1,.021.3Z",
    transform: "translate(-28.279 -195.915)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M78.5,289.293c-.006-.1-.015-.2-.021-.3.235-.041.35.053.339.294H78.5Z",
    transform: "translate(-29.452 -195.882)",
    fill: "#769a65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M370.937,289.293c-.013-.241.1-.333.337-.3a.207.207,0,0,1-.019.3Z",
    transform: "translate(-259.54 -195.882)",
    fill: "#699055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M372.412,289.319l.019-.3.318.006a.2.2,0,0,1-.021.3l-.318-.006Z",
    transform: "translate(-260.7 -195.907)",
    fill: "#a5bd9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M373.91,289.325c.006-.1.015-.2.021-.3l.313-.006C374.262,289.263,374.147,289.361,373.91,289.325Z",
    transform: "translate(-261.88 -195.907)",
    fill: "#e7ede3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M80,290.54c.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3C80.1,290.873,79.98,290.779,80,290.54Z",
    transform: "translate(-30.643 -197.103)",
    fill: "#f1f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M81.5,290.851c0-.1-.009-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292Z",
    transform: "translate(-31.82 -197.111)",
    fill: "#c2d2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M83,290.819c-.006-.1-.013-.2-.019-.292l.32-.006a.2.2,0,0,1,.015.3H83Z",
    transform: "translate(-32.992 -197.088)",
    fill: "#92af83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M84.5,290.784c0-.1-.011-.2-.015-.3.232-.034.348.062.335.3C84.718,290.786,84.612,290.786,84.5,290.784Z",
    transform: "translate(-34.18 -197.055)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M364.942,290.788c-.015-.237.1-.333.331-.3a.207.207,0,0,1-.013.3c-.107,0-.213,0-.32,0Z",
    transform: "translate(-254.823 -197.055)",
    fill: "#5b8545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M366.44,290.8l.013-.3.322.009a.2.2,0,0,1-.017.294h-.318Z",
    transform: "translate(-256.003 -197.072)",
    fill: "#86a577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M367.93,290.834c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-257.176 -197.103)",
    fill: "#b6c9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M369.42,290.849c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0C369.77,290.789,369.652,290.885,369.42,290.849Z",
    transform: "translate(-258.348 -197.111)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M86,292.05h.32a.206.206,0,0,1,.017.3C86.1,292.383,85.987,292.289,86,292.05Z",
    transform: "translate(-35.366 -198.291)",
    fill: "#e0e8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M87.507,292.341c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.32.006Z",
    transform: "translate(-36.54 -198.283)",
    fill: "#b1c6a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M89,292.294c-.006-.1-.013-.2-.019-.292.232-.043.352.045.337.29C89.21,292.292,89.106,292.292,89,292.294Z",
    transform: "translate(-37.713 -198.245)",
    fill: "#82a372"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M200.311,46.035c-.006.1-.011.2-.017.3-.107,0-.213,0-.318,0C199.964,46.1,200.079,46,200.311,46.035Z",
    transform: "translate(-125.038 -4.735)",
    fill: "#ecf2eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M360.427,292.291c-.011-.239.1-.335.337-.294a.2.2,0,0,1-.017.294Z",
    transform: "translate(-251.273 -198.242)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M361.922,292.324c.006-.1.011-.2.017-.294.107,0,.213,0,.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-252.447 -198.276)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M363.42,292.344l.019-.294h.32C363.77,292.291,363.655,292.387,363.42,292.344Z",
    transform: "translate(-253.627 -198.291)",
    fill: "#d6e0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M91.994,293.56h.318a.2.2,0,0,1,.017.294c-.232.04-.352-.049-.335-.292Z",
    transform: "translate(-40.083 -199.479)",
    fill: "#d1deca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M93.507,293.821c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294l-.318,0Z",
    transform: "translate(-41.261 -199.448)",
    fill: "#a0ba95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M95,293.791c-.006-.1-.013-.2-.017-.294.235-.041.348.055.337.3H95Z",
    transform: "translate(-42.433 -199.423)",
    fill: "#71965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M354.437,293.788c-.013-.239.1-.333.335-.3a.207.207,0,0,1-.015.3C354.65,293.786,354.543,293.786,354.437,293.788Z",
    transform: "translate(-246.559 -199.418)",
    fill: "#668d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M355.94,293.809c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.017.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-247.743 -199.44)",
    fill: "#96b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M357.422,293.834c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-248.907 -199.464)",
    fill: "#c5d5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M358.93,293.843c0-.1.009-.2.015-.3.107,0,.213,0,.32,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-250.095 -199.464)",
    fill: "#f3f6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M96.5,295.032c.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3c-.23.032-.348-.064-.333-.3Z",
    transform: "translate(-43.624 -200.636)",
    fill: "#f0f4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M98,295.351c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.017.292Z",
    transform: "translate(-44.801 -200.652)",
    fill: "#c0d0b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M99.507,295.311c-.006-.1-.013-.2-.017-.292.107,0,.213,0,.32-.009a.2.2,0,0,1,.015.3h-.318Z",
    transform: "translate(-45.981 -200.62)",
    fill: "#91ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M101,295.284c0-.1-.011-.2-.015-.3.232-.034.348.062.335.3C101.218,295.286,101.112,295.286,101,295.284Z",
    transform: "translate(-47.161 -200.595)",
    fill: "#628b4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M349.934,295.292c-.017-.245.1-.333.337-.29a.2.2,0,0,1-.017.294c-.107,0-.213,0-.318,0Z",
    transform: "translate(-243.016 -200.605)",
    fill: "#85a475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M351.43,295.334c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-244.194 -200.644)",
    fill: "#b4c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M352.93,295.356c.006-.1.011-.2.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-245.374 -200.659)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M102.487,296.55h.32a.2.2,0,0,1,.017.3C102.592,296.885,102.477,296.789,102.487,296.55Z",
    transform: "translate(-48.339 -201.832)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M104.007,296.831c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.32.006Z",
    transform: "translate(-49.522 -201.816)",
    fill: "#afc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M105.489,296.794c-.006-.1-.013-.2-.019-.292.232-.043.352.047.337.29h-.318Z",
    transform: "translate(-50.686 -201.786)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M343.938,296.786c-.011-.239.1-.335.337-.3a.2.2,0,0,1-.017.294h-.32Z",
    transform: "translate(-238.299 -201.778)",
    fill: "#749862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M345.432,296.816c.006-.1.011-.2.017-.3l.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-239.474 -201.808)",
    fill: "#a3bc98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M346.92,296.844l.019-.294h.318c.015.243-.1.335-.335.292Z",
    transform: "translate(-240.646 -201.832)",
    fill: "#d4dfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M108.484,298.052c.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294C108.586,298.385,108.467,298.3,108.484,298.052Z",
    transform: "translate(-53.056 -203.012)",
    fill: "#d0dcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M110.007,298.321c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-54.242 -202.988)",
    fill: "#9eb893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M111.5,298.294c-.006-.1-.011-.2-.017-.294.232-.038.348.058.337.3h-.32Z",
    transform: "translate(-55.414 -202.966)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M243.583,44.849c-.107,0-.213,0-.318,0a.2.2,0,0,1-.019-.294C243.478,44.514,243.6,44.6,243.583,44.849Z",
    transform: "translate(-159.037 -3.57)",
    fill: "#c7d7c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M337.946,298.288c-.013-.239.1-.333.335-.3a.207.207,0,0,1-.015.3C338.16,298.286,338.053,298.286,337.946,298.288Z",
    transform: "translate(-233.585 -202.958)",
    fill: "#658d51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M339.44,298.309c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.017.292C339.651,298.311,339.547,298.311,339.44,298.309Z",
    transform: "translate(-234.761 -202.98)",
    fill: "#94b085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M340.93,298.342c.006-.1.013-.2.017-.292.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3Z",
    transform: "translate(-235.933 -203.012)",
    fill: "#c3d3bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M342.43,298.343c0-.1.011-.2.015-.3.107,0,.213,0,.32,0C342.78,298.279,342.662,298.375,342.43,298.343Z",
    transform: "translate(-237.114 -203.004)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M112.989,299.54c.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3c-.23.032-.348-.062-.335-.3Z",
    transform: "translate(-56.599 -204.184)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M114.5,299.851c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.017.292Z",
    transform: "translate(-57.783 -204.192)",
    fill: "#bdcfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M116,299.811c-.006-.1-.013-.2-.017-.292.107,0,.213,0,.32-.009a.2.2,0,0,1,.015.3C116.208,299.809,116.1,299.809,116,299.811Z",
    transform: "translate(-58.955 -204.16)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M117.495,299.786c0-.1-.011-.2-.015-.3.23-.032.348.062.335.3C117.708,299.788,117.6,299.788,117.495,299.786Z",
    transform: "translate(-60.135 -204.138)",
    fill: "#61894c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M333.434,299.792c-.017-.245.1-.333.337-.29a.2.2,0,0,1-.017.294c-.107,0-.213,0-.318,0Z",
    transform: "translate(-230.035 -204.146)",
    fill: "#83a373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M334.94,299.824c.006-.1.011-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3C335.151,299.831,335.047,299.826,334.94,299.824Z",
    transform: "translate(-231.221 -204.176)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M336.43,299.846c.006-.1.013-.2.017-.3h.32C336.78,299.789,336.662,299.885,336.43,299.846Z",
    transform: "translate(-232.393 -204.192)",
    fill: "#e2eade"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M118.987,301.05h.32a.2.2,0,0,1,.017.3C119.092,301.385,118.977,301.289,118.987,301.05Z",
    transform: "translate(-61.32 -205.372)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M120.507,301.331c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.318.006Z",
    transform: "translate(-62.503 -205.356)",
    fill: "#adc3a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M121.989,301.294c-.006-.1-.013-.2-.019-.292.232-.043.352.047.337.292Z",
    transform: "translate(-63.667 -205.326)",
    fill: "#7ea06e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M327.438,301.286c-.011-.239.1-.335.337-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-225.318 -205.318)",
    fill: "#739861"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M328.932,301.316c.006-.1.011-.2.017-.3l.318.006a.2.2,0,0,1-.019.292l-.318,0Z",
    transform: "translate(-226.493 -205.348)",
    fill: "#a2bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M330.43,301.352c.006-.1.013-.2.019-.292h.318c.015.243-.1.335-.335.292Z",
    transform: "translate(-227.673 -205.38)",
    fill: "#d3decc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M124.978,302.552c.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294c-.232.043-.352-.047-.337-.29Z",
    transform: "translate(-66.031 -206.552)",
    fill: "#cddbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M126.5,302.821c-.006-.1-.013-.2-.017-.294.107,0,.213,0,.318-.006a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-67.216 -206.529)",
    fill: "#9db790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M127.987,302.794c-.006-.1-.011-.2-.017-.294.232-.038.348.058.337.3h-.32Z",
    transform: "translate(-68.388 -206.506)",
    fill: "#6f945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M321.442,302.788c-.013-.239.1-.333.333-.3a.207.207,0,0,1-.015.3c-.107,0-.213,0-.32,0Z",
    transform: "translate(-220.6 -206.498)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M322.95,302.809c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.017.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-221.788 -206.521)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M324.43,302.842c.006-.1.013-.2.017-.292.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3Z",
    transform: "translate(-222.952 -206.552)",
    fill: "#c0d1b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M325.94,302.843l.015-.3c.107,0,.213,0,.32,0C326.288,302.779,326.172,302.875,325.94,302.843Z",
    transform: "translate(-224.14 -206.544)",
    fill: "#f0f4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M129.487,304.04c.107,0,.213,0,.32,0a.206.206,0,0,1,.015.3C129.591,304.373,129.474,304.279,129.487,304.04Z",
    transform: "translate(-69.58 -207.724)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M131,304.333c0-.1-.011-.2-.015-.3.1,0,.211,0,.316,0a.2.2,0,0,1,.026.29l-.026.038-.3-.026Z",
    transform: "translate(-70.764 -207.717)",
    fill: "#bcceb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M242.07,44.6l.019.294-.32.006a.2.2,0,0,1-.017-.3C241.859,44.6,241.963,44.6,242.07,44.6Z",
    transform: "translate(-157.861 -3.611)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M318.236,304.02c.1,0,.209,0,.316.009a.2.2,0,0,1-.017.294c-.1.006-.194.013-.29.017l-.045-.019a.21.21,0,0,1,.038-.3Z",
    transform: "translate(-218.014 -207.709)",
    fill: "#b1c6a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M319.93,304.354c.006-.1.011-.2.017-.294h.32c.011.239-.1.335-.337.3Z",
    transform: "translate(-219.412 -207.74)",
    fill: "#e0e8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M240.784,44.594c.006.1.011.2.017.3-.232.034-.348-.06-.335-.3.107,0,.213,0,.318,0Z",
    transform: "translate(-156.893 -3.603)",
    fill: "#668d51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M209.092,44.61c.011.239-.1.335-.337.3a.2.2,0,0,1,.017-.3Z",
    transform: "translate(-131.902 -3.619)",
    fill: "#739760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M207.6,44.594c-.006.1-.011.2-.017.3l-.318-.006a.2.2,0,0,1,.019-.294c.107,0,.211,0,.318,0Z",
    transform: "translate(-130.73 -3.603)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M206.3,44.554l-.019.294h-.32C205.947,44.607,206.06,44.511,206.3,44.554Z",
    transform: "translate(-129.744 -3.567)",
    fill: "#d6e0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M239.087,43.349h-.318a.2.2,0,0,1-.017-.3c.232-.036.348.058.337.3Z",
    transform: "translate(-155.501 -2.387)",
    fill: "#e1e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M237.566,43.07c.006.1.011.2.017.3-.107,0-.211,0-.318,0a.2.2,0,0,1-.019-.294Z",
    transform: "translate(-154.317 -2.407)",
    fill: "#b0c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M236.283,43.11l.019.294c-.232.043-.352-.047-.337-.292h.318Z",
    transform: "translate(-153.352 -2.439)",
    fill: "#7d9e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M215.09,43.09c.015.239-.1.333-.333.3a.206.206,0,0,1,.013-.3l.318,0Z",
    transform: "translate(-136.622 -2.423)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M213.594,43.094c0,.1-.009.2-.013.3l-.322-.009a.2.2,0,0,1,.019-.294c.107,0,.211,0,.318,0Z",
    transform: "translate(-135.446 -2.423)",
    fill: "#8baa7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M212.1,43.076l-.019.294c-.107,0-.211,0-.318,0a.2.2,0,0,1,.017-.3c.107,0,.213,0,.32.009Z",
    transform: "translate(-134.264 -2.407)",
    fill: "#bdceb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M210.811,43.035c-.006.1-.011.2-.017.3-.107,0-.213,0-.318,0C210.464,43.1,210.579,43,210.811,43.035Z",
    transform: "translate(-133.299 -2.374)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M233.087,41.852c-.107,0-.213,0-.318,0a.2.2,0,0,1-.017-.292c.232-.043.352.045.337.29Z",
    transform: "translate(-150.781 -1.212)",
    fill: "#c8d8c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M231.566,41.592c.006.1.013.2.017.292-.107,0-.213,0-.32,0a.2.2,0,0,1-.015-.294c.1,0,.211,0,.316,0Z",
    transform: "translate(-149.596 -1.243)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M230.292,41.62c0,.1.009.2.015.294-.23.038-.35-.051-.333-.292h.318Z",
    transform: "translate(-148.638 -1.266)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M221.087,41.62c.019.241-.1.326-.326.3a.207.207,0,0,1,.011-.3Z",
    transform: "translate(-141.344 -1.266)",
    fill: "#5d8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M219.587,41.62c0,.1-.006.2-.011.3-.107,0-.215,0-.322-.009a.2.2,0,0,1,.015-.292Z",
    transform: "translate(-140.162 -1.266)",
    fill: "#80a06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M132.538,387.92l.294.013c0,.107,0,.213,0,.32C132.59,388.27,132.5,388.152,132.538,387.92Z",
    transform: "translate(-71.975 -273.717)",
    fill: "#e2eadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M317.04,387.943l.29-.013c0,.107.006.213.009.322a.2.2,0,0,1-.292.011c0-.107,0-.213,0-.32Z",
    transform: "translate(-217.138 -273.725)",
    fill: "#baccb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M317.06,389.451c.1,0,.2-.009.292-.011.041.232-.051.348-.292.333v-.322Z",
    transform: "translate(-217.154 -274.913)",
    fill: "#d7e1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M134.092,390.932c.243-.015.333.1.292.335a.2.2,0,0,1-.294-.019c0-.107,0-.211,0-.318Z",
    transform: "translate(-73.203 -276.085)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M134.059,392.42l.294.019c0,.107,0,.213,0,.318a.2.2,0,0,1-.3-.019C134.052,392.631,134.056,392.527,134.059,392.42Z",
    transform: "translate(-73.171 -277.257)",
    fill: "#b0c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M315.5,392.754c-.045-.235.045-.354.29-.339,0,.1,0,.211,0,.316a.2.2,0,0,1-.3.023Z",
    transform: "translate(-215.917 -277.253)",
    fill: "#89a77a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M134.026,393.91l.3.019c0,.1,0,.209.009.316C134.09,394.262,133.992,394.147,134.026,393.91Z",
    transform: "translate(-73.147 -278.429)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M315.54,393.923l.3-.023c.047.239-.053.352-.3.339Z",
    transform: "translate(-215.958 -278.422)",
    fill: "#cad9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M135.556,395.415c.245-.015.341.1.3.339a.207.207,0,0,1-.3-.023C135.55,395.626,135.554,395.52,135.556,395.415Z",
    transform: "translate(-74.351 -279.613)",
    fill: "#96b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M313.993,395.771c-.036-.235.06-.354.3-.337v.311a.2.2,0,0,1-.3.026Z",
    transform: "translate(-214.735 -279.627)",
    fill: "#6d935a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M135.526,396.9l.3.023c0,.1.006.207.011.309C135.592,397.256,135.492,397.141,135.526,396.9Z",
    transform: "translate(-74.328 -280.782)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M218.091,41.586c0,.1-.011.2-.015.292-.107,0-.213,0-.32,0a.2.2,0,0,1,.019-.294c.1,0,.211,0,.316,0Z",
    transform: "translate(-138.983 -1.235)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M314.012,396.926l.3-.026c.043.241-.058.354-.3.337v-.311Z",
    transform: "translate(-214.754 -280.782)",
    fill: "#cad9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M137.026,398.4c.25-.023.343.094.3.335C137.082,398.753,136.977,398.647,137.026,398.4Z",
    transform: "translate(-75.504 -281.959)",
    fill: "#b5c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M312.485,398.768c-.043-.241.06-.352.3-.335C312.835,398.679,312.737,398.794,312.485,398.768Z",
    transform: "translate(-213.547 -281.987)",
    fill: "#8caa7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M138.5,399.94c.243-.021.348.087.309.328C138.562,400.3,138.458,400.188,138.5,399.94Z",
    transform: "translate(-76.667 -283.172)",
    fill: "#89a97b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M310.987,400.283c-.034-.243.073-.352.316-.326,0,.1-.006.2-.009.307A.209.209,0,0,1,310.987,400.283Z",
    transform: "translate(-212.371 -283.184)",
    fill: "#6a9157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M139.977,401.452c.245-.03.35.079.32.322C140.047,401.808,139.943,401.7,139.977,401.452Z",
    transform: "translate(-77.829 -284.359)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M310.719,401.429l.307-.019c.036.23-.064.345-.3.348-.019-.017-.041-.032-.06-.049a.223.223,0,0,1,.049-.284Z",
    transform: "translate(-212.103 -284.33)",
    fill: "#e8efe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M141.472,402.964c.243-.036.352.068.328.311C141.553,403.316,141.443,403.214,141.472,402.964Z",
    transform: "translate(-79.007 -285.547)",
    fill: "#84a475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M307.976,403.283c-.026-.243.081-.35.326-.316a.208.208,0,0,1-.019.307Z",
    transform: "translate(-210.004 -285.55)",
    fill: "#6b9157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M309.422,403.032l.019-.307h0a.216.216,0,0,1,.3-.017l.028.028c-.006.228-.117.335-.35.3Z",
    transform: "translate(-211.143 -285.308)",
    fill: "#e8efe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M142.98,404.455c.243-.043.352.06.333.3C143.066,404.807,142.959,404.7,142.98,404.455Z",
    transform: "translate(-80.195 -286.718)",
    fill: "#a9c09e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M306.454,404.768c-.017-.243.094-.345.335-.3C306.814,404.717,306.7,404.815,306.454,404.768Z",
    transform: "translate(-208.808 -286.726)",
    fill: "#8caa7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M144.5,405.97l.309.006a.208.208,0,0,1,.026.3C144.595,406.315,144.479,406.217,144.5,405.97Z",
    transform: "translate(-81.391 -287.918)",
    fill: "#e0e8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M145.986,406.27c-.009-.1-.017-.2-.026-.3.237-.04.354.055.339.3h-.313Z",
    transform: "translate(-82.541 -287.908)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M303.455,406.275c-.015-.243.1-.339.337-.3a.206.206,0,0,1-.026.3h-.311Z",
    transform: "translate(-206.449 -287.914)",
    fill: "#6d935a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M304.92,406.3l.026-.3h.311c.017.245-.1.345-.337.3Z",
    transform: "translate(-207.603 -287.941)",
    fill: "#cbdac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M147.485,407.51c.1,0,.209,0,.313,0a.2.2,0,0,1,.023.3C147.585,407.849,147.47,407.753,147.485,407.51Z",
    transform: "translate(-83.74 -289.129)",
    fill: "#dbe4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M148.991,407.795c-.006-.1-.015-.2-.021-.3.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3C149.2,407.789,149.1,407.793,148.991,407.795Z",
    transform: "translate(-84.91 -289.113)",
    fill: "#97b289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M150.487,407.766c-.006-.1-.013-.2-.017-.3.23-.032.35.06.337.3h-.318Z",
    transform: "translate(-86.09 -289.091)",
    fill: "#5f884b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M300.445,407.769c-.015-.247.1-.335.339-.29a.2.2,0,0,1-.023.3c-.1,0-.211,0-.316,0Z",
    transform: "translate(-204.081 -289.095)",
    fill: "#88a87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M301.93,407.806c.009-.1.015-.2.023-.3h.316C302.282,407.753,302.169,407.851,301.93,407.806Z",
    transform: "translate(-205.25 -289.129)",
    fill: "#cad9c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M151.98,409.03h.324a.206.206,0,0,1,.009.3c-.228.032-.343-.064-.331-.3Z",
    transform: "translate(-87.278 -290.325)",
    fill: "#e7ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M153.5,409.339c0-.1,0-.2-.009-.3h.32a.206.206,0,0,1,.006.3C153.71,409.336,153.605,409.336,153.5,409.339Z",
    transform: "translate(-88.466 -290.333)",
    fill: "#cfdcc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M155.006,409.336c0-.1,0-.2-.006-.3h.32c0,.1,0,.2,0,.294-.107,0-.213,0-.32,0Z",
    transform: "translate(-89.654 -290.333)",
    fill: "#bdcfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M216.8,41.554l-.019.294h-.32C216.447,41.607,216.56,41.511,216.8,41.554Z",
    transform: "translate(-138.005 -1.206)",
    fill: "#d7e1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M295.95,409.32c0-.1.006-.194.011-.29.107,0,.213,0,.32,0a.2.2,0,0,1-.009.294c-.107,0-.213,0-.322-.009Z",
    transform: "translate(-200.546 -290.325)",
    fill: "#cad9c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M297.46,409.334c0-.1.006-.2.009-.294h.32C297.805,409.279,297.688,409.371,297.46,409.334Z",
    transform: "translate(-201.734 -290.333)",
    fill: "#dfe8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M132.878,56.359l.307.034a.477.477,0,0,0,.377.166c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.475.475,0,0,0,.377.171c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113l.307.034a.485.485,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.475.475,0,0,0,.377.171c.1,0,.2,0,.3.006a.534.534,0,0,1,.294.113l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.474.474,0,0,0,.377.171c.1,0,.2,0,.3.006a.548.548,0,0,1,.294.111l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.475.475,0,0,0,.377.171c.1,0,.2,0,.3.006a.548.548,0,0,1,.294.111l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.525.525,0,0,1,.292.115l-.013.028a.475.475,0,0,0,.377.171c.1,0,.2,0,.3.006a.548.548,0,0,1,.294.111l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.477.477,0,0,0,.371.173h.3a3.159,3.159,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.477.477,0,0,0,.371.173h.3a3.159,3.159,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.477.477,0,0,0,.371.173h.3a3.16,3.16,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.228.228,0,0,1,.023.309.472.472,0,0,1-.3.126c-.1.011-.2.009-.307.011a.469.469,0,0,0-.38.171l.013.028a.538.538,0,0,1-.292.113c-.1.009-.2.006-.3.009a.485.485,0,0,0-.38.166l.013.028a.556.556,0,0,1-.3.119,3.117,3.117,0,0,1-.316.006c-.1,0-.2,0-.3,0a.471.471,0,0,0-.375.168l.013.028a.521.521,0,0,1-.29.113c-.1.009-.2.006-.3.009a.488.488,0,0,0-.38.166l-.307.034a.559.559,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.521.521,0,0,1-.29.113c-.1.009-.2.006-.3.009a.5.5,0,0,0-.382.164l-.307.034a.52.52,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.544.544,0,0,1-.3.117,3.117,3.117,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.538.538,0,0,1-.292.113c-.1.009-.2.006-.3.009a.485.485,0,0,0-.38.166l.013.028a.538.538,0,0,1-.3.117,3.117,3.117,0,0,1-.316.006c-.1,0-.2,0-.3,0a.467.467,0,0,0-.375.171l.013.028a.538.538,0,0,1-.29.113c-.1.009-.2.006-.3.009a.481.481,0,0,0-.38.166l-.307.034a.542.542,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.56.56,0,0,1-.3.117,3.119,3.119,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.562.562,0,0,1-.292.113c-.1.009-.2.006-.3.009a.48.48,0,0,0-.38.168l.013.028a.544.544,0,0,1-.3.117,3.119,3.119,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.538.538,0,0,1-.292.113c-.1.009-.2.006-.3.009a.485.485,0,0,0-.38.166l.013.028a.538.538,0,0,1-.3.117,3.119,3.119,0,0,1-.316.006c-.1,0-.2,0-.3,0a.467.467,0,0,0-.375.171l.013.028a.521.521,0,0,1-.29.113c-.1.009-.2.006-.3.009a.481.481,0,0,0-.38.166l-.307.034a.559.559,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.577.577,0,0,1-.3.117,3.117,3.117,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.562.562,0,0,1-.292.113c-.1.009-.2.006-.3.009a.48.48,0,0,0-.38.168l.013.028a.544.544,0,0,1-.3.117,3.122,3.122,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.562.562,0,0,1-.292.113c-.1.009-.2.006-.3.009a.485.485,0,0,0-.38.166l.013.028a.557.557,0,0,1-.313.119,2.965,2.965,0,0,1-.337.009c-.113,0-.224,0-.337,0q-.3.006-.595,0c-.115,0-.23,0-.345-.006a.58.58,0,0,1-.324-.119l-.307-.034a.485.485,0,0,0-.38-.166c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.475.475,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.549.549,0,0,1-.294-.111l-.307-.034a.482.482,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.477.477,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.54.54,0,0,1-.3-.119l.013-.028a.487.487,0,0,0-.38-.168c-.1,0-.2,0-.3-.006a.538.538,0,0,1-.292-.113l.013-.028a.47.47,0,0,0-.371-.173h-.3a3.16,3.16,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.481.481,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.522.522,0,0,1-.292-.113l-.307-.034a.485.485,0,0,0-.38-.166c-.1,0-.2,0-.3-.006a.525.525,0,0,1-.292-.115l.013-.028a.475.475,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.549.549,0,0,1-.294-.111l-.307-.034a.482.482,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.477.477,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.54.54,0,0,1-.3-.119l.013-.028a.487.487,0,0,0-.38-.168c-.1,0-.2,0-.3-.006a.538.538,0,0,1-.292-.113l.013-.028a.47.47,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.484.484,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.522.522,0,0,1-.292-.113l-.307-.034a.485.485,0,0,0-.38-.166c-.1,0-.2,0-.3-.006a.525.525,0,0,1-.292-.115l.013-.028a.481.481,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.534.534,0,0,1-.294-.113l-.307-.034a.482.482,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.525.525,0,0,1-.292-.115l.013-.028a.471.471,0,0,0-.371-.171h-.3a3.16,3.16,0,0,1-.318,0,.54.54,0,0,1-.3-.119l.013-.028a.487.487,0,0,0-.38-.168c-.1,0-.2,0-.3-.006a.538.538,0,0,1-.292-.113l.013-.028a.47.47,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.484.484,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.522.522,0,0,1-.292-.113l-.307-.034a.485.485,0,0,0-.38-.166c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.481.481,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.54.54,0,0,1-.292-.115l.013-.021a.194.194,0,0,1,0-.3l-.013-.028a.54.54,0,0,1,.29-.115c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.525.525,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.54.54,0,0,1,.29-.115c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.525.525,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.54.54,0,0,1,.29-.115c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.525.525,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.116,3.116,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.119,3.119,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.117,3.117,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.117,3.117,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.119,3.119,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.116,3.116,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.119,3.119,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.538.538,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.118,3.118,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.538.538,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.118,3.118,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.577.577,0,0,1,.313-.117,2.962,2.962,0,0,1,.337-.009c.113,0,.224,0,.337,0q.294,0,.589,0c.113,0,.224,0,.337,0s.226,0,.339.006a.568.568,0,0,1,.318.117l.307.034a.485.485,0,0,0,.38.166c.1,0,.2,0,.3.006a.525.525,0,0,1,.292.115l-.013.028a.481.481,0,0,0,.377.171c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113l.307.034a.485.485,0,0,0,.38.166c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.481.481,0,0,0,.377.171c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113l.307.034a.485.485,0,0,0,.38.166c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.481.481,0,0,0,.377.171c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113Z",
    transform: "translate(-44.496 -11.243)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M72.546,102.013l.307.034a.485.485,0,0,0,.38.166c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.474.474,0,0,0,.377.171c.1,0,.2,0,.3.006a.548.548,0,0,1,.294.111l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.477.477,0,0,0,.371.173h.3a3.158,3.158,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.538.538,0,0,1,.292.113l-.013.028a.467.467,0,0,0,.371.173h.3a3.158,3.158,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.481.481,0,0,0,.377.171c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113l.307.034a.477.477,0,0,0,.377.166c.1,0,.2,0,.3.006a.525.525,0,0,1,.292.115l-.013.028a.475.475,0,0,0,.377.171c.1,0,.2,0,.3.006a.549.549,0,0,1,.294.111l.307.034a.476.476,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.47.47,0,0,0,.371.173h.3a3.158,3.158,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.538.538,0,0,1,.292.113l-.013.028a.466.466,0,0,0,.369.173h.3a3.158,3.158,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.537.537,0,0,0,.335.179.937.937,0,0,1,.275.062.248.248,0,0,1,.1.109.277.277,0,0,1-.055.284l-.015-.011a.513.513,0,0,0-.19.395.439.439,0,0,1-.117.252l-.015-.011c-.092.119-.213.213-.3.339l-.013-.011a.48.48,0,0,0-.2.39.462.462,0,0,1-.115.256l-.015-.011a.513.513,0,0,0-.19.395.439.439,0,0,1-.117.252l-.015-.011c-.092.119-.213.213-.3.339l-.013-.011a.48.48,0,0,0-.2.39.462.462,0,0,1-.115.256l-.017-.011a.513.513,0,0,0-.19.395.439.439,0,0,1-.117.252l-.015-.011c-.092.119-.213.213-.3.339L85.668,111a.48.48,0,0,0-.2.39.462.462,0,0,1-.115.256l-.015-.011a.514.514,0,0,0-.19.395.439.439,0,0,1-.117.252l-.015-.011c-.092.119-.213.213-.3.339l-.013-.011a.48.48,0,0,0-.2.39.462.462,0,0,1-.115.256l-.015-.011a.514.514,0,0,0-.19.395.439.439,0,0,1-.117.252l-.015-.011c-.092.119-.213.213-.3.339l-.013-.011a.48.48,0,0,0-.2.39.449.449,0,0,1-.115.254l-.015-.011a1.774,1.774,0,0,0-.239.3.416.416,0,0,1-.092.092.644.644,0,0,0-.228.226.393.393,0,0,1-.094.094.639.639,0,0,0-.228.23.478.478,0,0,1-.092.094,2.075,2.075,0,0,0-.3.241l.011.017a.453.453,0,0,1-.254.113.569.569,0,0,0-.4.183l.013.026a.573.573,0,0,1-.326.126c-.117.013-.235.009-.354.011q-.441.01-.883,0a3.31,3.31,0,0,1-.356-.009.571.571,0,0,1-.331-.126l.013-.028a.481.481,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.522.522,0,0,1-.292-.113L78,116.09a.477.477,0,0,0-.377-.166c-.1,0-.2,0-.3-.006a.525.525,0,0,1-.292-.115l.013-.028a.475.475,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.548.548,0,0,1-.294-.111l-.307-.034a.482.482,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.47.47,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.487.487,0,0,0-.38-.168c-.1,0-.2,0-.3-.006a.538.538,0,0,1-.292-.113l.013-.028a.466.466,0,0,0-.369-.173h-.3a3.158,3.158,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.481.481,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.522.522,0,0,1-.292-.113L70,113.847a.478.478,0,0,0-.38-.166c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.475.475,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.548.548,0,0,1-.294-.111l-.307-.034a.482.482,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.47.47,0,0,0-.371-.173h-.3a3.156,3.156,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.487.487,0,0,0-.38-.168c-.1,0-.2,0-.3-.006a.538.538,0,0,1-.292-.113l.013-.028a.467.467,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.481.481,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.522.522,0,0,1-.292-.113L62,111.6a.478.478,0,0,0-.38-.166c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.475.475,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.548.548,0,0,1-.294-.111l-.307-.034a.482.482,0,0,0-.377-.168c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.47.47,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.553.553,0,0,1-.3-.119l.013-.028a.487.487,0,0,0-.38-.168c-.1,0-.2,0-.3-.006a.538.538,0,0,1-.292-.113l.013-.028a.472.472,0,0,0-.375-.173c-.1,0-.2,0-.3-.009a.482.482,0,0,1-.288-.124l.011-.015c-.122-.092-.215-.209-.335-.3l.009-.009c-.109-.1-.209-.218-.328-.313-.1-.117-.207-.218-.313-.326l-.009.006c-.092-.119-.211-.215-.3-.335l-.015.011a.432.432,0,0,1-.117-.252.589.589,0,0,0-.181-.4c-.011-.1-.023-.2-.034-.3a.581.581,0,0,1-.117-.32c-.011-.115-.009-.228-.009-.343,0-.2,0-.4,0-.6,0-.115,0-.23.006-.345a.558.558,0,0,1,.124-.322l.028.013a.549.549,0,0,0,.183-.4.5.5,0,0,1,.111-.256l.017.011a.5.5,0,0,0,.19-.395.449.449,0,0,1,.115-.254l.017.011a.527.527,0,0,0,.19-.395.429.429,0,0,1,.119-.252l.015.011c.09-.122.211-.213.3-.339l.015.011a.5.5,0,0,0,.194-.392.449.449,0,0,1,.115-.254l.017.011a.524.524,0,0,0,.19-.395.429.429,0,0,1,.119-.252l.015.011c.09-.122.211-.213.3-.339l.015.011a.494.494,0,0,0,.194-.392.449.449,0,0,1,.115-.254l.017.011a.524.524,0,0,0,.19-.395.439.439,0,0,1,.117-.252l.015.011c.09-.122.211-.213.3-.339l.015.011a.488.488,0,0,0,.194-.392.449.449,0,0,1,.115-.254l.015.011a.517.517,0,0,0,.19-.395.439.439,0,0,1,.117-.252l.015.011c.09-.122.213-.213.3-.339l.013.011c.141-.1.2-.286.348-.38a.3.3,0,0,1,.3.041l.307.036a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.477.477,0,0,0,.371.173h.3a3.156,3.156,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.538.538,0,0,1,.292.113l-.013.028a.47.47,0,0,0,.371.173h.3a3.16,3.16,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.481.481,0,0,0,.377.171c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113l.307.034a.485.485,0,0,0,.38.166c.1,0,.2,0,.3.006a.525.525,0,0,1,.292.115l-.013.028a.475.475,0,0,0,.377.171c.1,0,.2,0,.3.006a.548.548,0,0,1,.294.111l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.477.477,0,0,0,.371.173h.3a3.158,3.158,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.538.538,0,0,1,.292.113l-.013.028a.47.47,0,0,0,.371.173h.3a3.158,3.158,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.481.481,0,0,0,.377.171c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113Z",
    transform: "translate(-10.07 -45.704)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M265.439,110.464l-.307.034a.525.525,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.544.544,0,0,1-.3.117,3.117,3.117,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.562.562,0,0,1-.292.113c-.1.009-.2.006-.3.009a.48.48,0,0,0-.38.168l.013.028a.544.544,0,0,1-.3.117,3.117,3.117,0,0,1-.316.006c-.1,0-.2,0-.3,0a.467.467,0,0,0-.375.171l.013.028a.538.538,0,0,1-.292.113c-.1.009-.2.006-.3.009a.481.481,0,0,0-.38.166l-.307.034a.559.559,0,0,1-.292.111c-.1.009-.2.006-.3.009a.475.475,0,0,0-.377.168l.013.028a.521.521,0,0,1-.29.113c-.1.009-.2.006-.3.009a.488.488,0,0,0-.38.166l-.307.034a.526.526,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.544.544,0,0,1-.3.117,3.117,3.117,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.562.562,0,0,1-.292.113c-.1.009-.2.006-.3.009a.485.485,0,0,0-.38.166l.013.028a.544.544,0,0,1-.3.117,3.121,3.121,0,0,1-.316.006c-.1,0-.2,0-.3,0a.467.467,0,0,0-.375.171l.013.028a.538.538,0,0,1-.292.113c-.1.009-.2.006-.3.009a.481.481,0,0,0-.38.166l-.307.034a.559.559,0,0,1-.292.111c-.1.009-.2.006-.3.009a.476.476,0,0,0-.377.168l.013.028a.522.522,0,0,1-.29.113c-.1.009-.2.006-.3.009a.488.488,0,0,0-.38.166l-.307.034a.525.525,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.544.544,0,0,1-.3.117,3.121,3.121,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.562.562,0,0,1-.292.113c-.1.009-.2.006-.3.009a.485.485,0,0,0-.38.166l.013.028a.544.544,0,0,1-.3.117,3.116,3.116,0,0,1-.316.006c-.1,0-.2,0-.3,0a.471.471,0,0,0-.375.168l.013.028a.583.583,0,0,1-.32.119c-.115.011-.23.009-.343.009-.2,0-.4,0-.6,0-.115,0-.23,0-.345-.006a.577.577,0,0,1-.324-.122l.013-.028a.463.463,0,0,0-.375-.173c-.1,0-.2,0-.3-.009a.482.482,0,0,1-.288-.124l.011-.015c-.119-.092-.215-.211-.335-.3l.009-.009c-.109-.1-.211-.218-.326-.313-.1-.115-.209-.218-.311-.326l-.009.006c-.092-.119-.211-.215-.3-.335l-.013.011a.435.435,0,0,1-.119-.252.531.531,0,0,0-.19-.395l-.015.011a.477.477,0,0,1-.115-.256.5.5,0,0,0-.194-.392l-.015.011c-.085-.126-.207-.218-.3-.339l-.015.011a.432.432,0,0,1-.117-.252.531.531,0,0,0-.19-.395l-.015.011a.477.477,0,0,1-.115-.256.5.5,0,0,0-.194-.392l-.015.011c-.085-.126-.207-.218-.3-.339l-.015.011a.432.432,0,0,1-.117-.252.531.531,0,0,0-.19-.395l-.015.011a.477.477,0,0,1-.115-.256.5.5,0,0,0-.194-.392l-.015.011c-.085-.126-.207-.218-.3-.339l-.015.011a.432.432,0,0,1-.117-.252.531.531,0,0,0-.19-.395l-.015.011a.477.477,0,0,1-.115-.256.5.5,0,0,0-.194-.392l-.015.011c-.085-.126-.207-.218-.3-.339l-.015.011a.432.432,0,0,1-.117-.252.531.531,0,0,0-.19-.395l-.015.011a.477.477,0,0,1-.115-.256.5.5,0,0,0-.194-.392l-.015.011c-.085-.126-.207-.218-.3-.339l-.015.011a.275.275,0,0,1-.041-.311.4.4,0,0,1,.271-.134.577.577,0,0,0,.42-.181l-.013-.028a.538.538,0,0,1,.3-.117,3.117,3.117,0,0,1,.316-.006c.1,0,.2,0,.3,0a.467.467,0,0,0,.375-.171l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034a.542.542,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.5.5,0,0,0,.382-.164l.307-.034a.525.525,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.113,3.113,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.538.538,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.485.485,0,0,0,.38-.166l-.013-.028a.538.538,0,0,1,.3-.117,3.117,3.117,0,0,1,.316-.006c.1,0,.2,0,.3,0a.471.471,0,0,0,.375-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034a.559.559,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.56.56,0,0,1,.3-.117,3.121,3.121,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.117,3.117,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.538.538,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.485.485,0,0,0,.38-.166l-.013-.028a.538.538,0,0,1,.3-.117,3.117,3.117,0,0,1,.316-.006c.1,0,.2,0,.3,0a.471.471,0,0,0,.375-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.559.559,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.56.56,0,0,1,.3-.117,3.121,3.121,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.561.561,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168L258.1,99.9a.544.544,0,0,1,.3-.117,3.118,3.118,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.538.538,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.492.492,0,0,0,.382-.166l-.013-.028a.556.556,0,0,1,.3-.119,3.117,3.117,0,0,1,.316-.006c.1,0,.2,0,.3,0a.471.471,0,0,0,.375-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.542.542,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.117,3.117,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.534.534,0,0,1,.326-.111.416.416,0,0,1,.313.134l0-.006a.4.4,0,0,1,.124.247.529.529,0,0,0,.192.395l.015-.011a.458.458,0,0,1,.113.256.486.486,0,0,0,.2.39l.013-.011c.083.126.207.218.3.339l.015-.011a.432.432,0,0,1,.117.252.531.531,0,0,0,.19.395l.015-.011a.477.477,0,0,1,.115.256.486.486,0,0,0,.2.39l.013-.011c.085.126.207.218.3.339l.015-.011a.432.432,0,0,1,.117.252.531.531,0,0,0,.19.395l.017-.011a.477.477,0,0,1,.115.256.486.486,0,0,0,.2.39l.013-.011c.085.126.207.218.3.339l.015-.011a.432.432,0,0,1,.117.252.531.531,0,0,0,.19.395l.015-.011a.477.477,0,0,1,.115.256.5.5,0,0,0,.194.392l.015-.011c.085.126.207.218.3.339l.015-.011a.432.432,0,0,1,.117.252.578.578,0,0,0,.183.4l.021-.013a.541.541,0,0,1,.124.311,2.958,2.958,0,0,1,.009.337c0,.113,0,.224,0,.337q0,.294,0,.589c0,.113,0,.226,0,.337s0,.228-.009.341a.557.557,0,0,1-.122.318l-.026-.013a.539.539,0,0,0-.186.4.467.467,0,0,1-.113.254l-.015-.011a1.6,1.6,0,0,0-.239.3.415.415,0,0,1-.092.092.643.643,0,0,0-.228.226.391.391,0,0,1-.094.094.639.639,0,0,0-.228.23.477.477,0,0,1-.092.094,2.213,2.213,0,0,0-.307.241l.011.017a.453.453,0,0,1-.254.113.571.571,0,0,0-.4.181c-.1.011-.2.021-.3.034a.559.559,0,0,1-.292.111c-.1.009-.2.006-.3.009a.476.476,0,0,0-.377.168l.013.028a.521.521,0,0,1-.29.113c-.1.009-.2.006-.3.009a.488.488,0,0,0-.38.166Z",
    transform: "translate(-153.085 -45.521)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M79.216,183.862l-.3-.034a.552.552,0,0,0-.4-.183.367.367,0,0,1-.243-.126h0a.369.369,0,0,1-.128-.243.584.584,0,0,0-.186-.4l-.026.013a.922.922,0,0,1-.147-.659V161.744a1.253,1.253,0,0,1,.064-.525.393.393,0,0,1,.324-.213,2.2,2.2,0,0,1,.375-.015c.119,0,.239,0,.356.009a.577.577,0,0,1,.324.122l-.013.028a.484.484,0,0,0,.377.171c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113l.307.034a.485.485,0,0,0,.38.166c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.481.481,0,0,0,.377.171c.1,0,.2,0,.3.006a.535.535,0,0,1,.294.113l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.471.471,0,0,0,.371.171h.3a3.163,3.163,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.538.538,0,0,1,.292.113l-.013.028a.47.47,0,0,0,.371.173h.3a3.163,3.163,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113l.307.034a.485.485,0,0,0,.38.166c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.481.481,0,0,0,.377.171c.1,0,.2,0,.3.006a.522.522,0,0,1,.292.113l.307.034a.482.482,0,0,0,.377.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.471.471,0,0,0,.371.171h.3a3.163,3.163,0,0,1,.318,0,.54.54,0,0,1,.3.119l-.013.028a.487.487,0,0,0,.38.168c.1,0,.2,0,.3.006a.524.524,0,0,1,.292.115l-.013.028a.47.47,0,0,0,.371.173h.3a3.163,3.163,0,0,1,.318,0,.553.553,0,0,1,.3.119l-.013.028a.478.478,0,0,0,.377.168c.1,0,.2,0,.3.006a.551.551,0,0,1,.294.113l-.013.028a.46.46,0,0,0,.369.173h.3a3.163,3.163,0,0,1,.318,0,.567.567,0,0,1,.3.117l-.013.028a.476.476,0,0,0,.373.171c.1,0,.2,0,.3,0s.213,0,.32,0,.224,0,.337,0q.432-.01.864,0c.113,0,.224,0,.337,0s.213,0,.322,0,.2,0,.3,0a.466.466,0,0,0,.377-.168l-.013-.028a.528.528,0,0,1,.292-.113c.1-.009.2-.006.3-.011a.442.442,0,0,0,.373-.177l-.013-.019a.515.515,0,0,1,.256-.107.34.34,0,0,0,.32-.179.478.478,0,0,1,.094-.092,1.525,1.525,0,0,0,.3-.245l-.009-.011c.117-.1.215-.209.331-.307l0,0c.109-.1.211-.215.324-.316s.211-.215.318-.324l0,0c.1-.115.213-.213.309-.331l.009.006a1.65,1.65,0,0,0,.243-.3.478.478,0,0,1,.092-.094.344.344,0,0,0,.181-.322.45.45,0,0,1,.111-.254l.015.011a.513.513,0,0,0,.19-.395.439.439,0,0,1,.117-.252l.015.011c.092-.119.213-.213.3-.339l.013.011a.48.48,0,0,0,.2-.39.462.462,0,0,1,.115-.256l.017.011a.513.513,0,0,0,.19-.395.426.426,0,0,1,.117-.252l.015.011a2.233,2.233,0,0,0,.239-.307.477.477,0,0,1,.092-.094.342.342,0,0,0,.179-.32.452.452,0,0,1,.113-.254l.015.011a.523.523,0,0,0,.192-.395.452.452,0,0,1,.117-.254l.015.011a2.232,2.232,0,0,0,.239-.307.478.478,0,0,1,.092-.094.342.342,0,0,0,.179-.32.453.453,0,0,1,.113-.254l.015.011a.2.2,0,0,1,.3,0q0,5.108.006,10.217a.87.87,0,0,1-.7.171c-4.195,0-8.392.006-12.586,0-.122-.006-.245,0-.369-.009-.1,0-.211,0-.316-.009a.477.477,0,0,0-.416.164l-.3.034a.53.53,0,0,1-.258.107.543.543,0,0,0-.4.186l.013.021a.49.49,0,0,1-.256.113.5.5,0,0,0-.392.194l.011.013c-.122.09-.218.209-.333.3l.006.009a.451.451,0,0,1-.262.124.229.229,0,0,0-.254.256.392.392,0,0,1-.13.256v0c-.1.115-.213.215-.311.331l-.011-.009c-.1.115-.215.211-.3.335l-.013-.011a.485.485,0,0,0-.194.392.509.509,0,0,1-.111.258l-.021-.013a.452.452,0,0,0-.175.373c0,.1,0,.2-.006.3a.522.522,0,0,1-.113.292c-.011.1-.023.207-.034.311a.578.578,0,0,0-.145.537q.006,6.071,0,12.143a1.611,1.611,0,0,1-.068.682.4.4,0,0,1-.328.2,1.926,1.926,0,0,1-.384.009.577.577,0,0,1-.343-.124l-.307-.034a.485.485,0,0,0-.38-.166c-.1,0-.2,0-.3-.006a.524.524,0,0,1-.292-.115l.013-.028a.471.471,0,0,0-.371-.171h-.3a3.158,3.158,0,0,1-.318,0,.54.54,0,0,1-.3-.119l.013-.028a.487.487,0,0,0-.38-.168c-.1,0-.2,0-.3-.006a.538.538,0,0,1-.292-.113l.013-.028a.467.467,0,0,0-.371-.173h-.3a3.154,3.154,0,0,1-.318,0,.567.567,0,0,1-.3-.117l.013-.028a.471.471,0,0,0-.371-.171h-.3a3.154,3.154,0,0,1-.318,0,.54.54,0,0,1-.3-.119l.013-.028a.487.487,0,0,0-.38-.168c-.1,0-.2,0-.3-.006a.538.538,0,0,1-.292-.113l.013-.028a.47.47,0,0,0-.371-.173h-.3a3.158,3.158,0,0,1-.318,0,.567.567,0,0,1-.3-.117l.013-.028a.481.481,0,0,0-.377-.171c-.1,0-.2,0-.3-.006a.548.548,0,0,1-.294-.111Z",
    transform: "translate(-28.906 -92.978)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M258.929,185.666l-.307.034a.559.559,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.577.577,0,0,1-.3.117,3.117,3.117,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.555.555,0,0,1-.292.113c-.1.009-.2.006-.3.009a.481.481,0,0,0-.38.166l-.307.034a.559.559,0,0,1-.292.111c-.1.009-.2.006-.3.009a.483.483,0,0,0-.38.168l.013.028a.577.577,0,0,1-.3.117,3.108,3.108,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.555.555,0,0,1-.292.113c-.1.009-.2.006-.3.009a.481.481,0,0,0-.38.166l-.307.034a.621.621,0,0,1-.339.119,1.862,1.862,0,0,1-.377-.006.394.394,0,0,1-.333-.194,1.255,1.255,0,0,1-.077-.574c0-4.007-.006-8.014,0-12.021.006-.122,0-.245.009-.367,0-.1,0-.211.009-.316a.487.487,0,0,0-.162-.418c-.011-.1-.023-.2-.034-.307a.514.514,0,0,1-.107-.258.546.546,0,0,0-.186-.4l-.021.013a.459.459,0,0,1-.113-.254.524.524,0,0,0-.19-.395l-.015.011a.424.424,0,0,1-.111-.25.352.352,0,0,0-.175-.32.467.467,0,0,1-.092-.092.644.644,0,0,0-.226-.228.435.435,0,0,1-.094-.094.644.644,0,0,0-.23-.23.489.489,0,0,1-.1-.092.343.343,0,0,0-.322-.179.447.447,0,0,1-.252-.113l.011-.015a.524.524,0,0,0-.395-.19.449.449,0,0,1-.254-.115l.013-.021a.536.536,0,0,0-.4-.183.507.507,0,0,1-.256-.107l-.307-.034a.491.491,0,0,0-.412-.166l-.316.011c-.124.009-.245,0-.369.009-4.109.009-8.219,0-12.328,0a.973.973,0,0,1-.661-.136.894.894,0,0,1-.151-.655v-8.669a1.048,1.048,0,0,1,.094-.569.247.247,0,0,1,.375-.036l.015-.011a.441.441,0,0,1,.115.254.511.511,0,0,0,.192.392l.015-.011a.472.472,0,0,1,.111.254.344.344,0,0,0,.179.32.478.478,0,0,1,.092.094,1.986,1.986,0,0,0,.241.307l.015-.011a.441.441,0,0,1,.115.254.519.519,0,0,0,.192.395l.015-.011a.471.471,0,0,1,.111.254.344.344,0,0,0,.179.32.478.478,0,0,1,.092.094,1.986,1.986,0,0,0,.241.307l.015-.011a.458.458,0,0,1,.117.254.519.519,0,0,0,.192.395l.015-.011a.465.465,0,0,1,.111.254.344.344,0,0,0,.179.32.545.545,0,0,1,.092.094,1.987,1.987,0,0,0,.241.307l.015-.011a.458.458,0,0,1,.117.254.481.481,0,0,0,.2.388l.009-.009a4.108,4.108,0,0,0,.309.331l0,0c.1.113.209.218.316.324s.211.215.322.316l0,0a4.081,4.081,0,0,0,.328.309l-.006.006a.482.482,0,0,0,.39.2.452.452,0,0,1,.254.117l-.011.017a.545.545,0,0,0,.4.188.446.446,0,0,1,.254.113l-.013.021a.544.544,0,0,0,.4.183.522.522,0,0,1,.258.107l.307.034a.478.478,0,0,0,.382.166c.1,0,.2,0,.307,0s.222,0,.333-.006q.438-.013.876,0c.2,0,.4,0,.6,0,.1,0,.2,0,.3,0a.484.484,0,0,0,.414-.164l-.013-.028a.544.544,0,0,1,.3-.117,3.113,3.113,0,0,1,.316-.006c.1,0,.2,0,.3,0a.467.467,0,0,0,.375-.171l-.013-.028a.538.538,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034a.559.559,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.521.521,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.525.525,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.121,3.121,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.122,3.122,0,0,1,.316-.006c.1,0,.2,0,.3,0a.467.467,0,0,0,.375-.171l-.013-.028a.538.538,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034a.559.559,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.476.476,0,0,0,.377-.168l-.013-.028a.522.522,0,0,1,.29-.113c.1-.009.2-.006.3-.009a.488.488,0,0,0,.38-.166l.307-.034a.525.525,0,0,1,.292-.111c.1-.009.2-.006.3-.009a.483.483,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.117,3.117,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.562.562,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.48.48,0,0,0,.38-.168l-.013-.028a.544.544,0,0,1,.3-.117,3.122,3.122,0,0,1,.316-.006c.1,0,.2,0,.3,0a.46.46,0,0,0,.373-.171l-.013-.028a.538.538,0,0,1,.292-.113c.1-.009.2-.006.3-.009a.481.481,0,0,0,.38-.166l.307-.034a.6.6,0,0,1,.339-.119,1.883,1.883,0,0,1,.38.006.394.394,0,0,1,.333.2,1.152,1.152,0,0,1,.075.522q0,10.463,0,20.929c0,.053-.006.107-.009.16a.588.588,0,0,1-.147.39l-.013-.011a2.816,2.816,0,0,1-.311.326h0a.394.394,0,0,1-.247.124.576.576,0,0,0-.4.186l.013.028a.544.544,0,0,1-.3.117,3.118,3.118,0,0,1-.316.006c-.1,0-.2,0-.3,0a.46.46,0,0,0-.373.171l.013.028a.555.555,0,0,1-.292.113c-.1.009-.2.006-.3.009a.481.481,0,0,0-.38.166Z",
    transform: "translate(-150.412 -94.177)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M304.647,230.265q0,9.03.009,18.063,0,7.594-.009,15.186a.247.247,0,0,1-.375-.036,1.551,1.551,0,0,1-.109-.781v-31.61a1.585,1.585,0,0,1,.107-.783A.248.248,0,0,1,304.647,230.265Z",
    transform: "translate(-207.005 -149.627)",
    fill: "#85a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M144.722,263.778c-.154,0-.292-.015-.3-.213,0-.124,0-.25,0-.373q0-16.039.006-32.075c0-.218-.179-.584.294-.586.026.023.051.049.079.073a1.486,1.486,0,0,1,.113.781q0,15.773,0,31.544a1.506,1.506,0,0,1-.111.78l-.079.073Z",
    transform: "translate(-81.309 -149.891)",
    fill: "#5b8546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M185.7,396.619l-23.654.009q-2.876,0-5.754-.009a.246.246,0,0,1,.032-.375,1.529,1.529,0,0,1,.781-.111q13.889,0,27.776,0a1.585,1.585,0,0,1,.783.107.246.246,0,0,1,.036.377Z",
    transform: "translate(-90.617 -280.176)",
    fill: "#85a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M157.777,218.511q7.885-.006,15.77-.011,6.66,0,13.32.011a.24.24,0,0,1-.036.373,1.562,1.562,0,0,1-.783.109q-13.723,0-27.448,0a1.585,1.585,0,0,1-.783-.107.249.249,0,0,1-.043-.377Z",
    transform: "translate(-91.785 -140.426)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M77.308,170.841c-.006,1.045-.017,2.092-.017,3.137v18.295c0,.107-.009.213-.011.318-.145-.013-.294-.017-.3-.217,0-.124-.006-.247-.006-.373q0-10.46,0-20.92c0-.228-.143-.586.328-.557a.25.25,0,0,1,0,.316Z",
    transform: "translate(-28.252 -102.679)",
    fill: "#658c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M372.226,192.6c0-1.7-.013-3.4-.013-5.105V171.492c0-.213-.011-.424-.015-.638a.245.245,0,0,1,0-.313c.171-.015.328-.013.328.224,0,.07,0,.143,0,.213q0,10.8-.009,21.6a.2.2,0,0,1-.3.019Z",
    transform: "translate(-260.491 -102.69)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M156.287,206.472q5.646-.01,11.29-.019c.71,0,1.42-.009,2.13-.013.058.38-.207.333-.437.333h-5.216q-3.887,0-7.771-.009a.2.2,0,0,1,.006-.292Z",
    transform: "translate(-90.614 -130.938)",
    fill: "#90ad82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M132.275,241.869q.006-6.548.015-13.1a.2.2,0,0,1,.294-.013q.006,6.551.019,13.1c0,.241-.049.384-.326.316a.221.221,0,0,1,0-.309Z",
    transform: "translate(-71.727 -148.45)",
    fill: "#c6d6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M232.709,206.4l6.794.021,6.317.019a.2.2,0,0,1,.006.29H232.716a.207.207,0,0,1-.077-.226.2.2,0,0,1,.073-.1Z",
    transform: "translate(-150.731 -130.906)",
    fill: "#90ad82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M317.249,230.263q.006,5.995.015,11.987c0,.267.009.533.015.8a.242.242,0,0,1,0,.311c-.444.064-.326-.267-.326-.486q-.01-3.112,0-6.227c0-2.128.009-4.259.013-6.387a.2.2,0,0,1,.292,0Z",
    transform: "translate(-217.055 -149.628)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M231.859,158.554v9.891l0,.047a.228.228,0,0,1-.313-.038q0-5.109.006-10.219a.233.233,0,0,1,.269-.06.227.227,0,0,1,.1.107.249.249,0,0,1-.066.273Z",
    transform: "translate(-149.879 -92.951)",
    fill: "#d2decb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M175.766,184.08h.968a.2.2,0,0,1-.013.292c-.316,0-.631,0-.947,0a.2.2,0,0,1-.011-.3Z",
    transform: "translate(-105.943 -113.346)",
    fill: "#a1ba94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M176.731,196.319h-.955a.206.206,0,0,1,0-.3c.322,0,.642,0,.964,0a.2.2,0,0,1-.006.294Z",
    transform: "translate(-105.947 -122.74)",
    fill: "#7c9e6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M271.215,196.329h-.953a.206.206,0,0,1-.006-.3c.322,0,.644,0,.968.009A.2.2,0,0,1,271.215,196.329Z",
    transform: "translate(-180.283 -122.748)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M274.972,196.352c0-.1.006-.194.009-.29.213,0,.426,0,.64,0a.193.193,0,0,1-.015.29h-.635Z",
    transform: "translate(-184.04 -122.771)",
    fill: "#92af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M271.757,184.072h.646a.2.2,0,0,1-.009.29c-.211,0-.42,0-.631,0a.2.2,0,0,1,0-.294Z",
    transform: "translate(-181.464 -113.338)",
    fill: "#a3bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M396.512,136.423c0-.215,0-.431,0-.646a.2.2,0,0,1,.294.009v.633A.2.2,0,0,1,396.512,136.423Z",
    transform: "translate(-279.661 -75.296)",
    fill: "#cbd9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M234.806,136.367c-.006.1-.011.207-.017.309-.26.021-.324-.119-.32-.354s.126-.3.333-.279a.257.257,0,0,1,0,.326Z",
    transform: "translate(-152.176 -75.55)",
    fill: "#6a9056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M53.392,135.785v.646a.2.2,0,0,1-.29,0c0-.211,0-.422,0-.631a.2.2,0,0,1,.294-.009Z",
    transform: "translate(-9.484 -75.304)",
    fill: "#a2bb98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M224.4,53.919h-.646a.2.2,0,0,1,.009-.3h.633a.207.207,0,0,1,0,.3Z",
    transform: "translate(-143.7 -10.707)",
    fill: "#e9eee6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M223.762,125.54c.22,0,.437,0,.657,0a.206.206,0,0,1-.015.3h-.625A.2.2,0,0,1,223.762,125.54Z",
    transform: "translate(-143.708 -67.29)",
    fill: "#e5ece2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M74.689,97.322l-.324.036a.247.247,0,0,1-.313,0c-.023-.2.032-.331.275-.335C74.551,97.015,74.711,97.051,74.689,97.322Z",
    transform: "translate(-25.964 -44.851)",
    fill: "#7fa06e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M213.793,55.339c-.107,0-.213,0-.318,0-.015-.239.1-.333.333-.3a.206.206,0,0,1-.013.3Z",
    transform: "translate(-135.658 -11.82)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M214.962,55.351l.013-.3.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-136.827 -11.832)",
    fill: "#8ba97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M216.46,55.384l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-138.007 -11.864)",
    fill: "#bdceb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M217.96,55.4c.006-.1.011-.2.017-.3.107,0,.213,0,.318,0C218.308,55.339,218.192,55.435,217.96,55.4Z",
    transform: "translate(-139.187 -11.872)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M233.291,55.394c-.232.045-.354-.045-.337-.29.107,0,.213,0,.318,0A.2.2,0,0,1,233.291,55.394Z",
    transform: "translate(-150.983 -11.872)",
    fill: "#c7d6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M234.469,55.371l-.019-.294.32-.006a.2.2,0,0,1,.017.3C234.68,55.367,234.576,55.369,234.469,55.371Z",
    transform: "translate(-152.161 -11.848)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M235.967,55.341c-.006-.1-.011-.2-.017-.3.232-.034.348.06.335.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-153.341 -11.823)",
    fill: "#658d51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M209.277,56.836h-.32c-.011-.239.1-.335.337-.3A.2.2,0,0,1,209.277,56.836Z",
    transform: "translate(-132.104 -12.998)",
    fill: "#739760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M210.452,56.867c.006-.1.011-.2.017-.3l.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-133.279 -13.028)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M211.95,56.894l.019-.294h.32C212.3,56.841,212.185,56.937,211.95,56.894Z",
    transform: "translate(-134.459 -13.052)",
    fill: "#d7e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M237.794,56.9c-.232.036-.348-.06-.337-.3h.32a.2.2,0,0,1,.017.3Z",
    transform: "translate(-154.526 -13.052)",
    fill: "#e1e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M238.977,56.891c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.32.006Z",
    transform: "translate(-155.709 -13.044)",
    fill: "#b0c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M240.469,56.836l-.019-.294c.232-.043.352.047.337.292h-.318Z",
    transform: "translate(-156.881 -12.998)",
    fill: "#7f9f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M203.293,58.339c-.107,0-.213,0-.318,0-.015-.239.1-.333.333-.3A.2.2,0,0,1,203.293,58.339Z",
    transform: "translate(-127.397 -14.181)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M204.47,58.359c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-128.574 -14.2)",
    fill: "#8dab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M205.96,58.384l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.32-.009Z",
    transform: "translate(-129.746 -14.224)",
    fill: "#becfb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M207.452,58.4c0-.1.011-.2.015-.3.107,0,.213,0,.318,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-130.918 -14.232)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M243.792,58.394c-.232.043-.352-.045-.337-.29.107,0,.211,0,.318,0A.2.2,0,0,1,243.792,58.394Z",
    transform: "translate(-159.245 -14.232)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M244.969,58.371l-.019-.294.32-.006a.2.2,0,0,1,.017.3C245.18,58.367,245.076,58.369,244.969,58.371Z",
    transform: "translate(-160.422 -14.208)",
    fill: "#98b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M246.467,58.341c-.006-.1-.011-.2-.017-.3.232-.034.348.06.337.3-.107,0-.213,0-.318,0Z",
    transform: "translate(-161.602 -14.183)",
    fill: "#668e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M198.787,59.836h-.32c-.011-.239.1-.335.337-.3a.2.2,0,0,1-.017.294Z",
    transform: "translate(-123.851 -15.358)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M199.962,59.867c.006-.1.011-.2.017-.3.107,0,.213,0,.318.006a.2.2,0,0,1-.019.294l-.318,0Z",
    transform: "translate(-125.026 -15.388)",
    fill: "#a6bd9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M201.45,59.9l.019-.294h.32C201.8,59.851,201.685,59.947,201.45,59.9Z",
    transform: "translate(-126.198 -15.42)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M248.3,59.9c-.232.036-.348-.06-.335-.3h.32a.2.2,0,0,1,.017.3Z",
    transform: "translate(-162.794 -15.412)",
    fill: "#e2eadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M249.477,59.891c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.32.006Z",
    transform: "translate(-163.97 -15.404)",
    fill: "#b0c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M250.959,59.844c-.006-.1-.013-.2-.019-.292.235-.043.352.047.337.292Z",
    transform: "translate(-165.134 -15.366)",
    fill: "#7fa16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M192.793,61.339c-.107,0-.213,0-.318,0-.015-.239.1-.333.333-.3A.2.2,0,0,1,192.793,61.339Z",
    transform: "translate(-119.136 -16.541)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M193.97,61.359c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-120.313 -16.561)",
    fill: "#8eac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M195.46,61.384l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3l-.32-.009Z",
    transform: "translate(-121.485 -16.584)",
    fill: "#becfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M196.96,61.393c.006-.1.011-.2.017-.3.107,0,.213,0,.318,0C197.31,61.329,197.192,61.425,196.96,61.393Z",
    transform: "translate(-122.666 -16.584)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M254.292,61.4c-.232.043-.352-.045-.337-.29.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-167.506 -16.6)",
    fill: "#cad9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M255.469,61.371l-.019-.294.318-.006a.2.2,0,0,1,.017.3l-.318,0Z",
    transform: "translate(-168.682 -16.569)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M256.967,61.339c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3h-.32Z",
    transform: "translate(-169.862 -16.541)",
    fill: "#698f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M188.287,62.841h-.32c-.011-.239.1-.335.337-.294A.2.2,0,0,1,188.287,62.841Z",
    transform: "translate(-115.59 -17.723)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M189.462,62.874c.006-.1.011-.2.017-.294.107,0,.213,0,.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-116.765 -17.757)",
    fill: "#a6be9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M190.96,62.9l.019-.294h.32C191.31,62.851,191.195,62.947,190.96,62.9Z",
    transform: "translate(-117.945 -17.78)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M258.791,62.9c-.232.036-.348-.06-.335-.3h.318a.2.2,0,0,1,.017.3Z",
    transform: "translate(-171.047 -17.772)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M259.967,62.891c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C260.18,62.884,260.074,62.887,259.967,62.891Z",
    transform: "translate(-172.223 -17.764)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M261.459,62.844c-.006-.1-.013-.2-.019-.292.235-.043.352.047.337.292Z",
    transform: "translate(-173.395 -17.727)",
    fill: "#80a270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M182.3,64.339c-.107,0-.213,0-.318,0-.015-.239.1-.333.333-.3A.206.206,0,0,1,182.3,64.339Z",
    transform: "translate(-110.883 -18.901)",
    fill: "#5f874b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M183.48,64.359c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-112.06 -18.921)",
    fill: "#8fab80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M184.96,64.384l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.32-.009Z",
    transform: "translate(-113.225 -18.945)",
    fill: "#c0d1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M186.462,64.393c0-.1.011-.2.015-.3.107,0,.213,0,.318,0,.015.239-.1.335-.335.3Z",
    transform: "translate(-114.405 -18.945)",
    fill: "#f1f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M264.792,64.4c-.232.043-.352-.045-.337-.29.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-175.766 -18.96)",
    fill: "#cbdac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M265.969,64.371l-.019-.294.32-.006a.2.2,0,0,1,.017.3Z",
    transform: "translate(-176.943 -18.929)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M267.457,64.339c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3h-.32Z",
    transform: "translate(-178.115 -18.901)",
    fill: "#6a9056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M177.787,65.841h-.32c-.011-.239.1-.335.337-.294A.2.2,0,0,1,177.787,65.841Z",
    transform: "translate(-107.329 -20.084)",
    fill: "#779b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M178.962,65.874c.006-.1.011-.2.017-.294.107,0,.213,0,.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-108.504 -20.117)",
    fill: "#a9bf9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M180.46,65.9l.019-.294h.32c.011.241-.1.337-.337.294Z",
    transform: "translate(-109.684 -20.14)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M269.291,65.9c-.232.034-.348-.06-.335-.3h.318a.2.2,0,0,1,.017.3Z",
    transform: "translate(-179.308 -20.133)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M270.467,65.891c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C270.68,65.884,270.574,65.887,270.467,65.891Z",
    transform: "translate(-180.484 -20.125)",
    fill: "#b3c7a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M271.959,65.842c-.006-.1-.013-.2-.019-.292.235-.045.352.047.337.29C272.17,65.84,272.066,65.84,271.959,65.842Z",
    transform: "translate(-181.656 -20.084)",
    fill: "#82a273"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M171.8,67.339c-.107,0-.213,0-.318,0-.013-.239.1-.333.333-.3A.206.206,0,0,1,171.8,67.339Z",
    transform: "translate(-102.624 -21.261)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M172.98,67.359c0-.1.011-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-103.799 -21.281)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M174.47,67.384l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.32-.009Z",
    transform: "translate(-104.972 -21.305)",
    fill: "#c1d2ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M175.962,67.393c0-.1.011-.2.015-.3.107,0,.213,0,.318,0,.015.239-.1.335-.335.3Z",
    transform: "translate(-106.144 -21.305)",
    fill: "#f2f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M275.282,67.394c-.232.043-.352-.047-.337-.292.107,0,.211,0,.318,0A.2.2,0,0,1,275.282,67.394Z",
    transform: "translate(-184.019 -21.313)",
    fill: "#cddbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M276.459,67.371l-.019-.294.318-.006a.2.2,0,0,1,.017.3l-.318,0Z",
    transform: "translate(-185.196 -21.289)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M277.957,67.339c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3h-.32Z",
    transform: "translate(-186.376 -21.262)",
    fill: "#6a9157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M167.287,68.841h-.32c-.011-.239.1-.335.337-.294A.2.2,0,0,1,167.287,68.841Z",
    transform: "translate(-99.068 -22.444)",
    fill: "#789b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M168.462,68.874c.006-.1.011-.2.017-.294.107,0,.213,0,.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-100.243 -22.477)",
    fill: "#a8bf9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M169.96,68.9l.019-.294h.32c.011.241-.1.337-.337.294Z",
    transform: "translate(-101.423 -22.501)",
    fill: "#dbe4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M279.791,68.9c-.232.034-.348-.06-.335-.3h.32a.206.206,0,0,1,.017.3Z",
    transform: "translate(-187.569 -22.493)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M280.967,68.891c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C281.18,68.884,281.074,68.887,280.967,68.891Z",
    transform: "translate(-188.744 -22.485)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M282.459,68.841c-.006-.1-.013-.2-.019-.292.235-.045.352.045.337.29C282.67,68.839,282.566,68.839,282.459,68.841Z",
    transform: "translate(-189.917 -22.444)",
    fill: "#84a374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M161.3,70.337h-.318c-.013-.235.1-.331.333-.3A.206.206,0,0,1,161.3,70.337Z",
    transform: "translate(-94.363 -23.619)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M162.48,70.359c0-.1.011-.2.015-.3l.322.009a.2.2,0,0,1-.019.294C162.691,70.363,162.587,70.361,162.48,70.359Z",
    transform: "translate(-95.538 -23.641)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M163.97,70.384l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-96.711 -23.665)",
    fill: "#c3d3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M165.47,70.393c0-.1.011-.2.015-.3.107,0,.213,0,.318,0C165.818,70.329,165.7,70.425,165.47,70.393Z",
    transform: "translate(-97.891 -23.665)",
    fill: "#f3f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M285.782,70.4c-.232.043-.352-.047-.337-.292h.318A.2.2,0,0,1,285.782,70.4Z",
    transform: "translate(-192.28 -23.681)",
    fill: "#cfdcc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M286.959,70.371l-.019-.294.318-.006a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-193.457 -23.649)",
    fill: "#9cb68f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M288.457,70.339c-.006-.1-.011-.2-.017-.3.232-.036.35.058.337.3h-.32Z",
    transform: "translate(-194.637 -23.621)",
    fill: "#6b9258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M156.787,71.841h-.32c-.011-.241.1-.335.337-.294A.2.2,0,0,1,156.787,71.841Z",
    transform: "translate(-90.808 -24.803)",
    fill: "#799c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M157.962,71.874c.006-.1.013-.2.017-.294.107,0,.213,0,.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-91.982 -24.837)",
    fill: "#aac19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M159.46,71.9l.019-.294h.32c.011.241-.1.335-.337.3Z",
    transform: "translate(-93.163 -24.861)",
    fill: "#dde5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M290.291,71.9c-.232.034-.348-.06-.335-.3.107,0,.213,0,.318,0A.206.206,0,0,1,290.291,71.9Z",
    transform: "translate(-195.829 -24.853)",
    fill: "#e7ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M291.467,71.891c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C291.68,71.884,291.574,71.887,291.467,71.891Z",
    transform: "translate(-197.005 -24.845)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M292.959,71.843c-.006-.1-.013-.2-.019-.292.232-.043.354.043.337.29C293.17,71.841,293.066,71.841,292.959,71.843Z",
    transform: "translate(-198.177 -24.806)",
    fill: "#84a473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M150.8,73.336c-.107,0-.213,0-.318,0-.013-.239.1-.333.333-.3A.206.206,0,0,1,150.8,73.336Z",
    transform: "translate(-86.102 -25.979)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M151.972,73.359c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-87.27 -26.002)",
    fill: "#92af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M153.47,73.384l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-88.45 -26.025)",
    fill: "#c3d3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M154.98,73.393c0-.1.011-.2.015-.3.107,0,.213,0,.318,0C155.328,73.329,155.21,73.425,154.98,73.393Z",
    transform: "translate(-89.638 -26.025)",
    fill: "#f3f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M296.289,73.4c-.232.041-.352-.049-.335-.292h.318a.2.2,0,0,1,.019.294Z",
    transform: "translate(-200.548 -26.041)",
    fill: "#d0dcca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M297.459,73.371l-.019-.294c.107,0,.213,0,.318-.006a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-201.718 -26.01)",
    fill: "#9eb791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M298.957,73.336c-.006-.1-.011-.2-.017-.3.232-.038.348.058.337.3Z",
    transform: "translate(-202.898 -25.979)",
    fill: "#6e935b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M146.3,74.841h-.32c-.011-.241.1-.335.337-.294A.2.2,0,0,1,146.3,74.841Z",
    transform: "translate(-82.555 -27.164)",
    fill: "#7b9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M147.472,74.874c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-83.729 -27.198)",
    fill: "#abc2a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M148.97,74.9l.019-.294h.32c.011.241-.1.337-.337.3Z",
    transform: "translate(-84.91 -27.221)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M300.781,74.891c-.23.034-.348-.062-.335-.3.107,0,.213,0,.318,0A.208.208,0,0,1,300.781,74.891Z",
    transform: "translate(-204.083 -27.205)",
    fill: "#e9efe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M301.957,74.883c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.32.009Z",
    transform: "translate(-205.258 -27.198)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M303.449,74.841c-.006-.1-.013-.2-.019-.292.232-.045.354.043.337.29C303.66,74.839,303.556,74.839,303.449,74.841Z",
    transform: "translate(-206.43 -27.164)",
    fill: "#84a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M140.3,76.326c-.107,0-.213,0-.318,0-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3Z",
    transform: "translate(-77.841 -28.332)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M141.472,76.349c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-79.009 -28.354)",
    fill: "#93af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M142.97,76.384l.019-.294c.107,0,.211,0,.318,0a.207.207,0,0,1-.015.3Z",
    transform: "translate(-80.189 -28.386)",
    fill: "#c5d4be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M144.48,76.385c0-.1.009-.2.015-.3.107,0,.213,0,.318,0C144.828,76.319,144.71,76.415,144.48,76.385Z",
    transform: "translate(-81.377 -28.378)",
    fill: "#f5f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M306.789,76.4c-.232.041-.352-.049-.335-.292h.318a.2.2,0,0,1,.017.294Z",
    transform: "translate(-208.808 -28.401)",
    fill: "#d0dcca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M307.967,76.371c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.3C308.178,76.367,308.074,76.369,307.967,76.371Z",
    transform: "translate(-209.987 -28.37)",
    fill: "#9fb993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M309.457,76.336c-.006-.1-.013-.2-.017-.3.235-.038.35.058.337.3Z",
    transform: "translate(-211.159 -28.339)",
    fill: "#6f945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M135.8,77.841h-.32c-.011-.241.1-.335.337-.294A.2.2,0,0,1,135.8,77.841Z",
    transform: "translate(-74.294 -29.524)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M136.98,77.874c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.294l-.318-.006Z",
    transform: "translate(-75.476 -29.558)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M138.47,77.9c.006-.1.013-.2.017-.294h.32c.011.239-.1.337-.337.3Z",
    transform: "translate(-76.649 -29.581)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M311.281,77.891c-.23.032-.348-.062-.335-.3h.318a.209.209,0,0,1,.015.3Z",
    transform: "translate(-212.343 -29.566)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M312.465,77.883c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.32.009Z",
    transform: "translate(-213.527 -29.558)",
    fill: "#b9cbb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M313.949,77.841c-.006-.1-.013-.2-.019-.292.232-.045.354.043.337.29-.107,0-.213,0-.318,0Z",
    transform: "translate(-214.691 -29.524)",
    fill: "#86a577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M129.814,79.326H129.5c-.013-.237.1-.331.335-.3a.206.206,0,0,1-.015.3Z",
    transform: "translate(-69.588 -30.692)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M130.982,79.349c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-70.756 -30.714)",
    fill: "#95b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M132.47,79.384l.019-.294h.318a.207.207,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-71.928 -30.746)",
    fill: "#c6d6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M133.98,79.385c0-.1.009-.2.015-.3.107,0,.213,0,.318,0C134.328,79.319,134.212,79.415,133.98,79.385Z",
    transform: "translate(-73.116 -30.738)",
    fill: "#f5f8f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M317.279,79.4c-.232.041-.352-.049-.335-.292h.318a.2.2,0,0,1,.019.294Z",
    transform: "translate(-217.061 -30.762)",
    fill: "#d2decb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M318.449,79.371l-.019-.294c.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-218.232 -30.73)",
    fill: "#9fb993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M319.947,79.344c-.006-.1-.011-.2-.017-.294.235-.038.348.058.337.3h-.32Z",
    transform: "translate(-219.412 -30.708)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M125.3,80.847h-.318c-.015-.243.1-.333.335-.292a.2.2,0,0,1-.017.294Z",
    transform: "translate(-66.039 -31.891)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M126.48,80.874c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-67.216 -31.918)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M127.97,80.9c.006-.1.013-.2.017-.294h.32c.011.239-.1.335-.337.3Z",
    transform: "translate(-68.388 -31.942)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M321.781,80.891c-.23.032-.348-.062-.335-.3.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3Z",
    transform: "translate(-220.604 -31.926)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M322.965,80.883c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-221.788 -31.918)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M324.449,80.843l-.019-.294.322-.009a.205.205,0,0,1,.013.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-222.952 -31.886)",
    fill: "#88a779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M325.963,80.821l-.013-.3c.23-.03.348.066.333.3-.107,0-.213,0-.318,0Z",
    transform: "translate(-224.148 -31.867)",
    fill: "#5b8546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M119.314,82.326c-.107,0-.213,0-.318,0-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3Z",
    transform: "translate(-61.327 -33.052)",
    fill: "#658d51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M120.482,82.349c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-62.495 -33.074)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M121.97,82.392l.019-.292c.107,0,.213,0,.318,0C122.322,82.347,122.2,82.437,121.97,82.392Z",
    transform: "translate(-63.667 -33.114)",
    fill: "#c7d7c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M327.773,82.394c-.235.043-.35-.053-.337-.294h.32a.2.2,0,0,1,.019.294Z",
    transform: "translate(-225.317 -33.114)",
    fill: "#d3decd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M328.949,82.371l-.019-.294c.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-226.493 -33.09)",
    fill: "#a0ba95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M330.447,82.344c-.006-.1-.013-.2-.017-.294.235-.038.35.058.337.3h-.32Z",
    transform: "translate(-227.673 -33.068)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M114.8,83.847h-.318c-.015-.243.1-.333.335-.292a.2.2,0,0,1-.019.294Z",
    transform: "translate(-57.778 -34.251)",
    fill: "#7d9f6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M115.98,83.874,116,83.58c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-58.955 -34.278)",
    fill: "#afc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M117.47,83.9c.006-.1.013-.2.017-.3h.32C117.82,83.839,117.7,83.935,117.47,83.9Z",
    transform: "translate(-60.127 -34.294)",
    fill: "#e1e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M332.271,83.891c-.23.032-.348-.062-.335-.3.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3Z",
    transform: "translate(-228.857 -34.286)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M333.455,83.883c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-230.041 -34.278)",
    fill: "#bbcdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M334.949,83.843l-.019-.294.322-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-231.213 -34.247)",
    fill: "#89a97b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M336.445,83.829c0-.1-.009-.2-.015-.3.23-.03.348.064.333.3C336.656,83.833,336.549,83.831,336.445,83.829Z",
    transform: "translate(-232.393 -34.235)",
    fill: "#5c8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M108.814,85.326c-.107,0-.213,0-.318,0-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3Z",
    transform: "translate(-53.066 -35.412)",
    fill: "#668e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M109.982,85.349c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-54.234 -35.435)",
    fill: "#97b289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M111.48,85.392l.019-.292c.107,0,.213,0,.318,0C111.832,85.347,111.715,85.437,111.48,85.392Z",
    transform: "translate(-55.414 -35.474)",
    fill: "#c7d7c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M338.273,85.394c-.235.041-.35-.053-.337-.294h.32A.2.2,0,0,1,338.273,85.394Z",
    transform: "translate(-233.578 -35.474)",
    fill: "#d5dfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M339.457,85.371c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-234.761 -35.451)",
    fill: "#a3bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M340.939,85.341l-.019-.294c.235-.041.35.055.337.3h-.32Z",
    transform: "translate(-235.926 -35.425)",
    fill: "#71965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M104.3,86.84h-.318c-.015-.245.1-.335.335-.294A.2.2,0,0,1,104.3,86.84Z",
    transform: "translate(-49.517 -36.604)",
    fill: "#80a070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M105.48,86.874c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3C105.691,86.881,105.587,86.877,105.48,86.874Z",
    transform: "translate(-50.694 -36.639)",
    fill: "#b1c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M106.98,86.9c.006-.1.013-.2.017-.3h.32C107.33,86.839,107.212,86.935,106.98,86.9Z",
    transform: "translate(-51.874 -36.654)",
    fill: "#e2eade"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M342.771,86.891c-.23.032-.348-.062-.335-.3.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3Z",
    transform: "translate(-237.118 -36.646)",
    fill: "#ecf2eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M343.955,86.883c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-238.302 -36.639)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M345.449,86.843l-.019-.294c.107,0,.213,0,.322-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-239.474 -36.607)",
    fill: "#89a97b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M346.945,86.827c0-.1-.009-.2-.015-.3.23-.032.348.064.333.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-240.654 -36.593)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M383.27,86.507c0,.1.009.207.013.311-.241.023-.345-.087-.313-.328l.3.015Z",
    transform: "translate(-269.003 -36.568)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M98.314,88.324c-.107,0-.213,0-.318,0-.013-.239.1-.335.335-.3A.2.2,0,0,1,98.314,88.324Z",
    transform: "translate(-44.805 -37.77)",
    fill: "#668d53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M99.49,88.349c.006-.1.011-.2.017-.3l.32.009a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-45.981 -37.795)",
    fill: "#98b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M100.98,88.392c.006-.1.013-.2.019-.292.107,0,.213,0,.318,0C101.332,88.347,101.215,88.437,100.98,88.392Z",
    transform: "translate(-47.154 -37.834)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M348.773,88.394c-.235.041-.35-.055-.337-.294h.32A.2.2,0,0,1,348.773,88.394Z",
    transform: "translate(-241.838 -37.834)",
    fill: "#d7e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M349.957,88.371c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.019.294l-.318.006Z",
    transform: "translate(-243.022 -37.811)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M351.439,88.331l-.019-.294c.235-.041.35.055.337.3h-.32Z",
    transform: "translate(-244.186 -37.778)",
    fill: "#739760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M65.04,89.795c0-.107.011-.211.015-.318l.3-.017c.032.239-.066.354-.311.333Z",
    transform: "translate(-18.878 -38.904)",
    fill: "#5d8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M95.447,89.868c-.126,0-.307.049-.307-.151s.181-.145.309-.149a.227.227,0,0,1,0,.3Z",
    transform: "translate(-42.559 -38.986)",
    fill: "#85a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M96.58,89.881v-.3c.1,0,.211,0,.316,0,0,.1,0,.2,0,.3Z",
    transform: "translate(-43.692 -38.999)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M352.959,89.872c0-.094-.006-.188-.009-.281h.313a.187.187,0,0,1,0,.3l.011.015a.222.222,0,0,1-.235.064.142.142,0,0,1-.083-.092Z",
    transform: "translate(-245.39 -39.007)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M354.422,89.857c0-.1,0-.2,0-.3.128,0,.311-.06.311.147S354.55,89.855,354.422,89.857Z",
    transform: "translate(-246.547 -38.977)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M97.985,91.09h.32a.2.2,0,0,1,.017.294C98.085,91.427,97.97,91.333,97.985,91.09Z",
    transform: "translate(-44.796 -40.187)",
    fill: "#83a473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M99.507,91.361c-.006-.1-.013-.2-.017-.294l.318-.006a.2.2,0,0,1,.017.3C99.718,91.357,99.614,91.359,99.507,91.361Z",
    transform: "translate(-45.981 -40.163)",
    fill: "#b3c7a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M101,91.329c-.006-.1-.011-.2-.017-.3.232-.036.348.058.337.3H101Z",
    transform: "translate(-47.154 -40.135)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M348.446,91.333c-.013-.239.1-.333.333-.3a.206.206,0,0,1-.015.3c-.107,0-.213,0-.318,0Z",
    transform: "translate(-241.846 -40.135)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M349.94,91.349c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-243.022 -40.155)",
    fill: "#bfd0b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M351.43,91.243c.006-.1.013-.2.017-.294l.314-.038,0,.045a.2.2,0,0,1-.006.294c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-244.194 -40.045)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M352.93,91.351l.006-.294.324-.017C353.28,91.281,353.169,91.383,352.93,91.351Z",
    transform: "translate(-245.374 -40.147)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M102.5,92.582h.32a.206.206,0,0,1,.015.3c-.23.034-.348-.062-.335-.3Z",
    transform: "translate(-48.346 -41.359)",
    fill: "#678f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M104.015,92.891c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.32.009Z",
    transform: "translate(-49.53 -41.367)",
    fill: "#98b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M105.5,92.841l-.019-.292c.235-.045.354.043.337.29C105.71,92.839,105.6,92.839,105.5,92.841Z",
    transform: "translate(-50.694 -41.325)",
    fill: "#c8d8c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M343.938,92.831c-.011-.241.1-.335.337-.294a.2.2,0,0,1-.017.294Z",
    transform: "translate(-238.299 -41.317)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M345.422,92.874c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-239.466 -41.359)",
    fill: "#a3bc98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M346.92,92.894l.019-.294h.32c.011.241-.1.335-.337.3Z",
    transform: "translate(-240.646 -41.375)",
    fill: "#739760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M108.494,94.1h.318a.2.2,0,0,1,.017.294c-.232.041-.352-.049-.335-.292Z",
    transform: "translate(-53.064 -42.555)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M110.007,94.371c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-54.242 -42.531)",
    fill: "#adc3a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M111.5,94.331c-.006-.1-.013-.2-.017-.294.235-.041.348.055.337.3h-.32Z",
    transform: "translate(-55.414 -42.498)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M337.946,94.328c-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3C338.16,94.326,338.053,94.326,337.946,94.328Z",
    transform: "translate(-233.585 -42.493)",
    fill: "#e9efe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M339.432,94.349c0-.1.011-.2.015-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-234.753 -42.515)",
    fill: "#b9cbb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M340.93,94.384l.019-.294c.107,0,.211,0,.318,0a.209.209,0,0,1-.013.3l-.322-.009Z",
    transform: "translate(-235.933 -42.547)",
    fill: "#86a778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M342.44,94.385l.013-.3c.107,0,.213,0,.32,0C342.788,94.319,342.672,94.415,342.44,94.385Z",
    transform: "translate(-237.121 -42.539)",
    fill: "#5b8446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M113,95.59c.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3C113.1,95.923,112.98,95.827,113,95.59Z",
    transform: "translate(-56.606 -43.727)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M114.5,95.891c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-57.783 -43.727)",
    fill: "#92ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M115.989,95.843l-.019-.294.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-58.947 -43.688)",
    fill: "#c1d2ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M117.495,95.827c0-.1-.011-.2-.015-.3.23-.032.348.064.335.3-.107,0-.213,0-.318,0Z",
    transform: "translate(-60.135 -43.674)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M333.445,95.837c-.015-.245.1-.333.337-.292a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-230.044 -43.684)",
    fill: "#cddac7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M334.94,95.874c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3C335.151,95.881,335.044,95.877,334.94,95.874Z",
    transform: "translate(-231.221 -43.719)",
    fill: "#9cb68f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M336.43,95.9c.006-.1.011-.2.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-232.393 -43.735)",
    fill: "#6d935a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M60.54,97.295c0-.107.011-.211.015-.318l.3-.017c.032.239-.066.354-.311.333Z",
    transform: "translate(-15.337 -44.805)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M118.987,97.1h.32a.2.2,0,0,1,.017.294C119.092,97.433,118.977,97.339,118.987,97.1Z",
    transform: "translate(-61.32 -44.915)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M120.5,97.379c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-62.495 -44.899)",
    fill: "#a5bd9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M121.989,97.328l-.019-.294c.235-.043.35.053.339.294Z",
    transform: "translate(-63.667 -44.855)",
    fill: "#d8e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M327.442,97.331c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3h-.32Z",
    transform: "translate(-225.32 -44.856)",
    fill: "#e2eadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M328.94,97.357c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-226.5 -44.884)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M330.43,97.392c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C330.782,97.347,330.665,97.437,330.43,97.392Z",
    transform: "translate(-227.673 -44.915)",
    fill: "#81a171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M374.244,97.332h-.326c-.011-.235.1-.335.333-.294A.2.2,0,0,1,374.244,97.332Z",
    transform: "translate(-261.886 -44.859)",
    fill: "#7a9c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M375.45,97.334l.006-.294c.256-.043.341.081.309.318l-.316-.026Z",
    transform: "translate(-263.092 -44.861)",
    fill: "#89a87b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M74.039,98.572c.1,0,.209,0,.313,0,.019.235-.1.324-.322.3,0-.1,0-.2.006-.309Z",
    transform: "translate(-25.951 -46.072)",
    fill: "#ebf1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M230.077,53.84h-.318a.2.2,0,0,1-.017-.294c.232-.041.352.049.335.292Z",
    transform: "translate(-148.413 -10.641)",
    fill: "#7d9f6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M78.829,98.892c-.232.04-.352-.049-.335-.292h.318a.2.2,0,0,1,.017.294Z",
    transform: "translate(-29.462 -46.095)",
    fill: "#d0ddca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M80.007,98.861c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-30.64 -46.064)",
    fill: "#9fb993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M81.5,98.834c-.006-.1-.011-.2-.017-.294.235-.038.348.058.337.3H81.5Z",
    transform: "translate(-31.812 -46.041)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M123.5,98.58c.107,0,.213,0,.32,0a.2.2,0,0,1,.013.3C123.6,98.913,123.484,98.817,123.5,98.58Z",
    transform: "translate(-64.868 -46.079)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M125,98.893l-.013-.3c.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.008Z",
    transform: "translate(-66.043 -46.087)",
    fill: "#89a97b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M126.489,98.861l-.019-.294.32-.006a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-67.208 -46.064)",
    fill: "#bbcdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M127.987,98.824c-.006-.1-.011-.2-.017-.3.232-.034.348.062.335.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-68.388 -46.031)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M322.934,98.831c-.017-.247.1-.333.337-.29a.2.2,0,0,1-.017.294C323.147,98.836,323.041,98.833,322.934,98.831Z",
    transform: "translate(-221.774 -46.041)",
    fill: "#c6d6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M324.432,98.874c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3l-.32-.006Z",
    transform: "translate(-222.952 -46.079)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M325.93,98.889c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-224.132 -46.087)",
    fill: "#668e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M368.256,98.826c-.107,0-.213,0-.32,0-.013-.239.1-.333.335-.3A.206.206,0,0,1,368.256,98.826Z",
    transform: "translate(-257.18 -46.033)",
    fill: "#658c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M369.432,98.849c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-258.356 -46.056)",
    fill: "#95b186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M370.92,98.884l.019-.294c.107,0,.211,0,.318,0a.207.207,0,0,1-.015.3Z",
    transform: "translate(-259.528 -46.087)",
    fill: "#c5d5bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M372.43,98.885c0-.1.009-.2.015-.3.107,0,.213,0,.318,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-260.716 -46.079)",
    fill: "#f5f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M228.565,53.59c.006.1.013.2.017.294-.107,0-.215,0-.322.009a.206.206,0,0,1-.013-.3c.1,0,.211,0,.316,0Z",
    transform: "translate(-147.235 -10.684)",
    fill: "#afc4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M376.971,98.832c0-.1-.009-.2-.011-.3.249-.026.35.087.313.331A.208.208,0,0,1,376.971,98.832Z",
    transform: "translate(-264.28 -46.035)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M72.831,99.973c.051.243-.049.356-.3.339C72.485,100.068,72.581,99.953,72.831,99.973Z",
    transform: "translate(-24.764 -47.173)",
    fill: "#adc3a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M83.331,100.391c-.23.032-.348-.062-.335-.3.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3Z",
    transform: "translate(-33.004 -47.267)",
    fill: "#ecf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M84.515,100.383c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294Z",
    transform: "translate(-34.188 -47.26)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M86.007,100.343c-.006-.1-.013-.2-.017-.294l.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-35.36 -47.228)",
    fill: "#8baa7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M87.5,100.327c0-.1-.011-.2-.015-.3.23-.032.348.064.333.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-36.54 -47.214)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M129.488,100.09h.32a.2.2,0,0,1,.017.3C129.592,100.423,129.477,100.329,129.488,100.09Z",
    transform: "translate(-69.581 -47.267)",
    fill: "#6f945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M131,100.381c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-70.756 -47.26)",
    fill: "#9eb893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M132.489,100.327l-.019-.294c.232-.043.352.047.337.292h-.318Z",
    transform: "translate(-71.928 -47.214)",
    fill: "#d0dcca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M316.937,100.336c-.011-.239.1-.335.337-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-217.057 -47.221)",
    fill: "#dce5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M318.432,100.356c.006-.1.011-.2.017-.3l.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-218.232 -47.244)",
    fill: "#aac19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M319.93,100.384l.019-.294h.318c.015.243-.1.335-.335.292Z",
    transform: "translate(-219.412 -47.267)",
    fill: "#7a9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M363.753,100.34c-.107,0-.211,0-.318,0-.015-.243.1-.333.335-.292A.2.2,0,0,1,363.753,100.34Z",
    transform: "translate(-253.639 -47.225)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M364.93,100.374c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3C365.141,100.381,365.037,100.376,364.93,100.374Z",
    transform: "translate(-254.815 -47.26)",
    fill: "#b0c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M366.42,100.4c.006-.1.013-.2.017-.3h.32C366.77,100.339,366.652,100.435,366.42,100.4Z",
    transform: "translate(-255.988 -47.275)",
    fill: "#e2e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M376.972,99.97l.3.026v.311c-.245.017-.343-.1-.3-.337Z",
    transform: "translate(-264.282 -47.173)",
    fill: "#d5dfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M71.342,101.5c0,.1,0,.207-.006.309a.208.208,0,0,1-.3.026c-.036-.239.062-.354.307-.335Z",
    transform: "translate(-23.587 -48.377)",
    fill: "#6c9259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M89.324,101.894c-.232.041-.348-.055-.337-.294h.32A.2.2,0,0,1,89.324,101.894Z",
    transform: "translate(-37.718 -48.455)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M90.507,101.879c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-38.901 -48.44)",
    fill: "#a7be9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M91.989,101.831l-.019-.294c.235-.041.35.053.337.294h-.318Z",
    transform: "translate(-40.065 -48.398)",
    fill: "#769a65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M135.485,101.6c.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.232.043-.352-.045-.337-.29Z",
    transform: "translate(-74.3 -48.455)",
    fill: "#84a374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M136.989,101.861l-.019-.294.318-.006a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-75.469 -48.424)",
    fill: "#b4c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M138.487,101.829c-.006-.1-.011-.2-.017-.3.232-.036.348.058.337.3h-.32Z",
    transform: "translate(-76.649 -48.396)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M310.946,101.823c-.013-.239.1-.333.333-.3a.206.206,0,0,1-.015.3c-.107,0-.213,0-.318,0Z",
    transform: "translate(-212.343 -48.388)",
    fill: "#f0f4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M312.45,101.849c0-.1.011-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-213.527 -48.416)",
    fill: "#c0d0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M313.94,101.874l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-214.699 -48.44)",
    fill: "#8fac7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M315.44,101.883c0-.1.011-.2.015-.3l.32,0C315.788,101.819,315.672,101.915,315.44,101.883Z",
    transform: "translate(-215.879 -48.44)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M357.756,101.821h-.32c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-248.919 -48.389)",
    fill: "#6c9259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M358.94,101.856c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C359.151,101.861,359.047,101.859,358.94,101.856Z",
    transform: "translate(-250.103 -48.424)",
    fill: "#9cb68f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M360.42,101.892c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C360.772,101.847,360.655,101.937,360.42,101.892Z",
    transform: "translate(-251.267 -48.455)",
    fill: "#cddbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M378.5,101.8c0-.1,0-.209,0-.313.245-.017.345.1.3.337A.208.208,0,0,1,378.5,101.8Z",
    transform: "translate(-265.492 -48.363)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M392.265,101.485c.006.107.011.211.017.318-.245.021-.345-.094-.313-.333l.3.017Z",
    transform: "translate(-276.083 -48.353)",
    fill: "#5c8546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M71.07,103l.3-.026c.041.241-.058.354-.3.337Z",
    transform: "translate(-23.622 -49.533)",
    fill: "#cedbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M93.828,103.383c-.23.03-.348-.064-.333-.3.107,0,.213,0,.318,0A.206.206,0,0,1,93.828,103.383Z",
    transform: "translate(-41.264 -49.62)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M95,103.391c0-.1-.009-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-42.441 -49.628)",
    fill: "#c2d3bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M96.5,103.343l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-43.613 -49.588)",
    fill: "#92ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M98,103.324c0-.1-.011-.2-.015-.3.232-.034.348.062.335.3C98.218,103.326,98.112,103.326,98,103.324Z",
    transform: "translate(-44.801 -49.571)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M139.99,103.082h.32a.206.206,0,0,1,.017.3c-.23.034-.348-.06-.335-.3Z",
    transform: "translate(-77.845 -49.62)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M141.5,103.389c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.32.009Z",
    transform: "translate(-79.017 -49.628)",
    fill: "#99b48b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M142.989,103.341l-.019-.292c.235-.045.354.045.337.29C143.2,103.339,143.094,103.339,142.989,103.341Z",
    transform: "translate(-80.189 -49.587)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M306.437,103.331c-.011-.241.1-.335.337-.294a.2.2,0,0,1-.017.294Z",
    transform: "translate(-208.796 -49.578)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M307.932,103.364c.006-.1.011-.2.017-.294.107,0,.213,0,.318,0a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-209.971 -49.612)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M309.43,103.394l.019-.294h.32c.011.241-.1.335-.337.3Z",
    transform: "translate(-211.151 -49.635)",
    fill: "#739861"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M351.755,103.323l-.32,0c-.015-.239.1-.333.331-.3a.207.207,0,0,1-.013.3Z",
    transform: "translate(-244.197 -49.571)",
    fill: "#5b8546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M352.94,103.341l.013-.3.324.009a.2.2,0,0,1-.019.294c-.1,0-.211,0-.316,0Z",
    transform: "translate(-245.382 -49.588)",
    fill: "#86a676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M354.43,103.374l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-246.555 -49.62)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M355.93,103.389c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-247.735 -49.628)",
    fill: "#e9efe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M378.476,102.96c.1.009.2.017.3.023,0,.1.006.207.009.309C378.54,103.314,378.442,103.2,378.476,102.96Z",
    transform: "translate(-265.467 -49.525)",
    fill: "#edf3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M56.05,104.795c0-.107.011-.211.015-.318l.3-.017C56.393,104.7,56.3,104.814,56.05,104.795Z",
    transform: "translate(-11.805 -50.705)",
    fill: "#5f884b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M69.838,104.494v.311a.207.207,0,0,1-.3.026c-.043-.241.058-.354.3-.337Z",
    transform: "translate(-22.407 -50.731)",
    fill: "#89a77a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M99.824,104.886c-.232.038-.348-.058-.337-.3h.32A.2.2,0,0,1,99.824,104.886Z",
    transform: "translate(-45.979 -50.808)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M101.007,104.871c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-47.161 -50.792)",
    fill: "#aec4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M102.489,104.827l-.019-.294c.232-.043.352.047.337.292h-.318Z",
    transform: "translate(-48.326 -50.754)",
    fill: "#7d9e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M145.984,104.6h.318a.2.2,0,0,1,.017.294c-.232.041-.352-.049-.335-.292Z",
    transform: "translate(-82.559 -50.816)",
    fill: "#7d9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M147.5,104.861c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-83.737 -50.784)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M148.987,104.832c-.006-.1-.013-.2-.017-.294.235-.041.348.058.337.3h-.32Z",
    transform: "translate(-84.91 -50.759)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M300.447,104.828c-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3c-.107,0-.213,0-.318,0Z",
    transform: "translate(-204.082 -50.754)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M301.942,104.849c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-205.258 -50.776)",
    fill: "#b9cbb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M303.44,104.884l.019-.294c.107,0,.211,0,.318,0a.206.206,0,0,1-.013.3l-.322-.009Z",
    transform: "translate(-206.438 -50.808)",
    fill: "#87a679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M304.95,104.893c0-.1.009-.2.013-.3.107,0,.213,0,.32,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-207.626 -50.808)",
    fill: "#5b8545"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M347.257,104.826h-.32c-.011-.239.1-.335.337-.3A.2.2,0,0,1,347.257,104.826Z",
    transform: "translate(-240.659 -50.754)",
    fill: "#739760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M348.44,104.856c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.294C348.651,104.861,348.547,104.859,348.44,104.856Z",
    transform: "translate(-241.842 -50.784)",
    fill: "#a3bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M349.92,104.884l.019-.294h.32c.011.241-.1.337-.339.292Z",
    transform: "translate(-243.006 -50.808)",
    fill: "#d4dfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M380.278,104.8c-.247.017-.348-.094-.3-.339C380.232,104.443,380.328,104.558,380.278,104.8Z",
    transform: "translate(-266.647 -50.706)",
    fill: "#afc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M69.549,105.986l.3-.026c.034.239-.064.356-.311.335l.006-.309Z",
    transform: "translate(-22.418 -51.886)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M105.822,106.392c-.232.043-.352-.045-.337-.29.107,0,.213,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-50.697 -51.996)",
    fill: "#cad9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M107.007,106.361c-.006-.1-.013-.2-.017-.294l.318-.006a.2.2,0,0,1,.017.3C107.218,106.356,107.114,106.359,107.007,106.361Z",
    transform: "translate(-51.882 -51.964)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M108.5,106.329c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3h-.32Z",
    transform: "translate(-53.054 -51.937)",
    fill: "#6a9056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M150.485,106.09c.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3C150.588,106.423,150.47,106.327,150.485,106.09Z",
    transform: "translate(-86.101 -51.988)",
    fill: "#628a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M151.995,106.383c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-87.278 -51.98)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M153.489,106.343l-.019-.294.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-88.45 -51.949)",
    fill: "#c2d2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M154.985,106.327c0-.1-.011-.2-.015-.3.23-.032.348.064.333.3C155.2,106.331,155.089,106.329,154.985,106.327Z",
    transform: "translate(-89.63 -51.934)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M295.942,106.327c-.017-.245.1-.333.335-.292a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-200.538 -51.937)",
    fill: "#cfdcc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M297.44,106.374l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3c-.107,0-.213,0-.318-.006Z",
    transform: "translate(-201.718 -51.98)",
    fill: "#9db790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M298.94,106.386c.006-.1.011-.2.017-.3h.32C299.29,106.329,299.175,106.425,298.94,106.386Z",
    transform: "translate(-202.898 -51.988)",
    fill: "#6e935b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M341.263,106.329c-.107,0-.213,0-.318,0-.015-.239.1-.333.333-.3A.206.206,0,0,1,341.263,106.329Z",
    transform: "translate(-235.945 -51.937)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M342.44,106.349c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-237.121 -51.956)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M343.93,106.374l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.32-.009Z",
    transform: "translate(-238.294 -51.98)",
    fill: "#bfd1b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M345.422,106.391c0-.1.011-.2.015-.3.107,0,.213,0,.318,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-239.466 -51.988)",
    fill: "#f0f4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M381.494,106.312c0-.1,0-.207,0-.309.245-.019.343.1.307.335A.208.208,0,0,1,381.494,106.312Z",
    transform: "translate(-267.844 -51.917)",
    fill: "#6e935b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M68.341,107.472c.049.243-.049.356-.3.339C68,107.568,68.091,107.453,68.341,107.472Z",
    transform: "translate(-21.232 -53.074)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M110.321,107.889c-.232.034-.348-.06-.335-.3h.32a.206.206,0,0,1,.017.3Z",
    transform: "translate(-54.239 -53.168)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M111.5,107.881c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C111.71,107.874,111.6,107.876,111.5,107.881Z",
    transform: "translate(-55.414 -53.16)",
    fill: "#b6c9ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M112.989,107.831c-.006-.1-.013-.2-.019-.292.232-.045.354.043.337.29C113.2,107.829,113.094,107.829,112.989,107.831Z",
    transform: "translate(-56.587 -53.119)",
    fill: "#85a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M156.478,107.6h.32a.2.2,0,0,1,.017.294C156.582,107.935,156.467,107.839,156.478,107.6Z",
    transform: "translate(-90.816 -53.176)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M158,107.879c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-91.998 -53.16)",
    fill: "#a6be9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M159.479,107.828l-.019-.294c.235-.043.35.053.339.294Z",
    transform: "translate(-93.163 -53.116)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M289.942,107.831c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3h-.32Z",
    transform: "translate(-195.817 -53.117)",
    fill: "#e3eae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M291.45,107.856c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C291.661,107.861,291.557,107.859,291.45,107.856Z",
    transform: "translate(-197.005 -53.144)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M292.94,107.892c.006-.1.013-.2.019-.292h.318c.015.245-.1.335-.337.29Z",
    transform: "translate(-198.177 -53.176)",
    fill: "#82a372"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M336.757,107.831h-.32c-.011-.241.1-.335.337-.294A.2.2,0,0,1,336.757,107.831Z",
    transform: "translate(-232.398 -53.119)",
    fill: "#7b9d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M337.932,107.864c.006-.1.011-.2.017-.294.107,0,.213,0,.318,0a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-233.573 -53.152)",
    fill: "#aac19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M339.43,107.894l.019-.294h.32c.011.241-.1.337-.337.294Z",
    transform: "translate(-234.753 -53.176)",
    fill: "#dbe4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M381.477,107.46l.3.026v.311C381.535,107.814,381.437,107.7,381.477,107.46Z",
    transform: "translate(-267.827 -53.066)",
    fill: "#d3decc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M66.853,109c0,.1,0,.207-.006.309a.208.208,0,0,1-.3.026C66.507,109.1,66.607,108.983,66.853,109Z",
    transform: "translate(-20.055 -54.278)",
    fill: "#699055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M116.329,109.392c-.232.041-.352-.049-.335-.292h.318a.2.2,0,0,1,.017.294Z",
    transform: "translate(-58.965 -54.356)",
    fill: "#d2decb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M117.507,109.361c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-60.143 -54.324)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M119,109.334c-.006-.1-.013-.2-.017-.294.235-.038.348.058.337.3H119Z",
    transform: "translate(-61.315 -54.302)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M160.986,109.08c.107,0,.213,0,.32,0a.2.2,0,0,1,.013.3C161.089,109.413,160.974,109.317,160.986,109.08Z",
    transform: "translate(-94.363 -54.34)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M162.493,109.391c0-.1-.009-.2-.013-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-95.538 -54.348)",
    fill: "#8aa97c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M163.989,109.343l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3C164.2,109.339,164.1,109.341,163.989,109.343Z",
    transform: "translate(-96.711 -54.309)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M165.477,109.324c-.006-.1-.011-.2-.017-.3.232-.034.348.062.335.3C165.688,109.326,165.582,109.326,165.477,109.324Z",
    transform: "translate(-97.883 -54.292)",
    fill: "#ecf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M283.955,109.328c-.015-.239.1-.333.331-.3a.207.207,0,0,1-.013.3Z",
    transform: "translate(-191.108 -54.291)",
    fill: "#f5f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M285.452,109.341l.013-.3.322.009a.2.2,0,0,1-.019.294h-.318Z",
    transform: "translate(-192.285 -54.309)",
    fill: "#c7d7c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M286.94,109.374l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-193.457 -54.34)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M288.44,109.389c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-194.637 -54.348)",
    fill: "#668e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M330.756,109.326c-.107,0-.213,0-.32,0-.013-.239.1-.333.335-.3A.206.206,0,0,1,330.756,109.326Z",
    transform: "translate(-227.677 -54.294)",
    fill: "#658d51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M331.932,109.349c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-228.853 -54.317)",
    fill: "#96b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M333.43,109.374l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-230.033 -54.34)",
    fill: "#c6d6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M334.94,109.383c0-.1.009-.2.015-.3l.318,0c.015.239-.1.335-.333.3Z",
    transform: "translate(-231.221 -54.34)",
    fill: "#f5f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M383,109.3c0-.1,0-.209,0-.313.245-.017.345.1.3.337A.208.208,0,0,1,383,109.3Z",
    transform: "translate(-269.032 -54.263)",
    fill: "#8cab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M396.763,108.985c0,.107.011.211.015.318-.245.021-.345-.094-.311-.333l.3.017Z",
    transform: "translate(-279.621 -54.254)",
    fill: "#5d8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M66.57,110.486l.3-.026c.041.241-.058.354-.3.337Z",
    transform: "translate(-20.082 -55.426)",
    fill: "#ccdac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M120.821,110.891c-.23.032-.348-.062-.335-.3.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3Z",
    transform: "translate(-62.499 -55.528)",
    fill: "#edf2eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M122,110.883c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294Z",
    transform: "translate(-63.683 -55.52)",
    fill: "#bcceb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M123.5,110.843c-.006-.1-.013-.2-.017-.294l.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-64.855 -55.489)",
    fill: "#8caa7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M124.995,110.827c0-.1-.011-.2-.015-.3.23-.032.348.064.333.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-66.035 -55.475)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M166.978,110.59h.32a.2.2,0,0,1,.017.3C167.082,110.923,166.967,110.829,166.978,110.59Z",
    transform: "translate(-99.076 -55.528)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M168.487,110.871c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-100.251 -55.512)",
    fill: "#9fb993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M169.979,110.827l-.019-.294c.232-.043.352.047.337.292h-.318Z",
    transform: "translate(-101.423 -55.475)",
    fill: "#d1deca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M279.448,110.826c-.011-.239.1-.335.337-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-187.562 -55.474)",
    fill: "#dde5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M280.942,110.856c.006-.1.011-.2.017-.3l.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-188.737 -55.505)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M282.44,110.884l.019-.294h.32c.011.241-.1.337-.339.292Z",
    transform: "translate(-189.917 -55.528)",
    fill: "#7b9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M326.263,110.829h-.318c-.015-.247.1-.335.335-.294A.2.2,0,0,1,326.263,110.829Z",
    transform: "translate(-224.143 -55.477)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M327.44,110.864c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-225.32 -55.512)",
    fill: "#b1c6a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M328.93,110.886c.006-.1.013-.2.017-.3h.32C329.28,110.829,329.162,110.925,328.93,110.886Z",
    transform: "translate(-226.493 -55.528)",
    fill: "#e2eade"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M382.976,110.46c.1.009.2.017.3.023,0,.1.006.207.009.309C383.04,110.814,382.942,110.7,382.976,110.46Z",
    transform: "translate(-269.008 -55.426)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M51.55,112.295c0-.107.009-.211.015-.318l.3-.017C51.9,112.2,51.8,112.316,51.55,112.295Z",
    transform: "translate(-8.265 -56.606)",
    fill: "#60884b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M65.338,111.994v.311a.207.207,0,0,1-.3.026C64.992,112.09,65.092,111.977,65.338,111.994Z",
    transform: "translate(-18.866 -56.631)",
    fill: "#86a577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M126.814,112.394c-.232.041-.348-.055-.337-.294h.32A.2.2,0,0,1,126.814,112.394Z",
    transform: "translate(-67.213 -56.716)",
    fill: "#d9e3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M128,112.379c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318.006Z",
    transform: "translate(-68.396 -56.7)",
    fill: "#a6be9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M129.5,112.328c-.006-.1-.013-.2-.017-.294.235-.043.35.053.337.294Z",
    transform: "translate(-69.576 -56.656)",
    fill: "#779b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M172.974,112.094c.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294C173.079,112.427,172.957,112.34,172.974,112.094Z",
    transform: "translate(-103.793 -56.708)",
    fill: "#83a473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M174.479,112.361l-.019-.294.318-.006a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-104.964 -56.685)",
    fill: "#b5c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M175.977,112.329c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3h-.32Z",
    transform: "translate(-106.144 -56.657)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M273.455,112.323c-.015-.239.1-.333.333-.3a.206.206,0,0,1-.015.3C273.666,112.319,273.56,112.321,273.455,112.323Z",
    transform: "translate(-182.847 -56.649)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M274.96,112.349c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-184.032 -56.677)",
    fill: "#c0d1b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M276.44,112.374l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-185.196 -56.7)",
    fill: "#8fad80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M277.95,112.383c0-.1.011-.2.015-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-186.384 -56.7)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M320.256,112.329h-.32c-.013-.237.1-.333.335-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-219.416 -56.657)",
    fill: "#6d935a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M321.44,112.356c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-220.6 -56.685)",
    fill: "#9cb68f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M322.93,112.392c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C323.282,112.347,323.165,112.437,322.93,112.392Z",
    transform: "translate(-221.772 -56.716)",
    fill: "#cddac7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M384.778,112.3c-.247.017-.348-.094-.3-.339C384.732,111.94,384.828,112.057,384.778,112.3Z",
    transform: "translate(-270.188 -56.605)",
    fill: "#afc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M65.056,113.486l.3-.026c.034.239-.064.356-.309.335Z",
    transform: "translate(-18.886 -57.786)",
    fill: "#e8efe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M131.318,113.883c-.23.03-.348-.066-.333-.3.107,0,.213,0,.318,0a.207.207,0,0,1,.013.3Z",
    transform: "translate(-70.759 -57.881)",
    fill: "#f3f6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M132.5,113.883l-.013-.3c.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-71.944 -57.881)",
    fill: "#c3d3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M133.989,113.851l-.019-.294.32-.006a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-73.108 -57.857)",
    fill: "#93af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M135.495,113.824c0-.1-.011-.2-.015-.3.232-.034.348.062.335.3C135.708,113.826,135.6,113.826,135.495,113.824Z",
    transform: "translate(-74.296 -57.832)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M177.48,113.582h.32a.206.206,0,0,1,.017.3c-.232.034-.348-.06-.335-.3Z",
    transform: "translate(-107.34 -57.881)",
    fill: "#699055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M178.987,113.889c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292c-.107,0-.213,0-.32.009Z",
    transform: "translate(-108.512 -57.888)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M180.479,113.831l-.019-.292c.235-.045.352.045.337.29C180.69,113.829,180.584,113.829,180.479,113.831Z",
    transform: "translate(-109.684 -57.84)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M268.948,113.831c-.011-.241.1-.335.337-.294a.2.2,0,0,1-.017.294Z",
    transform: "translate(-179.301 -57.839)",
    fill: "#d6e0d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M270.45,113.864c.006-.1.013-.2.017-.294.107,0,.211,0,.318.006a.2.2,0,0,1-.017.294C270.661,113.871,270.557,113.866,270.45,113.864Z",
    transform: "translate(-180.484 -57.873)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M271.94,113.894c.006-.1.013-.2.017-.294h.32C272.288,113.839,272.175,113.937,271.94,113.894Z",
    transform: "translate(-181.656 -57.896)",
    fill: "#749862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M314.273,113.823c-.107,0-.213,0-.318,0-.015-.239.1-.333.331-.3A.207.207,0,0,1,314.273,113.823Z",
    transform: "translate(-214.71 -57.832)",
    fill: "#5b8446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M315.442,113.841l.013-.3.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-215.879 -57.849)",
    fill: "#87a779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M316.94,113.874l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-217.059 -57.881)",
    fill: "#b9cbb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M318.43,113.889c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-218.232 -57.888)",
    fill: "#e9efe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M385.994,113.812c0-.1,0-.207,0-.309.245-.019.343.1.307.335A.208.208,0,0,1,385.994,113.812Z",
    transform: "translate(-271.384 -57.818)",
    fill: "#6e935b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M63.841,114.974c.049.243-.049.356-.3.339C63.5,115.07,63.594,114.957,63.841,114.974Z",
    transform: "translate(-17.692 -58.976)",
    fill: "#a6be9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M137.314,115.386c-.232.038-.348-.058-.337-.3h.32A.2.2,0,0,1,137.314,115.386Z",
    transform: "translate(-75.474 -59.069)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M138.5,115.371c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-76.657 -59.053)",
    fill: "#b0c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M139.989,115.327l-.019-.294c.232-.043.352.047.337.292h-.318Z",
    transform: "translate(-77.829 -59.015)",
    fill: "#7e9f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M183.474,115.1h.318a.2.2,0,0,1,.017.294c-.232.041-.352-.049-.335-.292Z",
    transform: "translate(-112.054 -59.076)",
    fill: "#7d9f6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M184.987,115.361c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-113.232 -59.045)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M186.477,115.334c-.006-.1-.013-.2-.017-.294.235-.038.35.058.337.3h-.32Z",
    transform: "translate(-114.405 -59.023)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M262.956,115.328c-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3C263.17,115.326,263.063,115.326,262.956,115.328Z",
    transform: "translate(-174.587 -59.015)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M264.452,115.349c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-175.763 -59.037)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M265.95,115.374l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-176.943 -59.061)",
    fill: "#89a87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M267.45,115.383c0-.1.009-.2.015-.3.107,0,.213,0,.32,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-178.123 -59.061)",
    fill: "#5c8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M309.757,115.326h-.32c-.011-.239.1-.335.337-.3A.2.2,0,0,1,309.757,115.326Z",
    transform: "translate(-211.156 -59.015)",
    fill: "#739861"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M310.932,115.356c.006-.1.011-.2.017-.3l.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-212.331 -59.045)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M312.43,115.384l.019-.294h.32C312.78,115.331,312.667,115.427,312.43,115.384Z",
    transform: "translate(-213.511 -59.069)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M385.977,114.96l.3.026v.311C386.035,115.314,385.937,115.2,385.977,114.96Z",
    transform: "translate(-271.367 -58.966)",
    fill: "#d1deca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M62.355,116.5l-.006.309a.21.21,0,0,1-.3.026C62.012,116.6,62.11,116.483,62.355,116.5Z",
    transform: "translate(-16.517 -60.178)",
    fill: "#678f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M143.312,116.884c-.232.043-.352-.045-.337-.29.107,0,.211,0,.318,0A.2.2,0,0,1,143.312,116.884Z",
    transform: "translate(-80.192 -60.249)",
    fill: "#cad9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M144.489,116.861l-.019-.294.32-.006a.2.2,0,0,1,.017.3C144.7,116.856,144.6,116.859,144.489,116.861Z",
    transform: "translate(-81.369 -60.225)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M145.987,116.829c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3h-.32Z",
    transform: "translate(-82.549 -60.198)",
    fill: "#6a9157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1644",
    "data-name": "Path 1644",
    d: "M187.98,116.58h.32a.209.209,0,0,1,.015.3c-.23.032-.348-.064-.333-.3Z",
    transform: "translate(-115.601 -60.241)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1645",
    "data-name": "Path 1645",
    d: "M189.485,116.883c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-116.773 -60.241)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1646",
    "data-name": "Path 1646",
    d: "M190.979,116.843l-.019-.294.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-117.945 -60.209)",
    fill: "#c3d3bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1647",
    "data-name": "Path 1647",
    d: "M192.485,116.827c0-.1-.011-.2-.015-.3.23-.032.348.064.333.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-119.133 -60.195)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1648",
    "data-name": "Path 1648",
    d: "M258.455,116.827c-.015-.245.1-.333.335-.292a.2.2,0,0,1-.017.294C258.666,116.829,258.562,116.829,258.455,116.827Z",
    transform: "translate(-171.046 -60.198)",
    fill: "#cfdcc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1649",
    "data-name": "Path 1649",
    d: "M259.95,116.864c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3C260.161,116.871,260.055,116.866,259.95,116.864Z",
    transform: "translate(-172.223 -60.233)",
    fill: "#9eb791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1650",
    "data-name": "Path 1650",
    d: "M261.44,116.886c.006-.1.011-.2.017-.3h.32C261.79,116.829,261.675,116.925,261.44,116.886Z",
    transform: "translate(-173.395 -60.249)",
    fill: "#6e945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M303.766,116.829c-.107,0-.213,0-.32,0-.013-.239.1-.333.333-.3a.2.2,0,0,1-.015.3Z",
    transform: "translate(-206.443 -60.197)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M304.95,116.849c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-207.626 -60.217)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M306.44,116.874l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.32-.009Z",
    transform: "translate(-208.799 -60.241)",
    fill: "#c0d0b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M307.932,116.883c0-.1.011-.2.015-.3.107,0,.213,0,.318,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-209.971 -60.241)",
    fill: "#f0f4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M387.5,116.8v-.313c.247-.017.345.1.3.337A.208.208,0,0,1,387.5,116.8Z",
    transform: "translate(-272.572 -60.164)",
    fill: "#8aa97c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M401.263,116.485c0,.107.011.211.015.318-.245.021-.345-.094-.311-.333l.3.017Z",
    transform: "translate(-283.162 -60.154)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M62.07,117.986l.3-.026c.043.241-.058.354-.3.337Z",
    transform: "translate(-16.541 -61.327)",
    fill: "#cad9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1658",
    "data-name": "Path 1658",
    d: "M147.821,118.389c-.232.034-.348-.06-.335-.3h.32a.208.208,0,0,1,.017.3Z",
    transform: "translate(-83.742 -61.429)",
    fill: "#e7ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1659",
    "data-name": "Path 1659",
    d: "M149,118.381c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C149.21,118.374,149.1,118.376,149,118.381Z",
    transform: "translate(-84.917 -61.421)",
    fill: "#b6c9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1660",
    "data-name": "Path 1660",
    d: "M150.489,118.331c-.006-.1-.013-.2-.019-.292.232-.045.354.043.337.29-.107,0-.213,0-.318,0Z",
    transform: "translate(-86.09 -61.379)",
    fill: "#85a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1661",
    "data-name": "Path 1661",
    d: "M193.968,118.09h.32a.2.2,0,0,1,.017.294C194.072,118.425,193.957,118.329,193.968,118.09Z",
    transform: "translate(-120.311 -61.429)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M195.487,118.379c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-121.493 -61.421)",
    fill: "#a7be9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M196.969,118.328l-.019-.294c.235-.043.35.053.339.294Z",
    transform: "translate(-122.658 -61.377)",
    fill: "#d9e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M252.452,118.321c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3h-.32Z",
    transform: "translate(-166.322 -61.37)",
    fill: "#e4ebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M253.96,118.356c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C254.171,118.361,254.067,118.359,253.96,118.356Z",
    transform: "translate(-167.51 -61.405)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1666",
    "data-name": "Path 1666",
    d: "M255.45,118.382c.006-.1.013-.2.019-.292h.318c.015.245-.1.335-.337.29Z",
    transform: "translate(-168.682 -61.429)",
    fill: "#82a273"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1667",
    "data-name": "Path 1667",
    d: "M299.267,118.331h-.32c-.011-.241.1-.335.337-.294A.2.2,0,0,1,299.267,118.331Z",
    transform: "translate(-202.903 -61.379)",
    fill: "#7b9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1668",
    "data-name": "Path 1668",
    d: "M300.442,118.364c.006-.1.011-.2.017-.294.107,0,.213,0,.318,0a.2.2,0,0,1-.019.294l-.318-.006Z",
    transform: "translate(-204.078 -61.413)",
    fill: "#aac19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1669",
    "data-name": "Path 1669",
    d: "M301.93,118.394l.019-.294h.32c.011.241-.1.337-.337.3Z",
    transform: "translate(-205.25 -61.437)",
    fill: "#dce5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1670",
    "data-name": "Path 1670",
    d: "M387.476,117.952c.1.009.2.017.3.023,0,.1,0,.207.009.309-.247.021-.345-.094-.311-.335Z",
    transform: "translate(-272.548 -61.319)",
    fill: "#ebf1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1671",
    "data-name": "Path 1671",
    d: "M47.042,119.795l.013-.318.3-.017c.034.239-.064.354-.311.335Z",
    transform: "translate(-4.716 -62.507)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1672",
    "data-name": "Path 1672",
    d: "M60.848,119.494v.311a.207.207,0,0,1-.3.026C60.5,119.59,60.6,119.477,60.848,119.494Z",
    transform: "translate(-15.334 -62.532)",
    fill: "#84a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1673",
    "data-name": "Path 1673",
    d: "M153.819,119.892c-.232.041-.352-.049-.335-.292h.318a.2.2,0,0,1,.017.294Z",
    transform: "translate(-88.46 -62.617)",
    fill: "#d3decc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M155,119.861c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.294l-.318,0Z",
    transform: "translate(-89.638 -62.585)",
    fill: "#a0ba95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M156.487,119.832c-.006-.1-.011-.2-.017-.294.235-.041.348.058.337.3h-.32Z",
    transform: "translate(-90.81 -62.56)",
    fill: "#71965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M198.467,119.58c.107,0,.213,0,.318,0a.2.2,0,0,1,.013.3c-.23.03-.348-.066-.333-.3Z",
    transform: "translate(-123.849 -62.601)",
    fill: "#5e8749"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M199.993,119.891c0-.1-.009-.2-.013-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-125.041 -62.609)",
    fill: "#8ba97d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1678",
    "data-name": "Path 1678",
    d: "M201.479,119.843l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3C201.69,119.839,201.586,119.841,201.479,119.843Z",
    transform: "translate(-126.206 -62.57)",
    fill: "#bccfb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1679",
    "data-name": "Path 1679",
    d: "M202.977,119.824c-.006-.1-.011-.2-.017-.3.232-.034.348.062.335.3h-.32Z",
    transform: "translate(-127.386 -62.553)",
    fill: "#edf2eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1680",
    "data-name": "Path 1680",
    d: "M246.465,119.828c-.015-.239.1-.333.331-.3a.207.207,0,0,1-.013.3C246.676,119.823,246.57,119.825,246.465,119.828Z",
    transform: "translate(-161.613 -62.552)",
    fill: "#f5f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1681",
    "data-name": "Path 1681",
    d: "M247.962,119.841l.013-.3.322.009a.2.2,0,0,1-.019.294h-.318Z",
    transform: "translate(-162.79 -62.57)",
    fill: "#c7d6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1682",
    "data-name": "Path 1682",
    d: "M249.45,119.874l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-163.962 -62.601)",
    fill: "#97b289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1683",
    "data-name": "Path 1683",
    d: "M250.95,119.889c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-165.142 -62.609)",
    fill: "#668e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1684",
    "data-name": "Path 1684",
    d: "M293.266,119.826c-.107,0-.213,0-.32,0-.013-.239.1-.333.335-.3A.206.206,0,0,1,293.266,119.826Z",
    transform: "translate(-198.182 -62.555)",
    fill: "#668e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1685",
    "data-name": "Path 1685",
    d: "M294.45,119.849c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.017.294C294.661,119.853,294.557,119.851,294.45,119.849Z",
    transform: "translate(-199.365 -62.577)",
    fill: "#96b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1686",
    "data-name": "Path 1686",
    d: "M295.932,119.874c.006-.1.013-.2.017-.294h.318a.207.207,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-200.53 -62.601)",
    fill: "#c6d5bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1687",
    "data-name": "Path 1687",
    d: "M297.45,119.875c0-.1.009-.2.015-.3.107,0,.213,0,.318,0C297.8,119.809,297.68,119.9,297.45,119.875Z",
    transform: "translate(-201.726 -62.593)",
    fill: "#f5f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1688",
    "data-name": "Path 1688",
    d: "M389.268,119.8c-.247.017-.348-.094-.3-.339C389.222,119.443,389.318,119.558,389.268,119.8Z",
    transform: "translate(-273.72 -62.507)",
    fill: "#adc3a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M60.556,120.986l.3-.026c.036.239-.062.356-.309.335C60.55,121.192,60.554,121.088,60.556,120.986Z",
    transform: "translate(-15.345 -63.687)",
    fill: "#e5ece2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1690",
    "data-name": "Path 1690",
    d: "M158.311,121.391c-.23.032-.348-.064-.335-.3.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3Z",
    transform: "translate(-91.995 -63.789)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1691",
    "data-name": "Path 1691",
    d: "M159.495,121.391c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-93.178 -63.789)",
    fill: "#bdceb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1692",
    "data-name": "Path 1692",
    d: "M160.979,121.343l-.019-.294.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-94.343 -63.75)",
    fill: "#8caa7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1693",
    "data-name": "Path 1693",
    d: "M162.485,121.317c0-.1-.011-.2-.015-.3.23-.032.348.064.333.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-95.531 -63.728)",
    fill: "#5e8749"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1694",
    "data-name": "Path 1694",
    d: "M204.468,121.09h.32a.2.2,0,0,1,.017.3C204.572,121.423,204.457,121.329,204.468,121.09Z",
    transform: "translate(-128.572 -63.789)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1695",
    "data-name": "Path 1695",
    d: "M205.987,121.371c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-129.754 -63.773)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1696",
    "data-name": "Path 1696",
    d: "M207.469,121.327l-.019-.294c.232-.043.352.047.337.292h-.318Z",
    transform: "translate(-130.918 -63.736)",
    fill: "#d2decb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1697",
    "data-name": "Path 1697",
    d: "M241.958,121.326c-.011-.239.1-.335.337-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-158.067 -63.735)",
    fill: "#dde5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1698",
    "data-name": "Path 1698",
    d: "M243.452,121.356c.006-.1.011-.2.017-.3l.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-159.241 -63.765)",
    fill: "#abc2a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1699",
    "data-name": "Path 1699",
    d: "M244.95,121.384l.019-.294h.32c.011.241-.1.337-.339.292Z",
    transform: "translate(-160.422 -63.789)",
    fill: "#7c9e6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1700",
    "data-name": "Path 1700",
    d: "M288.763,121.329c-.107,0-.211,0-.318,0-.015-.245.1-.333.335-.292A.2.2,0,0,1,288.763,121.329Z",
    transform: "translate(-194.64 -63.738)",
    fill: "#81a171"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1701",
    "data-name": "Path 1701",
    d: "M289.94,121.364c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3C290.151,121.371,290.044,121.366,289.94,121.364Z",
    transform: "translate(-195.817 -63.773)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1702",
    "data-name": "Path 1702",
    d: "M291.44,121.386c.006-.1.011-.2.017-.3h.32C291.79,121.329,291.675,121.425,291.44,121.386Z",
    transform: "translate(-196.997 -63.789)",
    fill: "#e2eadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1703",
    "data-name": "Path 1703",
    d: "M390.494,121.312c0-.1,0-.207,0-.309.245-.019.343.1.307.335A.208.208,0,0,1,390.494,121.312Z",
    transform: "translate(-274.925 -63.719)",
    fill: "#6c9259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1704",
    "data-name": "Path 1704",
    d: "M59.341,122.474c.049.243-.049.356-.3.339C59,122.57,59.094,122.457,59.341,122.474Z",
    transform: "translate(-14.152 -64.876)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1705",
    "data-name": "Path 1705",
    d: "M164.314,122.894c-.232.038-.348-.055-.337-.294h.32A.2.2,0,0,1,164.314,122.894Z",
    transform: "translate(-96.716 -64.977)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    "data-name": "Path 1706",
    d: "M165.5,122.879c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294c-.107,0-.211,0-.318.006Z",
    transform: "translate(-97.899 -64.961)",
    fill: "#a8bf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    "data-name": "Path 1707",
    d: "M166.987,122.828c-.006-.1-.013-.2-.017-.294.235-.043.35.053.337.294Z",
    transform: "translate(-99.071 -64.917)",
    fill: "#799c66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    "data-name": "Path 1708",
    d: "M210.464,122.584c.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294C210.569,122.917,210.447,122.83,210.464,122.584Z",
    transform: "translate(-133.289 -64.961)",
    fill: "#85a475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    "data-name": "Path 1709",
    d: "M211.979,122.851l-.019-.294.318-.006a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-134.467 -64.938)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1710",
    "data-name": "Path 1710",
    d: "M213.477,122.829c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3h-.32Z",
    transform: "translate(-135.647 -64.918)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1711",
    "data-name": "Path 1711",
    d: "M235.965,122.823c-.015-.239.1-.333.333-.3a.206.206,0,0,1-.015.3Z",
    transform: "translate(-153.352 -64.91)",
    fill: "#f1f5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1712",
    "data-name": "Path 1712",
    d: "M237.46,122.849c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-154.529 -64.938)",
    fill: "#c0d1b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1713",
    "data-name": "Path 1713",
    d: "M238.95,122.874l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-155.701 -64.961)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M240.45,122.873c0-.1.011-.2.015-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-156.881 -64.953)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M282.766,122.821h-.32c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-189.921 -64.91)",
    fill: "#6e935b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M283.95,122.856c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-191.105 -64.946)",
    fill: "#9db790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M285.44,122.882c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C285.792,122.837,285.675,122.927,285.44,122.882Z",
    transform: "translate(-192.277 -64.969)",
    fill: "#cfdbc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M390.477,122.46l.3.026v.311C390.535,122.814,390.437,122.7,390.477,122.46Z",
    transform: "translate(-274.908 -64.867)",
    fill: "#d0dcca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M57.855,124l-.006.309a.21.21,0,0,1-.3.026c-.034-.239.064-.354.311-.335Z",
    transform: "translate(-12.977 -66.079)",
    fill: "#668e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M168.809,124.383c-.23.03-.345-.066-.333-.3.107,0,.213,0,.318,0a.207.207,0,0,1,.013.3Z",
    transform: "translate(-100.255 -66.141)",
    fill: "#f3f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M169.993,124.383l-.013-.3c.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-101.439 -66.141)",
    fill: "#c5d4be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M171.479,124.343l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3C171.69,124.339,171.586,124.341,171.479,124.343Z",
    transform: "translate(-102.603 -66.11)",
    fill: "#94b085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M172.977,124.314c-.006-.1-.011-.2-.017-.3.232-.034.348.062.335.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-103.784 -66.085)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M214.97,124.09h.32a.208.208,0,0,1,.017.3c-.232.034-.348-.06-.335-.3Z",
    transform: "translate(-136.835 -66.149)",
    fill: "#6a9056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M216.477,124.381c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C216.69,124.374,216.584,124.376,216.477,124.381Z",
    transform: "translate(-138.007 -66.141)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M217.969,124.331c-.006-.1-.013-.2-.019-.292.235-.045.354.045.337.29C218.18,124.329,218.074,124.329,217.969,124.331Z",
    transform: "translate(-139.179 -66.1)",
    fill: "#cad9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M231.458,124.331c-.011-.241.1-.335.337-.294a.2.2,0,0,1-.017.294Z",
    transform: "translate(-149.806 -66.1)",
    fill: "#d7e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M232.952,124.364c.006-.1.013-.2.017-.294.107,0,.211,0,.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-150.981 -66.134)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M234.45,124.384l.019-.294h.32c.011.241-.1.335-.337.294Z",
    transform: "translate(-152.161 -66.149)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M276.775,124.313c-.107,0-.213,0-.32,0-.015-.239.1-.333.331-.3a.207.207,0,0,1-.013.3Z",
    transform: "translate(-185.207 -66.085)",
    fill: "#5c8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M277.952,124.331l.013-.3.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-186.384 -66.102)",
    fill: "#87a779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M279.44,124.374l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-187.556 -66.141)",
    fill: "#baccb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M280.94,124.389c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-188.737 -66.149)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M391.992,124.3v-.313c.245-.017.345.1.3.337a.207.207,0,0,1-.3-.026Z",
    transform: "translate(-276.105 -66.064)",
    fill: "#8aa97c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M57.57,125.486l.3-.026c.043.241-.058.354-.3.337v-.313Z",
    transform: "translate(-13.001 -67.227)",
    fill: "#c7d6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M174.8,125.886c-.232.036-.348-.058-.337-.3h.32A.2.2,0,0,1,174.8,125.886Z",
    transform: "translate(-104.969 -67.329)",
    fill: "#e0e8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M175.987,125.871c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292l-.32.006Z",
    transform: "translate(-106.152 -67.314)",
    fill: "#b0c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M177.479,125.834c-.006-.1-.013-.2-.019-.292.235-.043.352.047.337.292Z",
    transform: "translate(-107.324 -67.284)",
    fill: "#80a06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M220.965,125.592c.107,0,.211,0,.318,0a.2.2,0,0,1,.017.3C221.068,125.925,220.95,125.837,220.965,125.592Z",
    transform: "translate(-141.551 -67.329)",
    fill: "#7d9e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M222.477,125.845c-.006-.1-.011-.2-.017-.3l.322-.009c0,.1.011.2.017.3l-.32.006Z",
    transform: "translate(-142.728 -67.29)",
    fill: "#afc4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M227.306,53.6l.013.3c-.109,0-.215,0-.324,0,0-.1,0-.2,0-.3h.316Z",
    transform: "translate(-146.292 -10.692)",
    fill: "#d7e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M226.97,125.856c0-.1.011-.2.015-.3.107,0,.213,0,.32.006a.2.2,0,0,1-.019.294h-.316Z",
    transform: "translate(-146.276 -67.306)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M228.45,125.874l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-147.44 -67.322)",
    fill: "#89a87b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M229.96,125.883c0-.1.009-.2.015-.3.107,0,.213,0,.32,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-148.628 -67.322)",
    fill: "#5c8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M272.267,125.826h-.32c-.011-.239.1-.335.337-.3A.2.2,0,0,1,272.267,125.826Z",
    transform: "translate(-181.661 -67.276)",
    fill: "#749862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M273.442,125.856c.006-.1.011-.2.017-.3l.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-182.836 -67.306)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M274.94,125.884l.019-.294h.32C275.29,125.831,275.177,125.927,274.94,125.884Z",
    transform: "translate(-184.016 -67.329)",
    fill: "#d6e0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M391.976,125.46l.3.026c0,.1,0,.207.009.309C392.042,125.816,391.942,125.7,391.976,125.46Z",
    transform: "translate(-276.089 -67.227)",
    fill: "#ebf1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M56.35,126.994v.311a.207.207,0,0,1-.3.026C56.007,127.092,56.1,126.977,56.35,126.994Z",
    transform: "translate(-11.796 -68.433)",
    fill: "#80a06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M180.8,127.382c-.232.043-.352-.047-.337-.29.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294Z",
    transform: "translate(-109.687 -68.51)",
    fill: "#cbdac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M181.987,127.351c-.006-.1-.013-.2-.017-.294l.318-.006a.2.2,0,0,1,.017.3C182.2,127.346,182.094,127.349,181.987,127.351Z",
    transform: "translate(-110.872 -68.478)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M183.477,127.319c-.006-.1-.011-.2-.017-.3.232-.036.348.058.337.3h-.32Z",
    transform: "translate(-112.044 -68.45)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1753",
    "data-name": "Path 1753",
    d: "M266.284,127.319c-.107,0-.213,0-.318,0-.013-.239.1-.333.333-.3A.206.206,0,0,1,266.284,127.319Z",
    transform: "translate(-176.955 -68.45)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1754",
    "data-name": "Path 1754",
    d: "M267.46,127.339c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-178.131 -68.47)",
    fill: "#8fad80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1755",
    "data-name": "Path 1755",
    d: "M268.95,127.374l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-179.303 -68.502)",
    fill: "#c0d1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1756",
    "data-name": "Path 1756",
    d: "M270.45,127.383c0-.1.011-.2.015-.3.107,0,.213,0,.32,0C270.8,127.319,270.682,127.415,270.45,127.383Z",
    transform: "translate(-180.484 -68.502)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1757",
    "data-name": "Path 1757",
    d: "M393.768,127.3c-.247.017-.348-.094-.3-.339C393.722,126.943,393.818,127.058,393.768,127.3Z",
    transform: "translate(-277.261 -68.408)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M56.072,128.486l.3-.026c.036.237-.06.354-.3.337C56.07,128.692,56.07,128.59,56.072,128.486Z",
    transform: "translate(-11.821 -69.587)",
    fill: "#e3eae0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1759",
    "data-name": "Path 1759",
    d: "M185.311,128.889c-.232.034-.348-.062-.335-.3.107,0,.213,0,.32,0A.2.2,0,0,1,185.311,128.889Z",
    transform: "translate(-113.237 -69.69)",
    fill: "#e7ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1760",
    "data-name": "Path 1760",
    d: "M186.495,128.881c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292c-.107,0-.213,0-.32.009Z",
    transform: "translate(-114.42 -69.682)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1761",
    "data-name": "Path 1761",
    d: "M187.979,128.831c-.006-.1-.013-.2-.019-.292.232-.045.354.043.337.29-.107,0-.213,0-.318,0Z",
    transform: "translate(-115.585 -69.64)",
    fill: "#86a677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1762",
    "data-name": "Path 1762",
    d: "M261.772,128.83h-.318c-.017-.245.1-.335.335-.294A.2.2,0,0,1,261.772,128.83Z",
    transform: "translate(-173.405 -69.639)",
    fill: "#7b9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1763",
    "data-name": "Path 1763",
    d: "M262.942,128.864c.006-.1.011-.2.017-.294.107,0,.213,0,.318,0a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-174.575 -69.674)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1764",
    "data-name": "Path 1764",
    d: "M264.44,128.884l.019-.294h.32c.011.241-.1.335-.337.3Z",
    transform: "translate(-175.755 -69.69)",
    fill: "#dde5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1765",
    "data-name": "Path 1765",
    d: "M394.986,128.8c0-.1,0-.207-.006-.311.245-.019.343.1.309.335a.207.207,0,0,1-.3-.023Z",
    transform: "translate(-278.457 -69.611)",
    fill: "#699056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1766",
    "data-name": "Path 1766",
    d: "M54.841,129.975c0,.1,0,.211,0,.316a.2.2,0,0,1-.3.023C54.5,130.073,54.594,129.96,54.841,129.975Z",
    transform: "translate(-10.611 -70.778)",
    fill: "#95b186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1767",
    "data-name": "Path 1767",
    d: "M191.31,130.392c-.232.041-.35-.049-.335-.292h.318a.2.2,0,0,1,.017.294Z",
    transform: "translate(-117.956 -70.878)",
    fill: "#d3decd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1768",
    "data-name": "Path 1768",
    d: "M192.487,130.361c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-119.133 -70.846)",
    fill: "#a2bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1769",
    "data-name": "Path 1769",
    d: "M193.977,130.331c-.006-.1-.013-.2-.017-.294.235-.041.35.055.337.3h-.32Z",
    transform: "translate(-120.305 -70.821)",
    fill: "#719660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1770",
    "data-name": "Path 1770",
    d: "M255.776,130.316c-.107,0-.213,0-.32,0-.013-.239.1-.333.335-.3A.206.206,0,0,1,255.776,130.316Z",
    transform: "translate(-168.687 -70.808)",
    fill: "#668e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1771",
    "data-name": "Path 1771",
    d: "M256.952,130.339c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.292h-.318Z",
    transform: "translate(-169.862 -70.83)",
    fill: "#97b289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1772",
    "data-name": "Path 1772",
    d: "M258.45,130.382c.006-.1.013-.194.019-.292.107,0,.213,0,.32,0,.017.247-.1.335-.337.29Z",
    transform: "translate(-171.043 -70.87)",
    fill: "#c7d7c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1773",
    "data-name": "Path 1773",
    d: "M394.97,129.952c.1.009.2.017.3.023,0,.1,0,.211-.006.316-.245.015-.339-.1-.294-.341Z",
    transform: "translate(-278.441 -70.76)",
    fill: "#c0d2b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1774",
    "data-name": "Path 1774",
    d: "M54.6,131.483l.3-.023c.038.232-.055.352-.3.339v-.316Z",
    transform: "translate(-10.664 -71.948)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1775",
    "data-name": "Path 1775",
    d: "M195.808,131.873c-.23.032-.348-.064-.333-.3h.318A.212.212,0,0,1,195.808,131.873Z",
    transform: "translate(-121.496 -72.034)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1776",
    "data-name": "Path 1776",
    d: "M196.985,131.881c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-122.673 -72.042)",
    fill: "#bdcfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1777",
    "data-name": "Path 1777",
    d: "M198.479,131.833l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.015.3h-.318Z",
    transform: "translate(-123.846 -72.003)",
    fill: "#8dab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1778",
    "data-name": "Path 1778",
    d: "M199.975,131.817c0-.1-.011-.2-.015-.3.23-.032.348.064.335.3C200.188,131.821,200.082,131.819,199.975,131.817Z",
    transform: "translate(-125.026 -71.989)",
    fill: "#5f874a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1779",
    "data-name": "Path 1779",
    d: "M251.273,131.829c-.107,0-.211,0-.318,0-.015-.245.1-.333.335-.292A.2.2,0,0,1,251.273,131.829Z",
    transform: "translate(-165.145 -71.999)",
    fill: "#82a273"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1780",
    "data-name": "Path 1780",
    d: "M252.45,131.864c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-166.322 -72.034)",
    fill: "#b2c6a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M253.94,131.886c.006-.1.013-.2.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-167.494 -72.05)",
    fill: "#e4ebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M396.509,131.812c0-.107,0-.211-.009-.318.239-.017.337.1.307.331a.206.206,0,0,1-.3-.015Z",
    transform: "translate(-279.653 -71.973)",
    fill: "#60884b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    "data-name": "Path 1783",
    d: "M53.333,132.986c0,.107,0,.213,0,.32a.206.206,0,0,1-.3.011C53,133.087,53.1,132.974,53.333,132.986Z",
    transform: "translate(-9.425 -73.148)",
    fill: "#668d53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    "data-name": "Path 1784",
    d: "M201.8,133.376c-.232.038-.348-.055-.337-.3h.32A.2.2,0,0,1,201.8,133.376Z",
    transform: "translate(-126.211 -73.222)",
    fill: "#dbe4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    "data-name": "Path 1785",
    d: "M202.987,133.361c-.006-.1-.013-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294C203.2,133.354,203.094,133.359,202.987,133.361Z",
    transform: "translate(-127.394 -73.206)",
    fill: "#a8bf9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1786",
    "data-name": "Path 1786",
    d: "M204.477,133.328c-.006-.1-.013-.2-.017-.294.235-.043.35.053.337.294Z",
    transform: "translate(-128.566 -73.178)",
    fill: "#7a9c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1787",
    "data-name": "Path 1787",
    d: "M245.276,133.311h-.32c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-160.426 -73.163)",
    fill: "#6e945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M246.46,133.346c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-161.61 -73.199)",
    fill: "#9eb791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1789",
    "data-name": "Path 1789",
    d: "M247.95,133.382c.006-.1.013-.2.019-.292h.318c.015.245-.1.335-.337.29Z",
    transform: "translate(-162.782 -73.23)",
    fill: "#cfdcc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1790",
    "data-name": "Path 1790",
    d: "M396.524,132.99c.1,0,.2.009.3.015,0,.107,0,.213-.009.318a.2.2,0,0,1-.294-.013v-.32Z",
    transform: "translate(-279.669 -73.151)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1791",
    "data-name": "Path 1791",
    d: "M53.042,134.5l.3-.011v.322l-.294.009c0-.107,0-.213-.006-.32Z",
    transform: "translate(-9.437 -74.331)",
    fill: "#8aa97c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1792",
    "data-name": "Path 1792",
    d: "M206.308,134.875c-.23.03-.348-.066-.333-.3.107,0,.213,0,.318,0a.207.207,0,0,1,.013.3Z",
    transform: "translate(-129.757 -74.394)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1793",
    "data-name": "Path 1793",
    d: "M207.493,134.883l-.013-.3c.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-130.942 -74.402)",
    fill: "#c5d5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1794",
    "data-name": "Path 1794",
    d: "M208.979,134.851l-.019-.294.32-.006a.2.2,0,0,1,.017.3C209.19,134.846,209.086,134.849,208.979,134.851Z",
    transform: "translate(-132.106 -74.379)",
    fill: "#94b086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1795",
    "data-name": "Path 1795",
    d: "M210.467,134.821c-.006-.1-.011-.2-.017-.3.232-.034.348.06.335.3h-.32Z",
    transform: "translate(-133.279 -74.354)",
    fill: "#658c51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1796",
    "data-name": "Path 1796",
    d: "M239.293,134.813c-.107,0-.213,0-.318,0-.015-.239.1-.333.333-.3a.207.207,0,0,1-.013.3Z",
    transform: "translate(-155.72 -74.346)",
    fill: "#5c8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1797",
    "data-name": "Path 1797",
    d: "M240.462,134.831l.013-.3.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-156.889 -74.363)",
    fill: "#88a87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1798",
    "data-name": "Path 1798",
    d: "M241.95,134.864l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-158.061 -74.394)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1799",
    "data-name": "Path 1799",
    d: "M243.45,134.889c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-159.241 -74.41)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1800",
    "data-name": "Path 1800",
    d: "M396.514,134.49l.294.013c0,.107,0,.211,0,.318l-.294-.009C396.51,134.705,396.514,134.6,396.514,134.49Z",
    transform: "translate(-279.661 -74.331)",
    fill: "#b4c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1801",
    "data-name": "Path 1801",
    d: "M222.587,53.62c0,.1-.006.2-.009.3l-.324-.006a.2.2,0,0,1,.015-.292c.1,0,.211,0,.316,0Z",
    transform: "translate(-142.522 -10.707)",
    fill: "#cedcc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1802",
    "data-name": "Path 1802",
    d: "M221.088,53.587c0,.1-.011.2-.015.292-.107,0-.213,0-.32,0a.2.2,0,0,1,.019-.294c.107,0,.211,0,.318.006Z",
    transform: "translate(-141.34 -10.676)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1803",
    "data-name": "Path 1803",
    d: "M219.8,53.541l-.019.294h-.32c-.011-.241.1-.335.337-.3Z",
    transform: "translate(-140.365 -10.637)",
    fill: "#739760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1804",
    "data-name": "Path 1804",
    d: "M212.3,136.379c-.232.036-.348-.058-.337-.3h.32a.2.2,0,0,1,.017.3Z",
    transform: "translate(-134.472 -75.582)",
    fill: "#e1e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1805",
    "data-name": "Path 1805",
    d: "M213.487,136.371c-.006-.1-.011-.2-.017-.3.1,0,.211,0,.316,0a.21.21,0,0,1,0,.318l-.3-.015Z",
    transform: "translate(-135.655 -75.575)",
    fill: "#b0c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1806",
    "data-name": "Path 1806",
    d: "M214.944,136.348c0-.107,0-.211,0-.318.247-.038.36.062.322.316a.221.221,0,0,1-.309-.006Z",
    transform: "translate(-136.811 -75.537)",
    fill: "#779b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1807",
    "data-name": "Path 1807",
    d: "M236.05,136.376v-.326c.107,0,.211,0,.318.009a.2.2,0,0,1-.017.294l-.3.023Z",
    transform: "translate(-153.419 -75.559)",
    fill: "#a4bc99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1808",
    "data-name": "Path 1808",
    d: "M237.45,136.384c.006-.1.013-.2.017-.294h.32C237.8,136.331,237.685,136.427,237.45,136.384Z",
    transform: "translate(-154.521 -75.59)",
    fill: "#d6e0d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1809",
    "data-name": "Path 1809",
    d: "M215.01,137.51c.1,0,.207,0,.309.006.047.245-.073.335-.3.32C215.016,137.728,215.014,137.619,215.01,137.51Z",
    transform: "translate(-136.866 -76.707)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1810",
    "data-name": "Path 1810",
    d: "M53.092,138.992c.1,0,.192,0,.29,0v.322a.2.2,0,0,1-.292-.013c0-.1,0-.211,0-.316Z",
    transform: "translate(-9.476 -77.872)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1811",
    "data-name": "Path 1811",
    d: "M213.51,139.331c-.038-.239.06-.354.3-.337v.311A.209.209,0,0,1,213.51,139.331Z",
    transform: "translate(-135.68 -77.874)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1812",
    "data-name": "Path 1812",
    d: "M236,138.974c.247-.017.348.094.3.339C236.048,139.332,235.95,139.219,236,138.974Z",
    transform: "translate(-153.371 -77.858)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1813",
    "data-name": "Path 1813",
    d: "M396.52,139.014c.1,0,.194,0,.292,0v.316a.2.2,0,0,1-.29.011v-.322Z",
    transform: "translate(-279.669 -77.888)",
    fill: "#c0d0b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1814",
    "data-name": "Path 1814",
    d: "M53.046,140.48l.292.013v.32C53.1,140.83,53.005,140.712,53.046,140.48Z",
    transform: "translate(-9.434 -79.044)",
    fill: "#799c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1815",
    "data-name": "Path 1815",
    d: "M213.524,140.486l.3-.026c.036.239-.062.356-.307.337,0-.1,0-.207,0-.309Z",
    transform: "translate(-135.694 -79.028)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1816",
    "data-name": "Path 1816",
    d: "M237.51,140.5c.245-.021.345.094.311.335a.208.208,0,0,1-.3-.026l-.006-.309Z",
    transform: "translate(-154.568 -79.058)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1817",
    "data-name": "Path 1817",
    d: "M396.53,140.511c.1,0,.194-.009.29-.011,0,.1,0,.211.006.316a.2.2,0,0,1-.294.017C396.532,140.726,396.532,140.619,396.53,140.511Z",
    transform: "translate(-279.677 -79.06)",
    fill: "#a2bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1818",
    "data-name": "Path 1818",
    d: "M212.015,142.313c-.049-.243.051-.356.3-.339C212.361,142.217,212.265,142.332,212.015,142.313Z",
    transform: "translate(-134.501 -80.218)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1819",
    "data-name": "Path 1819",
    d: "M237.5,141.96l.3.026v.313c-.245.017-.345-.1-.3-.337Z",
    transform: "translate(-154.557 -80.208)",
    fill: "#88a87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1820",
    "data-name": "Path 1820",
    d: "M396.532,141.987l.294-.017c.04.237-.058.348-.3.337C396.53,142.2,396.53,142.094,396.532,141.987Z",
    transform: "translate(-279.677 -80.216)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1821",
    "data-name": "Path 1821",
    d: "M54.579,143.464c.25-.017.337.1.292.341a.2.2,0,0,1-.3-.023c0-.1.006-.211.009-.316Z",
    transform: "translate(-10.641 -81.391)",
    fill: "#bdceb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1822",
    "data-name": "Path 1822",
    d: "M210.506,143.842c-.034-.241.066-.356.311-.333,0,.1-.006.207-.009.309A.208.208,0,0,1,210.506,143.842Z",
    transform: "translate(-133.318 -81.425)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1823",
    "data-name": "Path 1823",
    d: "M239.03,143.484c.245-.017.343.1.3.337a.207.207,0,0,1-.3-.026Z",
    transform: "translate(-155.764 -81.406)",
    fill: "#cedcc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1824",
    "data-name": "Path 1824",
    d: "M394.972,143.826c-.036-.235.058-.352.3-.339v.313a.2.2,0,0,1-.3.023Z",
    transform: "translate(-278.445 -81.409)",
    fill: "#e4ebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1825",
    "data-name": "Path 1825",
    d: "M54.551,144.96c.1.009.2.017.3.023,0,.1,0,.207.009.311-.245.019-.343-.1-.307-.335Z",
    transform: "translate(-10.622 -82.569)",
    fill: "#6c9259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1826",
    "data-name": "Path 1826",
    d: "M210.53,144.993l.3-.023c.045.241-.055.354-.3.337v-.313Z",
    transform: "translate(-133.342 -82.577)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1827",
    "data-name": "Path 1827",
    d: "M239,144.95l.3.026c0,.1,0,.207.006.309C239.067,145.3,238.967,145.189,239,144.95Z",
    transform: "translate(-155.737 -82.561)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1828",
    "data-name": "Path 1828",
    d: "M395,144.993c.1-.009.2-.017.3-.023.049.243-.053.354-.3.339v-.316Z",
    transform: "translate(-278.473 -82.577)",
    fill: "#94b085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1829",
    "data-name": "Path 1829",
    d: "M56.036,146.472c.245-.019.345.094.3.335C56.089,146.828,55.987,146.72,56.036,146.472Z",
    transform: "translate(-11.785 -83.757)",
    fill: "#afc4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1830",
    "data-name": "Path 1830",
    d: "M209.01,146.821c-.038-.239.06-.354.3-.337v.311a.207.207,0,0,1-.3.026Z",
    transform: "translate(-132.14 -83.766)",
    fill: "#d5dfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1831",
    "data-name": "Path 1831",
    d: "M240.5,146.474c.247-.017.348.094.3.339C240.548,146.832,240.45,146.719,240.5,146.474Z",
    transform: "translate(-156.911 -83.758)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1832",
    "data-name": "Path 1832",
    d: "M393.473,146.826c-.036-.239.064-.35.307-.333v.311a.206.206,0,0,1-.3.021Z",
    transform: "translate(-277.266 -83.774)",
    fill: "#d7e1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1833",
    "data-name": "Path 1833",
    d: "M57.508,148q.365-.035.313.326C57.57,148.357,57.468,148.246,57.508,148Z",
    transform: "translate(-12.946 -84.957)",
    fill: "#d6e0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1834",
    "data-name": "Path 1834",
    d: "M209.024,147.976l.3-.026c.036.239-.062.356-.307.337,0-.1,0-.207,0-.309Z",
    transform: "translate(-132.154 -84.921)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1835",
    "data-name": "Path 1835",
    d: "M242.01,148c.245-.021.345.094.311.335a.208.208,0,0,1-.3-.026c0-.1,0-.207-.006-.309Z",
    transform: "translate(-158.108 -84.959)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1836",
    "data-name": "Path 1836",
    d: "M393.2,147.981l.3-.021c.034.224-.051.348-.29.343l-.064-.045a.222.222,0,0,1,.043-.284l0,.006Z",
    transform: "translate(-276.993 -84.929)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1837",
    "data-name": "Path 1837",
    d: "M58.98,149.517c.241-.034.352.07.328.313C59.059,149.873,58.948,149.771,58.98,149.517Z",
    transform: "translate(-14.106 -86.149)",
    fill: "#d4dfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M207.515,149.8c-.049-.243.051-.356.3-.339C207.861,149.707,207.765,149.822,207.515,149.8Z",
    transform: "translate(-130.96 -86.111)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1839",
    "data-name": "Path 1839",
    d: "M242,149.46l.3.026v.313c-.245.017-.345-.1-.3-.337Z",
    transform: "translate(-158.097 -86.109)",
    fill: "#88a77a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1840",
    "data-name": "Path 1840",
    d: "M392.033,149.293a.306.306,0,0,1-.335.333l-.058-.053a.223.223,0,0,1,.055-.284h0a.213.213,0,0,1,.3-.015l.036.021Z",
    transform: "translate(-275.809 -85.919)",
    fill: "#6e945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1841",
    "data-name": "Path 1841",
    d: "M60.49,151.014c.241-.043.354.055.335.3C60.578,151.366,60.469,151.262,60.49,151.014Z",
    transform: "translate(-15.296 -87.324)",
    fill: "#aac19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1842",
    "data-name": "Path 1842",
    d: "M206.006,151.332c-.034-.241.066-.356.311-.333,0,.1-.006.207-.009.309A.208.208,0,0,1,206.006,151.332Z",
    transform: "translate(-129.777 -87.318)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1843",
    "data-name": "Path 1843",
    d: "M243.53,150.984c.245-.017.343.1.3.337a.207.207,0,0,1-.3-.026Z",
    transform: "translate(-159.304 -87.307)",
    fill: "#cedcc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1844",
    "data-name": "Path 1844",
    d: "M388.925,151.321c-.015-.241.1-.343.335-.3a.205.205,0,0,1-.021.3c-.1,0-.209,0-.313,0Z",
    transform: "translate(-273.692 -87.328)",
    fill: "#c5d5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1845",
    "data-name": "Path 1845",
    d: "M390.4,151.082c.006-.1.015-.2.021-.3l-.009-.009a.228.228,0,0,1,.311-.013l.019.036C390.748,151.029,390.624,151.114,390.4,151.082Z",
    transform: "translate(-274.854 -87.085)",
    fill: "#60894c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1846",
    "data-name": "Path 1846",
    d: "M62.019,152.53l.311.009a.208.208,0,0,1,.023.3c-.239.034-.354-.064-.333-.309Z",
    transform: "translate(-16.501 -88.524)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1847",
    "data-name": "Path 1847",
    d: "M63.5,152.847c-.009-.1-.015-.2-.023-.3l.32-.006a.2.2,0,0,1,.019.3C63.715,152.841,63.608,152.843,63.5,152.847Z",
    transform: "translate(-17.651 -88.532)",
    fill: "#b4c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1848",
    "data-name": "Path 1848",
    d: "M65,152.816c-.006-.1-.013-.2-.019-.3.232-.032.35.062.335.3-.107,0-.211,0-.318,0Z",
    transform: "translate(-18.831 -88.51)",
    fill: "#f1f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1849",
    "data-name": "Path 1849",
    d: "M206.03,152.483c.1-.009.2-.017.3-.023.045.241-.055.354-.3.337C206.032,152.692,206.032,152.588,206.03,152.483Z",
    transform: "translate(-129.801 -88.469)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1850",
    "data-name": "Path 1850",
    d: "M243.5,152.45l.3.026c0,.1,0,.207.006.309C243.567,152.8,243.467,152.689,243.5,152.45Z",
    transform: "translate(-159.278 -88.461)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    d: "M385.925,152.821c-.015-.247.1-.337.339-.292a.2.2,0,0,1-.023.3C386.137,152.828,386.03,152.823,385.925,152.821Z",
    transform: "translate(-271.332 -88.515)",
    fill: "#c3d3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1852",
    "data-name": "Path 1852",
    d: "M387.41,152.853c.009-.1.017-.2.023-.3.1,0,.209,0,.314,0C387.764,152.8,387.649,152.893,387.41,152.853Z",
    transform: "translate(-272.501 -88.54)",
    fill: "#7a9c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1853",
    "data-name": "Path 1853",
    d: "M66.5,154.08h.32a.2.2,0,0,1,.017.294C66.6,154.415,66.487,154.319,66.5,154.08Z",
    transform: "translate(-20.024 -89.744)",
    fill: "#779b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1854",
    "data-name": "Path 1854",
    d: "M68.017,154.369c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-21.207 -89.736)",
    fill: "#a8bf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1855",
    "data-name": "Path 1855",
    d: "M69.5,154.321l-.019-.294c.235-.041.35.055.339.294Z",
    transform: "translate(-22.371 -89.695)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1856",
    "data-name": "Path 1856",
    d: "M204.52,154.321c-.038-.239.06-.354.3-.337v.311a.207.207,0,0,1-.3.026Z",
    transform: "translate(-128.607 -89.667)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1857",
    "data-name": "Path 1857",
    d: "M245,153.964c.247-.017.348.094.3.339C245.048,154.322,244.95,154.209,245,153.964Z",
    transform: "translate(-160.452 -89.651)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1858",
    "data-name": "Path 1858",
    d: "M379.937,154.324c-.013-.239.1-.333.335-.3a.2.2,0,0,1-.017.3h-.318Z",
    transform: "translate(-266.621 -89.695)",
    fill: "#e5ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1859",
    "data-name": "Path 1859",
    d: "M381.43,154.346c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C381.641,154.351,381.537,154.349,381.43,154.346Z",
    transform: "translate(-267.797 -89.72)",
    fill: "#b3c7aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1860",
    "data-name": "Path 1860",
    d: "M382.92,154.382c.006-.1.013-.194.019-.292.107,0,.211,0,.318,0C383.272,154.337,383.155,154.427,382.92,154.382Z",
    transform: "translate(-268.969 -89.752)",
    fill: "#84a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1861",
    "data-name": "Path 1861",
    d: "M71.005,155.57c.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3C71.108,155.9,70.99,155.809,71.005,155.57Z",
    transform: "translate(-23.57 -90.916)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1862",
    "data-name": "Path 1862",
    d: "M72.515,155.881c0-.1-.009-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-24.747 -90.924)",
    fill: "#8cab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1863",
    "data-name": "Path 1863",
    d: "M74.007,155.833c-.006-.1-.013-.2-.017-.294.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3h-.318Z",
    transform: "translate(-25.919 -90.885)",
    fill: "#bdceb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1864",
    "data-name": "Path 1864",
    d: "M75.5,155.814c0-.1-.011-.2-.017-.3.232-.034.348.062.335.3C75.708,155.816,75.6,155.816,75.5,155.814Z",
    transform: "translate(-27.091 -90.868)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1865",
    "data-name": "Path 1865",
    d: "M204.534,155.476l.3-.026c.036.239-.062.356-.307.337,0-.1,0-.207,0-.309Z",
    transform: "translate(-128.621 -90.822)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M218.04,155.954c.013-.13-.053-.324.177-.3.175.017.117.185.128.3A.231.231,0,0,1,218.04,155.954Z",
    transform: "translate(-139.25 -90.98)",
    fill: "#70965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M231.537,155.948c.011-.13-.053-.322.175-.3.175.015.119.183.13.3A.224.224,0,0,1,231.537,155.948Z",
    transform: "translate(-149.869 -90.974)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M246.51,155.5c.245-.021.345.094.311.335a.208.208,0,0,1-.3-.026l-.006-.309Z",
    transform: "translate(-161.649 -90.86)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M375.424,155.822c-.017-.245.1-.333.337-.29a.2.2,0,0,1-.019.294C375.635,155.826,375.529,155.824,375.424,155.822Z",
    transform: "translate(-263.07 -90.878)",
    fill: "#c8d8c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M376.922,155.864c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3l-.32-.006Z",
    transform: "translate(-264.249 -90.916)",
    fill: "#98b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M378.42,155.886c.006-.1.011-.2.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-265.429 -90.932)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M77,157.08h.32a.2.2,0,0,1,.017.3C77.1,157.415,76.987,157.319,77,157.08Z",
    transform: "translate(-28.285 -92.104)",
    fill: "#719660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M78.507,157.361c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-29.46 -92.088)",
    fill: "#a0ba95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M80,157.317l-.019-.294c.232-.043.352.049.335.292H80Z",
    transform: "translate(-30.632 -92.051)",
    fill: "#d3decd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1875",
    "data-name": "Path 1875",
    d: "M203.015,157.3c-.049-.243.051-.356.3-.339C203.361,157.207,203.265,157.322,203.015,157.3Z",
    transform: "translate(-127.42 -92.011)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1876",
    "data-name": "Path 1876",
    d: "M218.04,157.07h.3c0,.1-.006.209-.009.313h-.3v-.313Z",
    transform: "translate(-139.25 -92.096)",
    fill: "#d7e1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1877",
    "data-name": "Path 1877",
    d: "M231.54,157.031c.1,0,.2,0,.3,0l0-.006a.222.222,0,0,1,.009.313c-.1,0-.2,0-.307.006,0-.1-.006-.207-.009-.309Z",
    transform: "translate(-149.871 -92.057)",
    fill: "#c5d5bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1878",
    "data-name": "Path 1878",
    d: "M232.989,157.33c0-.1-.006-.209-.009-.313.245-.026.35.085.318.328a.221.221,0,0,1-.309-.017Z",
    transform: "translate(-151.004 -92.051)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1879",
    "data-name": "Path 1879",
    d: "M246.5,156.96l.3.026v.313c-.245.017-.345-.1-.3-.337Z",
    transform: "translate(-161.637 -92.01)",
    fill: "#88a87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1880",
    "data-name": "Path 1880",
    d: "M369.427,157.316c-.011-.239.1-.335.337-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-258.353 -92.05)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1881",
    "data-name": "Path 1881",
    d: "M370.93,157.346c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.294C371.141,157.351,371.037,157.349,370.93,157.346Z",
    transform: "translate(-259.536 -92.08)",
    fill: "#adc3a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1882",
    "data-name": "Path 1882",
    d: "M372.42,157.374l.019-.294h.318c.015.243-.1.335-.335.292Z",
    transform: "translate(-260.708 -92.104)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1883",
    "data-name": "Path 1883",
    d: "M82.984,158.584c.107,0,.213,0,.318,0a.2.2,0,0,1,.019.294C83.089,158.917,82.967,158.832,82.984,158.584Z",
    transform: "translate(-32.994 -93.284)",
    fill: "#85a577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M84.5,158.851l-.019-.294.32-.006a.2.2,0,0,1,.017.3C84.71,158.846,84.606,158.849,84.5,158.851Z",
    transform: "translate(-34.172 -93.261)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1885",
    "data-name": "Path 1885",
    d: "M86,158.819c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3C86.21,158.821,86.1,158.821,86,158.819Z",
    transform: "translate(-35.352 -93.233)",
    fill: "#e7ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M201.516,158.832c-.034-.241.066-.356.311-.333,0,.1-.006.207-.009.309A.208.208,0,0,1,201.516,158.832Z",
    transform: "translate(-126.245 -93.218)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1887",
    "data-name": "Path 1887",
    d: "M216.685,158.472c0,.1,0,.209,0,.313a.212.212,0,0,1-.237.09.234.234,0,0,1-.111-.075c.021-.207.1-.358.343-.326Z",
    transform: "translate(-137.913 -93.198)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1888",
    "data-name": "Path 1888",
    d: "M233,158.48l.309.017c0,.1,0,.211,0,.316-.1,0-.207,0-.309,0C233,158.7,233,158.589,233,158.48Z",
    transform: "translate(-151.02 -93.206)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1889",
    "data-name": "Path 1889",
    d: "M248.03,158.484c.245-.017.343.1.3.337a.207.207,0,0,1-.3-.026Z",
    transform: "translate(-162.845 -93.207)",
    fill: "#cedcc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1890",
    "data-name": "Path 1890",
    d: "M363.435,158.813c-.015-.239.1-.333.333-.3a.2.2,0,0,1-.015.3C363.646,158.809,363.54,158.811,363.435,158.813Z",
    transform: "translate(-253.638 -93.225)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1891",
    "data-name": "Path 1891",
    d: "M364.94,158.839c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-254.823 -93.253)",
    fill: "#c1d3ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1892",
    "data-name": "Path 1892",
    d: "M366.43,158.864l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-255.996 -93.276)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1893",
    "data-name": "Path 1893",
    d: "M367.93,158.881c0-.1.011-.2.015-.3.107,0,.213,0,.32,0C368.278,158.819,368.162,158.915,367.93,158.881Z",
    transform: "translate(-257.176 -93.284)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1894",
    "data-name": "Path 1894",
    d: "M87.5,160.072h.32a.206.206,0,0,1,.017.3c-.232.036-.348-.06-.335-.3Z",
    transform: "translate(-36.548 -94.456)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1895",
    "data-name": "Path 1895",
    d: "M89.007,160.371c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C89.22,160.364,89.114,160.366,89.007,160.371Z",
    transform: "translate(-37.72 -94.456)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1896",
    "data-name": "Path 1896",
    d: "M90.5,160.321c-.006-.1-.013-.2-.019-.292.235-.045.352.045.337.29H90.5Z",
    transform: "translate(-38.893 -94.416)",
    fill: "#cbd9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1897",
    "data-name": "Path 1897",
    d: "M201.54,159.983c.1-.009.2-.017.3-.023.045.241-.055.354-.3.337v-.313Z",
    transform: "translate(-126.269 -94.37)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1898",
    "data-name": "Path 1898",
    d: "M215.01,160.336c-.026-.211.034-.352.282-.333l.049,0a.243.243,0,0,1-.015.318l-.013-.011A.212.212,0,0,1,215.01,160.336Z",
    transform: "translate(-136.862 -94.403)",
    fill: "#5c8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1899",
    "data-name": "Path 1899",
    d: "M234.54,160.3v-.311c.245-.017.343.1.3.337a.208.208,0,0,1-.3-.026Z",
    transform: "translate(-152.231 -94.387)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1900",
    "data-name": "Path 1900",
    d: "M248,159.95l.3.026c0,.1,0,.207.006.309C248.067,160.3,247.967,160.189,248,159.95Z",
    transform: "translate(-162.818 -94.362)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1901",
    "data-name": "Path 1901",
    d: "M358.927,160.321c-.011-.241.1-.335.337-.294a.2.2,0,0,1-.017.294Z",
    transform: "translate(-250.092 -94.415)",
    fill: "#d8e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1902",
    "data-name": "Path 1902",
    d: "M360.43,160.354c.006-.1.013-.2.017-.294.107,0,.211,0,.318.006a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-251.275 -94.449)",
    fill: "#a6bd9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1903",
    "data-name": "Path 1903",
    d: "M361.92,160.384c.006-.1.013-.2.017-.294h.32C362.268,160.331,362.152,160.427,361.92,160.384Z",
    transform: "translate(-252.447 -94.472)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1904",
    "data-name": "Path 1904",
    d: "M93.494,161.59h.318a.2.2,0,0,1,.017.292C93.6,161.923,93.477,161.833,93.494,161.59Z",
    transform: "translate(-41.263 -95.652)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1905",
    "data-name": "Path 1905",
    d: "M95.007,161.851c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.3C95.218,161.846,95.114,161.849,95.007,161.851Z",
    transform: "translate(-42.441 -95.621)",
    fill: "#b0c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1906",
    "data-name": "Path 1906",
    d: "M96.5,161.816c-.006-.1-.013-.2-.017-.3.232-.038.348.058.337.3Z",
    transform: "translate(-43.613 -95.591)",
    fill: "#e0e8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1907",
    "data-name": "Path 1907",
    d: "M200.02,161.821c-.038-.239.06-.354.3-.337v.311a.207.207,0,0,1-.3.026Z",
    transform: "translate(-125.067 -95.568)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1908",
    "data-name": "Path 1908",
    d: "M215.03,161.491l.3-.021c.047.243-.055.354-.3.337C215.034,161.7,215.032,161.6,215.03,161.491Z",
    transform: "translate(-136.882 -95.558)",
    fill: "#b4c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1909",
    "data-name": "Path 1909",
    d: "M234.51,161.45l.3.026c0,.1,0,.207,0,.311C234.57,161.806,234.472,161.689,234.51,161.45Z",
    transform: "translate(-152.202 -95.542)",
    fill: "#dce5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1910",
    "data-name": "Path 1910",
    d: "M249.492,161.464c.247-.017.348.094.3.339C249.538,161.822,249.44,161.709,249.492,161.464Z",
    transform: "translate(-163.984 -95.552)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1911",
    "data-name": "Path 1911",
    d: "M352.936,161.818c-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3c-.107,0-.213,0-.318,0Z",
    transform: "translate(-245.379 -95.591)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1912",
    "data-name": "Path 1912",
    d: "M354.432,161.839c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-246.555 -95.613)",
    fill: "#bbcdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1913",
    "data-name": "Path 1913",
    d: "M355.93,161.864l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3c-.107,0-.213,0-.322-.009Z",
    transform: "translate(-247.735 -95.637)",
    fill: "#89a97b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1914",
    "data-name": "Path 1914",
    d: "M357.43,161.873c0-.1.009-.2.015-.3.107,0,.213,0,.32,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-248.915 -95.637)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1915",
    "data-name": "Path 1915",
    d: "M97.989,163.07c.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3c-.23.032-.348-.062-.335-.3Z",
    transform: "translate(-44.798 -96.817)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1916",
    "data-name": "Path 1916",
    d: "M99.5,163.373c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-45.981 -96.817)",
    fill: "#94b085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1917",
    "data-name": "Path 1917",
    d: "M101,163.333l-.019-.294.322-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-47.154 -96.785)",
    fill: "#c5d5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1918",
    "data-name": "Path 1918",
    d: "M102.495,163.319c0-.1-.009-.2-.015-.3.23-.03.348.064.333.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-48.334 -96.773)",
    fill: "#f3f6f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1919",
    "data-name": "Path 1919",
    d: "M200.034,162.976l.3-.026c.036.239-.062.356-.307.337,0-.1,0-.207,0-.309Z",
    transform: "translate(-125.081 -96.722)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1920",
    "data-name": "Path 1920",
    d: "M213.82,162.986c0,.1,0,.207,0,.309a.208.208,0,0,1-.3.026c-.036-.239.062-.354.307-.337Z",
    transform: "translate(-135.683 -96.748)",
    fill: "#70965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1921",
    "data-name": "Path 1921",
    d: "M236.02,163.278c0-.1,0-.209,0-.313.249-.032.322.119.341.326l-.06.053A.228.228,0,0,1,236.02,163.278Z",
    transform: "translate(-153.396 -96.73)",
    fill: "#97b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M251,163c.245-.021.345.094.311.335a.208.208,0,0,1-.3-.026L251,163Z",
    transform: "translate(-165.181 -96.76)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M348.435,163.318c-.015-.243.1-.333.335-.292a.2.2,0,0,1-.017.294h-.318Z",
    transform: "translate(-241.837 -96.774)",
    fill: "#d0dcca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M349.93,163.354c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3C350.141,163.361,350.037,163.356,349.93,163.354Z",
    transform: "translate(-243.014 -96.809)",
    fill: "#9eb893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M351.42,163.376c.006-.1.013-.2.017-.3h.32C351.768,163.319,351.652,163.415,351.42,163.376Z",
    transform: "translate(-244.186 -96.825)",
    fill: "#6f945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M103.987,164.58h.32a.2.2,0,0,1,.017.294C104.09,164.915,103.977,164.819,103.987,164.58Z",
    transform: "translate(-49.519 -98.005)",
    fill: "#799c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1927",
    "data-name": "Path 1927",
    d: "M105.507,164.859c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-50.702 -97.989)",
    fill: "#a8bf9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M106.989,164.821l-.019-.294c.235-.041.35.055.337.294h-.318Z",
    transform: "translate(-51.866 -97.956)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M198.515,164.8c-.049-.243.051-.356.3-.339C198.861,164.707,198.765,164.822,198.515,164.8Z",
    transform: "translate(-123.88 -97.912)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M213.532,164.476l.3-.026c.038.239-.06.354-.3.337v-.311Z",
    transform: "translate(-135.702 -97.902)",
    fill: "#d7e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M237.277,164.5c.247-.019.307.119.281.333a.212.212,0,0,1-.3-.021l-.013.011a.243.243,0,0,1-.015-.318Z",
    transform: "translate(-154.305 -97.943)",
    fill: "#5f874b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1932",
    "data-name": "Path 1932",
    d: "M251,164.46l.3.026v.313c-.245.017-.345-.1-.3-.337Z",
    transform: "translate(-165.178 -97.91)",
    fill: "#88a77a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1933",
    "data-name": "Path 1933",
    d: "M342.437,164.824c-.013-.239.1-.333.335-.3a.2.2,0,0,1-.017.3h-.318Z",
    transform: "translate(-237.118 -97.956)",
    fill: "#e5ece2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1934",
    "data-name": "Path 1934",
    d: "M343.94,164.846c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C344.151,164.851,344.047,164.849,343.94,164.846Z",
    transform: "translate(-238.302 -97.981)",
    fill: "#b3c7aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1935",
    "data-name": "Path 1935",
    d: "M345.43,164.872l.019-.292c.107,0,.211,0,.318,0C345.782,164.827,345.665,164.917,345.43,164.872Z",
    transform: "translate(-239.474 -98.005)",
    fill: "#83a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1936",
    "data-name": "Path 1936",
    d: "M65.012,166.334c-.011-.1-.021-.2-.032-.3.254-.043.365.06.32.318l-.286-.019Z",
    transform: "translate(-18.831 -99.142)",
    fill: "#87a779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1937",
    "data-name": "Path 1937",
    d: "M108.5,166.07c.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3C108.6,166.4,108.48,166.309,108.5,166.07Z",
    transform: "translate(-53.065 -99.177)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1938",
    "data-name": "Path 1938",
    d: "M110,166.381c0-.1-.009-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.017.292l-.322.009Z",
    transform: "translate(-54.242 -99.185)",
    fill: "#8dab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1939",
    "data-name": "Path 1939",
    d: "M111.507,166.341c-.006-.1-.013-.2-.017-.292.107,0,.213,0,.32-.009a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-55.422 -99.153)",
    fill: "#bdceb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1940",
    "data-name": "Path 1940",
    d: "M113,166.316c-.006-.1-.011-.2-.017-.3.232-.032.348.062.335.3C113.208,166.318,113.1,166.318,113,166.316Z",
    transform: "translate(-56.595 -99.131)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1941",
    "data-name": "Path 1941",
    d: "M197.016,166.332c-.034-.241.066-.356.311-.333,0,.1-.006.207-.009.309A.208.208,0,0,1,197.016,166.332Z",
    transform: "translate(-122.705 -99.119)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1942",
    "data-name": "Path 1942",
    d: "M212.185,165.972c0,.1,0,.209,0,.313a.211.211,0,0,1-.237.09.234.234,0,0,1-.111-.075c.021-.207.1-.358.343-.326Z",
    transform: "translate(-134.372 -99.098)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1943",
    "data-name": "Path 1943",
    d: "M237.5,165.962l.3.021c0,.1,0,.209,0,.313-.243.017-.345-.094-.3-.337Z",
    transform: "translate(-154.554 -99.09)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1944",
    "data-name": "Path 1944",
    d: "M252.53,165.984c.245-.017.343.1.3.337a.207.207,0,0,1-.3-.026Z",
    transform: "translate(-166.385 -99.108)",
    fill: "#cedcc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1945",
    "data-name": "Path 1945",
    d: "M337.934,166.322c-.017-.245.1-.333.337-.29a.2.2,0,0,1-.017.294c-.107,0-.213,0-.318,0Z",
    transform: "translate(-233.575 -99.139)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1946",
    "data-name": "Path 1946",
    d: "M339.43,166.354c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-234.753 -99.169)",
    fill: "#99b48b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1947",
    "data-name": "Path 1947",
    d: "M340.93,166.386c.006-.1.011-.2.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-235.933 -99.193)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1948",
    "data-name": "Path 1948",
    d: "M384.81,166.031c-.013.1-.028.207-.04.311-.1,0-.19,0-.284.009-.036-.254.077-.354.324-.318Z",
    transform: "translate(-270.195 -99.143)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1949",
    "data-name": "Path 1949",
    d: "M114.488,167.58h.32a.2.2,0,0,1,.017.3C114.592,167.915,114.477,167.819,114.488,167.58Z",
    transform: "translate(-57.78 -100.365)",
    fill: "#71965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1950",
    "data-name": "Path 1950",
    d: "M116.007,167.861c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-58.963 -100.349)",
    fill: "#a1ba96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1951",
    "data-name": "Path 1951",
    d: "M117.489,167.817l-.019-.294c.232-.043.352.049.335.292h-.318Z",
    transform: "translate(-60.127 -100.312)",
    fill: "#d3decd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1952",
    "data-name": "Path 1952",
    d: "M197.04,167.483c.1-.009.2-.017.3-.023.045.241-.055.354-.3.337C197.042,167.692,197.042,167.588,197.04,167.483Z",
    transform: "translate(-122.728 -100.271)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1953",
    "data-name": "Path 1953",
    d: "M210.51,167.836c-.026-.211.034-.352.281-.333l.049,0a.243.243,0,0,1-.015.318l-.013-.011A.212.212,0,0,1,210.51,167.836Z",
    transform: "translate(-133.322 -100.303)",
    fill: "#5c8546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1954",
    "data-name": "Path 1954",
    d: "M239.032,167.8c0-.1,0-.207,0-.311.245-.017.343.1.3.337A.208.208,0,0,1,239.032,167.8Z",
    transform: "translate(-155.764 -100.288)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1955",
    "data-name": "Path 1955",
    d: "M252.5,167.45l.3.026c0,.1,0,.207.006.309C252.567,167.8,252.467,167.689,252.5,167.45Z",
    transform: "translate(-166.359 -100.263)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1956",
    "data-name": "Path 1956",
    d: "M331.937,167.816c-.011-.239.1-.335.337-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-228.858 -100.311)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1957",
    "data-name": "Path 1957",
    d: "M333.44,167.846c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.294C333.651,167.851,333.547,167.849,333.44,167.846Z",
    transform: "translate(-230.041 -100.341)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1958",
    "data-name": "Path 1958",
    d: "M334.93,167.874l.019-.294h.318c.015.243-.1.335-.335.292Z",
    transform: "translate(-231.213 -100.365)",
    fill: "#7d9f6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    "data-name": "Path 1959",
    d: "M120.484,169.074l.318,0a.2.2,0,0,1,.019.294C120.589,169.407,120.467,169.322,120.484,169.074Z",
    transform: "translate(-62.497 -101.537)",
    fill: "#85a676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1960",
    "data-name": "Path 1960",
    d: "M121.989,169.341l-.019-.294.32-.006a.2.2,0,0,1,.017.3C122.2,169.336,122.1,169.339,121.989,169.341Z",
    transform: "translate(-63.667 -101.514)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1961",
    "data-name": "Path 1961",
    d: "M123.487,169.319c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3C123.7,169.321,123.594,169.321,123.487,169.319Z",
    transform: "translate(-64.847 -101.494)",
    fill: "#e7ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1962",
    "data-name": "Path 1962",
    d: "M195.52,169.321c-.038-.239.06-.354.3-.337v.311A.209.209,0,0,1,195.52,169.321Z",
    transform: "translate(-121.526 -101.468)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1963",
    "data-name": "Path 1963",
    d: "M210.53,168.991l.3-.021c.047.243-.055.354-.3.337C210.534,169.2,210.532,169.1,210.53,168.991Z",
    transform: "translate(-133.342 -101.459)",
    fill: "#b4c8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1964",
    "data-name": "Path 1964",
    d: "M239.01,168.95l.3.026c0,.1,0,.207,0,.311C239.07,169.3,238.972,169.189,239.01,168.95Z",
    transform: "translate(-155.742 -101.443)",
    fill: "#dce4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1965",
    "data-name": "Path 1965",
    d: "M253.991,168.964c.247-.017.348.094.3.339C254.038,169.322,253.94,169.209,253.991,168.964Z",
    transform: "translate(-167.525 -101.452)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1966",
    "data-name": "Path 1966",
    d: "M325.945,169.313c-.015-.239.1-.333.333-.3a.2.2,0,0,1-.015.3Z",
    transform: "translate(-224.143 -101.486)",
    fill: "#f2f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1967",
    "data-name": "Path 1967",
    d: "M327.45,169.331c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294C327.661,169.333,327.557,169.333,327.45,169.331Z",
    transform: "translate(-225.328 -101.506)",
    fill: "#c2d2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1968",
    "data-name": "Path 1968",
    d: "M328.93,169.364l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-226.493 -101.537)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1969",
    "data-name": "Path 1969",
    d: "M330.43,169.371c0-.1.011-.2.015-.3.107,0,.213,0,.32,0C330.778,169.309,330.662,169.4,330.43,169.371Z",
    transform: "translate(-227.673 -101.537)",
    fill: "#628a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1970",
    "data-name": "Path 1970",
    d: "M78.594,170.856c0-.1,0-.211,0-.316l.3.011a.208.208,0,0,1,.015.3c-.1,0-.207,0-.309.006Z",
    transform: "translate(-29.538 -102.694)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1971",
    "data-name": "Path 1971",
    d: "M80,170.881c0-.1-.009-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-30.64 -102.725)",
    fill: "#c1d2ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1972",
    "data-name": "Path 1972",
    d: "M81.5,170.833l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-31.812 -102.686)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1973",
    "data-name": "Path 1973",
    d: "M83,170.806c0-.1-.011-.2-.015-.3.232-.032.348.062.335.3C83.218,170.808,83.112,170.808,83,170.806Z",
    transform: "translate(-33 -102.663)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1974",
    "data-name": "Path 1974",
    d: "M124.99,170.572h.32a.206.206,0,0,1,.017.3c-.232.036-.348-.06-.335-.3Z",
    transform: "translate(-66.043 -102.717)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1975",
    "data-name": "Path 1975",
    d: "M126.5,170.871c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C126.71,170.864,126.6,170.866,126.5,170.871Z",
    transform: "translate(-67.216 -102.717)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1976",
    "data-name": "Path 1976",
    d: "M127.989,170.821c-.006-.1-.013-.2-.019-.292.235-.045.352.045.337.29C128.2,170.819,128.1,170.819,127.989,170.821Z",
    transform: "translate(-68.388 -102.676)",
    fill: "#cbd9c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1977",
    "data-name": "Path 1977",
    d: "M195.534,170.476l.3-.026c.036.239-.062.356-.307.337l0-.309Z",
    transform: "translate(-121.54 -102.623)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1978",
    "data-name": "Path 1978",
    d: "M209.32,170.486c0,.1,0,.207,0,.309a.208.208,0,0,1-.3.026c-.036-.239.062-.354.307-.337Z",
    transform: "translate(-132.142 -102.648)",
    fill: "#70965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1979",
    "data-name": "Path 1979",
    d: "M240.52,170.779c0-.1,0-.209,0-.313.247-.03.322.119.341.326l-.06.053A.228.228,0,0,1,240.52,170.779Z",
    transform: "translate(-156.936 -102.632)",
    fill: "#96b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1980",
    "data-name": "Path 1980",
    d: "M255.5,170.491c.245-.021.345.094.311.335a.208.208,0,0,1-.3-.026l-.006-.309Z",
    transform: "translate(-168.722 -102.653)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M321.438,170.821c-.011-.239.1-.335.337-.294a.2.2,0,0,1-.017.294Z",
    transform: "translate(-220.597 -102.676)",
    fill: "#d7e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1982",
    "data-name": "Path 1982",
    d: "M322.932,170.854c.006-.1.013-.2.017-.294.107,0,.213,0,.318.006a.2.2,0,0,1-.019.294l-.318,0Z",
    transform: "translate(-221.772 -102.709)",
    fill: "#a6be9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1983",
    "data-name": "Path 1983",
    d: "M324.43,170.874l.019-.294h.32c.011.241-.1.335-.337.294Z",
    transform: "translate(-222.952 -102.725)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1984",
    "data-name": "Path 1984",
    d: "M368.252,170.816c-.107,0-.213,0-.318,0-.017-.245.1-.333.337-.29A.2.2,0,0,1,368.252,170.816Z",
    transform: "translate(-257.178 -102.671)",
    fill: "#86a577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1985",
    "data-name": "Path 1985",
    d: "M369.43,170.854l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.32-.009Z",
    transform: "translate(-258.356 -102.709)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1986",
    "data-name": "Path 1986",
    d: "M370.93,170.863c0-.1.011-.2.015-.3.1,0,.2,0,.3,0,0,.1,0,.209,0,.313Z",
    transform: "translate(-259.536 -102.709)",
    fill: "#e7ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1987",
    "data-name": "Path 1987",
    d: "M84.824,172.376c-.232.038-.348-.058-.337-.3h.32A.2.2,0,0,1,84.824,172.376Z",
    transform: "translate(-34.178 -103.905)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1988",
    "data-name": "Path 1988",
    d: "M86.007,172.361c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.318.006Z",
    transform: "translate(-35.36 -103.89)",
    fill: "#adc3a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1989",
    "data-name": "Path 1989",
    d: "M87.5,172.317l-.019-.294c.232-.043.352.047.335.292H87.5Z",
    transform: "translate(-36.532 -103.852)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1990",
    "data-name": "Path 1990",
    d: "M130.984,172.09h.318a.2.2,0,0,1,.017.294c-.232.043-.352-.049-.335-.292Z",
    transform: "translate(-70.758 -103.913)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1991",
    "data-name": "Path 1991",
    d: "M132.5,172.351c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.3C132.708,172.346,132.6,172.349,132.5,172.351Z",
    transform: "translate(-71.936 -103.882)",
    fill: "#b0c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1992",
    "data-name": "Path 1992",
    d: "M133.987,172.316c-.006-.1-.013-.2-.017-.3.232-.038.348.058.337.3Z",
    transform: "translate(-73.108 -103.851)",
    fill: "#e0e8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1993",
    "data-name": "Path 1993",
    d: "M194.015,172.3c-.049-.243.051-.356.3-.339C194.361,172.207,194.265,172.322,194.015,172.3Z",
    transform: "translate(-120.339 -103.813)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1994",
    "data-name": "Path 1994",
    d: "M209.032,171.976l.3-.026c.038.239-.058.354-.3.337v-.311Z",
    transform: "translate(-132.162 -103.803)",
    fill: "#d6e0d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1995",
    "data-name": "Path 1995",
    d: "M241.777,172c.247-.019.307.119.281.333a.212.212,0,0,1-.3-.021l-.013.011a.243.243,0,0,1-.015-.318Z",
    transform: "translate(-157.845 -103.844)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1996",
    "data-name": "Path 1996",
    d: "M255.5,171.95l.3.026v.313c-.245.017-.345-.1-.3-.337Z",
    transform: "translate(-168.718 -103.803)",
    fill: "#88a87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1997",
    "data-name": "Path 1997",
    d: "M315.446,172.318c-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3c-.107,0-.213,0-.318,0Z",
    transform: "translate(-215.884 -103.851)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1998",
    "data-name": "Path 1998",
    d: "M316.942,172.329c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-217.059 -103.866)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M318.44,172.364l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-218.24 -103.897)",
    fill: "#8aa97c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M319.94,172.373l.015-.3c.107,0,.213,0,.32,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-219.42 -103.897)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2001",
    "data-name": "Path 2001",
    d: "M362.247,172.316h-.32c-.011-.239.1-.335.337-.3A.2.2,0,0,1,362.247,172.316Z",
    transform: "translate(-252.453 -103.851)",
    fill: "#719660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2002",
    "data-name": "Path 2002",
    d: "M363.43,172.346c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.294Z",
    transform: "translate(-253.635 -103.882)",
    fill: "#a1ba96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M364.92,172.374l.019-.294h.318c.015.243-.1.335-.335.292Z",
    transform: "translate(-254.808 -103.905)",
    fill: "#d3decd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2004",
    "data-name": "Path 2004",
    d: "M90.822,173.864c-.232.043-.352-.045-.337-.29.107,0,.213,0,.318,0A.2.2,0,0,1,90.822,173.864Z",
    transform: "translate(-38.896 -105.078)",
    fill: "#c8d8c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2005",
    "data-name": "Path 2005",
    d: "M92.007,173.841c-.006-.1-.013-.2-.017-.294l.32-.006a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-40.081 -105.054)",
    fill: "#98b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2006",
    "data-name": "Path 2006",
    d: "M93.5,173.809c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3C93.71,173.811,93.6,173.811,93.5,173.809Z",
    transform: "translate(-41.253 -105.027)",
    fill: "#698f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2007",
    "data-name": "Path 2007",
    d: "M135.479,173.57c.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3c-.23.032-.348-.062-.335-.3Z",
    transform: "translate(-74.293 -105.078)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2008",
    "data-name": "Path 2008",
    d: "M137,173.863c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-75.484 -105.07)",
    fill: "#94b085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2009",
    "data-name": "Path 2009",
    d: "M138.489,173.823l-.019-.294.322-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-76.649 -105.038)",
    fill: "#c5d4be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2010",
    "data-name": "Path 2010",
    d: "M139.995,173.809c0-.1-.009-.2-.015-.3.23-.03.348.064.333.3C140.206,173.813,140.1,173.811,139.995,173.809Z",
    transform: "translate(-77.837 -105.026)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2011",
    "data-name": "Path 2011",
    d: "M192.516,173.832c-.034-.241.066-.356.311-.333,0,.1-.006.207-.009.309A.208.208,0,0,1,192.516,173.832Z",
    transform: "translate(-119.164 -105.019)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M207.812,173.474c0,.1,0,.209,0,.313a.2.2,0,0,1-.3.023C207.467,173.57,207.567,173.457,207.812,173.474Z",
    transform: "translate(-130.959 -105.001)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M242.009,173.462l.3.021c0,.1,0,.209,0,.313-.245.017-.345-.094-.3-.337Z",
    transform: "translate(-158.099 -104.991)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M257.03,173.484c.245-.017.343.1.3.337a.207.207,0,0,1-.3-.026Z",
    transform: "translate(-169.925 -105.008)",
    fill: "#cedbc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M310.945,173.818c-.015-.243.1-.333.335-.292a.2.2,0,0,1-.017.294h-.318Z",
    transform: "translate(-212.342 -105.035)",
    fill: "#d0dcca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M312.44,173.854c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-213.519 -105.07)",
    fill: "#9fb993"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M313.93,173.884c.006-.1.013-.2.017-.294h.32c.011.239-.1.335-.337.3Z",
    transform: "translate(-214.691 -105.093)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M356.263,173.809c-.107,0-.213,0-.318,0-.015-.239.1-.333.333-.3A.2.2,0,0,1,356.263,173.809Z",
    transform: "translate(-247.746 -105.026)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M357.44,173.829c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-248.923 -105.046)",
    fill: "#8caa7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M358.93,173.864l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-250.095 -105.078)",
    fill: "#bdceb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M360.43,173.871c.006-.1.011-.2.017-.3.107,0,.213,0,.318,0C360.778,173.809,360.662,173.9,360.43,173.871Z",
    transform: "translate(-251.275 -105.078)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M95.331,175.379c-.232.034-.348-.06-.335-.3h.318a.2.2,0,0,1,.017.3Z",
    transform: "translate(-42.445 -106.266)",
    fill: "#e5ece2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M96.507,175.371c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C96.72,175.364,96.614,175.366,96.507,175.371Z",
    transform: "translate(-43.621 -106.258)",
    fill: "#b3c7aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M98,175.321l-.019-.292c.235-.045.352.045.337.29C98.21,175.319,98.1,175.319,98,175.321Z",
    transform: "translate(-44.793 -106.217)",
    fill: "#83a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M141.477,175.08h.32a.2.2,0,0,1,.017.294C141.58,175.415,141.467,175.319,141.477,175.08Z",
    transform: "translate(-79.014 -106.266)",
    fill: "#7a9c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M143,175.351c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.019.294l-.318.006Z",
    transform: "translate(-80.197 -106.242)",
    fill: "#a8bf9e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M144.479,175.321l-.019-.294c.235-.041.35.055.337.294h-.318Z",
    transform: "translate(-81.361 -106.217)",
    fill: "#dbe4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M192.54,174.983c.1-.009.2-.017.3-.023.045.241-.055.354-.3.337v-.313Z",
    transform: "translate(-119.188 -106.171)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M207.511,174.973l.3-.023c.034.241-.066.356-.313.333,0-.1.006-.207.009-.309Z",
    transform: "translate(-130.958 -106.163)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M243.53,175.3v-.309c.243-.019.341.1.3.337a.208.208,0,0,1-.3-.026Z",
    transform: "translate(-159.304 -106.195)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M257,174.95l.3.026.006.309C257.065,175.306,256.967,175.191,257,174.95Z",
    transform: "translate(-169.898 -106.163)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M304.942,175.314c-.013-.239.1-.333.335-.3a.2.2,0,0,1-.017.3h-.32Z",
    transform: "translate(-207.618 -106.209)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M306.45,175.346c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C306.661,175.351,306.557,175.349,306.45,175.346Z",
    transform: "translate(-208.806 -106.242)",
    fill: "#b4c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M307.93,175.372c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C308.284,175.327,308.162,175.417,307.93,175.372Z",
    transform: "translate(-209.971 -106.266)",
    fill: "#84a374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M351.747,175.321h-.32c-.011-.239.1-.335.337-.294A.2.2,0,0,1,351.747,175.321Z",
    transform: "translate(-244.192 -106.217)",
    fill: "#779b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M352.922,175.354c.006-.1.011-.2.017-.294.107,0,.213,0,.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-245.367 -106.25)",
    fill: "#a8bf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M354.42,175.374l.019-.294h.32C354.77,175.321,354.655,175.415,354.42,175.374Z",
    transform: "translate(-246.547 -106.266)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M101.329,176.874c-.232.041-.352-.049-.335-.292.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-47.163 -107.446)",
    fill: "#d0ddca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M102.5,176.851l-.019-.294c.107,0,.213,0,.318-.006a.2.2,0,0,1,.017.3l-.318,0Z",
    transform: "translate(-48.334 -107.422)",
    fill: "#9eb892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M104,176.806c-.006-.1-.011-.2-.017-.3.232-.038.348.058.337.3Z",
    transform: "translate(-49.514 -107.384)",
    fill: "#6f945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M145.985,176.57c.107,0,.213,0,.318,0a.207.207,0,0,1,.015.3C146.088,176.9,145.97,176.809,145.985,176.57Z",
    transform: "translate(-82.56 -107.438)",
    fill: "#5f874a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M147.495,176.881c0-.1-.009-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-83.737 -107.446)",
    fill: "#8dab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M148.989,176.833l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-84.91 -107.406)",
    fill: "#bdcfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M150.495,176.806c0-.1-.011-.2-.015-.3.232-.032.348.062.335.3-.107,0-.213,0-.318,0Z",
    transform: "translate(-86.098 -107.384)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M191.011,176.816c-.038-.239.064-.35.3-.333v.311a.208.208,0,0,1-.307.021Z",
    transform: "translate(-117.979 -107.369)",
    fill: "#d1deca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M206.311,176.452c.049.243-.051.356-.3.339C205.965,176.548,206.061,176.433,206.311,176.452Z",
    transform: "translate(-129.779 -107.344)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M243.5,176.45l.3.026c0,.1,0,.207,0,.311C243.56,176.806,243.462,176.689,243.5,176.45Z",
    transform: "translate(-159.275 -107.343)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M258.5,176.462c.245-.019.345.092.3.335C258.552,176.818,258.447,176.71,258.5,176.462Z",
    transform: "translate(-171.07 -107.351)",
    fill: "#a5bd9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M300.444,176.822c-.017-.245.1-.333.337-.29a.2.2,0,0,1-.017.294c-.107,0-.213,0-.318,0Z",
    transform: "translate(-204.08 -107.4)",
    fill: "#c9d8c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M301.94,176.854c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-205.258 -107.43)",
    fill: "#99b48b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M303.44,176.886c.006-.1.011-.2.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-206.438 -107.454)",
    fill: "#698f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M345.756,176.806c-.107,0-.213,0-.32,0-.013-.239.1-.333.335-.3A.207.207,0,0,1,345.756,176.806Z",
    transform: "translate(-239.478 -107.384)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M346.932,176.829c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-240.654 -107.406)",
    fill: "#93af85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M348.43,176.864l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-241.834 -107.438)",
    fill: "#c4d4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M349.93,176.873c0-.1.009-.2.015-.3.107,0,.213,0,.32,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-243.014 -107.438)",
    fill: "#f3f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M105.821,178.371c-.23.032-.348-.062-.335-.3.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3Z",
    transform: "translate(-50.698 -108.618)",
    fill: "#ecf1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M107,178.363c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-51.882 -108.61)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M108.5,178.323l-.019-.294.322-.009a.2.2,0,0,1,.015.3H108.5Z",
    transform: "translate(-53.054 -108.579)",
    fill: "#89a97b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M109.995,178.309c0-.1-.009-.2-.015-.3.23-.03.348.064.333.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-54.234 -108.567)",
    fill: "#5d8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M151.978,178.08h.32a.2.2,0,0,1,.017.3C152.082,178.415,151.967,178.319,151.978,178.08Z",
    transform: "translate(-87.275 -108.626)",
    fill: "#71965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M153.5,178.361c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.318.006Z",
    transform: "translate(-88.458 -108.61)",
    fill: "#a2bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M154.979,178.317l-.019-.294c.235-.043.352.049.335.292h-.318Z",
    transform: "translate(-89.622 -108.573)",
    fill: "#d3decd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M190.75,177.971l.307-.021c.034.224-.051.35-.29.343l-.064-.045a.224.224,0,0,1,.043-.284Z",
    transform: "translate(-117.718 -108.523)",
    fill: "#618a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M204.82,177.992c0,.1,0,.207,0,.309a.208.208,0,0,1-.3.026C204.477,178.088,204.575,177.973,204.82,177.992Z",
    transform: "translate(-128.602 -108.555)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M245.02,178.278c0-.1,0-.209,0-.313.247-.032.322.119.343.326l-.06.053a.228.228,0,0,1-.286-.066Z",
    transform: "translate(-160.477 -108.531)",
    fill: "#96b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M259.965,177.989c.243-.023.348.087.311.328C260.022,178.349,259.922,178.236,259.965,177.989Z",
    transform: "translate(-172.227 -108.551)",
    fill: "#cfdbc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M294.448,178.316c-.011-.239.1-.335.337-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-199.363 -108.572)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M295.95,178.346c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.294C296.161,178.351,296.057,178.349,295.95,178.346Z",
    transform: "translate(-200.546 -108.602)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M297.44,178.374l.019-.294h.318c.015.243-.1.335-.335.292Z",
    transform: "translate(-201.718 -108.626)",
    fill: "#7d9f6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M341.253,178.328h-.318c-.015-.243.1-.333.335-.292a.2.2,0,0,1-.017.294Z",
    transform: "translate(-235.937 -108.583)",
    fill: "#7fa06e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M342.43,178.354c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-237.114 -108.61)",
    fill: "#afc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M343.93,178.376c.006-.1.013-.2.017-.3h.32C344.278,178.319,344.165,178.415,343.93,178.376Z",
    transform: "translate(-238.294 -108.626)",
    fill: "#dfe8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M111.824,179.874c-.235.041-.348-.055-.337-.294h.32A.2.2,0,0,1,111.824,179.874Z",
    transform: "translate(-55.42 -109.806)",
    fill: "#d7e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M113.007,179.859c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-56.602 -109.79)",
    fill: "#a5bd9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M114.489,179.821l-.019-.294c.235-.041.35.055.337.294h-.318Z",
    transform: "translate(-57.767 -109.757)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M157.974,179.574c.107,0,.213,0,.318,0a.2.2,0,0,1,.019.294C158.079,179.907,157.957,179.822,157.974,179.574Z",
    transform: "translate(-91.992 -109.798)",
    fill: "#86a577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M159.489,179.841l-.019-.294.32-.006a.2.2,0,0,1,.017.3C159.7,179.836,159.6,179.839,159.489,179.841Z",
    transform: "translate(-93.17 -109.774)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M160.987,179.809c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3C161.2,179.811,161.094,179.811,160.987,179.809Z",
    transform: "translate(-94.35 -109.747)",
    fill: "#e8efe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M189.583,179.283a.3.3,0,0,1-.333.333l-.058-.053a.227.227,0,0,1,.055-.284h0a.213.213,0,0,1,.3-.015Z",
    transform: "translate(-116.534 -109.513)",
    fill: "#6b9258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M204.532,179.476l.3-.026c.038.239-.06.354-.3.337v-.311Z",
    transform: "translate(-128.621 -109.704)",
    fill: "#d5dfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M246.267,179.5c.247-.019.307.119.282.333a.212.212,0,0,1-.3-.021l-.013.011a.243.243,0,0,1-.015-.318Z",
    transform: "translate(-161.378 -109.744)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M261.438,179.507q.361-.051.326.313C261.514,179.863,261.4,179.761,261.438,179.507Z",
    transform: "translate(-173.388 -109.743)",
    fill: "#d3decc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M288.455,179.813c-.015-.239.1-.333.333-.3a.2.2,0,0,1-.015.3C288.666,179.809,288.56,179.811,288.455,179.813Z",
    transform: "translate(-194.648 -109.747)",
    fill: "#f2f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M289.95,179.821c0-.1.009-.2.015-.3l.322.009a.2.2,0,0,1-.019.294C290.161,179.823,290.057,179.823,289.95,179.821Z",
    transform: "translate(-195.825 -109.759)",
    fill: "#c2d2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M291.44,179.864l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-196.997 -109.798)",
    fill: "#92ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M292.94,179.879c0-.1.011-.2.015-.3h.32C293.288,179.817,293.172,179.911,292.94,179.879Z",
    transform: "translate(-198.177 -109.806)",
    fill: "#628a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M335.256,179.8h-.32c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-231.217 -109.739)",
    fill: "#6b9157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M336.44,179.836c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C336.651,179.841,336.547,179.839,336.44,179.836Z",
    transform: "translate(-232.401 -109.774)",
    fill: "#9ab58d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M337.93,179.872c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C338.284,179.827,338.162,179.917,337.93,179.872Z",
    transform: "translate(-233.573 -109.806)",
    fill: "#cbdac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M116.328,181.373c-.23.03-.348-.064-.333-.3.107,0,.213,0,.318,0A.206.206,0,0,1,116.328,181.373Z",
    transform: "translate(-58.966 -110.978)",
    fill: "#f1f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M117.5,181.381c0-.1-.009-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-60.143 -110.986)",
    fill: "#c1d2ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M118.989,181.333l-.019-.294c.107,0,.213,0,.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-61.307 -110.947)",
    fill: "#91ad82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M120.495,181.306c0-.1-.011-.2-.015-.3.232-.032.348.062.335.3C120.708,181.308,120.6,181.308,120.495,181.306Z",
    transform: "translate(-62.495 -110.924)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M162.48,181.062h.32a.206.206,0,0,1,.017.3c-.232.036-.348-.06-.335-.3Z",
    transform: "translate(-95.538 -110.97)",
    fill: "#6b9258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M163.987,181.361c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C164.2,181.354,164.094,181.356,163.987,181.361Z",
    transform: "translate(-96.711 -110.97)",
    fill: "#9bb58e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M165.479,181.321c-.006-.1-.013-.2-.019-.292.235-.045.352.045.337.29C165.69,181.319,165.586,181.319,165.479,181.321Z",
    transform: "translate(-97.883 -110.937)",
    fill: "#ccdac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M186.474,181.311c-.017-.241.1-.343.335-.3a.205.205,0,0,1-.021.3c-.1,0-.209,0-.313,0Z",
    transform: "translate(-114.414 -110.923)",
    fill: "#c6d5bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M187.95,181.08c.006-.1.015-.2.021-.3l-.009-.006a.228.228,0,0,1,.311-.013l.019.034C188.3,181.026,188.174,181.112,187.95,181.08Z",
    transform: "translate(-115.577 -110.687)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M203.193,180.958c0,.1,0,.209,0,.313a.207.207,0,0,1-.237.087.222.222,0,0,1-.109-.077c.021-.207.1-.356.343-.326Z",
    transform: "translate(-127.299 -110.885)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M246.494,180.952l.3.021c0,.1,0,.209,0,.313-.245.017-.345-.094-.3-.337Z",
    transform: "translate(-161.626 -110.884)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M262.95,181c.241-.045.352.058.335.3C263.038,181.354,262.929,181.252,262.95,181Z",
    transform: "translate(-174.581 -110.917)",
    fill: "#a9c09e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M283.948,181.321c-.011-.239.1-.335.337-.294a.2.2,0,0,1-.017.294Z",
    transform: "translate(-191.102 -110.937)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M285.442,181.354c.006-.1.013-.2.017-.294.107,0,.213,0,.318.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-192.277 -110.97)",
    fill: "#a6be9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M286.94,181.374l.019-.294h.32c.011.241-.1.335-.337.294Z",
    transform: "translate(-193.457 -110.986)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M330.762,181.316c-.107,0-.213,0-.318,0-.017-.245.1-.333.337-.29A.2.2,0,0,1,330.762,181.316Z",
    transform: "translate(-227.683 -110.932)",
    fill: "#85a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M331.94,181.354c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3Z",
    transform: "translate(-228.861 -110.97)",
    fill: "#b6c9ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M333.43,181.369c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0C333.78,181.309,333.662,181.4,333.43,181.369Z",
    transform: "translate(-230.033 -110.978)",
    fill: "#e7ede3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M122.314,182.876c-.232.038-.348-.058-.337-.3h.32A.2.2,0,0,1,122.314,182.876Z",
    transform: "translate(-63.673 -112.166)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M123.5,182.861c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.318.006Z",
    transform: "translate(-64.855 -112.15)",
    fill: "#acc2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2110",
    "data-name": "Path 2110",
    d: "M124.989,182.817l-.019-.294c.232-.043.352.049.335.292h-.318Z",
    transform: "translate(-66.028 -112.113)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M168.474,182.582c.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294C168.576,182.915,168.457,182.827,168.474,182.582Z",
    transform: "translate(-100.253 -112.166)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2112",
    "data-name": "Path 2112",
    d: "M169.987,182.841c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318-.006a.2.2,0,0,1,.017.3C170.2,182.836,170.094,182.839,169.987,182.841Z",
    transform: "translate(-101.431 -112.135)",
    fill: "#b0c5a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2113",
    "data-name": "Path 2113",
    d: "M171.487,182.806c-.006-.1-.013-.2-.017-.3.232-.038.348.058.337.3Z",
    transform: "translate(-102.611 -112.104)",
    fill: "#e1e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2114",
    "data-name": "Path 2114",
    d: "M183.467,182.818c-.013-.243.107-.337.341-.294a.2.2,0,0,1-.026.3C183.678,182.822,183.571,182.818,183.467,182.818Z",
    transform: "translate(-112.049 -112.114)",
    fill: "#cddac7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2115",
    "data-name": "Path 2115",
    d: "M184.95,182.851c.009-.1.017-.2.026-.3.1,0,.209,0,.311,0,.017.245-.1.343-.337.3Z",
    transform: "translate(-113.217 -112.143)",
    fill: "#7b9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2116",
    "data-name": "Path 2116",
    d: "M201.51,182.836c-.026-.213.034-.352.282-.333l.049.006a.236.236,0,0,1-.017.316l-.011-.009a.212.212,0,0,1-.3.021Z",
    transform: "translate(-126.241 -112.105)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    "data-name": "Path 2117",
    d: "M248.03,182.8v-.309c.245-.019.343.1.307.335a.209.209,0,0,1-.3-.026Z",
    transform: "translate(-162.845 -112.096)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    "data-name": "Path 2118",
    d: "M264.472,182.53l.311.009a.208.208,0,0,1,.023.3C264.568,182.875,264.453,182.775,264.472,182.53Z",
    transform: "translate(-175.779 -112.127)",
    fill: "#699055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2119",
    "data-name": "Path 2119",
    d: "M265.963,182.837c-.009-.1-.015-.2-.023-.3l.322-.006a.207.207,0,0,1,.017.3c-.1,0-.211,0-.316.009Z",
    transform: "translate(-176.935 -112.127)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2120",
    "data-name": "Path 2120",
    d: "M267.467,182.809c-.006-.1-.011-.2-.017-.3.232-.032.35.064.335.3-.107,0-.211,0-.318,0Z",
    transform: "translate(-178.123 -112.105)",
    fill: "#f5f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2121",
    "data-name": "Path 2121",
    d: "M277.956,182.808c-.013-.239.1-.333.335-.3a.206.206,0,0,1-.015.3h-.318Z",
    transform: "translate(-186.389 -112.104)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2122",
    "data-name": "Path 2122",
    d: "M279.442,182.829c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-187.556 -112.127)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2123",
    "data-name": "Path 2123",
    d: "M280.94,182.864c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.32-.009Z",
    transform: "translate(-188.737 -112.158)",
    fill: "#8baa7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2124",
    "data-name": "Path 2124",
    d: "M282.45,182.873c0-.1.011-.2.015-.3.107,0,.213,0,.32,0,.015.239-.1.335-.333.3Z",
    transform: "translate(-189.925 -112.158)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2125",
    "data-name": "Path 2125",
    d: "M324.757,182.806h-.32c-.011-.239.1-.335.337-.3A.2.2,0,0,1,324.757,182.806Z",
    transform: "translate(-222.958 -112.104)",
    fill: "#70965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2126",
    "data-name": "Path 2126",
    d: "M325.94,182.836c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.294C326.151,182.841,326.047,182.839,325.94,182.836Z",
    transform: "translate(-224.14 -112.135)",
    fill: "#a0ba95"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2127",
    "data-name": "Path 2127",
    d: "M327.43,182.864l.019-.294h.318c.015.243-.1.335-.337.292Z",
    transform: "translate(-225.312 -112.158)",
    fill: "#d2decb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M128.311,184.364c-.232.043-.354-.043-.337-.29.107,0,.213,0,.32,0A.2.2,0,0,1,128.311,184.364Z",
    transform: "translate(-68.39 -113.338)",
    fill: "#c7d6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2129",
    "data-name": "Path 2129",
    d: "M129.5,184.341c-.006-.1-.013-.2-.017-.294l.318-.006a.2.2,0,0,1,.017.3C129.708,184.336,129.6,184.339,129.5,184.341Z",
    transform: "translate(-69.576 -113.315)",
    fill: "#97b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2130",
    "data-name": "Path 2130",
    d: "M130.987,184.311c-.006-.1-.011-.2-.017-.3.232-.034.348.06.337.3C131.2,184.314,131.094,184.314,130.987,184.311Z",
    transform: "translate(-70.748 -113.29)",
    fill: "#668d53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2131",
    "data-name": "Path 2131",
    d: "M172.976,184.07c.107,0,.213,0,.322,0a.207.207,0,0,1,.009.3C173.079,184.4,172.964,184.3,172.976,184.07Z",
    transform: "translate(-103.796 -113.338)",
    fill: "#628a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2132",
    "data-name": "Path 2132",
    d: "M174.5,184.381c0-.1-.006-.2-.009-.3h.32c0,.1.006.2.011.3-.107,0-.213,0-.322.006Z",
    transform: "translate(-104.987 -113.346)",
    fill: "#83a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M180.47,184.372l.013-.292h.32a.2.2,0,0,1-.011.3l-.32-.009Z",
    transform: "translate(-109.692 -113.346)",
    fill: "#82a373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2134",
    "data-name": "Path 2134",
    d: "M181.98,184.365c0-.1.009-.2.011-.3.107,0,.213,0,.32-.006C182.325,184.3,182.212,184.395,181.98,184.365Z",
    transform: "translate(-110.88 -113.331)",
    fill: "#5d8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2135",
    "data-name": "Path 2135",
    d: "M201.53,183.991l.3-.021c.043.245-.062.354-.3.333Z",
    transform: "translate(-126.261 -113.26)",
    fill: "#bfd1b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2136",
    "data-name": "Path 2136",
    d: "M248,183.95l.3.026c0,.1.006.2.009.307C248.07,184.308,247.968,184.193,248,183.95Z",
    transform: "translate(-162.818 -113.244)",
    fill: "#e2e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2137",
    "data-name": "Path 2137",
    d: "M268.946,184.08h.324a.2.2,0,0,1,.009.3C269.047,184.413,268.934,184.317,268.946,184.08Z",
    transform: "translate(-179.3 -113.346)",
    fill: "#7c9e6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2138",
    "data-name": "Path 2138",
    d: "M270.479,184.376c0-.1-.006-.2-.009-.3h.322c0,.1,0,.2,0,.294-.107,0-.211,0-.318,0Z",
    transform: "translate(-180.499 -113.346)",
    fill: "#96b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2139",
    "data-name": "Path 2139",
    d: "M274.952,184.37c0-.1.006-.194.009-.29h.32a.2.2,0,0,1-.013.3l-.318-.006Z",
    transform: "translate(-184.024 -113.346)",
    fill: "#8cab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2140",
    "data-name": "Path 2140",
    d: "M276.45,184.369c0-.1.009-.2.013-.3.107,0,.215,0,.322,0C276.8,184.307,276.682,184.4,276.45,184.369Z",
    transform: "translate(-185.204 -113.338)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2141",
    "data-name": "Path 2141",
    d: "M318.773,184.309c-.107,0-.213,0-.318,0-.015-.239.1-.333.333-.3a.206.206,0,0,1-.013.3Z",
    transform: "translate(-218.251 -113.287)",
    fill: "#5e8749"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2142",
    "data-name": "Path 2142",
    d: "M319.942,184.329c0-.1.009-.2.013-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-219.42 -113.307)",
    fill: "#8caa7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2143",
    "data-name": "Path 2143",
    d: "M321.44,184.354l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3C321.653,184.361,321.547,184.359,321.44,184.354Z",
    transform: "translate(-220.6 -113.331)",
    fill: "#bdceb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2144",
    "data-name": "Path 2144",
    d: "M322.94,184.371c.006-.1.011-.2.017-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-221.78 -113.338)",
    fill: "#edf2eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2145",
    "data-name": "Path 2145",
    d: "M132.821,185.869c-.232.036-.348-.06-.335-.3h.32a.206.206,0,0,1,.017.3Z",
    transform: "translate(-71.94 -114.519)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2146",
    "data-name": "Path 2146",
    d: "M134,185.861c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292C134.21,185.854,134.1,185.856,134,185.861Z",
    transform: "translate(-73.116 -114.511)",
    fill: "#b3c7a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2147",
    "data-name": "Path 2147",
    d: "M135.489,185.824c-.006-.1-.013-.2-.019-.292.232-.043.352.045.337.29h-.318Z",
    transform: "translate(-74.288 -114.48)",
    fill: "#82a373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2148",
    "data-name": "Path 2148",
    d: "M200.311,185.48c.043.247-.06.356-.309.331C199.963,185.568,200.068,185.459,200.311,185.48Z",
    transform: "translate(-125.052 -114.446)",
    fill: "#95b186"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2149",
    "data-name": "Path 2149",
    d: "M249.815,185.779c-.247.026-.352-.083-.309-.331C249.751,185.425,249.853,185.536,249.815,185.779Z",
    transform: "translate(-163.998 -114.421)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2150",
    "data-name": "Path 2150",
    d: "M314.257,185.811h-.32c-.011-.239.1-.335.337-.294A.2.2,0,0,1,314.257,185.811Z",
    transform: "translate(-214.697 -114.47)",
    fill: "#789b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M315.44,185.844c.006-.1.011-.2.017-.294.107,0,.213,0,.32.006a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-215.879 -114.503)",
    fill: "#a6be9c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M316.93,185.874l.019-.294h.32C317.28,185.821,317.165,185.917,316.93,185.874Z",
    transform: "translate(-217.052 -114.526)",
    fill: "#d9e3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M138.819,187.364c-.232.041-.352-.047-.335-.292.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294Z",
    transform: "translate(-76.658 -115.699)",
    fill: "#d0dcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M139.989,187.341l-.019-.294c.107,0,.213,0,.318-.006a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-77.829 -115.675)",
    fill: "#9eb791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M141.487,187.306c-.006-.1-.011-.2-.017-.3.232-.038.348.058.337.3Z",
    transform: "translate(-79.009 -115.645)",
    fill: "#6f945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M198.817,186.994c.036.247-.068.356-.318.324C198.467,187.075,198.572,186.967,198.817,186.994Z",
    transform: "translate(-123.872 -115.636)",
    fill: "#80a270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M251.3,187.3c-.247.032-.354-.075-.316-.324C251.225,186.951,251.329,187.057,251.3,187.3Z",
    transform: "translate(-165.161 -115.622)",
    fill: "#a3bc98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M308.266,187.306c-.107,0-.213,0-.32,0-.013-.239.1-.333.335-.3A.206.206,0,0,1,308.266,187.306Z",
    transform: "translate(-209.983 -115.645)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M309.442,187.329c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-211.159 -115.667)",
    fill: "#92af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M310.94,187.364l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.322-.009Z",
    transform: "translate(-212.339 -115.699)",
    fill: "#c3d3bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M312.44,187.373l.015-.3c.107,0,.213,0,.318,0C312.788,187.309,312.67,187.4,312.44,187.373Z",
    transform: "translate(-213.519 -115.699)",
    fill: "#f3f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M143.321,188.871c-.23.032-.348-.062-.335-.3.107,0,.213,0,.318,0a.206.206,0,0,1,.015.3Z",
    transform: "translate(-80.201 -116.879)",
    fill: "#ebf1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M144.5,188.863c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.32.009Z",
    transform: "translate(-81.385 -116.871)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M145.989,188.823l-.019-.294.322-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-82.549 -116.839)",
    fill: "#89a87b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M147.485,188.809c0-.1-.009-.2-.015-.3.23-.03.348.064.333.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-83.729 -116.827)",
    fill: "#5c8546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M197.319,188.507c.032.25-.077.354-.324.316C196.967,188.577,197.075,188.473,197.319,188.507Z",
    transform: "translate(-122.689 -116.824)",
    fill: "#82a372"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M252.8,188.805c-.247.038-.354-.068-.322-.316C252.723,188.458,252.829,188.564,252.8,188.805Z",
    transform: "translate(-166.341 -116.811)",
    fill: "#a3bc98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M303.763,188.828h-.318c-.015-.243.1-.333.335-.292a.2.2,0,0,1-.017.294Z",
    transform: "translate(-206.442 -116.844)",
    fill: "#7d9f6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M304.94,188.854c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-207.618 -116.871)",
    fill: "#afc4a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M306.43,188.874c.006-.1.013-.2.017-.294h.32c.011.239-.1.335-.337.3Z",
    transform: "translate(-208.791 -116.887)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M149.314,190.374c-.235.04-.348-.055-.337-.294h.32A.2.2,0,0,1,149.314,190.374Z",
    transform: "translate(-84.915 -118.067)",
    fill: "#d7e1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M150.5,190.359c-.006-.1-.013-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.211,0-.318.006Z",
    transform: "translate(-86.098 -118.051)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M151.979,190.311l-.019-.294c.235-.041.35.055.337.294h-.318Z",
    transform: "translate(-87.262 -118.01)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M195.8,190c.026.25-.083.352-.331.307C195.449,190.063,195.558,189.958,195.8,190Z",
    transform: "translate(-121.491 -117.996)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M254.3,190.3c-.247.043-.354-.064-.328-.309C254.219,189.953,254.33,190.055,254.3,190.3Z",
    transform: "translate(-167.52 -117.991)",
    fill: "#baccb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M297.766,190.3h-.32c-.013-.239.1-.333.335-.3a.2.2,0,0,1-.017.3Z",
    transform: "translate(-201.722 -118.002)",
    fill: "#699056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M298.942,190.336c0-.1.011-.2.015-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-202.898 -118.035)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M300.44,190.372c.006-.1.013-.2.019-.292.107,0,.213,0,.318,0C300.792,190.327,300.675,190.417,300.44,190.372Z",
    transform: "translate(-204.078 -118.067)",
    fill: "#cad9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M153.818,191.863c-.23.03-.348-.064-.333-.3.107,0,.213,0,.318,0A.206.206,0,0,1,153.818,191.863Z",
    transform: "translate(-88.461 -119.231)",
    fill: "#f1f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M154.995,191.871c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292Z",
    transform: "translate(-89.638 -119.239)",
    fill: "#c0d1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M156.5,191.823c-.006-.1-.013-.2-.017-.294.107,0,.213,0,.32-.009a.2.2,0,0,1,.015.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-90.818 -119.2)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M157.985,191.806c0-.1-.011-.2-.015-.3.232-.032.348.062.335.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-91.99 -119.185)",
    fill: "#61894d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M192.5,191.794c-.021-.249.117-.309.331-.284a.21.21,0,0,1-.023.3l.009.009a.221.221,0,0,1-.239.066.129.129,0,0,1-.079-.1Z",
    transform: "translate(-119.157 -119.187)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M193.96,191.843c.009-.1.015-.2.023-.3h.309c.021.245-.09.348-.333.3Z",
    transform: "translate(-120.305 -119.215)",
    fill: "#c7d7c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M255.812,191.813c-.243.036-.356-.064-.333-.313l.307.009A.211.211,0,0,1,255.812,191.813Z",
    transform: "translate(-168.703 -119.184)",
    fill: "#dee6da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M256.956,191.818l-.026-.3c.239-.036.354.062.337.307h-.311Z",
    transform: "translate(-169.847 -119.188)",
    fill: "#719660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M293.262,191.816c-.107,0-.211,0-.318,0-.017-.245.1-.333.337-.29A.2.2,0,0,1,293.262,191.816Z",
    transform: "translate(-198.18 -119.193)",
    fill: "#84a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M294.44,191.854l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3l-.318-.006Z",
    transform: "translate(-199.358 -119.231)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M295.94,191.876l.017-.3h.32c.013.239-.1.335-.337.3Z",
    transform: "translate(-200.538 -119.247)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M159.814,193.366c-.232.038-.348-.058-.337-.3h.32A.2.2,0,0,1,159.814,193.366Z",
    transform: "translate(-93.176 -120.419)",
    fill: "#dde5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M161,193.351c-.006-.1-.011-.2-.017-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294l-.318.006Z",
    transform: "translate(-94.358 -120.403)",
    fill: "#abc2a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M162.479,193.308l-.019-.294c.235-.043.35.051.339.292h-.32Z",
    transform: "translate(-95.523 -120.367)",
    fill: "#7c9e6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M191.263,193.213l-.318-.009c-.032-.254.126-.318.331-.335v.049a.194.194,0,0,1-.015.3Z",
    transform: "translate(-117.93 -120.262)",
    fill: "#a3bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M258.784,193.349c-.243.049-.354-.051-.339-.3.1,0,.209,0,.314,0a.2.2,0,0,1,.023.3Z",
    transform: "translate(-171.038 -120.403)",
    fill: "#bbccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M259.953,193.313c-.009-.1-.017-.2-.023-.3.237-.036.354.06.337.3-.1,0-.209,0-.313,0Z",
    transform: "translate(-172.207 -120.368)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M287.267,193.306h-.32c-.011-.239.1-.335.337-.3A.2.2,0,0,1,287.267,193.306Z",
    transform: "translate(-193.462 -120.365)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M288.45,193.336c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.294C288.661,193.341,288.557,193.339,288.45,193.336Z",
    transform: "translate(-194.645 -120.396)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M289.94,193.364l.019-.294h.318c.015.245-.1.335-.337.292Z",
    transform: "translate(-195.817 -120.419)",
    fill: "#d2decb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M164.316,194.865c-.23.03-.345-.066-.331-.3.107,0,.213,0,.318,0A.207.207,0,0,1,164.316,194.865Z",
    transform: "translate(-96.722 -121.591)",
    fill: "#f5f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M165.493,194.881l-.013-.3h.318a.2.2,0,0,1,.019.294l-.322.009Z",
    transform: "translate(-97.899 -121.607)",
    fill: "#c7d6c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M166.989,194.841l-.019-.294.32-.006a.2.2,0,0,1,.017.3C167.2,194.836,167.1,194.839,166.989,194.841Z",
    transform: "translate(-99.071 -121.576)",
    fill: "#97b289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M168.477,194.811c-.006-.1-.011-.2-.017-.3.232-.034.348.06.335.3h-.32Z",
    transform: "translate(-100.243 -121.551)",
    fill: "#668d53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M186.785,194.816h-.318c-.011-.241.1-.335.337-.3a.2.2,0,0,1-.021.3Z",
    transform: "translate(-114.41 -121.553)",
    fill: "#739861"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M187.96,194.846c.006-.1.013-.2.021-.3.107,0,.211,0,.318,0a.207.207,0,0,1-.019.3l-.318-.009Z",
    transform: "translate(-115.585 -121.583)",
    fill: "#b0c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M189.45,194.839l.019-.3.313-.009c.019.243-.1.343-.333.311Z",
    transform: "translate(-116.757 -121.568)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M261.785,194.864q-.358.07-.339-.294h.316a.2.2,0,0,1,.021.294Z",
    transform: "translate(-173.399 -121.599)",
    fill: "#c4d4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M262.961,194.823c-.006-.1-.015-.2-.021-.294.235-.045.354.045.339.292-.1,0-.211,0-.316,0Z",
    transform: "translate(-174.575 -121.558)",
    fill: "#86a778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M281.275,194.8c-.107,0-.213,0-.32,0-.015-.239.1-.333.333-.3a.206.206,0,0,1-.013.3Z",
    transform: "translate(-188.748 -121.54)",
    fill: "#5d8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M282.46,194.829c0-.1.009-.2.013-.3l.322.009a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-189.932 -121.568)",
    fill: "#8baa7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M283.932,194.854c.006-.1.013-.2.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.017.3c-.107,0-.213,0-.32-.009Z",
    transform: "translate(-191.089 -121.591)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M285.44,194.871c.006-.1.011-.2.017-.3.107,0,.213,0,.318,0C285.788,194.809,285.672,194.9,285.44,194.871Z",
    transform: "translate(-192.277 -121.599)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M170.312,196.369c-.23.034-.345-.062-.335-.3.107,0,.213,0,.32,0a.2.2,0,0,1,.013.3Z",
    transform: "translate(-101.437 -122.779)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M171.5,196.376l-.013-.3h.32a.2.2,0,0,1,.013.29l-.318.006Z",
    transform: "translate(-102.627 -122.787)",
    fill: "#bdcfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M172.993,196.346l-.013-.29c.107,0,.215,0,.322-.006a.2.2,0,0,1,.009.3Z",
    transform: "translate(-103.799 -122.764)",
    fill: "#9eb892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M174.5,196.321c0-.1,0-.2-.009-.3.107,0,.215,0,.322,0,0,.1,0,.2,0,.3H174.5Z",
    transform: "translate(-104.987 -122.74)",
    fill: "#87a779"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M180.5,196.334c0-.1,0-.2.006-.294.107,0,.215,0,.322,0a.2.2,0,0,1-.011.29Z",
    transform: "translate(-109.716 -122.756)",
    fill: "#8baa7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M181.99,196.36c0-.1.006-.194.011-.29.107,0,.213,0,.32,0a.2.2,0,0,1-.013.292C182.2,196.364,182.1,196.362,181.99,196.36Z",
    transform: "translate(-110.888 -122.779)",
    fill: "#a2bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M183.48,196.362l.013-.292h.32a.2.2,0,0,1-.015.3c-.107,0-.213,0-.318-.009Z",
    transform: "translate(-112.06 -122.779)",
    fill: "#c2d2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M184.97,196.363c0-.1.009-.2.015-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-113.232 -122.771)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M266.287,196.372c-.23.041-.35-.049-.333-.292h.32A.2.2,0,0,1,266.287,196.372Z",
    transform: "translate(-176.945 -122.787)",
    fill: "#d0ddca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M267.473,196.356l-.013-.292c.107,0,.213,0,.32,0a.2.2,0,0,1,.011.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-178.131 -122.771)",
    fill: "#afc4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M268.971,196.331c0-.1-.006-.2-.011-.294.107,0,.215,0,.322-.006,0,.1,0,.2.006.3C269.182,196.326,269.077,196.329,268.971,196.331Z",
    transform: "translate(-179.311 -122.748)",
    fill: "#93af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M277.95,196.35l.013-.29c.107,0,.213,0,.32,0a.2.2,0,0,1-.015.294Z",
    transform: "translate(-186.384 -122.771)",
    fill: "#b5c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M279.45,196.374c0-.1.011-.2.015-.294h.322C279.8,196.319,279.685,196.415,279.45,196.374Z",
    transform: "translate(-187.564 -122.787)",
    fill: "#dde5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M151.984,206.8c-.017-.241.1-.333.331-.294a.2.2,0,0,1-.011.294Z",
    transform: "translate(-87.279 -130.985)",
    fill: "#d8e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M153.49,206.834c0-.1.009-.2.011-.294.107,0,.211,0,.318,0a.2.2,0,0,1-.009.292C153.7,206.836,153.6,206.836,153.49,206.834Z",
    transform: "translate(-88.466 -131.017)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M154.982,206.862c0-.1.006-.2.009-.292.107,0,.211,0,.318,0,0,.1,0,.2-.006.292-.107,0-.215,0-.322,0Z",
    transform: "translate(-89.638 -131.04)",
    fill: "#9eb893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M231.52,206.44l.313.038v.284C231.575,206.8,231.481,206.687,231.52,206.44Z",
    transform: "translate(-149.849 -130.938)",
    fill: "#80a06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M294.476,206.872c0-.1,0-.194-.006-.29.107,0,.213,0,.318,0a.2.2,0,0,1,.009.29c-.107,0-.213,0-.322,0Z",
    transform: "translate(-199.381 -131.048)",
    fill: "#9db790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M295.969,206.852c0-.1-.006-.194-.009-.29.107,0,.211,0,.318,0a.2.2,0,0,1,.013.29h-.32Z",
    transform: "translate(-200.553 -131.032)",
    fill: "#b1c6a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M297.463,206.8l-.013-.292c.232-.043.35.047.333.29h-.322Z",
    transform: "translate(-201.726 -130.987)",
    fill: "#cedcc7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M147.485,208.313c-.015-.243.1-.341.337-.3a.2.2,0,0,1-.023.3C147.694,208.311,147.59,208.311,147.485,208.313Z",
    transform: "translate(-83.74 -132.169)",
    fill: "#d4dfcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M148.96,208.346c.009-.1.015-.2.023-.3l.318.006C149.318,208.306,149.195,208.391,148.96,208.346Z",
    transform: "translate(-84.902 -132.205)",
    fill: "#8fad80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M300.45,208.064c.1,0,.209,0,.316,0a.2.2,0,0,1,.023.3c-.232.043-.352-.047-.337-.292Z",
    transform: "translate(-204.086 -132.212)",
    fill: "#80a270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M301.953,208.312c-.009-.1-.015-.2-.023-.3.241-.049.354.051.339.294h-.316Z",
    transform: "translate(-205.25 -132.168)",
    fill: "#c1d1ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M144.492,209.818c-.019-.245.094-.345.335-.307a.208.208,0,0,1-.026.3C144.7,209.813,144.595,209.818,144.492,209.818Z",
    transform: "translate(-81.385 -133.347)",
    fill: "#dbe4d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M145.96,209.843c.009-.1.017-.2.026-.3h.313c.015.243-.1.341-.339.3Z",
    transform: "translate(-82.541 -133.377)",
    fill: "#7b9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M303.454,209.532c.1,0,.207,0,.311,0a.208.208,0,0,1,.026.3c-.237.036-.354-.06-.337-.3Z",
    transform: "translate(-206.448 -133.369)",
    fill: "#698f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M304.946,209.822l-.026-.3c.243-.045.354.055.337.3Z",
    transform: "translate(-207.603 -133.354)",
    fill: "#c3d3bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M142.979,211.3c-.023-.247.085-.352.333-.3C143.33,211.243,143.219,211.345,142.979,211.3Z",
    transform: "translate(-80.193 -134.517)",
    fill: "#a1ba96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M306.445,211.03h.311a.21.21,0,0,1,.087.239.2.2,0,0,1-.081.107c-.209-.019-.348-.1-.318-.343Z",
    transform: "translate(-208.799 -134.549)",
    fill: "#85a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M141.255,212.5c.1,0,.2,0,.309,0,.032.232-.085.333-.3.343l-.062-.051A.219.219,0,0,1,141.255,212.5Z",
    transform: "translate(-78.773 -135.706)",
    fill: "#7e9f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M308.251,212.589c-.2-.006-.331-.081-.316-.307l.015-.047a.221.221,0,0,1,.309.021h0a.208.208,0,0,1,.079.235A.172.172,0,0,1,308.251,212.589Z",
    transform: "translate(-209.974 -135.455)",
    fill: "#668d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M140,214.064c0-.1.006-.2.009-.3a.211.211,0,0,1,.3-.026l.03.038c0,.226-.115.326-.341.292Z",
    transform: "translate(-77.852 -136.634)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M309.731,214.086c-.218.011-.316-.1-.311-.311l.021-.03a.214.214,0,0,1,.3.017.2.2,0,0,1,.075.232A.164.164,0,0,1,309.731,214.086Z",
    transform: "translate(-211.143 -136.641)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M138.5,215.775c-.043-.247.06-.358.309-.331C138.841,215.686,138.738,215.8,138.5,215.775Z",
    transform: "translate(-76.661 -138.019)",
    fill: "#85a475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M311.189,215.588c-.232.021-.3-.119-.309-.316l.032-.019a.208.208,0,0,1,.3.019v0a.208.208,0,0,1,.073.241.131.131,0,0,1-.1.081Z",
    transform: "translate(-212.292 -137.827)",
    fill: "#678f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M137.026,217.3c-.049-.247.055-.354.3-.335C137.372,217.2,137.274,217.318,137.026,217.3Z",
    transform: "translate(-75.504 -139.214)",
    fill: "#b0c5a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M312.683,216.769v.311c-.243.032-.322-.113-.343-.32l.047-.013a.2.2,0,0,1,.3.021Z",
    transform: "translate(-213.44 -139.002)",
    fill: "#86a778"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M135.526,218.822c-.034-.241.064-.356.311-.333,0,.1-.006.207-.009.309a.206.206,0,0,1-.3.023Z",
    transform: "translate(-74.327 -140.415)",
    fill: "#e8efe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M155.016,218.8c-.028-.245.1-.322.32-.292a.252.252,0,0,1,.053.279.231.231,0,0,1-.262.1A.189.189,0,0,1,155.016,218.8Z",
    transform: "translate(-89.663 -140.427)",
    fill: "#6f945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M156.5,218.826l.006-.3c.107,0,.213,0,.32,0,0,.1,0,.194-.006.292A.2.2,0,0,1,156.5,218.826Z",
    transform: "translate(-90.834 -140.45)",
    fill: "#82a272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M294.453,218.817l-.013-.292c.228-.038.354.036.324.288l-.045.06A.2.2,0,0,1,294.453,218.817Z",
    transform: "translate(-199.358 -140.438)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M314.01,218.474c.245-.017.345.094.3.337a.2.2,0,0,1-.3-.026Z",
    transform: "translate(-214.754 -140.404)",
    fill: "#c6d5bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M135.542,219.973c.1-.009.2-.017.3-.023.045.239-.051.354-.3.339,0-.1,0-.211-.006-.316Z",
    transform: "translate(-74.344 -141.567)",
    fill: "#91ae82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M151.994,220.3c-.03-.26.1-.328.331-.284a.258.258,0,0,1,.043.281.239.239,0,0,1-.264.1A.182.182,0,0,1,151.994,220.3Z",
    transform: "translate(-87.286 -141.606)",
    fill: "#a3bc98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M153.46,220.243c.006-.1.015-.2.021-.3l.313-.034-.009.043C153.912,220.313,153.767,220.368,153.46,220.243Z",
    transform: "translate(-88.442 -141.535)",
    fill: "#ebf1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M295.806,219.9l.316.036a.229.229,0,0,1,0,.339c-.3.073-.448,0-.3-.333Z",
    transform: "translate(-200.398 -141.528)",
    fill: "#f5f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M297.467,220.339c-.006-.1-.013-.2-.017-.3l.316-.009a.24.24,0,0,1,.034.328.242.242,0,0,1-.333-.021Z",
    transform: "translate(-201.726 -141.63)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M298.943,220.308c-.009-.1-.015-.2-.023-.3.215-.03.352.034.337.282l-.038.068A.2.2,0,0,1,298.943,220.308Z",
    transform: "translate(-202.882 -141.605)",
    fill: "#638b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M313.992,219.94l.3.026c0,.1,0,.209,0,.311C314.05,220.294,313.956,220.175,313.992,219.94Z",
    transform: "translate(-214.734 -141.559)",
    fill: "#6c9258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M134.026,221.81c-.034-.235.064-.35.3-.335,0,.1,0,.209-.006.316A.207.207,0,0,1,134.026,221.81Z",
    transform: "translate(-73.147 -142.766)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M148.92,221.8c.009-.228.119-.335.352-.294a.265.265,0,0,1,.053.264.23.23,0,0,1-.092.1.321.321,0,0,1-.209.017.189.189,0,0,1-.1-.09Z",
    transform: "translate(-84.87 -142.787)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M150.48,221.727l.019-.307.307-.03v.051c.1.339-.013.424-.326.284Z",
    transform: "translate(-86.098 -142.7)",
    fill: "#e7ede3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M300.269,221.35c.2.019.343.1.337.331l-.064.066c-.3.051-.409-.049-.286-.345l.011-.051Z",
    transform: "translate(-203.894 -142.668)",
    fill: "#88a77a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M315.54,221.456c.243-.013.341.1.3.339a.2.2,0,0,1-.3-.023Z",
    transform: "translate(-215.958 -142.751)",
    fill: "#c5d5bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M134.05,222.979l.3-.019c0,.107,0,.211,0,.318a.2.2,0,0,1-.294.019C134.056,223.19,134.052,223.086,134.05,222.979Z",
    transform: "translate(-73.171 -143.935)",
    fill: "#adc3a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M147.521,223.27c-.038-.23.062-.343.292-.35l.032.028a.262.262,0,0,1,.049.271.239.239,0,0,1-.1.1A.266.266,0,0,1,147.521,223.27Z",
    transform: "translate(-83.763 -143.903)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M301.718,222.9c.228,0,.316.134.333.339l-.064.058a.293.293,0,0,1-.32-.043.256.256,0,0,1,.015-.316l.034-.036Z",
    transform: "translate(-205.006 -143.888)",
    fill: "#88a87a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M315.5,222.94l.3.023c0,.1,0,.211,0,.316C315.547,223.294,315.459,223.175,315.5,222.94Z",
    transform: "translate(-215.92 -143.919)",
    fill: "#84a476"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M134.09,224.469l.294-.019c.041.232-.049.352-.292.335v-.318Z",
    transform: "translate(-73.203 -145.107)",
    fill: "#7b9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M147.44,224.481l.3-.021c.154.235.083.367-.188.405a.248.248,0,0,1-.147-.077C147.421,224.686,147.429,224.584,147.44,224.481Z",
    transform: "translate(-83.682 -145.115)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M303.225,224.472c.243-.013.309.122.281.335a.266.266,0,0,1-.273.049.232.232,0,0,1-.1-.1.274.274,0,0,1,.045-.275l.049-.011Z",
    transform: "translate(-206.18 -145.123)",
    fill: "#61894c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M146.041,226.319c-.041-.226.032-.356.284-.331h.049a.285.285,0,0,1,0,.335.255.255,0,0,1-.331,0Z",
    transform: "translate(-82.597 -146.315)",
    fill: "#8aa97c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M303.219,225.95l.3.021c0,.1-.006.211-.009.316a.224.224,0,1,1-.292-.337Z",
    transform: "translate(-206.196 -146.287)",
    fill: "#b3c7aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M317.052,225.964c.241-.017.331.1.292.331a.2.2,0,0,1-.294-.011v-.32Z",
    transform: "translate(-217.146 -146.297)",
    fill: "#d5dfd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M132.833,227.787c-.1,0-.2.009-.294.011-.038-.23.051-.348.292-.333v.32Z",
    transform: "translate(-71.975 -147.479)",
    fill: "#e1e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M146.072,227.471l.294-.021a.252.252,0,0,1,.043.333.244.244,0,0,1-.335,0c0-.1,0-.209,0-.316Z",
    transform: "translate(-82.628 -147.467)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M303.237,227.45l.3.019c.011.1.023.211.034.316-.026.017-.051.034-.077.053-.311.021-.414-.1-.258-.388Z",
    transform: "translate(-206.22 -147.467)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M317.052,227.48l.294.011c0,.107,0,.211,0,.318a.2.2,0,0,1-.294-.006C317.05,227.7,317.05,227.589,317.052,227.48Z",
    transform: "translate(-217.146 -147.491)",
    fill: "#b8caaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M145.956,228.983l.3-.013c.122.311.058.45-.3.322l-.038.011c.011-.107.023-.213.034-.32Z",
    transform: "translate(-82.51 -148.663)",
    fill: "#f5f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M305.033,229.3l-.294-.009a.228.228,0,0,1-.038-.322l.043.011c.247-.028.324.1.29.322Z",
    transform: "translate(-207.392 -148.663)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M317.05,228.972l.294.006c0,.107,0,.213,0,.318-.1,0-.2,0-.292,0v-.32Z",
    transform: "translate(-217.146 -148.663)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M78.576,273.948c.241-.011.335.107.3.339a.207.207,0,0,1-.3-.026C78.57,274.157,78.574,274.052,78.576,273.948Z",
    transform: "translate(-29.523 -184.049)",
    fill: "#dae3d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M372.483,273.949l.3-.019c.036.241-.064.356-.311.335l.013-.314Z",
    transform: "translate(-260.747 -184.035)",
    fill: "#5c8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M78.542,275.43l.3.026c0,.1.011.2.015.3-.252.034-.356-.079-.318-.326Z",
    transform: "translate(-29.494 -185.216)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M370.933,275.755c-.028-.235.07-.35.311-.326C371.294,275.683,371.185,275.789,370.933,275.755Z",
    transform: "translate(-259.535 -185.212)",
    fill: "#99b48b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M80.032,276.96l.3.017a.208.208,0,0,1,.026.3C80.114,277.314,80,277.212,80.032,276.96Z",
    transform: "translate(-30.669 -186.419)",
    fill: "#729760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M81.5,277.306c-.009-.1-.017-.2-.023-.3.232-.04.354.049.337.294Z",
    transform: "translate(-31.812 -186.448)",
    fill: "#ccdac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M367.922,277.3c-.011-.243.107-.335.339-.3a.2.2,0,0,1-.026.3c-.1,0-.209,0-.316,0Z",
    transform: "translate(-257.168 -186.443)",
    fill: "#dde5d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M369.41,277.289c.009-.1.017-.2.026-.3l.307-.011c.026.249-.083.354-.331.309Z",
    transform: "translate(-258.34 -186.435)",
    fill: "#89a87b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M84.476,278.554c.107,0,.213,0,.318,0a.2.2,0,0,1,.017.294c-.232.043-.354-.045-.337-.29Z",
    transform: "translate(-34.166 -187.67)",
    fill: "#85a475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M86.007,278.821c-.006-.1-.013-.2-.017-.294l.318-.006a.2.2,0,0,1,.017.3C86.218,278.816,86.114,278.819,86.007,278.821Z",
    transform: "translate(-35.36 -187.647)",
    fill: "#b4c8aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M87.5,278.789c-.006-.1-.011-.2-.017-.3.232-.036.348.058.337.3H87.5Z",
    transform: "translate(-36.532 -187.619)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M361.936,278.793c-.013-.239.1-.333.333-.3a.206.206,0,0,1-.015.3c-.107,0-.213,0-.318,0Z",
    transform: "translate(-252.459 -187.619)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2296",
    "data-name": "Path 2296",
    d: "M363.44,278.809c0-.1.011-.2.015-.3l.32.009a.2.2,0,0,1-.017.292C363.651,278.811,363.547,278.811,363.44,278.809Z",
    transform: "translate(-253.643 -187.639)",
    fill: "#c0d0b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2297",
    "data-name": "Path 2297",
    d: "M364.93,278.842c.006-.1.013-.2.017-.292.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3C365.143,278.849,365.037,278.846,364.93,278.842Z",
    transform: "translate(-254.815 -187.67)",
    fill: "#91ae83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2298",
    "data-name": "Path 2298",
    d: "M366.43,278.843c0-.1.011-.2.015-.3.107,0,.213,0,.32,0,.013.239-.1.335-.335.3Z",
    transform: "translate(-255.996 -187.662)",
    fill: "#628a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2299",
    "data-name": "Path 2299",
    d: "M89,280.05h.32a.209.209,0,0,1,.015.3C89.1,280.385,88.984,280.289,89,280.05Z",
    transform: "translate(-37.725 -188.85)",
    fill: "#668e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2300",
    "data-name": "Path 2300",
    d: "M90.515,280.343c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294C90.728,280.336,90.622,280.339,90.515,280.343Z",
    transform: "translate(-38.908 -188.842)",
    fill: "#96b187"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2301",
    "data-name": "Path 2301",
    d: "M92.007,280.3c-.006-.1-.013-.2-.017-.294l.322-.009a.2.2,0,0,1,.015.3h-.318Z",
    transform: "translate(-40.081 -188.811)",
    fill: "#c5d5be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2302",
    "data-name": "Path 2302",
    d: "M93.5,280.289c0-.1-.009-.2-.015-.3.23-.03.348.064.333.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-41.261 -188.799)",
    fill: "#f3f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2303",
    "data-name": "Path 2303",
    d: "M357.435,280.3c-.015-.243.1-.333.335-.292a.2.2,0,0,1-.017.294h-.318Z",
    transform: "translate(-248.918 -188.808)",
    fill: "#d1deca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2304",
    "data-name": "Path 2304",
    d: "M358.93,280.334c.006-.1.011-.2.017-.294.107,0,.213,0,.318,0a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-250.095 -188.842)",
    fill: "#a1ba96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2305",
    "data-name": "Path 2305",
    d: "M360.42,280.354c.006-.1.013-.2.017-.294h.32c.011.239-.1.335-.337.3Z",
    transform: "translate(-251.267 -188.858)",
    fill: "#729760"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2306",
    "data-name": "Path 2306",
    d: "M94.988,281.56h.32a.2.2,0,0,1,.017.294C95.092,281.895,94.977,281.8,94.988,281.56Z",
    transform: "translate(-42.438 -190.038)",
    fill: "#769a65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2307",
    "data-name": "Path 2307",
    d: "M96.507,281.839c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-43.621 -190.023)",
    fill: "#a6be9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2308",
    "data-name": "Path 2308",
    d: "M98,281.788c-.006-.1-.013-.2-.017-.294.235-.043.35.053.339.294H98Z",
    transform: "translate(-44.793 -189.979)",
    fill: "#d6e0d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2309",
    "data-name": "Path 2309",
    d: "M351.432,281.791c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3h-.32Z",
    transform: "translate(-244.194 -189.979)",
    fill: "#e2e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M352.94,281.816c.006-.1.011-.2.017-.3l.32.006a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-245.382 -190.007)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M354.42,281.852c.006-.1.013-.2.019-.292.107,0,.211,0,.318,0C354.772,281.807,354.655,281.9,354.42,281.852Z",
    transform: "translate(-246.547 -190.038)",
    fill: "#82a272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M99.5,283.04c.107,0,.213,0,.32,0a.207.207,0,0,1,.013.3c-.23.03-.345-.066-.331-.3Z",
    transform: "translate(-45.989 -191.203)",
    fill: "#5b8446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M101,283.361l-.013-.3h.318a.2.2,0,0,1,.017.294l-.322.009Z",
    transform: "translate(-47.161 -191.218)",
    fill: "#86a676"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M102.507,283.321c-.006-.1-.013-.2-.017-.294l.318-.006a.2.2,0,0,1,.017.3C102.718,283.316,102.614,283.319,102.507,283.321Z",
    transform: "translate(-48.342 -191.187)",
    fill: "#b6c9ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M104,283.289c-.006-.1-.011-.2-.017-.3.232-.036.348.06.337.3H104Z",
    transform: "translate(-49.514 -191.16)",
    fill: "#e7ede3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M345.445,283.293c-.015-.239.1-.333.333-.3a.206.206,0,0,1-.013.3C345.659,283.289,345.552,283.291,345.445,283.293Z",
    transform: "translate(-239.485 -191.159)",
    fill: "#f1f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M346.932,283.309c0-.1.009-.2.013-.3l.322.009a.2.2,0,0,1-.019.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-240.654 -191.179)",
    fill: "#c2d2bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M348.43,283.334l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.32-.006Z",
    transform: "translate(-241.834 -191.203)",
    fill: "#92af83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M349.93,283.351c0-.1.011-.2.015-.3.107,0,.213,0,.32,0C350.278,283.289,350.162,283.385,349.93,283.351Z",
    transform: "translate(-243.014 -191.211)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M380.264,283.28l-.3.019c-.03-.241.07-.354.316-.331,0,.1-.009.207-.015.309Z",
    transform: "translate(-266.637 -191.144)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M71.332,284.8l-.307-.013c0-.1-.009-.2-.015-.307C71.253,284.456,71.36,284.563,71.332,284.8Z",
    transform: "translate(-23.575 -192.336)",
    fill: "#6c9258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M105.487,284.542h.32a.2.2,0,0,1,.015.3c-.23.034-.348-.06-.335-.3Z",
    transform: "translate(-50.698 -192.383)",
    fill: "#699055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M107,284.841c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294c-.107,0-.213,0-.32.009Z",
    transform: "translate(-51.882 -192.383)",
    fill: "#97b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M108.5,284.8c-.006-.1-.013-.2-.017-.294l.322-.009a.2.2,0,0,1,.013.3H108.5Z",
    transform: "translate(-53.054 -192.351)",
    fill: "#c7d7c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M110,284.789c0-.1-.009-.2-.013-.3.23-.03.348.064.333.3C110.216,284.793,110.109,284.791,110,284.789Z",
    transform: "translate(-54.242 -192.339)",
    fill: "#f5f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M340.945,284.8c-.015-.243.1-.333.335-.292a.2.2,0,0,1-.017.294h-.318Z",
    transform: "translate(-235.945 -192.348)",
    fill: "#d3decd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M342.44,284.834c.006-.1.011-.2.017-.294.107,0,.213,0,.318,0a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318-.006Z",
    transform: "translate(-237.121 -192.383)",
    fill: "#a3bc98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M343.93,284.854c.006-.1.013-.2.017-.294h.32C344.278,284.8,344.162,284.895,343.93,284.854Z",
    transform: "translate(-238.294 -192.399)",
    fill: "#749862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M111.487,286.06h.32a.2.2,0,0,1,.017.294C111.59,286.395,111.477,286.3,111.487,286.06Z",
    transform: "translate(-55.42 -193.579)",
    fill: "#799c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M113.007,286.339c-.006-.1-.011-.2-.017-.294.107,0,.211,0,.318,0a.2.2,0,0,1,.019.294c-.107,0-.213,0-.318.006Z",
    transform: "translate(-56.602 -193.563)",
    fill: "#a8bf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M114.489,286.288l-.019-.294c.235-.043.35.053.339.294Z",
    transform: "translate(-57.767 -193.519)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M334.932,286.291c-.013-.239.1-.335.335-.3a.2.2,0,0,1-.017.3h-.32Z",
    transform: "translate(-231.213 -193.52)",
    fill: "#e4ebe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M336.44,286.316c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292C336.651,286.321,336.547,286.319,336.44,286.316Z",
    transform: "translate(-232.401 -193.547)",
    fill: "#b3c7a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M337.93,286.352l.019-.292c.107,0,.213,0,.318,0C338.284,286.307,338.162,286.395,337.93,286.352Z",
    transform: "translate(-233.573 -193.579)",
    fill: "#84a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M377.264,286.281c-.1,0-.209.009-.313.011-.021-.245.092-.345.331-.313l-.019.3Z",
    transform: "translate(-264.271 -193.51)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M75.807,287.8l-.322-.011c0-.1-.009-.2-.015-.3.235-.032.352.064.335.307Z",
    transform: "translate(-27.084 -194.697)",
    fill: "#5b8546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M116,287.54c.107,0,.213,0,.32,0a.207.207,0,0,1,.013.3c-.23.03-.345-.066-.333-.3Z",
    transform: "translate(-58.967 -194.743)",
    fill: "#5d8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M117.5,287.853l-.013-.3c.107,0,.211,0,.318,0a.2.2,0,0,1,.017.294Z",
    transform: "translate(-60.143 -194.751)",
    fill: "#88a77a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M119,287.821c-.006-.1-.013-.2-.017-.294l.32-.006a.2.2,0,0,1,.017.3c-.107,0-.211,0-.318,0Z",
    transform: "translate(-61.315 -194.727)",
    fill: "#b9cbb0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M120.487,287.791c-.006-.1-.011-.2-.017-.3.232-.034.348.06.335.3-.107,0-.213,0-.32,0Z",
    transform: "translate(-62.487 -194.702)",
    fill: "#e9efe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M328.945,287.793c-.015-.239.1-.333.333-.3a.2.2,0,0,1-.013.3C329.159,287.789,329.052,287.791,328.945,287.793Z",
    transform: "translate(-226.504 -194.7)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M330.442,287.8l.013-.3.322.009a.2.2,0,0,1-.019.294h-.318Z",
    transform: "translate(-227.68 -194.712)",
    fill: "#c4d4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M331.93,287.834l.019-.294c.107,0,.211,0,.318,0a.2.2,0,0,1-.015.3l-.32-.006Z",
    transform: "translate(-228.853 -194.743)",
    fill: "#94b086"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M333.43,287.849c0-.1.011-.2.015-.3.107,0,.213,0,.32,0C333.778,287.789,333.662,287.885,333.43,287.849Z",
    transform: "translate(-230.033 -194.751)",
    fill: "#668e52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M121.986,289.042h.32a.2.2,0,0,1,.015.3c-.232.034-.348-.06-.335-.3Z",
    transform: "translate(-63.68 -195.923)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M123.5,289.349c0-.1-.011-.2-.015-.3.107,0,.211,0,.318,0a.2.2,0,0,1,.019.292c-.107,0-.213,0-.32.009Z",
    transform: "translate(-64.863 -195.931)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M124.989,289.3l-.019-.292c.232-.045.354.043.337.29-.107,0-.213,0-.32,0Z",
    transform: "translate(-66.028 -195.89)",
    fill: "#c8d8c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M324.444,289.293c-.017-.243.1-.333.335-.294a.2.2,0,0,1-.017.294Z",
    transform: "translate(-222.962 -195.884)",
    fill: "#d6e0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M325.94,289.324c.006-.1.011-.2.017-.294.107,0,.213,0,.318.006a.2.2,0,0,1-.017.294c-.107,0-.211,0-.318,0Z",
    transform: "translate(-224.14 -195.915)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M327.43,289.354c.006-.1.013-.2.017-.294h.32C327.778,289.3,327.662,289.395,327.43,289.354Z",
    transform: "translate(-225.312 -195.939)",
    fill: "#769963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M127.985,290.56h.318a.2.2,0,0,1,.017.292C128.088,290.893,127.97,290.8,127.985,290.56Z",
    transform: "translate(-68.399 -197.119)",
    fill: "#7c9e6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M129.5,290.831c-.006-.1-.011-.2-.017-.294l.32-.006a.2.2,0,0,1,.017.3c-.107,0-.213,0-.318,0Z",
    transform: "translate(-69.576 -197.095)",
    fill: "#a9c09e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M131,290.769c-.006-.1-.011-.2-.017-.3l.324-.013v.309H131Z",
    transform: "translate(-70.756 -197.04)",
    fill: "#dbe4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M318.522,290.771c0-.1,0-.209,0-.311l.313.013a.206.206,0,0,1-.017.3c-.1,0-.2,0-.3,0Z",
    transform: "translate(-218.302 -197.04)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M319.94,290.816c.006-.1.011-.2.017-.3.107,0,.213,0,.32.009a.2.2,0,0,1-.019.292c-.107,0-.211,0-.318,0Z",
    transform: "translate(-219.42 -197.088)",
    fill: "#b5c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M321.43,290.842c.006-.1.013-.194.019-.292.107,0,.213,0,.32,0,.017.247-.1.333-.337.29Z",
    transform: "translate(-220.592 -197.111)",
    fill: "#86a677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M132.486,304.287l-.026-.29c.256-.043.36.066.32.32l-.3-.032Z",
    transform: "translate(-71.92 -207.683)",
    fill: "#7fa06f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M317.319,303.989l-.038.3-.286.019c-.036-.252.075-.356.324-.322Z",
    transform: "translate(-217.098 -207.678)",
    fill: "#6b9258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M145.964,386.588c-.011-.107-.023-.213-.034-.318l.038.011c.333-.145.405,0,.337.3a.227.227,0,0,1-.339.006Z",
    transform: "translate(-82.518 -272.383)",
    fill: "#f4f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M304.75,386.449l.294-.009c.034.226-.045.35-.29.322l-.06-.045a.194.194,0,0,1,.055-.267Z",
    transform: "translate(-207.402 -272.552)",
    fill: "#6e945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M146.066,387.93l.3.013a.246.246,0,0,1,.023.331.239.239,0,0,1-.328-.03l0-.313Z",
    transform: "translate(-82.62 -273.725)",
    fill: "#c7d7c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M303.608,387.783c-.011.1-.023.209-.034.316a.226.226,0,0,1-.339,0c-.073-.3,0-.448.333-.307l.043-.009Z",
    transform: "translate(-206.256 -273.573)",
    fill: "#f0f4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M146.039,389.41l.3.023a.19.19,0,0,1,.077.224.144.144,0,0,1-.087.085c-.252.023-.324-.1-.284-.331Z",
    transform: "translate(-82.597 -274.889)",
    fill: "#86a577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M303.242,389.439l.3-.019c0,.1.006.211.009.316a.215.215,0,1,1-.309-.3Z",
    transform: "translate(-206.225 -274.897)",
    fill: "#b0c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M147.44,391.091c-.011-.1-.019-.2-.03-.307h.049c.326-.126.407,0,.316.307A.221.221,0,0,1,147.44,391.091Z",
    transform: "translate(-83.682 -275.932)",
    fill: "#d7e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M303.246,390.931l.3-.021c.028.213-.036.352-.281.335l-.068-.038a.24.24,0,0,1-.011-.222Z",
    transform: "translate(-206.223 -276.069)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M147.514,392.4l.3.021.051.043a.274.274,0,0,1,.023.192.164.164,0,0,1-.09.092c-.235,0-.328-.119-.292-.348Z",
    transform: "translate(-83.757 -277.241)",
    fill: "#668d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M302.049,392.2c-.019.2-.1.343-.331.337-.021-.017-.043-.036-.066-.053a.273.273,0,0,1,.034-.316.254.254,0,0,1,.313.023l.047.009Z",
    transform: "translate(-205.005 -277.027)",
    fill: "#83a373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M149.264,393.984c-.237.04-.341-.072-.354-.3l.032-.026a.262.262,0,0,1,.271-.051.217.217,0,0,1,.1.1.267.267,0,0,1-.049.273Z",
    transform: "translate(-84.862 -278.179)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M150.491,394.006c-.006-.1-.015-.2-.021-.307.235-.151.367-.083.4.188a.248.248,0,0,1-.077.147l-.3-.03Z",
    transform: "translate(-86.09 -278.201)",
    fill: "#e2e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M300.529,393.7c0,.226-.134.316-.337.331-.019-.021-.038-.043-.058-.062a.293.293,0,0,1,.043-.32.257.257,0,0,1,.316.017Z",
    transform: "translate(-203.815 -278.189)",
    fill: "#83a473"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M152.321,395.472c-.23.045-.358-.03-.333-.284v-.051a.288.288,0,0,1,.337,0A.255.255,0,0,1,152.321,395.472Z",
    transform: "translate(-87.281 -279.354)",
    fill: "#9cb68f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M153.473,395.5l-.023-.3c.232-.154.367-.087.409.183a.248.248,0,0,1-.072.149l-.313-.036Z",
    transform: "translate(-88.434 -279.381)",
    fill: "#e3eadf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M296.06,395.508l-.316.036c-.017-.026-.034-.051-.053-.077-.034-.313.107-.395.386-.292A.238.238,0,0,1,296.06,395.508Z",
    transform: "translate(-200.338 -279.392)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M297.44,395.524l.019-.3a.226.226,0,0,1,.32-.011.222.222,0,0,1-.023.318Z",
    transform: "translate(-201.718 -279.408)",
    fill: "#b0c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M298.93,395.5l.021-.3c.015-.017.03-.036.045-.055a.225.225,0,0,1,.26.028l.011.047c.013.243-.122.309-.337.281Z",
    transform: "translate(-202.89 -279.376)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M155.32,396.716l.013.3c-.224.032-.352-.043-.324-.29L155,396.68A.227.227,0,0,1,155.32,396.716Z",
    transform: "translate(-89.654 -280.57)",
    fill: "#678f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M294.46,397.017l.009-.294a.23.23,0,0,1,.322-.038l-.008.043C294.81,396.974,294.686,397.051,294.46,397.017Z",
    transform: "translate(-199.373 -280.574)",
    fill: "#6e945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M309.787,401.767l-.3.017c-.03-.245.077-.352.322-.322C309.8,401.564,309.793,401.665,309.787,401.767Z",
    transform: "translate(-211.188 -284.367)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M189.812,178.306l-.3.017c-.032-.243.075-.352.318-.326C189.823,178.1,189.817,178.2,189.812,178.306Z",
    transform: "translate(-116.8 -108.557)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M188.31,179.812l-.311.013c-.023-.243.085-.348.326-.316C188.321,179.61,188.314,179.712,188.31,179.812Z",
    transform: "translate(-115.613 -109.746)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M392.274,148.321l-.3.017c-.03-.243.075-.352.318-.324C392.285,148.117,392.279,148.219,392.274,148.321Z",
    transform: "translate(-276.086 -84.968)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M390.76,149.822l-.311.013c-.023-.243.085-.348.328-.316C390.771,149.619,390.766,149.72,390.76,149.822Z",
    transform: "translate(-274.89 -86.151)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M216.51,160.285c0-.107.009-.211.015-.318l.3-.017C216.855,160.189,216.757,160.3,216.51,160.285Z",
    transform: "translate(-138.046 -94.362)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M212.01,167.785c0-.107.009-.211.015-.318l.3-.017C212.355,167.689,212.257,167.8,212.01,167.785Z",
    transform: "translate(-134.506 -100.263)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M203.01,182.783c.006-.1.011-.211.017-.316.1-.006.2-.013.3-.017C203.358,182.691,203.257,182.806,203.01,182.783Z",
    transform: "translate(-127.425 -112.064)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M192.45,193.316c0-.1.011-.2.015-.3l.318-.019C192.806,193.245,192.691,193.348,192.45,193.316Z",
    transform: "translate(-119.117 -120.364)",
    fill: "#f4f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M140.317,212.813l-.3.026c-.03-.249.079-.356.328-.326C140.332,212.612,140.326,212.712,140.317,212.813Z",
    transform: "translate(-77.858 -135.711)",
    fill: "#f5f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M236.293,164.475c0,.107.011.211.015.318-.245.021-.345-.094-.311-.333l.3.017Z",
    transform: "translate(-153.372 -97.91)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M240.795,171.967c0,.107.011.211.015.318-.245.021-.343-.1-.311-.335Z",
    transform: "translate(-156.915 -103.803)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M245.295,179.467c0,.107.011.211.015.318-.245.021-.343-.1-.311-.335Z",
    transform: "translate(-160.455 -109.704)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M308.241,211.329l-.309-.021c-.006-.1-.013-.2-.021-.3.245-.032.358.07.328.32Z",
    transform: "translate(-209.955 -134.528)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M309.764,212.827c-.1-.006-.2-.013-.3-.017-.006-.1-.013-.2-.019-.3C309.687,212.473,309.794,212.58,309.764,212.827Z",
    transform: "translate(-211.159 -135.706)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M311.27,214.326l-.3-.019c-.006-.1-.013-.2-.017-.3C311.2,213.972,311.3,214.079,311.27,214.326Z",
    transform: "translate(-212.347 -136.883)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M312.77,215.823c-.1-.006-.2-.013-.3-.021-.006-.1-.015-.2-.021-.309.25-.03.352.085.32.328Z",
    transform: "translate(-213.527 -138.057)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    "data-name": "Path 2396",
    d: "M178.006,257.653l-.322.038c-.247-.006-.5-.015-.744-.015H148.626c-.124,0-.247.011-.371.015l-.32-.036c.028-.252-.1-.322-.328-.29-.1-.013-.207-.026-.309-.036.023-.247-.111-.314-.326-.284h0a3.82,3.82,0,0,0-.32-.324l0,.006c.032-.22-.038-.352-.286-.328l-.038-.309c0-.109.006-.215.009-.324.026-.222-.047-.352-.3-.322-.006-.16-.019-.318-.019-.478V222.65c0-.16.013-.318.019-.478.247.032.322-.1.3-.322,0-.109-.006-.215-.009-.324l.038-.311c.25.026.318-.109.286-.326l0,.006a3.278,3.278,0,0,0,.32-.324h0c.215.028.35-.036.326-.284l.309-.036c.22.028.356-.038.326-.29.107-.013.215-.026.322-.04h.32c.16.006.318.017.478.017h28.314c.107,0,.211-.011.318-.017.107.013.215.026.322.036-.03.252.1.318.324.292.107,0,.213,0,.32-.006l.3.028c-.034.243.092.328.313.316.006.1.013.2.019.292.092.122.207.222.311.335l.015-.011c0,.107,0,.213-.006.318-.026.22.041.354.292.324l.038.322c-.006.247-.015.5-.015.744v32.043c0,.16.011.318.015.478l-.038.322c-.252-.03-.32.1-.292.324,0,.107,0,.211.006.318l-.015-.011c-.1.111-.217.213-.311.335l-.019.294-.294.019c-.122.092-.222.207-.335.311l.011.015c-.107,0-.211,0-.318-.006-.22-.028-.354.04-.324.292Z",
    transform: "translate(-82.589 -141.543)",
    fill: "#f1f8ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    "data-name": "Path 2397",
    d: "M149.32,222.97c.03.241-.077.35-.32.324,0-.1.011-.2.015-.307Z",
    transform: "translate(-84.933 -143.943)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2398",
    "data-name": "Path 2398",
    d: "M302.29,224.775c-.245.019-.343-.1-.311-.335l.3.019Z",
    transform: "translate(-205.284 -145.099)",
    fill: "#f5f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2399",
    "data-name": "Path 2399",
    d: "M301.988,391.277c-.032-.237.066-.354.311-.335,0,.1-.006.211-.011.316l-.3.019Z",
    transform: "translate(-205.292 -276.093)",
    fill: "#f3f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2400",
    "data-name": "Path 2400",
    d: "M149,392.456c.243-.026.348.081.32.324l-.3-.015-.015-.307Z",
    transform: "translate(-84.933 -277.283)",
    fill: "#f0f4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2401",
    "data-name": "Path 2401",
    d: "M298.963,394.27c-.019-.245.1-.343.335-.311-.006.1-.013.2-.019.3l-.316.011Z",
    transform: "translate(-202.914 -278.463)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2402",
    "data-name": "Path 2402",
    d: "M227.713,362.933H213.975a.567.567,0,0,0-.4-.181.367.367,0,0,1-.243-.126h0a.356.356,0,0,1-.128-.241.584.584,0,0,0-.186-.4l-.028.013a.514.514,0,0,1,0-.65l.03.013a.552.552,0,0,0,.183-.4.392.392,0,0,1,.122-.247.4.4,0,0,1,.254-.124.556.556,0,0,0,.388-.186l-.013-.026a.934.934,0,0,1,.659-.145h12.45a.934.934,0,0,1,.659.145l-.013.026a.548.548,0,0,0,.395.188.384.384,0,0,1,.247.124.4.4,0,0,1,.124.254.578.578,0,0,0,.181.39l.03-.013a.511.511,0,0,1,0,.65l-.028-.013a.576.576,0,0,0-.186.4.361.361,0,0,1-.128.243h0a.4.4,0,0,1-.258.13.568.568,0,0,0-.384.177Z",
    transform: "translate(-135.188 -251.937)",
    fill: "#517e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2403",
    "data-name": "Path 2403",
    d: "M228.924,288.158c-.011.1-.023.207-.034.311a2.59,2.59,0,0,0-.23.3.477.477,0,0,1-.092.094,1.08,1.08,0,0,0-.29.292.469.469,0,0,1-.147.07,2.229,2.229,0,0,1-.358.047q-6.551.01-13.1,0c-.122-.009-.245,0-.365-.013a1.485,1.485,0,0,1-.322-.047.411.411,0,0,1-.128-.068.9.9,0,0,0-.279-.281.374.374,0,0,1-.092-.092,2.482,2.482,0,0,0-.232-.3l-.034-.311a.266.266,0,0,1,0-.328l.03.013a.557.557,0,0,0,.183-.4.411.411,0,0,1,.119-.25h0a4.049,4.049,0,0,1,.326-.307l-.011-.015a.613.613,0,0,1,.388-.143q6.81-.029,13.618,0a.592.592,0,0,1,.388.145l-.011.015a3.725,3.725,0,0,1,.326.309h0a.4.4,0,0,1,.119.245.573.573,0,0,0,.183.4l.032-.013a.272.272,0,0,1,0,.328Z",
    transform: "translate(-135.414 -194.092)",
    fill: "#527e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2404",
    "data-name": "Path 2404",
    d: "M213.975,253.144c-.1-.009-.2-.017-.3-.028a2.852,2.852,0,0,1-.331-.311.405.405,0,0,1-.124-.254.569.569,0,0,0-.181-.39l-.032.013a.511.511,0,0,1,0-.65l.026.013a2.669,2.669,0,0,0,.23-.3.477.477,0,0,1,.092-.094,1.08,1.08,0,0,0,.29-.292.468.468,0,0,1,.147-.07,2.224,2.224,0,0,1,.358-.047q6.7-.01,13.388,0a2.049,2.049,0,0,1,.36.04.513.513,0,0,1,.145.062c.1.094.166.235.3.3a.444.444,0,0,1,.1.094,2.742,2.742,0,0,0,.235.309l.026-.013a.511.511,0,0,1,0,.65l-.032-.013a.553.553,0,0,0-.183.4.392.392,0,0,1-.122.247,3.032,3.032,0,0,1-.331.309l-.3.03a.647.647,0,0,1-.395.132c-4.271.023-8.545,0-12.816.011a.807.807,0,0,1-.552-.145Z",
    transform: "translate(-135.2 -165.781)",
    fill: "#517e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2405",
    "data-name": "Path 2405",
    d: "M228.881,325.026c.011.1.023.207.034.311a.269.269,0,0,1,0,.328l-.032-.013a.557.557,0,0,0-.183.4.411.411,0,0,1-.119.249l0,0a4.5,4.5,0,0,1-.326.311l.011.015a.58.58,0,0,1-.354.136c-.132.015-.264.006-.4.013-4.419,0-8.839.017-13.258-.006a.6.6,0,0,1-.388-.143l.011-.015a4.5,4.5,0,0,1-.326-.311h0a.4.4,0,0,1-.119-.247.569.569,0,0,0-.183-.4l-.032.013a.269.269,0,0,1,0-.328l.034-.311a2.592,2.592,0,0,0,.23-.3.48.48,0,0,1,.092-.094,1.08,1.08,0,0,0,.29-.292.468.468,0,0,1,.147-.07,2.235,2.235,0,0,1,.356-.047q6.7-.01,13.388,0a2.049,2.049,0,0,1,.36.041.513.513,0,0,1,.145.062c.1.094.166.235.3.3a.445.445,0,0,1,.1.094A2.741,2.741,0,0,0,228.881,325.026Z",
    transform: "translate(-135.405 -223.599)",
    fill: "#527e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2406",
    "data-name": "Path 2406",
    d: "M170.716,237.536l.307-.034a.508.508,0,0,1,.646.011l-.013.023a2.545,2.545,0,0,0,.3.228.4.4,0,0,1,.092.087.732.732,0,0,0,.269.267.361.361,0,0,1,.077.117,1.029,1.029,0,0,1,.045.29c0,.177,0,.352,0,.529a1.136,1.136,0,0,1-.041.292.38.38,0,0,1-.068.122.878.878,0,0,0-.275.271.406.406,0,0,1-.09.092.62.62,0,0,0-.222.224.416.416,0,0,1-.092.092.656.656,0,0,0-.226.226.477.477,0,0,1-.092.094.662.662,0,0,0-.228.226.477.477,0,0,1-.092.094.661.661,0,0,0-.228.226.478.478,0,0,1-.092.094.662.662,0,0,0-.228.226.478.478,0,0,1-.092.094.661.661,0,0,0-.228.226.477.477,0,0,1-.092.094.662.662,0,0,0-.228.226.476.476,0,0,1-.092.094.661.661,0,0,0-.228.226.479.479,0,0,1-.092.094.661.661,0,0,0-.228.226.478.478,0,0,1-.092.094.655.655,0,0,0-.228.224.478.478,0,0,1-.092.094.667.667,0,0,0-.23.226.434.434,0,0,1-.094.094.645.645,0,0,0-.23.23.426.426,0,0,1-.092.094,2.093,2.093,0,0,0-.307.241l.013.021a.566.566,0,0,1-.316.122,1.846,1.846,0,0,1-.343,0,.576.576,0,0,1-.318-.119l.013-.026a.531.531,0,0,0-.395-.19.384.384,0,0,1-.247-.124h0c-.111-.1-.217-.211-.322-.32s-.218-.209-.32-.32-.217-.209-.32-.32a3.774,3.774,0,0,1-.316-.324l0,.006a.5.5,0,0,1-.137-.313,3.179,3.179,0,0,1-.011-.35c0-.2-.006-.409.006-.614a.582.582,0,0,1,.128-.328l.013.011a1.946,1.946,0,0,0,.267-.322.372.372,0,0,1,.124-.083,1.158,1.158,0,0,1,.309-.051c.19-.006.38-.006.569-.006a2.959,2.959,0,0,1,.337.009.5.5,0,0,1,.311.134l-.006.006c.115.1.211.215.333.3l-.011.015c.109.132.215.136.32-.009l-.006,0a2.4,2.4,0,0,0,.324-.318,9483.822,9483.822,0,0,1,.64-.64,18966.964,18966.964,0,0,1,.64-.64,6322.07,6322.07,0,0,1,.64-.64,2.832,2.832,0,0,0,.32-.32c.115-.1.217-.207.324-.313l-.006-.006c.119-.092.213-.213.337-.3Z",
    transform: "translate(-97.359 -155.288)",
    fill: "#527e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2407",
    "data-name": "Path 2407",
    d: "M167.232,354.915l-.309-.034a2.923,2.923,0,0,0-.3-.232.416.416,0,0,1-.092-.092.638.638,0,0,0-.226-.226.479.479,0,0,1-.094-.092.638.638,0,0,0-.226-.226.478.478,0,0,1-.094-.092.649.649,0,0,0-.224-.226.407.407,0,0,1-.092-.09.632.632,0,0,0-.22-.224.467.467,0,0,1-.094-.09.8.8,0,0,0-.273-.273.4.4,0,0,1-.077-.122,1.106,1.106,0,0,1-.047-.3c-.006-.19-.006-.377-.006-.565a2.958,2.958,0,0,1,.009-.337.468.468,0,0,1,.141-.307v0a.365.365,0,0,1,.252-.13.56.56,0,0,0,.388-.186l-.013-.026a.855.855,0,0,1,.627-.128.553.553,0,0,1,.343.134l-.013.019c.122.09.218.207.335.3l0,0a.426.426,0,0,0,.328.186,2.227,2.227,0,0,0,.267,0,.3.3,0,0,0,.286-.162.444.444,0,0,1,.1-.094.644.644,0,0,0,.228-.226.477.477,0,0,1,.092-.094.662.662,0,0,0,.228-.226.477.477,0,0,1,.092-.094.661.661,0,0,0,.228-.226.477.477,0,0,1,.092-.094.662.662,0,0,0,.228-.226.477.477,0,0,1,.092-.094.662.662,0,0,0,.228-.226.478.478,0,0,1,.092-.094.655.655,0,0,0,.228-.224.478.478,0,0,1,.092-.094.667.667,0,0,0,.23-.226.436.436,0,0,1,.094-.094.644.644,0,0,0,.23-.23.426.426,0,0,1,.092-.094,2.1,2.1,0,0,0,.307-.241l-.013-.021a.522.522,0,0,1,.29-.113,2.5,2.5,0,0,1,.309,0,.938.938,0,0,1,.3.047.383.383,0,0,1,.119.081.38.38,0,0,0,.335.2.357.357,0,0,1,.247.128l0-.006a.466.466,0,0,1,.134.3,2.857,2.857,0,0,1,.009.331c0,.109,0,.22,0,.328s0,.222-.006.333a.526.526,0,0,1-.126.307l-.011-.009c-.1.113-.211.213-.311.328a4.124,4.124,0,0,0-.32.32,12644.651,12644.651,0,0,1-1.28,1.28,18966.964,18966.964,0,0,1-.64.64,6322.07,6322.07,0,0,1-.64.64,18966.964,18966.964,0,0,1-.64.64c-.113.1-.218.209-.324.316l.006.006a.446.446,0,0,1-.252.117.561.561,0,0,0-.4.183l.013.032a.269.269,0,0,1-.328,0Z",
    transform: "translate(-97.407 -242.603)",
    fill: "#527e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2408",
    "data-name": "Path 2408",
    d: "M171.041,311.56h.313a.533.533,0,0,0,.388.179.453.453,0,0,1,.26.115l-.009.009c.1.109.213.213.316.322l.015-.011a.556.556,0,0,1,.124.311c.013.19.006.382,0,.572a1.2,1.2,0,0,1-.041.3.39.39,0,0,1-.068.124.9.9,0,0,0-.279.275.375.375,0,0,1-.092.092.643.643,0,0,0-.224.224.416.416,0,0,1-.092.092.655.655,0,0,0-.226.226.478.478,0,0,1-.092.094.661.661,0,0,0-.228.226.479.479,0,0,1-.092.094.661.661,0,0,0-.228.226.478.478,0,0,1-.092.094.661.661,0,0,0-.228.226.479.479,0,0,1-.092.094.661.661,0,0,0-.228.226.478.478,0,0,1-.092.094.661.661,0,0,0-.228.226.479.479,0,0,1-.092.094.662.662,0,0,0-.228.226.478.478,0,0,1-.092.094.661.661,0,0,0-.228.226.478.478,0,0,1-.092.094.656.656,0,0,0-.228.224.478.478,0,0,1-.092.094.667.667,0,0,0-.23.226.435.435,0,0,1-.094.094.644.644,0,0,0-.23.23.426.426,0,0,1-.092.094,1.756,1.756,0,0,0-.3.243l.013.021a.6.6,0,0,1-.333.124,4.387,4.387,0,0,1-.627,0,.519.519,0,0,1-.326-.139l.009-.009c-.119-.094-.22-.207-.328-.311s-.213-.213-.32-.32l-.32-.32-.32-.32c-.107-.107-.215-.211-.316-.324l-.006.006a.482.482,0,0,1-.13-.3,2.847,2.847,0,0,1-.009-.331c0-.109,0-.22,0-.328s0-.222.006-.333a.537.537,0,0,1,.126-.309l.011.009c.1-.109.209-.215.32-.318l-.009-.013a.569.569,0,0,1,.324-.128c.2-.015.407-.011.612-.009a3.186,3.186,0,0,1,.35.009.492.492,0,0,1,.316.139l-.006,0c.117.094.213.213.333.3l-.011.017c.111.126.22.13.324-.009l0,0a4.141,4.141,0,0,0,.324-.318q.166-.154.32-.32t.32-.32q.166-.154.32-.32t.32-.32q.166-.154.32-.32t.32-.32q.166-.154.32-.32c.111-.1.213-.211.324-.313l-.006-.009a.474.474,0,0,1,.264-.122.536.536,0,0,0,.382-.177Z",
    transform: "translate(-97.373 -213.641)",
    fill: "#527e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2409",
    "data-name": "Path 2409",
    d: "M231.527,323.846H217.759a.2.2,0,0,1,.017-.3H231.51A.2.2,0,0,1,231.527,323.846Z",
    transform: "translate(-138.984 -223.074)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2410",
    "data-name": "Path 2410",
    d: "M231.522,286.319H217.757a.2.2,0,0,1,.019-.3H231.5A.2.2,0,0,1,231.522,286.319Z",
    transform: "translate(-138.982 -193.547)",
    fill: "#bccdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2411",
    "data-name": "Path 2411",
    d: "M231.728,359.743H217.96c0-.414.316-.3.537-.3q4.274-.01,8.549,0h4.195c.22,0,.493-.066.484.3Z",
    transform: "translate(-139.187 -251.3)",
    fill: "#d2decb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2412",
    "data-name": "Path 2412",
    d: "M231.52,250.371H217.759a.2.2,0,0,1,.013-.3h13.736a.2.2,0,0,1,.013.3Z",
    transform: "translate(-138.982 -165.264)",
    fill: "#5b8546"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2413",
    "data-name": "Path 2413",
    d: "M219.257,297.982q6.721,0,13.439,0a.2.2,0,0,1-.017.3H219.257a.207.207,0,0,1,0-.3Z",
    transform: "translate(-140.156 -202.957)",
    fill: "#658d51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2414",
    "data-name": "Path 2414",
    d: "M217.758,335.54q6.721,0,13.441,0a.2.2,0,0,1,0,.29q-6.708,0-13.416,0A.2.2,0,0,1,217.758,335.54Z",
    transform: "translate(-138.983 -232.507)",
    fill: "#b0c5a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M217.967,262.06q6.721,0,13.441,0a.2.2,0,0,1,0,.292q-6.5,0-13,.011C218.183,262.365,217.953,262.388,217.967,262.06Z",
    transform: "translate(-139.193 -174.697)",
    fill: "#c6d6bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M194.632,236.8l-.646-.011c-.013-.211.079-.3.3-.3S194.647,236.546,194.632,236.8Z",
    transform: "translate(-120.325 -154.572)",
    fill: "#eff4ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M287.04,366.087c0-.217,0-.433,0-.65.252-.013.311.126.309.352s-.109.3-.311.3Z",
    transform: "translate(-193.536 -256.028)",
    fill: "#f6f8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M200.06,242.908v-.657a.2.2,0,0,1,.294.015v.625a.2.2,0,0,1-.292.017Z",
    transform: "translate(-125.104 -159.068)",
    fill: "#80a16f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M164.376,254.249v.657a.2.2,0,0,1-.3-.013v-.625A.2.2,0,0,1,164.376,254.249Z",
    transform: "translate(-96.797 -168.509)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M212.3,254.469c0,.218,0,.433,0,.65-.252.013-.309-.128-.307-.354s.109-.3.313-.3Z",
    transform: "translate(-134.49 -168.724)",
    fill: "#f4f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M287.044,255.119c0-.218,0-.433,0-.65.2-.006.311.072.313.3S287.3,255.13,287.044,255.119Z",
    transform: "translate(-193.536 -168.724)",
    fill: "#f6f8f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M168.52,286.24c.021-.51.409-.224.633-.292a.25.25,0,0,1,.045.309.546.546,0,0,1-.554.092A.237.237,0,0,1,168.52,286.24Z",
    transform: "translate(-100.29 -193.475)",
    fill: "#c4d4bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2423",
    "data-name": "Path 2423",
    d: "M164.09,292.358v-.625a.24.24,0,0,1,.341,0,.586.586,0,0,1,0,.638.235.235,0,0,1-.341-.009Z",
    transform: "translate(-96.805 -197.985)",
    fill: "#71965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2424",
    "data-name": "Path 2424",
    d: "M174.895,303.806h-.627a.234.234,0,0,1-.013-.339.59.59,0,0,1,.638,0,.239.239,0,0,1,0,.343Z",
    transform: "translate(-104.75 -207.198)",
    fill: "#628a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M200.06,316.4v-.657a.2.2,0,0,1,.292.019v.625a.2.2,0,0,1-.292.015Z",
    transform: "translate(-125.104 -216.886)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M168.917,323.844h-.657a.2.2,0,0,1,.021-.294h.625A.2.2,0,0,1,168.917,323.844Z",
    transform: "translate(-100.043 -223.074)",
    fill: "#799c68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2427",
    "data-name": "Path 2427",
    d: "M174.269,341.53c.218,0,.435,0,.653.006a.2.2,0,0,1-.009.29c-.207,0-.414,0-.621,0a.2.2,0,0,1-.021-.3Z",
    transform: "translate(-104.77 -237.22)",
    fill: "#acc2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2428",
    "data-name": "Path 2428",
    d: "M169.128,359.733l-.648.006c.028-.5.409-.245.644-.307A.207.207,0,0,1,169.128,359.733Z",
    transform: "translate(-100.259 -251.296)",
    fill: "#dce5d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2429",
    "data-name": "Path 2429",
    d: "M164.386,365.231v.655a.206.206,0,0,1-.3-.017v-.625a.206.206,0,0,1,.3-.011Z",
    transform: "translate(-96.805 -255.822)",
    fill: "#70965e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2430",
    "data-name": "Path 2430",
    d: "M212.3,365.437l0,.65c-.2.006-.309-.072-.311-.3s.058-.365.309-.352Z",
    transform: "translate(-134.49 -256.028)",
    fill: "#f4f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2431",
    "data-name": "Path 2431",
    d: "M168.912,250.369h-.653a.2.2,0,0,1,.017-.3h.627A.206.206,0,0,1,168.912,250.369Z",
    transform: "translate(-100.041 -165.264)",
    fill: "#638b4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2432",
    "data-name": "Path 2432",
    d: "M191.307,238.013c.017.247-.1.339-.337.3C190.949,238.06,191.056,237.956,191.307,238.013Z",
    transform: "translate(-117.951 -155.766)",
    fill: "#a2bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2433",
    "data-name": "Path 2433",
    d: "M197.293,238.335c-.235.038-.35-.058-.337-.3l.316-.009A.206.206,0,0,1,197.293,238.335Z",
    transform: "translate(-122.662 -155.791)",
    fill: "#85a677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2434",
    "data-name": "Path 2434",
    d: "M198.461,238.307c-.006-.1-.015-.2-.021-.3.237-.038.348.07.352.3-.017.019-.034.038-.053.058a.234.234,0,0,1-.284-.047l.006-.006Z",
    transform: "translate(-123.83 -155.763)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M189.794,239.469c.026.243-.083.348-.324.316C189.438,239.535,189.544,239.429,189.794,239.469Z",
    transform: "translate(-116.768 -156.917)",
    fill: "#83a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M199.774,239.44c.232,0,.328.113.3.341a.214.214,0,0,1-.3-.017l-.015.011a.235.235,0,0,1,0-.313l.028-.019Z",
    transform: "translate(-124.812 -156.9)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M188.289,240.947q.048.368-.32.32C187.938,241.022,188.044,240.913,188.289,240.947Z",
    transform: "translate(-115.588 -158.082)",
    fill: "#83a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2438",
    "data-name": "Path 2438",
    d: "M200.05,240.96l.3.017c0,.107-.006.211-.011.318l-.294-.015Z",
    transform: "translate(-125.097 -158.096)",
    fill: "#aac19f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M186.789,242.447q.048.368-.32.32C186.438,242.522,186.544,242.413,186.789,242.447Z",
    transform: "translate(-114.408 -159.262)",
    fill: "#84a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M185.289,243.947q.048.368-.32.32C184.938,244.022,185.044,243.913,185.289,243.947Z",
    transform: "translate(-113.228 -160.442)",
    fill: "#83a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M183.789,245.447q.048.368-.32.32C183.438,245.522,183.544,245.413,183.789,245.447Z",
    transform: "translate(-112.048 -161.622)",
    fill: "#84a374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M200.052,245.477l.292-.017c0,.1.006.211.011.316a.209.209,0,0,1-.3.019v-.318Z",
    transform: "translate(-125.097 -161.637)",
    fill: "#abc1a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M182.289,246.947q.048.368-.32.32C181.938,247.022,182.044,246.913,182.289,246.947Z",
    transform: "translate(-110.868 -162.802)",
    fill: "#83a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2444",
    "data-name": "Path 2444",
    d: "M199.741,246.959l.3-.019c.032.226-.055.348-.294.339-.021-.015-.041-.03-.062-.047a.232.232,0,0,1,.036-.284Z",
    transform: "translate(-124.787 -162.801)",
    fill: "#f5f8f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2445",
    "data-name": "Path 2445",
    d: "M180.789,248.447q.048.368-.32.32C180.438,248.522,180.544,248.413,180.789,248.447Z",
    transform: "translate(-109.687 -163.982)",
    fill: "#84a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2446",
    "data-name": "Path 2446",
    d: "M198.574,248.265c-.006.209-.1.333-.324.328-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.281.213.213,0,0,1,.3-.013l.032.017Z",
    transform: "translate(-123.61 -163.787)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2447",
    "data-name": "Path 2447",
    d: "M165.512,250.318q-.045-.371.326-.326a.217.217,0,0,1-.017.307l.009.011A.24.24,0,0,1,165.512,250.318Z",
    transform: "translate(-97.92 -165.199)",
    fill: "#f5f8f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2448",
    "data-name": "Path 2448",
    d: "M166.98,250.327c.006-.1.011-.2.017-.307.107,0,.213.009.32.011-.006.1-.011.2-.017.3C167.193,250.331,167.087,250.329,166.98,250.327Z",
    transform: "translate(-99.079 -165.224)",
    fill: "#9eb893"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2449",
    "data-name": "Path 2449",
    d: "M171.5,250.353c0-.1-.006-.2-.009-.3.1,0,.207,0,.311,0a.207.207,0,0,1,.026.3c-.109,0-.218,0-.326.006Z",
    transform: "translate(-102.627 -165.248)",
    fill: "#7c9e6b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2450",
    "data-name": "Path 2450",
    d: "M172.976,250.3l-.026-.3q.368-.064.333.307l-.309-.009Z",
    transform: "translate(-103.776 -165.205)",
    fill: "#ccd9c5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2451",
    "data-name": "Path 2451",
    d: "M179.289,249.947q.048.368-.32.32C178.938,250.022,179.044,249.913,179.289,249.947Z",
    transform: "translate(-108.507 -165.162)",
    fill: "#84a374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2452",
    "data-name": "Path 2452",
    d: "M197.08,249.77a.279.279,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.281.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-122.438 -164.963)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2453",
    "data-name": "Path 2453",
    d: "M214.92,250.29c0-.232.119-.328.348-.29a.21.21,0,0,1-.021.3l.011.011a.231.231,0,0,1-.245.068A.156.156,0,0,1,214.92,250.29Z",
    transform: "translate(-136.796 -165.202)",
    fill: "#e5ece2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2454",
    "data-name": "Path 2454",
    d: "M216.46,250.333c.006-.1.013-.2.021-.3l.316.011-.013.3C216.675,250.339,216.569,250.337,216.46,250.333Z",
    transform: "translate(-138.007 -165.232)",
    fill: "#8dab80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2455",
    "data-name": "Path 2455",
    d: "M282.463,250.339l-.013-.3.313-.011a.206.206,0,0,1,.023.3c-.109,0-.215,0-.324.009Z",
    transform: "translate(-189.925 -165.232)",
    fill: "#8dab80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2456",
    "data-name": "Path 2456",
    d: "M283.943,250.292c-.009-.1-.015-.2-.023-.3.228-.038.345.058.35.29l-.047.064a.236.236,0,0,1-.29-.041l.011-.013Z",
    transform: "translate(-191.081 -165.194)",
    fill: "#e6ece4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2457",
    "data-name": "Path 2457",
    d: "M165.522,251.509l.318-.009c.023.237-.083.341-.32.318,0-.1,0-.207,0-.311Z",
    transform: "translate(-97.93 -166.389)",
    fill: "#70965f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2458",
    "data-name": "Path 2458",
    d: "M174.811,251.791c-.249.051-.356-.055-.333-.3C174.717,251.447,174.83,251.547,174.811,251.791Z",
    transform: "translate(-104.976 -166.372)",
    fill: "#adc3a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2459",
    "data-name": "Path 2459",
    d: "M177.78,251.45c.032.247-.077.354-.324.318C177.431,251.524,177.537,251.418,177.78,251.45Z",
    transform: "translate(-107.318 -166.345)",
    fill: "#84a374"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M195.58,251.27a.279.279,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.281.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-121.258 -166.143)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M213.507,251.744c-.043-.237.07-.343.3-.354l.028.032a.22.22,0,0,1-.013.307l-.006-.009a.212.212,0,0,1-.3.023Z",
    transform: "translate(-135.677 -166.302)",
    fill: "#e2e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M285.253,251.382c.226.013.339.119.3.354a.21.21,0,0,1-.3-.023l-.009.009a.223.223,0,0,1-.013-.307l.026-.034Z",
    transform: "translate(-192.065 -166.294)",
    fill: "#e2e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M164.318,253.262l-.3.019c-.058-.247.043-.358.292-.339,0,.107,0,.213,0,.318Z",
    transform: "translate(-96.739 -167.522)",
    fill: "#a7bf9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M176.32,252.98c-.015.128.041.313-.179.3-.171-.013-.124-.177-.141-.288Z",
    transform: "translate(-106.175 -167.553)",
    fill: "#6c9259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M194.08,252.77a.279.279,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.281.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-120.078 -167.324)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M213.54,252.963l.3-.023c.04.235-.055.35-.294.337,0-.1,0-.211-.009-.316Z",
    transform: "translate(-135.71 -167.522)",
    fill: "#7e9f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M285.5,252.95l.3.023c0,.1,0,.211-.009.316-.241.011-.335-.1-.294-.337Z",
    transform: "translate(-192.314 -167.53)",
    fill: "#7f9f6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M192.58,254.27a.279.279,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.281.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-118.897 -168.504)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M191.08,255.77a.279.279,0,0,1-.32.32c-.019-.017-.04-.034-.06-.049a.22.22,0,0,1,.049-.281.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-117.717 -169.684)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2470",
    "data-name": "Path 2470",
    d: "M164.066,257.47l.3.013c0,.109,0,.215,0,.324a.208.208,0,0,1-.3-.023l.006-.311Z",
    transform: "translate(-96.782 -171.086)",
    fill: "#90ad81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2471",
    "data-name": "Path 2471",
    d: "M189.58,257.27a.279.279,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.281.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-116.537 -170.864)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M213.554,257.458c.241-.011.333.109.3.339a.206.206,0,0,1-.3-.026C213.55,257.667,213.552,257.562,213.554,257.458Z",
    transform: "translate(-135.718 -171.075)",
    fill: "#668e53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2473",
    "data-name": "Path 2473",
    d: "M285.494,257.8c-.034-.23.055-.352.3-.339,0,.1,0,.209,0,.316a.208.208,0,0,1-.3.026Z",
    transform: "translate(-192.314 -171.074)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2474",
    "data-name": "Path 2474",
    d: "M164.024,258.93l.3.023c0,.1.011.2.015.307C164.09,259.288,163.988,259.175,164.024,258.93Z",
    transform: "translate(-96.748 -172.234)",
    fill: "#e1e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2475",
    "data-name": "Path 2475",
    d: "M188.08,258.77a.279.279,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.281.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-115.357 -172.044)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2476",
    "data-name": "Path 2476",
    d: "M213.52,258.93l.3.026c0,.1.006.2.009.307-.252.028-.356-.081-.309-.331Z",
    transform: "translate(-135.685 -172.234)",
    fill: "#becfb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2477",
    "data-name": "Path 2477",
    d: "M285.489,258.956l.3-.026c.047.25-.058.358-.309.331,0-.1.006-.2.009-.307Z",
    transform: "translate(-192.308 -172.234)",
    fill: "#becfb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2478",
    "data-name": "Path 2478",
    d: "M165.522,260.435c.245-.028.35.083.316.324C165.59,260.789,165.483,260.682,165.522,260.435Z",
    transform: "translate(-97.926 -173.415)",
    fill: "#c8d8c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2479",
    "data-name": "Path 2479",
    d: "M186.58,260.27a.279.279,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.282.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-114.177 -173.224)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2480",
    "data-name": "Path 2480",
    d: "M214.99,260.461c.235-.03.35.068.331.311C215.067,260.821,214.958,260.717,214.99,260.461Z",
    transform: "translate(-136.846 -173.435)",
    fill: "#b6c9ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2481",
    "data-name": "Path 2481",
    d: "M283.921,260.77c-.021-.243.1-.339.331-.309C284.283,260.714,284.175,260.819,283.921,260.77Z",
    transform: "translate(-191.08 -173.434)",
    fill: "#b6c9ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2482",
    "data-name": "Path 2482",
    d: "M167.01,261.95q.368-.048.32.32Q166.962,262.317,167.01,261.95Z",
    transform: "translate(-99.098 -174.606)",
    fill: "#c7d7c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2483",
    "data-name": "Path 2483",
    d: "M185.08,261.77a.279.279,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.282.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-112.997 -174.404)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2484",
    "data-name": "Path 2484",
    d: "M280.97,262.362c0-.1,0-.194,0-.292h.324C281.315,262.309,281.2,262.4,280.97,262.362Z",
    transform: "translate(-188.76 -174.705)",
    fill: "#d2decb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2485",
    "data-name": "Path 2485",
    d: "M168.51,263.45q.368-.048.32.32Q168.462,263.817,168.51,263.45Z",
    transform: "translate(-100.278 -175.786)",
    fill: "#c7d6c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2486",
    "data-name": "Path 2486",
    d: "M183.58,263.27a.279.279,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.049-.281.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-111.817 -175.584)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2487",
    "data-name": "Path 2487",
    d: "M170.01,264.95c.245-.032.352.075.322.32C170.087,265.3,169.978,265.2,170.01,264.95Z",
    transform: "translate(-101.458 -176.966)",
    fill: "#c7d7c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2488",
    "data-name": "Path 2488",
    d: "M182.084,264.77a.28.28,0,0,1-.32.32c-.019-.017-.041-.034-.06-.049a.22.22,0,0,1,.051-.281.216.216,0,0,1,.3-.015l.028.026Z",
    transform: "translate(-110.641 -176.764)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2489",
    "data-name": "Path 2489",
    d: "M171.5,266.462l.3.009a.209.209,0,0,1,.023.3c-.247.038-.358-.064-.328-.316Z",
    transform: "translate(-102.633 -178.158)",
    fill: "#d0dcc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2490",
    "data-name": "Path 2490",
    d: "M172.983,266.8c-.009-.1-.017-.2-.023-.3.232-.032.352.062.337.3h-.313Z",
    transform: "translate(-103.784 -178.183)",
    fill: "#618a4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M178.972,266.8c-.015-.239.1-.337.333-.3a.206.206,0,0,1-.021.307c-.1,0-.209,0-.313,0Z",
    transform: "translate(-108.512 -178.181)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M180.45,266.569c.006-.1.013-.2.021-.307h0a.22.22,0,0,1,.307-.015l.028.028c0,.23-.117.335-.35.3Z",
    transform: "translate(-109.676 -177.947)",
    fill: "#ebf1e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2493",
    "data-name": "Path 2493",
    d: "M174.466,268.06c.109,0,.218,0,.326,0a.2.2,0,0,1,.006.292C174.564,268.4,174.454,268.3,174.466,268.06Z",
    transform: "translate(-104.968 -179.417)",
    fill: "#cbdac5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2494",
    "data-name": "Path 2494",
    d: "M176.006,268.362c0-.1,0-.194-.006-.292h.326a.2.2,0,0,1-.011.292Z",
    transform: "translate(-106.175 -179.425)",
    fill: "#bcceb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2495",
    "data-name": "Path 2495",
    d: "M177.48,268.339c0-.1.006-.2.011-.292.107,0,.215,0,.322-.006C177.825,268.277,177.719,268.381,177.48,268.339Z",
    transform: "translate(-107.34 -179.402)",
    fill: "#d8e1d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2496",
    "data-name": "Path 2496",
    d: "M192.492,274.3c-.032-.256.1-.326.324-.282a.244.244,0,0,1,.047.277.237.237,0,0,1-.262.1A.189.189,0,0,1,192.492,274.3Z",
    transform: "translate(-119.147 -184.091)",
    fill: "#b9cbaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2497",
    "data-name": "Path 2497",
    d: "M193.98,274.348c0-.1.009-.192.011-.288h.311a.238.238,0,0,1,.009.333A.243.243,0,0,1,193.98,274.348Z",
    transform: "translate(-120.321 -184.138)",
    fill: "#9db790"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2498",
    "data-name": "Path 2498",
    d: "M195.5,274.316c0-.1,0-.192-.006-.288l.311-.009a.217.217,0,1,1-.3.3Z",
    transform: "translate(-121.509 -184.106)",
    fill: "#abc2a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2499",
    "data-name": "Path 2499",
    d: "M196.969,274.3l-.019-.3c.215-.032.35.034.335.279l-.038.068a.2.2,0,0,1-.275-.051Z",
    transform: "translate(-122.658 -184.086)",
    fill: "#e5ece2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2500",
    "data-name": "Path 2500",
    d: "M189.412,275.778c.006-.23.122-.331.35-.29a.264.264,0,0,1,.038.29.251.251,0,0,1-.275.1.2.2,0,0,1-.115-.1Z",
    transform: "translate(-116.726 -185.254)",
    fill: "#dae3d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2501",
    "data-name": "Path 2501",
    d: "M190.952,275.717l.021-.307.309-.03-.006.049c.109.341-.011.427-.326.288Z",
    transform: "translate(-117.937 -185.176)",
    fill: "#61894c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M198.284,275.34a.318.318,0,0,1,.345.343l-.07.06c-.292.043-.42-.049-.286-.352l.009-.049Z",
    transform: "translate(-123.657 -185.145)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M187.91,277.21a.288.288,0,0,1,.32-.32l.032.036c.119.241.036.363-.224.377A.186.186,0,0,1,187.91,277.21Z",
    transform: "translate(-115.545 -186.364)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M199.739,276.949c.241-.006.318.119.279.341a.263.263,0,0,1-.331.009.266.266,0,0,1,0-.331l.047-.017Z",
    transform: "translate(-124.766 -186.411)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M186.41,278.71a.286.286,0,0,1,.32-.32l.034.036c.119.241.036.363-.224.377a.186.186,0,0,1-.128-.094Z",
    transform: "translate(-114.365 -187.544)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2506",
    "data-name": "Path 2506",
    d: "M199.745,278.44l.3.023c0,.1,0,.207-.006.311a.244.244,0,0,1-.333,0,.252.252,0,0,1,.043-.333Z",
    transform: "translate(-124.789 -187.584)",
    fill: "#92af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2507",
    "data-name": "Path 2507",
    d: "M184.91,280.21a.286.286,0,0,1,.32-.32l.034.036c.119.241.036.363-.224.377a.186.186,0,0,1-.128-.094Z",
    transform: "translate(-113.185 -188.725)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M199.74,279.96l.292.009v.313a.237.237,0,0,1-.331.011A.25.25,0,0,1,199.74,279.96Z",
    transform: "translate(-124.787 -188.78)",
    fill: "#7b9d6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M183.41,281.71a.286.286,0,0,1,.32-.32l.034.036c.119.241.036.363-.224.377a.186.186,0,0,1-.128-.094Z",
    transform: "translate(-112.005 -189.905)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M199.755,281.479c.1,0,.194,0,.292-.009,0,.1,0,.207.006.311a.235.235,0,0,1-.328.028.245.245,0,0,1,.032-.333Z",
    transform: "translate(-124.802 -189.968)",
    fill: "#8dab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M181.91,283.2a.286.286,0,0,1,.32-.32l.034.036c.119.241.036.363-.224.377a.186.186,0,0,1-.128-.094Z",
    transform: "translate(-110.825 -191.077)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M199.771,282.961l.3-.021c.041.224-.034.352-.279.337l-.064-.041a.2.2,0,0,1,.049-.273Z",
    transform: "translate(-124.816 -191.124)",
    fill: "#cddac7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M180.41,284.7a.286.286,0,0,1,.32-.32l.034.036c.119.241.036.363-.224.377a.186.186,0,0,1-.128-.094Z",
    transform: "translate(-109.645 -192.257)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M198.633,284.275c-.011.209-.092.348-.331.331l-.064-.064c-.047-.292.051-.405.343-.279l.049.013Z",
    transform: "translate(-123.663 -192.124)",
    fill: "#a2bc97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2515",
    "data-name": "Path 2515",
    d: "M171.5,286.291c0-.1-.006-.2-.009-.294.222-.03.348.045.322.288l-.045.064a.194.194,0,0,1-.271-.058Z",
    transform: "translate(-102.627 -193.524)",
    fill: "#dde6d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M178.92,286.2a.286.286,0,0,1,.32-.32l.034.036c.119.241.036.363-.224.377a.186.186,0,0,1-.128-.094Z",
    transform: "translate(-108.473 -193.437)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M197.131,285.776c.009.222-.1.333-.32.32l-.064-.064c-.049-.294.058-.4.345-.29l.036.034Z",
    transform: "translate(-122.489 -193.295)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M216.817,286l-.019.3-.316.011c-.019-.245.094-.345.335-.307Z",
    transform: "translate(-138.023 -193.526)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M282.449,286.292c-.006-.1-.013-.2-.019-.3.241-.036.354.064.335.307l-.316-.011Z",
    transform: "translate(-189.909 -193.521)",
    fill: "#edf2eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M165.38,287.787c.017-.222.115-.35.36-.3a.233.233,0,0,1-.239.388A.214.214,0,0,1,165.38,287.787Z",
    transform: "translate(-97.82 -194.694)",
    fill: "#c5d5bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M166.96,287.725c.009-.1.015-.2.023-.3l.311-.03-.009.047C167.412,287.8,167.263,287.849,166.96,287.725Z",
    transform: "translate(-99.063 -194.625)",
    fill: "#5e8649"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M172.826,287.37c.1.011.2.021.309.03a.219.219,0,0,1,0,.335c-.307.092-.435.011-.307-.318v-.047Z",
    transform: "translate(-103.641 -194.609)",
    fill: "#82a272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M174.469,287.8l-.019-.307c.215-.028.352.036.335.284l-.038.066a.247.247,0,0,1-.222.013c-.019-.017-.036-.036-.055-.053Z",
    transform: "translate(-104.956 -194.705)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M177.448,287.7c-.011-.22.111-.307.313-.314l.034.036c.117.239.038.363-.224.375a.177.177,0,0,1-.124-.1Z",
    transform: "translate(-107.314 -194.625)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M195.632,287.279c.009.222-.1.331-.32.32l-.064-.064c-.049-.294.06-.4.348-.29Z",
    transform: "translate(-121.31 -194.478)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M215.316,287.494c.019.239-.092.339-.326.309C214.957,287.552,215.062,287.443,215.316,287.494Z",
    transform: "translate(-136.846 -194.698)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M284.268,287.814c-.235.03-.345-.07-.326-.309C284.2,287.453,284.3,287.562,284.268,287.814Z",
    transform: "translate(-191.097 -194.705)",
    fill: "#a6bd9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M164.027,289.266c-.038-.224.047-.345.281-.345l.045.023a.266.266,0,0,1,0,.331A.261.261,0,0,1,164.027,289.266Z",
    transform: "translate(-96.749 -195.829)",
    fill: "#dbe4d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2529",
    "data-name": "Path 2529",
    d: "M175.752,288.84c.1,0,.2,0,.3,0l.026.045c.124.328-.019.409-.32.341a.235.235,0,0,1-.019-.341l.006-.047Z",
    transform: "translate(-105.923 -195.766)",
    fill: "#c9d8c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2530",
    "data-name": "Path 2530",
    d: "M194.132,288.779c.009.222-.1.331-.32.32l-.064-.064c-.049-.294.06-.4.348-.29Z",
    transform: "translate(-120.13 -195.658)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2531",
    "data-name": "Path 2531",
    d: "M213.821,288.958c0,.1,0,.2-.006.307a.2.2,0,0,1-.3.023c-.051-.252.055-.358.3-.333Z",
    transform: "translate(-135.679 -195.855)",
    fill: "#b4c8ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2532",
    "data-name": "Path 2532",
    d: "M285.5,289.283c0-.1,0-.2-.006-.307.25-.026.356.081.307.333a.2.2,0,0,1-.3-.023Z",
    transform: "translate(-192.316 -195.87)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2533",
    "data-name": "Path 2533",
    d: "M164.052,290.453l.3-.023a.212.212,0,0,1,0,.324l-.294.011c0-.1,0-.207-.006-.311Z",
    transform: "translate(-96.774 -197.017)",
    fill: "#8aa97c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2534",
    "data-name": "Path 2534",
    d: "M192.64,290.279c.009.222-.1.331-.32.32-.021-.021-.043-.043-.062-.064-.049-.294.06-.4.348-.29l.036.034Z",
    transform: "translate(-118.957 -196.838)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2535",
    "data-name": "Path 2535",
    d: "M213.56,290.453l.3-.023c.034.23-.055.352-.3.339C213.562,290.665,213.562,290.558,213.56,290.453Z",
    transform: "translate(-135.726 -197.017)",
    fill: "#628a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2536",
    "data-name": "Path 2536",
    d: "M285.5,290.43l.3.023c0,.1,0,.211,0,.316-.241.013-.331-.109-.3-.339Z",
    transform: "translate(-192.322 -197.017)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2537",
    "data-name": "Path 2537",
    d: "M191.132,291.779c.009.222-.1.331-.32.32l-.064-.064c-.049-.294.06-.4.348-.29Z",
    transform: "translate(-117.769 -198.018)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2538",
    "data-name": "Path 2538",
    d: "M212.386,291.95c0,.109,0,.22,0,.328-.109-.015-.26.023-.277-.139-.019-.207.158-.166.279-.188Z",
    transform: "translate(-134.579 -198.213)",
    fill: "#f0f4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2539",
    "data-name": "Path 2539",
    d: "M287.054,292.278c0-.109,0-.218,0-.328.122.021.3-.019.279.188-.015.164-.166.126-.277.139Z",
    transform: "translate(-193.544 -198.213)",
    fill: "#f2f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2540",
    "data-name": "Path 2540",
    d: "M189.64,293.279c.009.222-.1.331-.32.32-.021-.021-.043-.043-.062-.064-.049-.294.06-.4.348-.29l.036.034Z",
    transform: "translate(-116.597 -199.199)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2541",
    "data-name": "Path 2541",
    d: "M164.038,294.93c.1.006.2.013.3.021a.2.2,0,0,1,.075.228.142.142,0,0,1-.09.085C164.063,295.29,163.989,295.162,164.038,294.93Z",
    transform: "translate(-96.753 -200.557)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2542",
    "data-name": "Path 2542",
    d: "M188.132,294.779c.009.222-.1.331-.32.32l-.064-.064c-.049-.294.06-.4.348-.29Z",
    transform: "translate(-115.409 -200.379)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2543",
    "data-name": "Path 2543",
    d: "M213.541,294.945c.243-.015.335.1.294.335a.206.206,0,0,1-.3-.021c0-.1.006-.209.009-.313Z",
    transform: "translate(-135.702 -200.568)",
    fill: "#84a475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2544",
    "data-name": "Path 2544",
    d: "M285.5,295.28c-.038-.232.053-.35.3-.335,0,.1.006.209.009.313A.205.205,0,0,1,285.5,295.28Z",
    transform: "translate(-192.317 -200.568)",
    fill: "#86a677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2545",
    "data-name": "Path 2545",
    d: "M165.428,296.619c-.009-.1-.019-.2-.028-.3l.051-.006c.328-.119.405.011.311.311A.224.224,0,0,1,165.428,296.619Z",
    transform: "translate(-97.836 -201.606)",
    fill: "#789b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2546",
    "data-name": "Path 2546",
    d: "M186.632,296.279c.009.222-.1.331-.32.32l-.064-.064c-.049-.294.06-.4.348-.29Z",
    transform: "translate(-114.229 -201.559)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M213.507,296.42l.3.021.009-.009a.229.229,0,0,1,.073.241.192.192,0,0,1-.085.1c-.23-.006-.339-.117-.3-.352Z",
    transform: "translate(-135.679 -201.729)",
    fill: "#e8efe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M285.225,296.441l.3-.021c.041.237-.068.345-.3.352-.019-.017-.038-.034-.06-.051a.234.234,0,0,1,.047-.288l.009.009Z",
    transform: "translate(-192.043 -201.729)",
    fill: "#e8efe5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M165.506,297.93l.311.017c.017.019.036.036.053.055a.256.256,0,0,1,0,.22l-.058.051C165.572,298.278,165.472,298.162,165.506,297.93Z",
    transform: "translate(-97.914 -202.917)",
    fill: "#f4f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M185.132,297.779c.009.222-.1.331-.32.32l-.064-.064c-.049-.294.06-.4.348-.29Z",
    transform: "translate(-113.049 -202.739)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2551",
    "data-name": "Path 2551",
    d: "M215.285,298.048c-.228.036-.345-.062-.345-.294l.023-.03a.232.232,0,0,1,.311.009l-.011.013A.212.212,0,0,1,215.285,298.048Z",
    transform: "translate(-136.811 -202.711)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2552",
    "data-name": "Path 2552",
    d: "M216.481,298.317c-.006-.1-.013-.2-.021-.3.107,0,.215,0,.322,0a.206.206,0,0,1,.013.3Z",
    transform: "translate(-138.007 -202.98)",
    fill: "#9cb68e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2553",
    "data-name": "Path 2553",
    d: "M217.983,298.293c0-.1-.009-.2-.013-.3.109,0,.218,0,.324,0,0,.1,0,.2,0,.3-.1,0-.209,0-.316,0Z",
    transform: "translate(-139.195 -202.965)",
    fill: "#70955d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2554",
    "data-name": "Path 2554",
    d: "M282.44,298.306c.006-.1.011-.2.017-.3.107,0,.215,0,.322.006a.2.2,0,0,1-.021.3Z",
    transform: "translate(-189.917 -202.98)",
    fill: "#9cb68e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2555",
    "data-name": "Path 2555",
    d: "M283.93,298.048c.006-.1.015-.2.021-.3l-.011-.013a.232.232,0,0,1,.311-.009l.023.03C284.275,297.986,284.158,298.084,283.93,298.048Z",
    transform: "translate(-191.089 -202.711)",
    fill: "#eff3ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2556",
    "data-name": "Path 2556",
    d: "M167.269,299.524c-.222.009-.326-.1-.32-.32l.021-.021a.252.252,0,0,1,.256-.058.237.237,0,0,1,.107.087.292.292,0,0,1-.009.269Z",
    transform: "translate(-99.054 -203.848)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2557",
    "data-name": "Path 2557",
    d: "M183.632,299.279c.009.222-.1.331-.32.32l-.064-.064c-.049-.294.06-.4.348-.29Z",
    transform: "translate(-111.869 -203.919)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2558",
    "data-name": "Path 2558",
    d: "M168.769,301.024c-.222.009-.326-.1-.32-.32l.021-.021a.252.252,0,0,1,.256-.058.237.237,0,0,1,.107.087.292.292,0,0,1-.009.269Z",
    transform: "translate(-100.234 -205.028)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2559",
    "data-name": "Path 2559",
    d: "M182.14,300.779c.009.222-.1.331-.32.32-.021-.021-.043-.043-.062-.064-.049-.294.06-.4.348-.29l.036.034Z",
    transform: "translate(-110.697 -205.099)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2560",
    "data-name": "Path 2560",
    d: "M170.293,302.512c-.235.034-.345-.07-.343-.3l.021-.021a.258.258,0,0,1,.271-.051.222.222,0,0,1,.1.1.266.266,0,0,1-.051.275Z",
    transform: "translate(-101.415 -206.214)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2561",
    "data-name": "Path 2561",
    d: "M171.5,302.533c-.006-.1-.011-.207-.017-.311.237-.147.367-.077.4.194a.24.24,0,0,1-.079.145l-.3-.028Z",
    transform: "translate(-102.619 -206.235)",
    fill: "#769a65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2562",
    "data-name": "Path 2562",
    d: "M180.627,302.28c.015.232-.113.324-.326.328-.019-.023-.041-.045-.06-.068-.047-.292.06-.405.352-.294l.036.034Z",
    transform: "translate(-109.503 -206.28)",
    fill: "#a0b994"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2563",
    "data-name": "Path 2563",
    d: "M173.3,303.716c.006.1.013.2.021.3-.235.053-.36-.026-.337-.281l.009-.051A.223.223,0,0,1,173.3,303.716Z",
    transform: "translate(-103.797 -207.407)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2564",
    "data-name": "Path 2564",
    d: "M177.5,304.024c0-.1,0-.2.006-.3a.249.249,0,0,1,.333-.026.237.237,0,0,1-.028.328C177.707,304.028,177.6,304.026,177.5,304.024Z",
    transform: "translate(-107.355 -207.416)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2565",
    "data-name": "Path 2565",
    d: "M178.95,304.024c.009-.1.017-.2.023-.3a.209.209,0,0,1,.3-.032l.019.047c.011.243-.111.328-.341.281Z",
    transform: "translate(-108.496 -207.414)",
    fill: "#c0d1b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2566",
    "data-name": "Path 2566",
    d: "M191.3,311.8c-.1,0-.207,0-.309,0-.021-.247.085-.352.335-.3a.2.2,0,0,1-.023.3Z",
    transform: "translate(-117.967 -213.582)",
    fill: "#baccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2567",
    "data-name": "Path 2567",
    d: "M192.442,311.839c.009-.1.015-.2.023-.3.1,0,.209,0,.311,0,.017.245-.109.328-.337.294Z",
    transform: "translate(-119.109 -213.625)",
    fill: "#6e935b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2568",
    "data-name": "Path 2568",
    d: "M195.816,311.849c-.226.03-.352-.051-.333-.3.1,0,.209,0,.313,0A.207.207,0,0,1,195.816,311.849Z",
    transform: "translate(-121.502 -213.633)",
    fill: "#628a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2569",
    "data-name": "Path 2569",
    d: "M196.979,311.791l-.019-.3c.25-.058.358.045.337.3C197.19,311.789,197.086,311.789,196.979,311.791Z",
    transform: "translate(-122.666 -213.575)",
    fill: "#9cb68f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2570",
    "data-name": "Path 2570",
    d: "M189.806,312.966c.023.241-.083.348-.324.313C189.452,313.03,189.556,312.924,189.806,312.966Z",
    transform: "translate(-116.778 -214.74)",
    fill: "#96b289"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2571",
    "data-name": "Path 2571",
    d: "M198.812,313.271c-.237.021-.341-.087-.316-.322C198.754,312.909,198.859,313.015,198.812,313.271Z",
    transform: "translate(-123.871 -214.727)",
    fill: "#769a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2572",
    "data-name": "Path 2572",
    d: "M188.3,314.45q.048.368-.32.32Q187.932,314.4,188.3,314.45Z",
    transform: "translate(-115.596 -215.91)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2573",
    "data-name": "Path 2573",
    d: "M200.352,314.771l-.292-.019v-.318c.247-.017.35.092.294.337Z",
    transform: "translate(-125.104 -215.9)",
    fill: "#b3c7a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2574",
    "data-name": "Path 2574",
    d: "M186.8,315.95q.048.368-.32.32Q186.432,315.9,186.8,315.95Z",
    transform: "translate(-114.416 -217.09)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2575",
    "data-name": "Path 2575",
    d: "M185.3,317.45q.048.368-.32.32Q184.932,317.4,185.3,317.45Z",
    transform: "translate(-113.236 -218.27)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2576",
    "data-name": "Path 2576",
    d: "M183.8,318.95q.048.368-.32.32Q183.432,318.9,183.8,318.95Z",
    transform: "translate(-112.055 -219.45)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2577",
    "data-name": "Path 2577",
    d: "M200.052,318.965c.1,0,.194-.009.292-.015,0,.1.006.209.009.314a.206.206,0,0,1-.3.021v-.32Z",
    transform: "translate(-125.097 -219.455)",
    fill: "#a3bb97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2578",
    "data-name": "Path 2578",
    d: "M182.3,320.45q.048.368-.32.32Q181.932,320.4,182.3,320.45Z",
    transform: "translate(-110.875 -220.63)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2579",
    "data-name": "Path 2579",
    d: "M199.744,320.441l.3-.021c.034.222-.049.348-.288.341a.7.7,0,0,0-.066-.043.235.235,0,0,1,.034-.288Z",
    transform: "translate(-124.789 -220.611)",
    fill: "#eef3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2580",
    "data-name": "Path 2580",
    d: "M180.8,321.95q.048.368-.32.32Q180.432,321.9,180.8,321.95Z",
    transform: "translate(-109.695 -221.81)",
    fill: "#96b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2581",
    "data-name": "Path 2581",
    d: "M198.586,321.735c-.013.2-.1.333-.326.328l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.015l.038.019Z",
    transform: "translate(-123.616 -221.585)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2582",
    "data-name": "Path 2582",
    d: "M167.32,323.489c-.006.1-.015.2-.021.294h-.316c-.017-.247.09-.352.337-.3Z",
    transform: "translate(-99.08 -223.012)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M171.5,323.821c0-.1-.006-.2-.011-.294l.311-.006a.205.205,0,0,1,.023.3H171.5Z",
    transform: "translate(-102.627 -223.05)",
    fill: "#92af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M172.973,323.79c-.009-.1-.015-.2-.023-.3.245-.038.356.066.331.314Z",
    transform: "translate(-103.776 -223.022)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2585",
    "data-name": "Path 2585",
    d: "M179.3,323.45q.048.368-.32.32Q178.932,323.4,179.3,323.45Z",
    transform: "translate(-108.515 -222.99)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2586",
    "data-name": "Path 2586",
    d: "M197.08,323.25a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-122.436 -222.769)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2587",
    "data-name": "Path 2587",
    d: "M214.95,323.774c0-.235.113-.328.341-.3a.212.212,0,0,1-.019.3l.011.015a.237.237,0,0,1-.241.064A.167.167,0,0,1,214.95,323.774Z",
    transform: "translate(-136.819 -223.012)",
    fill: "#f2f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2588",
    "data-name": "Path 2588",
    d: "M216.46,323.8l.019-.3.32.013c-.006.1-.011.2-.017.3C216.675,323.809,216.569,323.807,216.46,323.8Z",
    transform: "translate(-138.007 -223.035)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2589",
    "data-name": "Path 2589",
    d: "M282.467,323.8c-.006-.1-.013-.2-.017-.3l.318-.013a.206.206,0,0,1,.019.3c-.107,0-.213,0-.32,0Z",
    transform: "translate(-189.925 -223.027)",
    fill: "#a5bd9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M283.949,323.787l-.019-.3c.228-.034.348.058.343.3-.015.021-.032.041-.047.062a.239.239,0,0,1-.286-.038l.011-.015Z",
    transform: "translate(-191.089 -223.017)",
    fill: "#f3f6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M165.814,324.963c.021.235-.085.341-.32.318C165.449,325.023,165.558,324.918,165.814,324.963Z",
    transform: "translate(-97.902 -224.178)",
    fill: "#80a170"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M174.791,325.286c-.252.053-.356-.055-.333-.3C174.7,324.942,174.81,325.042,174.791,325.286Z",
    transform: "translate(-104.96 -224.193)",
    fill: "#c7d7c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2593",
    "data-name": "Path 2593",
    d: "M177.788,324.95c.032.247-.077.354-.324.318C177.436,325.024,177.543,324.918,177.788,324.95Z",
    transform: "translate(-107.324 -224.171)",
    fill: "#97b288"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2594",
    "data-name": "Path 2594",
    d: "M195.58,324.75a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-121.255 -223.949)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2595",
    "data-name": "Path 2595",
    d: "M213.5,325.242c-.04-.239.073-.343.3-.352l.021.03a.223.223,0,0,1-.011.309l-.006-.009a.214.214,0,0,1-.3.021Z",
    transform: "translate(-135.672 -224.128)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M285.261,324.89c.228.006.343.113.3.352a.214.214,0,0,1-.3-.021l-.006.009a.225.225,0,0,1-.011-.309Z",
    transform: "translate(-192.077 -224.128)",
    fill: "#edf2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M164.328,326.442v.316a.2.2,0,0,1-.3.019C163.977,326.529,164.081,326.423,164.328,326.442Z",
    transform: "translate(-96.747 -225.347)",
    fill: "#b2c6a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M176.314,326.47c-.017.126.043.313-.181.3-.175-.013-.124-.177-.143-.288Z",
    transform: "translate(-106.167 -225.371)",
    fill: "#82a372"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M194.08,326.25a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-120.075 -225.129)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2600",
    "data-name": "Path 2600",
    d: "M213.53,326.461l.3-.021c.038.232-.053.352-.3.335C213.536,326.67,213.532,326.566,213.53,326.461Z",
    transform: "translate(-135.702 -225.348)",
    fill: "#88a77a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2601",
    "data-name": "Path 2601",
    d: "M285.489,326.44l.3.021c0,.1-.006.209-.009.313C285.542,326.792,285.451,326.672,285.489,326.44Z",
    transform: "translate(-192.309 -225.348)",
    fill: "#89a77b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2602",
    "data-name": "Path 2602",
    d: "M164.08,327.949l.3-.019c0,.109,0,.22.006.328a.206.206,0,0,1-.3,0c0-.1,0-.209,0-.311Z",
    transform: "translate(-96.797 -226.52)",
    fill: "#799c67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2603",
    "data-name": "Path 2603",
    d: "M192.58,327.75a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-118.895 -226.31)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2604",
    "data-name": "Path 2604",
    d: "M164.09,329.464c.1,0,.2,0,.3,0v.328a.2.2,0,0,1-.3-.011v-.313Z",
    transform: "translate(-96.805 -227.724)",
    fill: "#6b9258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2605",
    "data-name": "Path 2605",
    d: "M191.08,329.25a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-117.715 -227.49)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2606",
    "data-name": "Path 2606",
    d: "M212.392,329.47c0,.109,0,.22,0,.328-.122-.021-.3.017-.279-.19C212.13,329.444,212.281,329.485,212.392,329.47Z",
    transform: "translate(-134.587 -227.731)",
    fill: "#f0f4ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2607",
    "data-name": "Path 2607",
    d: "M287.06,329.8c0-.109,0-.218,0-.328.109.015.26-.023.277.139C287.359,329.815,287.182,329.775,287.06,329.8Z",
    transform: "translate(-193.551 -227.731)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2608",
    "data-name": "Path 2608",
    d: "M164.059,330.96c.1,0,.2.006.3.011,0,.109,0,.218-.006.326a.2.2,0,0,1-.3-.023c0-.1,0-.207.006-.311Z",
    transform: "translate(-96.774 -228.904)",
    fill: "#87a679"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M189.58,330.74a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-116.535 -228.662)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2610",
    "data-name": "Path 2610",
    d: "M213.562,330.947c.241-.013.331.109.3.339a.208.208,0,0,1-.3-.023C213.56,331.158,213.56,331.051,213.562,330.947Z",
    transform: "translate(-135.726 -228.892)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2611",
    "data-name": "Path 2611",
    d: "M285.494,331.277c-.034-.228.055-.35.3-.339,0,.1,0,.211,0,.316A.208.208,0,0,1,285.494,331.277Z",
    transform: "translate(-192.314 -228.886)",
    fill: "#61894c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2612",
    "data-name": "Path 2612",
    d: "M164.026,332.412c.1.009.2.017.3.023,0,.1.009.2.011.307-.247.023-.352-.087-.309-.333Z",
    transform: "translate(-96.747 -230.044)",
    fill: "#d6e0d0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2613",
    "data-name": "Path 2613",
    d: "M188.08,332.24a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-115.355 -229.842)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2614",
    "data-name": "Path 2614",
    d: "M213.514,332.43l.3.023c0,.1,0,.207,0,.309C213.569,332.788,213.463,332.682,213.514,332.43Z",
    transform: "translate(-135.679 -230.06)",
    fill: "#adc3a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2615",
    "data-name": "Path 2615",
    d: "M285.5,332.443l.3-.023c.051.252-.055.358-.3.333C285.5,332.65,285.5,332.546,285.5,332.443Z",
    transform: "translate(-192.324 -230.052)",
    fill: "#b0c4a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2616",
    "data-name": "Path 2616",
    d: "M165.512,333.937c.243-.026.348.083.316.324C165.58,334.291,165.473,334.184,165.512,333.937Z",
    transform: "translate(-97.918 -231.243)",
    fill: "#b7caad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2617",
    "data-name": "Path 2617",
    d: "M186.58,333.74a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-114.175 -231.022)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M214.987,333.951c.235-.03.345.072.326.311C215.06,334.314,214.953,334.205,214.987,333.951Z",
    transform: "translate(-136.843 -231.253)",
    fill: "#9eb892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2619",
    "data-name": "Path 2619",
    d: "M283.942,334.255c-.019-.237.092-.339.326-.311C284.3,334.2,284.2,334.3,283.942,334.255Z",
    transform: "translate(-191.097 -231.248)",
    fill: "#9eb892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2620",
    "data-name": "Path 2620",
    d: "M167,335.45q.368-.048.32.32Q166.952,335.817,167,335.45Z",
    transform: "translate(-99.09 -232.431)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2621",
    "data-name": "Path 2621",
    d: "M185.08,335.24a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-112.995 -232.202)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2622",
    "data-name": "Path 2622",
    d: "M216.8,335.509c.006.1.015.2.021.3-.241.041-.354-.06-.337-.3Z",
    transform: "translate(-138.025 -232.476)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2623",
    "data-name": "Path 2623",
    d: "M280.98,335.84c0-.1,0-.194,0-.29h.324a.2.2,0,0,1-.015.3Z",
    transform: "translate(-188.768 -232.515)",
    fill: "#baccb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2624",
    "data-name": "Path 2624",
    d: "M282.432,335.807c0-.1.011-.2.015-.3l.316-.011c.019.241-.094.343-.333.307Z",
    transform: "translate(-189.909 -232.476)",
    fill: "#e6ece3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2625",
    "data-name": "Path 2625",
    d: "M168.5,336.95q.368-.048.32.32Q168.452,337.317,168.5,336.95Z",
    transform: "translate(-100.27 -233.612)",
    fill: "#b6c9ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2626",
    "data-name": "Path 2626",
    d: "M183.58,336.74a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-111.814 -233.382)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2627",
    "data-name": "Path 2627",
    d: "M170,338.45q.368-.048.32.32Q169.952,338.821,170,338.45Z",
    transform: "translate(-101.45 -234.792)",
    fill: "#b6c9ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2628",
    "data-name": "Path 2628",
    d: "M182.08,338.24a.286.286,0,0,1-.32.32l-.062-.049a.223.223,0,0,1,.049-.286h0a.213.213,0,0,1,.3-.017l.032.03Z",
    transform: "translate(-110.634 -234.563)",
    fill: "#dee7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2629",
    "data-name": "Path 2629",
    d: "M171.5,339.946c.239-.034.352.066.328.311C171.583,340.3,171.476,340.2,171.5,339.946Z",
    transform: "translate(-102.635 -235.968)",
    fill: "#bbcdb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2630",
    "data-name": "Path 2630",
    d: "M178.984,340.291c-.017-.239.1-.339.331-.3a.209.209,0,0,1-.019.307h-.311Z",
    transform: "translate(-108.521 -236)",
    fill: "#658c50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2631",
    "data-name": "Path 2631",
    d: "M180.442,340.035l.019-.307h0a.212.212,0,0,1,.3-.019l.032.03c-.011.226-.119.335-.352.294Z",
    transform: "translate(-109.668 -235.743)",
    fill: "#dfe7db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2632",
    "data-name": "Path 2632",
    d: "M173.31,341.483c.006.1.015.2.021.3-.243.038-.356-.064-.333-.311Z",
    transform: "translate(-103.812 -237.172)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2633",
    "data-name": "Path 2633",
    d: "M177.49,341.834c0-.1.006-.192.009-.29.109,0,.215,0,.324,0C177.838,341.779,177.729,341.881,177.49,341.834Z",
    transform: "translate(-107.348 -237.227)",
    fill: "#c0d1b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2634",
    "data-name": "Path 2634",
    d: "M192.788,347.774c-.107,0-.215,0-.322,0-.013-.239.094-.341.333-.3A.2.2,0,0,1,192.788,347.774Z",
    transform: "translate(-119.129 -241.894)",
    fill: "#cfdbc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2635",
    "data-name": "Path 2635",
    d: "M193.972,347.812c0-.1.006-.194.011-.292h.309a.2.2,0,0,1,.006.29h-.328Z",
    transform: "translate(-120.313 -241.932)",
    fill: "#b3c7aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2636",
    "data-name": "Path 2636",
    d: "M195.5,347.789l-.006-.29.316-.009a.205.205,0,0,1,.015.3C195.712,347.791,195.605,347.791,195.5,347.789Z",
    transform: "translate(-121.509 -241.909)",
    fill: "#c4d4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2637",
    "data-name": "Path 2637",
    d: "M196.985,347.771c0-.1-.011-.2-.015-.3.211-.026.348.038.328.281-.013.023-.026.045-.036.068a.238.238,0,0,1-.288-.026l.013-.026Z",
    transform: "translate(-122.673 -241.889)",
    fill: "#f5f7f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2638",
    "data-name": "Path 2638",
    d: "M189.43,349.272c0-.232.119-.331.35-.292a.217.217,0,0,1-.021.307h0a.208.208,0,0,1-.239.075A.168.168,0,0,1,189.43,349.272Z",
    transform: "translate(-116.741 -243.075)",
    fill: "#e7ede3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2639",
    "data-name": "Path 2639",
    d: "M190.97,349.307c.006-.1.015-.2.021-.307.1,0,.209,0,.311,0,.015.239-.1.339-.333.3Z",
    transform: "translate(-117.953 -243.097)",
    fill: "#70955e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2640",
    "data-name": "Path 2640",
    d: "M198.578,349.173l-.3-.013a.2.2,0,0,1-.017-.3l.006-.049c.213.026.363.107.311.36Z",
    transform: "translate(-123.642 -242.947)",
    fill: "#cad9c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2641",
    "data-name": "Path 2641",
    d: "M187.92,350.7c0-.218.113-.316.322-.32l.028.032a.21.21,0,0,1-.019.3h0a.207.207,0,0,1-.237.075.168.168,0,0,1-.094-.09Z",
    transform: "translate(-115.553 -244.182)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2642",
    "data-name": "Path 2642",
    d: "M200,350.772l-.015-.307c.247-.028.352.083.316.328a.207.207,0,0,1-.3-.021Z",
    transform: "translate(-125.049 -244.246)",
    fill: "#e1e9de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2643",
    "data-name": "Path 2643",
    d: "M186.42,352.2a.284.284,0,0,1,.32-.32l.028.03a.212.212,0,0,1-.019.3h0a.208.208,0,0,1-.237.075.168.168,0,0,1-.094-.09Z",
    transform: "translate(-114.373 -245.362)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2644",
    "data-name": "Path 2644",
    d: "M200.052,351.92l.3.021c0,.1-.006.209-.009.314a.2.2,0,0,1-.292-.011C200.05,352.135,200.05,352.029,200.052,351.92Z",
    transform: "translate(-125.097 -245.394)",
    fill: "#98b38a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2645",
    "data-name": "Path 2645",
    d: "M184.92,353.7c0-.215.109-.316.32-.32l.028.03a.212.212,0,0,1-.019.3h0a.208.208,0,0,1-.237.075.168.168,0,0,1-.094-.09Z",
    transform: "translate(-113.193 -246.543)",
    fill: "#e4ebe2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2646",
    "data-name": "Path 2646",
    d: "M200.042,353.44l.292.011v.314a.2.2,0,0,1-.294,0v-.328Z",
    transform: "translate(-125.089 -246.59)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2647",
    "data-name": "Path 2647",
    d: "M183.42,355.2a.284.284,0,0,1,.32-.32l.028.03a.212.212,0,0,1-.019.3h0a.207.207,0,0,1-.237.075.168.168,0,0,1-.094-.09Z",
    transform: "translate(-112.013 -247.723)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2648",
    "data-name": "Path 2648",
    d: "M200.04,354.964c.1,0,.2,0,.294,0,0,.1,0,.207,0,.311a.2.2,0,0,1-.294.021C200.044,355.184,200.042,355.075,200.04,354.964Z",
    transform: "translate(-125.089 -247.786)",
    fill: "#88a77a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2649",
    "data-name": "Path 2649",
    d: "M181.92,356.7a.284.284,0,0,1,.32-.32l.028.03a.212.212,0,0,1-.019.3h0a.207.207,0,0,1-.237.075.168.168,0,0,1-.094-.09Z",
    transform: "translate(-110.833 -248.903)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2650",
    "data-name": "Path 2650",
    d: "M200.036,356.441l.294-.021c.049.245-.055.354-.3.335Z",
    transform: "translate(-125.081 -248.934)",
    fill: "#c2d2ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M180.43,358.2c0-.215.109-.316.32-.32l.028.03a.212.212,0,0,1-.019.3h0a.207.207,0,0,1-.237.075.168.168,0,0,1-.094-.09Z",
    transform: "translate(-109.66 -250.083)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M198.5,358.27c-.034-.239.07-.348.311-.328C198.855,358.194,198.746,358.3,198.5,358.27Z",
    transform: "translate(-123.87 -250.13)",
    fill: "#8fac80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M171.5,359.757c0-.1,0-.2,0-.3.232-.026.343.077.324.311l-.32-.013Z",
    transform: "translate(-102.635 -251.32)",
    fill: "#f2f6f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M178.93,359.7a.284.284,0,0,1,.32-.32l.028.03a.212.212,0,0,1-.019.3h0a.207.207,0,0,1-.237.075.168.168,0,0,1-.094-.09Z",
    transform: "translate(-108.48 -251.263)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M197,359.779q-.048-.368.32-.32Q197.367,359.827,197,359.779Z",
    transform: "translate(-122.692 -251.321)",
    fill: "#8cab7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M165.826,361.286l-.3.015c-.036-.254.075-.358.326-.32a.212.212,0,0,1-.023.3Z",
    transform: "translate(-97.929 -252.517)",
    fill: "#d8e2d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M166.96,361.315c.009-.1.017-.2.023-.3.1,0,.209,0,.313,0C167.31,361.255,167.19,361.349,166.96,361.315Z",
    transform: "translate(-99.063 -252.545)",
    fill: "#6c9259"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M173.3,361.277c-.237.038-.35-.06-.335-.3C173.217,360.921,173.323,361.026,173.3,361.277Z",
    transform: "translate(-103.787 -252.508)",
    fill: "#99b48c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2659",
    "data-name": "Path 2659",
    d: "M177.432,361.19c-.006-.218.109-.316.318-.32l.028.03a.212.212,0,0,1-.019.3h0a.208.208,0,0,1-.237.075.168.168,0,0,1-.094-.09Z",
    transform: "translate(-107.3 -252.435)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2660",
    "data-name": "Path 2660",
    d: "M195.5,361.279q-.048-.368.32-.32Q195.867,361.327,195.5,361.279Z",
    transform: "translate(-121.512 -252.501)",
    fill: "#8caa7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M215.3,361.283l-.3.009c-.032-.252.077-.358.328-.311a.206.206,0,0,1-.023.3Z",
    transform: "translate(-136.854 -252.514)",
    fill: "#bdceb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2662",
    "data-name": "Path 2662",
    d: "M216.432,361.323c.009-.1.017-.2.023-.3h.313c.015.243-.107.335-.339.3Z",
    transform: "translate(-137.983 -252.553)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2663",
    "data-name": "Path 2663",
    d: "M282.8,361.331c-.23.032-.352-.06-.337-.3h.314a.208.208,0,0,1,.026.3Z",
    transform: "translate(-189.936 -252.561)",
    fill: "#5f874a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M283.956,361.286l-.026-.3c.252-.045.36.06.328.313l-.3-.011Z",
    transform: "translate(-191.089 -252.516)",
    fill: "#becfb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2665",
    "data-name": "Path 2665",
    d: "M164.337,362.472c-.006.1-.011.2-.017.3a.21.21,0,0,1-.3.021C163.983,362.551,164.087,362.442,164.337,362.472Z",
    transform: "translate(-96.743 -253.692)",
    fill: "#e4ebe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2666",
    "data-name": "Path 2666",
    d: "M174.835,362.771c-.247.043-.358-.062-.331-.311l.307.009A.206.206,0,0,1,174.835,362.771Z",
    transform: "translate(-104.996 -253.686)",
    fill: "#83a474"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2667",
    "data-name": "Path 2667",
    d: "M175.983,362.7c-.009-.1-.017-.2-.023-.3l.318-.028.026.032a.208.208,0,0,1-.023.3c-.1,0-.2,0-.294,0Z",
    transform: "translate(-106.144 -253.615)",
    fill: "#e0e8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2668",
    "data-name": "Path 2668",
    d: "M194,362.779q-.048-.368.32-.32Q194.367,362.827,194,362.779Z",
    transform: "translate(-120.332 -253.682)",
    fill: "#8cab7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2669",
    "data-name": "Path 2669",
    d: "M213.832,362.464c0,.1-.006.2-.009.3a.206.206,0,0,1-.3.026c-.045-.25.06-.358.311-.331Z",
    transform: "translate(-135.688 -253.686)",
    fill: "#c4d5bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2670",
    "data-name": "Path 2670",
    d: "M285.481,362.769c0-.1-.006-.2-.011-.3.25-.028.356.081.311.331A.2.2,0,0,1,285.481,362.769Z",
    transform: "translate(-192.3 -253.686)",
    fill: "#c4d4bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2671",
    "data-name": "Path 2671",
    d: "M164.05,363.941l.3-.021c0,.109,0,.215,0,.324l-.3.011C164.056,364.15,164.052,364.046,164.05,363.941Z",
    transform: "translate(-96.774 -254.835)",
    fill: "#93af84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2672",
    "data-name": "Path 2672",
    d: "M192.5,364.279q-.048-.368.32-.32Q192.867,364.327,192.5,364.279Z",
    transform: "translate(-119.152 -254.862)",
    fill: "#8cab7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2673",
    "data-name": "Path 2673",
    d: "M213.55,363.936l.3-.026c.036.23-.055.352-.3.339,0-.1,0-.209,0-.316Z",
    transform: "translate(-135.718 -254.827)",
    fill: "#6a9056"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2674",
    "data-name": "Path 2674",
    d: "M285.491,363.91l.3.026c0,.1,0,.209,0,.316C285.545,364.262,285.455,364.142,285.491,363.91Z",
    transform: "translate(-192.311 -254.827)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2675",
    "data-name": "Path 2675",
    d: "M191,365.779q-.048-.368.32-.32Q191.367,365.827,191,365.779Z",
    transform: "translate(-117.972 -256.042)",
    fill: "#8cab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2676",
    "data-name": "Path 2676",
    d: "M189.5,367.28q-.048-.368.32-.32Q189.867,367.327,189.5,367.28Z",
    transform: "translate(-116.792 -257.222)",
    fill: "#8cab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2677",
    "data-name": "Path 2677",
    d: "M164.059,368.43c.1.006.2.013.3.017v.318a.209.209,0,0,1-.3-.019c0-.1.006-.211.011-.316Z",
    transform: "translate(-96.774 -258.383)",
    fill: "#a3bc98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2678",
    "data-name": "Path 2678",
    d: "M188,368.779q-.048-.368.32-.32Q188.367,368.827,188,368.779Z",
    transform: "translate(-115.612 -258.402)",
    fill: "#8caa7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2679",
    "data-name": "Path 2679",
    d: "M213.546,368.422c.241-.011.335.107.3.339a.207.207,0,0,1-.3-.026c0-.1,0-.209.006-.316Z",
    transform: "translate(-135.71 -258.375)",
    fill: "#7b9d69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2680",
    "data-name": "Path 2680",
    d: "M285.5,368.766c-.038-.232.053-.352.3-.339l.006.316a.208.208,0,0,1-.3.026Z",
    transform: "translate(-192.317 -258.38)",
    fill: "#7c9e6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2681",
    "data-name": "Path 2681",
    d: "M164.009,369.9l.3.019.013-.011a.237.237,0,0,1,.064.241.155.155,0,0,1-.09.09c-.239.009-.326-.115-.294-.341Z",
    transform: "translate(-96.735 -259.54)",
    fill: "#f4f7f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2682",
    "data-name": "Path 2682",
    d: "M186.5,370.279q-.048-.368.32-.32Q186.867,370.327,186.5,370.279Z",
    transform: "translate(-114.431 -259.582)",
    fill: "#8cab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2683",
    "data-name": "Path 2683",
    d: "M213.514,369.91l.3.026.017.3c-.252.032-.356-.079-.32-.326Z",
    transform: "translate(-135.684 -259.547)",
    fill: "#dde6d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2684",
    "data-name": "Path 2684",
    d: "M285.467,369.926l.3-.026c.036.25-.068.36-.32.326.006-.1.011-.2.017-.3Z",
    transform: "translate(-192.285 -259.54)",
    fill: "#dde6d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2685",
    "data-name": "Path 2685",
    d: "M165.742,371.565c-.224.006-.318-.117-.322-.326l.032-.017a.211.211,0,0,1,.3.015.2.2,0,0,1,.077.235.175.175,0,0,1-.087.1Z",
    transform: "translate(-97.852 -260.535)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2686",
    "data-name": "Path 2686",
    d: "M185,371.779q-.048-.368.32-.32Q185.367,371.827,185,371.779Z",
    transform: "translate(-113.251 -260.762)",
    fill: "#8cab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2687",
    "data-name": "Path 2687",
    d: "M215.018,371.43l.3.017a.21.21,0,0,1,.026.3c-.247.036-.358-.068-.326-.318Z",
    transform: "translate(-136.87 -260.743)",
    fill: "#e0e8dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2688",
    "data-name": "Path 2688",
    d: "M216.466,371.78c-.009-.1-.017-.2-.026-.3.23-.038.356.045.339.292Z",
    transform: "translate(-137.991 -260.773)",
    fill: "#84a575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2689",
    "data-name": "Path 2689",
    d: "M282.444,371.769c-.017-.247.109-.331.339-.292a.208.208,0,0,1-.023.3l-.314-.011Z",
    transform: "translate(-189.919 -260.773)",
    fill: "#84a475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2690",
    "data-name": "Path 2690",
    d: "M283.912,371.75c.009-.1.017-.2.023-.3l.3-.017c.032.252-.079.356-.328.32Z",
    transform: "translate(-191.073 -260.743)",
    fill: "#e0e8dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2691",
    "data-name": "Path 2691",
    d: "M167.25,373.06a.279.279,0,0,1-.32-.32l.028-.026a.214.214,0,0,1,.3.017.2.2,0,0,1,.077.235.175.175,0,0,1-.087.1Z",
    transform: "translate(-99.039 -261.71)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2692",
    "data-name": "Path 2692",
    d: "M183.5,373.279q-.048-.368.32-.32Q183.867,373.327,183.5,373.279Z",
    transform: "translate(-112.071 -261.942)",
    fill: "#8caa7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    d: "M168.75,374.56a.279.279,0,0,1-.32-.32l.028-.026a.214.214,0,0,1,.3.017.2.2,0,0,1,.077.235.175.175,0,0,1-.087.1Z",
    transform: "translate(-100.22 -262.891)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    d: "M182,374.779q-.048-.368.32-.32Q182.367,374.827,182,374.779Z",
    transform: "translate(-110.891 -263.122)",
    fill: "#8caa7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    d: "M170.254,376.062a.286.286,0,0,1-.324-.322l.028-.026a.214.214,0,0,1,.3.017.205.205,0,0,1,.077.232.187.187,0,0,1-.083.1Z",
    transform: "translate(-101.4 -264.071)",
    fill: "#eaf0e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    d: "M180.487,376.275c-.026-.243.083-.348.324-.316C180.843,376.207,180.736,376.315,180.487,376.275Z",
    transform: "translate(-109.702 -264.302)",
    fill: "#8cab7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    d: "M171.8,377.536c-.23.034-.345-.062-.345-.294l.023-.03a.225.225,0,0,1,.309.011l-.009.009A.214.214,0,0,1,171.8,377.536Z",
    transform: "translate(-102.596 -265.248)",
    fill: "#f0f4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    d: "M172.991,377.783c-.006-.1-.015-.2-.021-.3.232-.038.352.051.337.3l-.316.011Z",
    transform: "translate(-103.791 -265.495)",
    fill: "#8caa7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    d: "M177.477,377.766c-.013-.241.109-.331.339-.3a.209.209,0,0,1-.021.3h-.316Z",
    transform: "translate(-107.336 -265.488)",
    fill: "#5f874b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    d: "M178.952,377.791c.006-.1.015-.2.021-.3h.311c.023.25-.083.356-.335.3Z",
    transform: "translate(-108.496 -265.511)",
    fill: "#a8c09e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    d: "M176,379.042c.109,0,.22,0,.328,0-.021.122.017.3-.19.279C175.977,379.3,176.015,379.151,176,379.042Z",
    transform: "translate(-106.175 -266.73)",
    fill: "#f2f5f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    d: "M215.322,296.784c-.1,0-.209,0-.311-.009,0-.1-.006-.2-.011-.309.235-.026.343.079.322.316Z",
    transform: "translate(-136.858 -201.763)",
    fill: "#628a4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    d: "M284.282,296.783c-.1,0-.209,0-.311.009-.021-.237.087-.341.322-.316,0,.1-.006.2-.011.309Z",
    transform: "translate(-191.119 -201.771)",
    fill: "#648b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    d: "M214.99,251.818l.013-.307.309-.011C215.333,251.737,215.227,251.843,214.99,251.818Z",
    transform: "translate(-136.851 -166.389)",
    fill: "#5c8646"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    d: "M284.289,251.511l.013.307c-.237.026-.343-.081-.322-.318Z",
    transform: "translate(-191.126 -166.389)",
    fill: "#5c8547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    d: "M215,325.316c0-.1.006-.207.011-.309.1,0,.209,0,.313-.006.019.237-.09.339-.322.316Z",
    transform: "translate(-136.858 -224.215)",
    fill: "#668d52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    d: "M284.282,325.006c0,.1.006.207.011.309-.235.026-.343-.079-.322-.316l.313.006Z",
    transform: "translate(-191.119 -224.215)",
    fill: "#678f53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    d: "M198.805,239.5c0,.1,0,.209,0,.313-.237.019-.339-.09-.313-.324Z",
    transform: "translate(-123.871 -156.94)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    d: "M198.811,247.278l-.3.015c-.032-.237.068-.35.309-.331,0,.1,0,.209-.006.313Z",
    transform: "translate(-123.879 -162.817)",
    fill: "#6b9158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    d: "M197.315,248.8l-.3.017c-.032-.245.077-.352.322-.322C197.325,248.594,197.321,248.695,197.315,248.8Z",
    transform: "translate(-122.7 -164.018)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    d: "M195.815,250.3l-.3.017c-.032-.245.077-.352.322-.322C195.825,250.094,195.821,250.195,195.815,250.3Z",
    transform: "translate(-121.52 -165.198)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    d: "M194.315,251.8l-.3.017c-.032-.245.077-.352.322-.322C194.325,251.594,194.321,251.695,194.315,251.8Z",
    transform: "translate(-120.34 -166.379)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    d: "M192.815,253.3l-.3.017c-.032-.245.077-.352.322-.322C192.825,253.094,192.821,253.195,192.815,253.3Z",
    transform: "translate(-119.16 -167.559)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M191.315,254.8l-.3.017c-.032-.245.077-.352.322-.322C191.325,254.594,191.321,254.695,191.315,254.8Z",
    transform: "translate(-117.98 -168.739)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M189.815,256.3l-.3.017c-.032-.245.077-.352.322-.322C189.825,256.094,189.821,256.195,189.815,256.3Z",
    transform: "translate(-116.8 -169.919)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M188.315,257.8l-.3.017c-.032-.245.077-.352.322-.322C188.325,257.594,188.321,257.695,188.315,257.8Z",
    transform: "translate(-115.62 -171.099)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M186.815,259.3l-.3.017c-.032-.245.077-.352.322-.322C186.825,259.094,186.821,259.195,186.815,259.3Z",
    transform: "translate(-114.44 -172.279)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    d: "M185.315,260.8l-.3.017c-.032-.245.077-.352.322-.322C185.325,260.594,185.321,260.695,185.315,260.8Z",
    transform: "translate(-113.259 -173.459)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    d: "M183.815,262.3l-.3.017c-.032-.245.077-.352.322-.322C183.825,262.094,183.821,262.195,183.815,262.3Z",
    transform: "translate(-112.079 -174.639)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    d: "M182.315,263.8l-.3.017c-.032-.245.077-.352.322-.322C182.325,263.594,182.321,263.695,182.315,263.8Z",
    transform: "translate(-110.899 -175.82)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2721",
    "data-name": "Path 2721",
    d: "M180.811,265.3l-.307.015c-.028-.245.081-.35.324-.32C180.822,265.094,180.818,265.194,180.811,265.3Z",
    transform: "translate(-109.716 -176.999)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2722",
    "data-name": "Path 2722",
    d: "M197.3,349.024c.006.1.011.2.017.3-.232.032-.352-.062-.337-.3.107,0,.213,0,.318,0Z",
    transform: "translate(-122.677 -243.112)",
    fill: "#5d8647"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2723",
    "data-name": "Path 2723",
    d: "M189.47,350.77l.019-.3.3-.017C189.822,350.7,189.713,350.8,189.47,350.77Z",
    transform: "translate(-116.773 -244.237)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2724",
    "data-name": "Path 2724",
    d: "M187.97,352.262l.019-.3.3-.019C188.324,352.185,188.215,352.294,187.97,352.262Z",
    transform: "translate(-115.593 -245.41)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2725",
    "data-name": "Path 2725",
    d: "M186.47,353.762l.019-.3.3-.019C186.824,353.685,186.715,353.794,186.47,353.762Z",
    transform: "translate(-114.413 -246.59)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2726",
    "data-name": "Path 2726",
    d: "M184.97,355.262l.019-.3.3-.019C185.324,355.185,185.215,355.294,184.97,355.262Z",
    transform: "translate(-113.232 -247.77)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2727",
    "data-name": "Path 2727",
    d: "M183.47,356.762l.019-.3.3-.019C183.824,356.685,183.715,356.794,183.47,356.762Z",
    transform: "translate(-112.052 -248.95)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2728",
    "data-name": "Path 2728",
    d: "M181.97,358.262l.019-.3.3-.019C182.324,358.185,182.215,358.294,181.97,358.262Z",
    transform: "translate(-110.872 -250.13)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2729",
    "data-name": "Path 2729",
    d: "M180.47,359.762l.019-.3.3-.019C180.824,359.685,180.715,359.794,180.47,359.762Z",
    transform: "translate(-109.692 -251.31)",
    fill: "#638b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2730",
    "data-name": "Path 2730",
    d: "M178.97,361.262l.019-.3.3-.019C179.324,361.185,179.215,361.294,178.97,361.262Z",
    transform: "translate(-108.512 -252.49)",
    fill: "#638b4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2731",
    "data-name": "Path 2731",
    d: "M177.442,362.752c.009-.1.015-.2.023-.3l.3-.019c.032.25-.081.354-.328.322Z",
    transform: "translate(-107.308 -253.663)",
    fill: "#638a4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2732",
    "data-name": "Path 2732",
    d: "M165.849,370.281l-.3-.015-.006-.314c.241-.019.343.092.311.328Z",
    transform: "translate(-97.946 -259.579)",
    fill: "#6a9157"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2733",
    "data-name": "Path 2733",
    d: "M167.3,371.794l-.3-.017c-.006-.1-.011-.2-.017-.3C167.225,371.442,167.332,371.549,167.3,371.794Z",
    transform: "translate(-99.079 -260.772)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2734",
    "data-name": "Path 2734",
    d: "M168.8,373.292l-.3-.017c-.006-.1-.011-.2-.017-.3C168.725,372.938,168.832,373.047,168.8,373.292Z",
    transform: "translate(-100.259 -261.95)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2735",
    "data-name": "Path 2735",
    d: "M170.3,374.794l-.3-.017c-.006-.1-.011-.2-.017-.3C170.225,374.442,170.332,374.549,170.3,374.794Z",
    transform: "translate(-101.439 -263.133)",
    fill: "#688f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2736",
    "data-name": "Path 2736",
    d: "M171.806,376.285l-.309-.011c-.006-.1-.011-.2-.017-.3C171.721,375.937,171.83,376.042,171.806,376.285Z",
    transform: "translate(-102.619 -264.31)",
    fill: "#698f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2737",
    "data-name": "Path 2737",
    d: "M198.811,320.776l-.3.017c-.032-.237.068-.35.309-.331Z",
    transform: "translate(-123.879 -220.643)",
    fill: "#60884c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2738",
    "data-name": "Path 2738",
    d: "M197.313,322.283l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-122.7 -221.834)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2739",
    "data-name": "Path 2739",
    d: "M195.813,323.783l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-121.52 -223.014)",
    fill: "#5f874a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2740",
    "data-name": "Path 2740",
    d: "M194.313,325.283l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-120.34 -224.194)",
    fill: "#5f874a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2741",
    "data-name": "Path 2741",
    d: "M192.813,326.783l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-119.16 -225.375)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2742",
    "data-name": "Path 2742",
    d: "M191.313,328.283l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-117.98 -226.555)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2743",
    "data-name": "Path 2743",
    d: "M189.813,329.783l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-116.8 -227.735)",
    fill: "#5f874a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2744",
    "data-name": "Path 2744",
    d: "M188.313,331.283l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-115.62 -228.915)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2745",
    "data-name": "Path 2745",
    d: "M186.813,332.783l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-114.44 -230.095)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2746",
    "data-name": "Path 2746",
    d: "M185.313,334.283l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-113.259 -231.275)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2747",
    "data-name": "Path 2747",
    d: "M183.813,335.783l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-112.079 -232.455)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2748",
    "data-name": "Path 2748",
    d: "M182.313,337.283l-.3.019c-.032-.245.077-.354.322-.322Z",
    transform: "translate(-110.899 -233.635)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2749",
    "data-name": "Path 2749",
    d: "M180.815,338.785l-.3.019c-.03-.245.079-.352.324-.322l-.019.3Z",
    transform: "translate(-109.721 -234.818)",
    fill: "#5f884a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2750",
    "data-name": "Path 2750",
    d: "M168.661,281.489l-.3.032c-.109,0-.217,0-.328,0h-.653l-.307-.034c.017-.241-.113-.314-.328-.286a2.848,2.848,0,0,0-.322-.32,3.042,3.042,0,0,0-.322-.32,3.233,3.233,0,0,0-.32-.32c.028-.215-.043-.348-.286-.326-.013-.1-.026-.2-.036-.307v-.981c.009-.1.019-.2.028-.3l.292-.015c.215.026.356-.036.326-.288l.648-.045.318.04c-.028.25.1.322.326.29l0,0a2.417,2.417,0,0,0,.331.314c.245.053.335-.064.32-.294.232.017.345-.083.322-.322q.355.035.32-.32.355.035.32-.32.355.035.32-.32.355.035.32-.32.355.035.32-.32.355.035.32-.32.355.035.32-.32l.3-.019c.213.023.354-.036.326-.288l.32-.043h.653l.3.032c-.026.23.081.331.307.311.011.1.021.2.03.3s0,.218,0,.324v.331c0,.109,0,.218,0,.326s-.023.2-.034.3c-.23-.026-.318.1-.318.309a9484.5,9484.5,0,0,1-.64.64,9483.143,9483.143,0,0,1-.64.64,28450.334,28450.334,0,0,1-.96.96,63666159981238.125,63666159981238.125,0,0,1-1.28,1.28c-.211,0-.333.09-.309.316Z",
    transform: "translate(-97.883 -185.208)",
    fill: "#527e3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2751",
    "data-name": "Path 2751",
    d: "M174.835,289.294c-.245.036-.358-.066-.331-.314l.311.019.019.3Z",
    transform: "translate(-104.996 -195.876)",
    fill: "#6e945c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2752",
    "data-name": "Path 2752",
    d: "M166.982,297.982c.245-.03.352.077.32.322l-.307-.015c0-.1-.011-.2-.015-.307Z",
    transform: "translate(-99.079 -202.954)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2753",
    "data-name": "Path 2753",
    d: "M168.48,299.482c.245-.03.352.077.322.322l-.307-.015C168.491,299.687,168.484,299.584,168.48,299.482Z",
    transform: "translate(-100.259 -204.135)",
    fill: "#759963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2754",
    "data-name": "Path 2754",
    d: "M169.98,300.98c.245-.032.352.077.322.32l-.307-.015c0-.1-.011-.2-.015-.307Z",
    transform: "translate(-101.439 -205.313)",
    fill: "#759963"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures);
export default __webpack_public_path__ + "static/media/Features.3b3a79e086af1b80aac3cc771f53ca36.svg";
export { ForwardRef as ReactComponent };